// (function() {

// })();




(function() {

      function Dv(l) {
        return l &&
          l.__esModule &&
          Object.prototype.hasOwnProperty.call(l, 'default')
          ? l.default
          : l;
      }
      var Zo = { exports: {} },
        Fa = {};
      /**
       * @license React
       * react-jsx-runtime.production.js
       *
       * Copyright (c) Meta Platforms, Inc. and affiliates.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */ var Eh;
      function Lv() {
        if (Eh) return Fa;
        Eh = 1;
        var l = Symbol.for('react.transitional.element'),
          a = Symbol.for('react.fragment');
        function s(r, u, f) {
          var p = null;
          if (
            (f !== void 0 && (p = '' + f),
            u.key !== void 0 && (p = '' + u.key),
            'key' in u)
          ) {
            f = {};
            for (var g in u) g !== 'key' && (f[g] = u[g]);
          } else f = u;
          return (
            (u = f.ref),
            {
              $$typeof: l,
              type: r,
              key: p,
              ref: u !== void 0 ? u : null,
              props: f,
            }
          );
        }
        return ((Fa.Fragment = a), (Fa.jsx = s), (Fa.jsxs = s), Fa);
      }
      var wh;
      function jv() {
        return (wh || ((wh = 1), (Zo.exports = Lv())), Zo.exports);
      }
      var A = jv(),
        ko = { exports: {} },
        Pa = {},
        Jo = { exports: {} },
        Fo = {};
      /**
       * @license React
       * scheduler.production.js
       *
       * Copyright (c) Meta Platforms, Inc. and affiliates.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */ var Mh;
      function Hv() {
        return (
          Mh ||
            ((Mh = 1),
            (function (l) {
              function a(L, Z) {
                var $ = L.length;
                L.push(Z);
                e: for (; 0 < $; ) {
                  var ne = ($ - 1) >>> 1,
                    x = L[ne];
                  if (0 < u(x, Z)) ((L[ne] = Z), (L[$] = x), ($ = ne));
                  else break e;
                }
              }
              function s(L) {
                return L.length === 0 ? null : L[0];
              }
              function r(L) {
                if (L.length === 0) return null;
                var Z = L[0],
                  $ = L.pop();
                if ($ !== Z) {
                  L[0] = $;
                  e: for (var ne = 0, x = L.length, j = x >>> 1; ne < j; ) {
                    var P = 2 * (ne + 1) - 1,
                      F = L[P],
                      le = P + 1,
                      Se = L[le];
                    if (0 > u(F, $))
                      le < x && 0 > u(Se, F)
                        ? ((L[ne] = Se), (L[le] = $), (ne = le))
                        : ((L[ne] = F), (L[P] = $), (ne = P));
                    else if (le < x && 0 > u(Se, $))
                      ((L[ne] = Se), (L[le] = $), (ne = le));
                    else break e;
                  }
                }
                return Z;
              }
              function u(L, Z) {
                var $ = L.sortIndex - Z.sortIndex;
                return $ !== 0 ? $ : L.id - Z.id;
              }
              if (
                ((l.unstable_now = void 0),
                typeof performance == 'object' &&
                  typeof performance.now == 'function')
              ) {
                var f = performance;
                l.unstable_now = function () {
                  return f.now();
                };
              } else {
                var p = Date,
                  g = p.now();
                l.unstable_now = function () {
                  return p.now() - g;
                };
              }
              var d = [],
                h = [],
                y = 1,
                b = null,
                w = 3,
                T = !1,
                _ = !1,
                O = !1,
                D = !1,
                q = typeof setTimeout == 'function' ? setTimeout : null,
                U = typeof clearTimeout == 'function' ? clearTimeout : null,
                Y = typeof setImmediate < 'u' ? setImmediate : null;
              function X(L) {
                for (var Z = s(h); Z !== null; ) {
                  if (Z.callback === null) r(h);
                  else if (Z.startTime <= L)
                    (r(h), (Z.sortIndex = Z.expirationTime), a(d, Z));
                  else break;
                  Z = s(h);
                }
              }
              function B(L) {
                if (((O = !1), X(L), !_))
                  if (s(d) !== null) ((_ = !0), W || ((W = !0), ie()));
                  else {
                    var Z = s(h);
                    Z !== null && be(B, Z.startTime - L);
                  }
              }
              var W = !1,
                k = -1,
                V = 5,
                ee = -1;
              function Q() {
                return D ? !0 : !(l.unstable_now() - ee < V);
              }
              function J() {
                if (((D = !1), W)) {
                  var L = l.unstable_now();
                  ee = L;
                  var Z = !0;
                  try {
                    e: {
                      ((_ = !1), O && ((O = !1), U(k), (k = -1)), (T = !0));
                      var $ = w;
                      try {
                        t: {
                          for (
                            X(L), b = s(d);
                            b !== null && !(b.expirationTime > L && Q());
                          ) {
                            var ne = b.callback;
                            if (typeof ne == 'function') {
                              ((b.callback = null), (w = b.priorityLevel));
                              var x = ne(b.expirationTime <= L);
                              if (
                                ((L = l.unstable_now()), typeof x == 'function')
                              ) {
                                ((b.callback = x), X(L), (Z = !0));
                                break t;
                              }
                              (b === s(d) && r(d), X(L));
                            } else r(d);
                            b = s(d);
                          }
                          if (b !== null) Z = !0;
                          else {
                            var j = s(h);
                            (j !== null && be(B, j.startTime - L), (Z = !1));
                          }
                        }
                        break e;
                      } finally {
                        ((b = null), (w = $), (T = !1));
                      }
                      Z = void 0;
                    }
                  } finally {
                    Z ? ie() : (W = !1);
                  }
                }
              }
              var ie;
              if (typeof Y == 'function')
                ie = function () {
                  Y(J);
                };
              else if (typeof MessageChannel < 'u') {
                var de = new MessageChannel(),
                  ve = de.port2;
                ((de.port1.onmessage = J),
                  (ie = function () {
                    ve.postMessage(null);
                  }));
              } else
                ie = function () {
                  q(J, 0);
                };
              function be(L, Z) {
                k = q(function () {
                  L(l.unstable_now());
                }, Z);
              }
              ((l.unstable_IdlePriority = 5),
                (l.unstable_ImmediatePriority = 1),
                (l.unstable_LowPriority = 4),
                (l.unstable_NormalPriority = 3),
                (l.unstable_Profiling = null),
                (l.unstable_UserBlockingPriority = 2),
                (l.unstable_cancelCallback = function (L) {
                  L.callback = null;
                }),
                (l.unstable_forceFrameRate = function (L) {
                  0 > L || 125 < L
                    ? console.error(
                        'forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported'
                      )
                    : (V = 0 < L ? Math.floor(1e3 / L) : 5);
                }),
                (l.unstable_getCurrentPriorityLevel = function () {
                  return w;
                }),
                (l.unstable_next = function (L) {
                  switch (w) {
                    case 1:
                    case 2:
                    case 3:
                      var Z = 3;
                      break;
                    default:
                      Z = w;
                  }
                  var $ = w;
                  w = Z;
                  try {
                    return L();
                  } finally {
                    w = $;
                  }
                }),
                (l.unstable_requestPaint = function () {
                  D = !0;
                }),
                (l.unstable_runWithPriority = function (L, Z) {
                  switch (L) {
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                      break;
                    default:
                      L = 3;
                  }
                  var $ = w;
                  w = L;
                  try {
                    return Z();
                  } finally {
                    w = $;
                  }
                }),
                (l.unstable_scheduleCallback = function (L, Z, $) {
                  var ne = l.unstable_now();
                  switch (
                    (typeof $ == 'object' && $ !== null
                      ? (($ = $.delay),
                        ($ = typeof $ == 'number' && 0 < $ ? ne + $ : ne))
                      : ($ = ne),
                    L)
                  ) {
                    case 1:
                      var x = -1;
                      break;
                    case 2:
                      x = 250;
                      break;
                    case 5:
                      x = 1073741823;
                      break;
                    case 4:
                      x = 1e4;
                      break;
                    default:
                      x = 5e3;
                  }
                  return (
                    (x = $ + x),
                    (L = {
                      id: y++,
                      callback: Z,
                      priorityLevel: L,
                      startTime: $,
                      expirationTime: x,
                      sortIndex: -1,
                    }),
                    $ > ne
                      ? ((L.sortIndex = $),
                        a(h, L),
                        s(d) === null &&
                          L === s(h) &&
                          (O ? (U(k), (k = -1)) : (O = !0), be(B, $ - ne)))
                      : ((L.sortIndex = x),
                        a(d, L),
                        _ || T || ((_ = !0), W || ((W = !0), ie()))),
                    L
                  );
                }),
                (l.unstable_shouldYield = Q),
                (l.unstable_wrapCallback = function (L) {
                  var Z = w;
                  return function () {
                    var $ = w;
                    w = Z;
                    try {
                      return L.apply(this, arguments);
                    } finally {
                      w = $;
                    }
                  };
                }));
            })(Fo)),
          Fo
        );
      }
      var Ah;
      function Uv() {
        return (Ah || ((Ah = 1), (Jo.exports = Hv())), Jo.exports);
      }
      var Po = { exports: {} },
        fe = {};
      /**
       * @license React
       * react.production.js
       *
       * Copyright (c) Meta Platforms, Inc. and affiliates.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */ var Oh;
      function Bv() {
        if (Oh) return fe;
        Oh = 1;
        var l = Symbol.for('react.transitional.element'),
          a = Symbol.for('react.portal'),
          s = Symbol.for('react.fragment'),
          r = Symbol.for('react.strict_mode'),
          u = Symbol.for('react.profiler'),
          f = Symbol.for('react.consumer'),
          p = Symbol.for('react.context'),
          g = Symbol.for('react.forward_ref'),
          d = Symbol.for('react.suspense'),
          h = Symbol.for('react.memo'),
          y = Symbol.for('react.lazy'),
          b = Symbol.iterator;
        function w(x) {
          return x === null || typeof x != 'object'
            ? null
            : ((x = (b && x[b]) || x['@@iterator']),
              typeof x == 'function' ? x : null);
        }
        var T = {
            isMounted: function () {
              return !1;
            },
            enqueueForceUpdate: function () {},
            enqueueReplaceState: function () {},
            enqueueSetState: function () {},
          },
          _ = Object.assign,
          O = {};
        function D(x, j, P) {
          ((this.props = x),
            (this.context = j),
            (this.refs = O),
            (this.updater = P || T));
        }
        ((D.prototype.isReactComponent = {}),
          (D.prototype.setState = function (x, j) {
            if (typeof x != 'object' && typeof x != 'function' && x != null)
              throw Error(
                'takes an object of state variables to update or a function which returns an object of state variables.'
              );
            this.updater.enqueueSetState(this, x, j, 'setState');
          }),
          (D.prototype.forceUpdate = function (x) {
            this.updater.enqueueForceUpdate(this, x, 'forceUpdate');
          }));
        function q() {}
        q.prototype = D.prototype;
        function U(x, j, P) {
          ((this.props = x),
            (this.context = j),
            (this.refs = O),
            (this.updater = P || T));
        }
        var Y = (U.prototype = new q());
        ((Y.constructor = U), _(Y, D.prototype), (Y.isPureReactComponent = !0));
        var X = Array.isArray,
          B = { H: null, A: null, T: null, S: null, V: null },
          W = Object.prototype.hasOwnProperty;
        function k(x, j, P, F, le, Se) {
          return (
            (P = Se.ref),
            {
              $$typeof: l,
              type: x,
              key: j,
              ref: P !== void 0 ? P : null,
              props: Se,
            }
          );
        }
        function V(x, j) {
          return k(x.type, j, void 0, void 0, void 0, x.props);
        }
        function ee(x) {
          return typeof x == 'object' && x !== null && x.$$typeof === l;
        }
        function Q(x) {
          var j = { '=': '=0', ':': '=2' };
          return (
            '$' +
            x.replace(/[=:]/g, function (P) {
              return j[P];
            })
          );
        }
        var J = /\/+/g;
        function ie(x, j) {
          return typeof x == 'object' && x !== null && x.key != null
            ? Q('' + x.key)
            : j.toString(36);
        }
        function de() {}
        function ve(x) {
          switch (x.status) {
            case 'fulfilled':
              return x.value;
            case 'rejected':
              throw x.reason;
            default:
              switch (
                (typeof x.status == 'string'
                  ? x.then(de, de)
                  : ((x.status = 'pending'),
                    x.then(
                      function (j) {
                        x.status === 'pending' &&
                          ((x.status = 'fulfilled'), (x.value = j));
                      },
                      function (j) {
                        x.status === 'pending' &&
                          ((x.status = 'rejected'), (x.reason = j));
                      }
                    )),
                x.status)
              ) {
                case 'fulfilled':
                  return x.value;
                case 'rejected':
                  throw x.reason;
              }
          }
          throw x;
        }
        function be(x, j, P, F, le) {
          var Se = typeof x;
          (Se === 'undefined' || Se === 'boolean') && (x = null);
          var ce = !1;
          if (x === null) ce = !0;
          else
            switch (Se) {
              case 'bigint':
              case 'string':
              case 'number':
                ce = !0;
                break;
              case 'object':
                switch (x.$$typeof) {
                  case l:
                  case a:
                    ce = !0;
                    break;
                  case y:
                    return ((ce = x._init), be(ce(x._payload), j, P, F, le));
                }
            }
          if (ce)
            return (
              (le = le(x)),
              (ce = F === '' ? '.' + ie(x, 0) : F),
              X(le)
                ? ((P = ''),
                  ce != null && (P = ce.replace(J, '$&/') + '/'),
                  be(le, j, P, '', function (oi) {
                    return oi;
                  }))
                : le != null &&
                  (ee(le) &&
                    (le = V(
                      le,
                      P +
                        (le.key == null || (x && x.key === le.key)
                          ? ''
                          : ('' + le.key).replace(J, '$&/') + '/') +
                        ce
                    )),
                  j.push(le)),
              1
            );
          ce = 0;
          var dt = F === '' ? '.' : F + ':';
          if (X(x))
            for (var ze = 0; ze < x.length; ze++)
              ((F = x[ze]), (Se = dt + ie(F, ze)), (ce += be(F, j, P, Se, le)));
          else if (((ze = w(x)), typeof ze == 'function'))
            for (x = ze.call(x), ze = 0; !(F = x.next()).done; )
              ((F = F.value),
                (Se = dt + ie(F, ze++)),
                (ce += be(F, j, P, Se, le)));
          else if (Se === 'object') {
            if (typeof x.then == 'function') return be(ve(x), j, P, F, le);
            throw (
              (j = String(x)),
              Error(
                'Objects are not valid as a React child (found: ' +
                  (j === '[object Object]'
                    ? 'object with keys {' + Object.keys(x).join(', ') + '}'
                    : j) +
                  '). If you meant to render a collection of children, use an array instead.'
              )
            );
          }
          return ce;
        }
        function L(x, j, P) {
          if (x == null) return x;
          var F = [],
            le = 0;
          return (
            be(x, F, '', '', function (Se) {
              return j.call(P, Se, le++);
            }),
            F
          );
        }
        function Z(x) {
          if (x._status === -1) {
            var j = x._result;
            ((j = j()),
              j.then(
                function (P) {
                  (x._status === 0 || x._status === -1) &&
                    ((x._status = 1), (x._result = P));
                },
                function (P) {
                  (x._status === 0 || x._status === -1) &&
                    ((x._status = 2), (x._result = P));
                }
              ),
              x._status === -1 && ((x._status = 0), (x._result = j)));
          }
          if (x._status === 1) return x._result.default;
          throw x._result;
        }
        var $ =
          typeof reportError == 'function'
            ? reportError
            : function (x) {
                if (
                  typeof window == 'object' &&
                  typeof window.ErrorEvent == 'function'
                ) {
                  var j = new window.ErrorEvent('error', {
                    bubbles: !0,
                    cancelable: !0,
                    message:
                      typeof x == 'object' &&
                      x !== null &&
                      typeof x.message == 'string'
                        ? String(x.message)
                        : String(x),
                    error: x,
                  });
                  if (!window.dispatchEvent(j)) return;
                } else if (
                  typeof process == 'object' &&
                  typeof process.emit == 'function'
                ) {
                  process.emit('uncaughtException', x);
                  return;
                }
                console.error(x);
              };
        function ne() {}
        return (
          (fe.Children = {
            map: L,
            forEach: function (x, j, P) {
              L(
                x,
                function () {
                  j.apply(this, arguments);
                },
                P
              );
            },
            count: function (x) {
              var j = 0;
              return (
                L(x, function () {
                  j++;
                }),
                j
              );
            },
            toArray: function (x) {
              return (
                L(x, function (j) {
                  return j;
                }) || []
              );
            },
            only: function (x) {
              if (!ee(x))
                throw Error(
                  'React.Children.only expected to receive a single React element child.'
                );
              return x;
            },
          }),
          (fe.Component = D),
          (fe.Fragment = s),
          (fe.Profiler = u),
          (fe.PureComponent = U),
          (fe.StrictMode = r),
          (fe.Suspense = d),
          (fe.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE =
            B),
          (fe.__COMPILER_RUNTIME = {
            __proto__: null,
            c: function (x) {
              return B.H.useMemoCache(x);
            },
          }),
          (fe.cache = function (x) {
            return function () {
              return x.apply(null, arguments);
            };
          }),
          (fe.cloneElement = function (x, j, P) {
            if (x == null)
              throw Error(
                'The argument must be a React element, but you passed ' +
                  x +
                  '.'
              );
            var F = _({}, x.props),
              le = x.key,
              Se = void 0;
            if (j != null)
              for (ce in (j.ref !== void 0 && (Se = void 0),
              j.key !== void 0 && (le = '' + j.key),
              j))
                !W.call(j, ce) ||
                  ce === 'key' ||
                  ce === '__self' ||
                  ce === '__source' ||
                  (ce === 'ref' && j.ref === void 0) ||
                  (F[ce] = j[ce]);
            var ce = arguments.length - 2;
            if (ce === 1) F.children = P;
            else if (1 < ce) {
              for (var dt = Array(ce), ze = 0; ze < ce; ze++)
                dt[ze] = arguments[ze + 2];
              F.children = dt;
            }
            return k(x.type, le, void 0, void 0, Se, F);
          }),
          (fe.createContext = function (x) {
            return (
              (x = {
                $$typeof: p,
                _currentValue: x,
                _currentValue2: x,
                _threadCount: 0,
                Provider: null,
                Consumer: null,
              }),
              (x.Provider = x),
              (x.Consumer = { $$typeof: f, _context: x }),
              x
            );
          }),
          (fe.createElement = function (x, j, P) {
            var F,
              le = {},
              Se = null;
            if (j != null)
              for (F in (j.key !== void 0 && (Se = '' + j.key), j))
                W.call(j, F) &&
                  F !== 'key' &&
                  F !== '__self' &&
                  F !== '__source' &&
                  (le[F] = j[F]);
            var ce = arguments.length - 2;
            if (ce === 1) le.children = P;
            else if (1 < ce) {
              for (var dt = Array(ce), ze = 0; ze < ce; ze++)
                dt[ze] = arguments[ze + 2];
              le.children = dt;
            }
            if (x && x.defaultProps)
              for (F in ((ce = x.defaultProps), ce))
                le[F] === void 0 && (le[F] = ce[F]);
            return k(x, Se, void 0, void 0, null, le);
          }),
          (fe.createRef = function () {
            return { current: null };
          }),
          (fe.forwardRef = function (x) {
            return { $$typeof: g, render: x };
          }),
          (fe.isValidElement = ee),
          (fe.lazy = function (x) {
            return {
              $$typeof: y,
              _payload: { _status: -1, _result: x },
              _init: Z,
            };
          }),
          (fe.memo = function (x, j) {
            return { $$typeof: h, type: x, compare: j === void 0 ? null : j };
          }),
          (fe.startTransition = function (x) {
            var j = B.T,
              P = {};
            B.T = P;
            try {
              var F = x(),
                le = B.S;
              (le !== null && le(P, F),
                typeof F == 'object' &&
                  F !== null &&
                  typeof F.then == 'function' &&
                  F.then(ne, $));
            } catch (Se) {
              $(Se);
            } finally {
              B.T = j;
            }
          }),
          (fe.unstable_useCacheRefresh = function () {
            return B.H.useCacheRefresh();
          }),
          (fe.use = function (x) {
            return B.H.use(x);
          }),
          (fe.useActionState = function (x, j, P) {
            return B.H.useActionState(x, j, P);
          }),
          (fe.useCallback = function (x, j) {
            return B.H.useCallback(x, j);
          }),
          (fe.useContext = function (x) {
            return B.H.useContext(x);
          }),
          (fe.useDebugValue = function () {}),
          (fe.useDeferredValue = function (x, j) {
            return B.H.useDeferredValue(x, j);
          }),
          (fe.useEffect = function (x, j, P) {
            var F = B.H;
            if (typeof P == 'function')
              throw Error(
                'useEffect CRUD overload is not enabled in this build of React.'
              );
            return F.useEffect(x, j);
          }),
          (fe.useId = function () {
            return B.H.useId();
          }),
          (fe.useImperativeHandle = function (x, j, P) {
            return B.H.useImperativeHandle(x, j, P);
          }),
          (fe.useInsertionEffect = function (x, j) {
            return B.H.useInsertionEffect(x, j);
          }),
          (fe.useLayoutEffect = function (x, j) {
            return B.H.useLayoutEffect(x, j);
          }),
          (fe.useMemo = function (x, j) {
            return B.H.useMemo(x, j);
          }),
          (fe.useOptimistic = function (x, j) {
            return B.H.useOptimistic(x, j);
          }),
          (fe.useReducer = function (x, j, P) {
            return B.H.useReducer(x, j, P);
          }),
          (fe.useRef = function (x) {
            return B.H.useRef(x);
          }),
          (fe.useState = function (x) {
            return B.H.useState(x);
          }),
          (fe.useSyncExternalStore = function (x, j, P) {
            return B.H.useSyncExternalStore(x, j, P);
          }),
          (fe.useTransition = function () {
            return B.H.useTransition();
          }),
          (fe.version = '19.1.1'),
          fe
        );
      }
      var _h;
      function wu() {
        return (_h || ((_h = 1), (Po.exports = Bv())), Po.exports);
      }
      var Io = { exports: {} },
        tt = {};
      /**
       * @license React
       * react-dom.production.js
       *
       * Copyright (c) Meta Platforms, Inc. and affiliates.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */ var Ch;
      function Gv() {
        if (Ch) return tt;
        Ch = 1;
        var l = wu();
        function a(d) {
          var h = 'https://react.dev/errors/' + d;
          if (1 < arguments.length) {
            h += '?args[]=' + encodeURIComponent(arguments[1]);
            for (var y = 2; y < arguments.length; y++)
              h += '&args[]=' + encodeURIComponent(arguments[y]);
          }
          return (
            'Minified React error #' +
            d +
            '; visit ' +
            h +
            ' for the full message or use the non-minified dev environment for full errors and additional helpful warnings.'
          );
        }
        function s() {}
        var r = {
            d: {
              f: s,
              r: function () {
                throw Error(a(522));
              },
              D: s,
              C: s,
              L: s,
              m: s,
              X: s,
              S: s,
              M: s,
            },
            p: 0,
            findDOMNode: null,
          },
          u = Symbol.for('react.portal');
        function f(d, h, y) {
          var b =
            3 < arguments.length && arguments[3] !== void 0
              ? arguments[3]
              : null;
          return {
            $$typeof: u,
            key: b == null ? null : '' + b,
            children: d,
            containerInfo: h,
            implementation: y,
          };
        }
        var p =
          l.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
        function g(d, h) {
          if (d === 'font') return '';
          if (typeof h == 'string') return h === 'use-credentials' ? h : '';
        }
        return (
          (tt.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = r),
          (tt.createPortal = function (d, h) {
            var y =
              2 < arguments.length && arguments[2] !== void 0
                ? arguments[2]
                : null;
            if (
              !h ||
              (h.nodeType !== 1 && h.nodeType !== 9 && h.nodeType !== 11)
            )
              throw Error(a(299));
            return f(d, h, null, y);
          }),
          (tt.flushSync = function (d) {
            var h = p.T,
              y = r.p;
            try {
              if (((p.T = null), (r.p = 2), d)) return d();
            } finally {
              ((p.T = h), (r.p = y), r.d.f());
            }
          }),
          (tt.preconnect = function (d, h) {
            typeof d == 'string' &&
              (h
                ? ((h = h.crossOrigin),
                  (h =
                    typeof h == 'string'
                      ? h === 'use-credentials'
                        ? h
                        : ''
                      : void 0))
                : (h = null),
              r.d.C(d, h));
          }),
          (tt.prefetchDNS = function (d) {
            typeof d == 'string' && r.d.D(d);
          }),
          (tt.preinit = function (d, h) {
            if (typeof d == 'string' && h && typeof h.as == 'string') {
              var y = h.as,
                b = g(y, h.crossOrigin),
                w = typeof h.integrity == 'string' ? h.integrity : void 0,
                T =
                  typeof h.fetchPriority == 'string' ? h.fetchPriority : void 0;
              y === 'style'
                ? r.d.S(
                    d,
                    typeof h.precedence == 'string' ? h.precedence : void 0,
                    { crossOrigin: b, integrity: w, fetchPriority: T }
                  )
                : y === 'script' &&
                  r.d.X(d, {
                    crossOrigin: b,
                    integrity: w,
                    fetchPriority: T,
                    nonce: typeof h.nonce == 'string' ? h.nonce : void 0,
                  });
            }
          }),
          (tt.preinitModule = function (d, h) {
            if (typeof d == 'string')
              if (typeof h == 'object' && h !== null) {
                if (h.as == null || h.as === 'script') {
                  var y = g(h.as, h.crossOrigin);
                  r.d.M(d, {
                    crossOrigin: y,
                    integrity:
                      typeof h.integrity == 'string' ? h.integrity : void 0,
                    nonce: typeof h.nonce == 'string' ? h.nonce : void 0,
                  });
                }
              } else h == null && r.d.M(d);
          }),
          (tt.preload = function (d, h) {
            if (
              typeof d == 'string' &&
              typeof h == 'object' &&
              h !== null &&
              typeof h.as == 'string'
            ) {
              var y = h.as,
                b = g(y, h.crossOrigin);
              r.d.L(d, y, {
                crossOrigin: b,
                integrity:
                  typeof h.integrity == 'string' ? h.integrity : void 0,
                nonce: typeof h.nonce == 'string' ? h.nonce : void 0,
                type: typeof h.type == 'string' ? h.type : void 0,
                fetchPriority:
                  typeof h.fetchPriority == 'string' ? h.fetchPriority : void 0,
                referrerPolicy:
                  typeof h.referrerPolicy == 'string'
                    ? h.referrerPolicy
                    : void 0,
                imageSrcSet:
                  typeof h.imageSrcSet == 'string' ? h.imageSrcSet : void 0,
                imageSizes:
                  typeof h.imageSizes == 'string' ? h.imageSizes : void 0,
                media: typeof h.media == 'string' ? h.media : void 0,
              });
            }
          }),
          (tt.preloadModule = function (d, h) {
            if (typeof d == 'string')
              if (h) {
                var y = g(h.as, h.crossOrigin);
                r.d.m(d, {
                  as:
                    typeof h.as == 'string' && h.as !== 'script'
                      ? h.as
                      : void 0,
                  crossOrigin: y,
                  integrity:
                    typeof h.integrity == 'string' ? h.integrity : void 0,
                });
              } else r.d.m(d);
          }),
          (tt.requestFormReset = function (d) {
            r.d.r(d);
          }),
          (tt.unstable_batchedUpdates = function (d, h) {
            return d(h);
          }),
          (tt.useFormState = function (d, h, y) {
            return p.H.useFormState(d, h, y);
          }),
          (tt.useFormStatus = function () {
            return p.H.useHostTransitionStatus();
          }),
          (tt.version = '19.1.1'),
          tt
        );
      }
      var Nh;
      function Vv() {
        if (Nh) return Io.exports;
        Nh = 1;
        function l() {
          if (
            !(
              typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > 'u' ||
              typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != 'function'
            )
          )
            try {
              __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(l);
            } catch (a) {
              console.error(a);
            }
        }
        return (l(), (Io.exports = Gv()), Io.exports);
      }
      /**
       * @license React
       * react-dom-client.production.js
       *
       * Copyright (c) Meta Platforms, Inc. and affiliates.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */ var zh;
      function Kv() {
        if (zh) return Pa;
        zh = 1;
        var l = Uv(),
          a = wu(),
          s = Vv();
        function r(e) {
          var t = 'https://react.dev/errors/' + e;
          if (1 < arguments.length) {
            t += '?args[]=' + encodeURIComponent(arguments[1]);
            for (var i = 2; i < arguments.length; i++)
              t += '&args[]=' + encodeURIComponent(arguments[i]);
          }
          return (
            'Minified React error #' +
            e +
            '; visit ' +
            t +
            ' for the full message or use the non-minified dev environment for full errors and additional helpful warnings.'
          );
        }
        function u(e) {
          return !(
            !e ||
            (e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11)
          );
        }
        function f(e) {
          var t = e,
            i = e;
          if (e.alternate) for (; t.return; ) t = t.return;
          else {
            e = t;
            do
              ((t = e),
                (t.flags & 4098) !== 0 && (i = t.return),
                (e = t.return));
            while (e);
          }
          return t.tag === 3 ? i : null;
        }
        function p(e) {
          if (e.tag === 13) {
            var t = e.memoizedState;
            if (
              (t === null &&
                ((e = e.alternate), e !== null && (t = e.memoizedState)),
              t !== null)
            )
              return t.dehydrated;
          }
          return null;
        }
        function g(e) {
          if (f(e) !== e) throw Error(r(188));
        }
        function d(e) {
          var t = e.alternate;
          if (!t) {
            if (((t = f(e)), t === null)) throw Error(r(188));
            return t !== e ? null : e;
          }
          for (var i = e, n = t; ; ) {
            var o = i.return;
            if (o === null) break;
            var c = o.alternate;
            if (c === null) {
              if (((n = o.return), n !== null)) {
                i = n;
                continue;
              }
              break;
            }
            if (o.child === c.child) {
              for (c = o.child; c; ) {
                if (c === i) return (g(o), e);
                if (c === n) return (g(o), t);
                c = c.sibling;
              }
              throw Error(r(188));
            }
            if (i.return !== n.return) ((i = o), (n = c));
            else {
              for (var m = !1, v = o.child; v; ) {
                if (v === i) {
                  ((m = !0), (i = o), (n = c));
                  break;
                }
                if (v === n) {
                  ((m = !0), (n = o), (i = c));
                  break;
                }
                v = v.sibling;
              }
              if (!m) {
                for (v = c.child; v; ) {
                  if (v === i) {
                    ((m = !0), (i = c), (n = o));
                    break;
                  }
                  if (v === n) {
                    ((m = !0), (n = c), (i = o));
                    break;
                  }
                  v = v.sibling;
                }
                if (!m) throw Error(r(189));
              }
            }
            if (i.alternate !== n) throw Error(r(190));
          }
          if (i.tag !== 3) throw Error(r(188));
          return i.stateNode.current === i ? e : t;
        }
        function h(e) {
          var t = e.tag;
          if (t === 5 || t === 26 || t === 27 || t === 6) return e;
          for (e = e.child; e !== null; ) {
            if (((t = h(e)), t !== null)) return t;
            e = e.sibling;
          }
          return null;
        }
        var y = Object.assign,
          b = Symbol.for('react.element'),
          w = Symbol.for('react.transitional.element'),
          T = Symbol.for('react.portal'),
          _ = Symbol.for('react.fragment'),
          O = Symbol.for('react.strict_mode'),
          D = Symbol.for('react.profiler'),
          q = Symbol.for('react.provider'),
          U = Symbol.for('react.consumer'),
          Y = Symbol.for('react.context'),
          X = Symbol.for('react.forward_ref'),
          B = Symbol.for('react.suspense'),
          W = Symbol.for('react.suspense_list'),
          k = Symbol.for('react.memo'),
          V = Symbol.for('react.lazy'),
          ee = Symbol.for('react.activity'),
          Q = Symbol.for('react.memo_cache_sentinel'),
          J = Symbol.iterator;
        function ie(e) {
          return e === null || typeof e != 'object'
            ? null
            : ((e = (J && e[J]) || e['@@iterator']),
              typeof e == 'function' ? e : null);
        }
        var de = Symbol.for('react.client.reference');
        function ve(e) {
          if (e == null) return null;
          if (typeof e == 'function')
            return e.$$typeof === de ? null : e.displayName || e.name || null;
          if (typeof e == 'string') return e;
          switch (e) {
            case _:
              return 'Fragment';
            case D:
              return 'Profiler';
            case O:
              return 'StrictMode';
            case B:
              return 'Suspense';
            case W:
              return 'SuspenseList';
            case ee:
              return 'Activity';
          }
          if (typeof e == 'object')
            switch (e.$$typeof) {
              case T:
                return 'Portal';
              case Y:
                return (e.displayName || 'Context') + '.Provider';
              case U:
                return (e._context.displayName || 'Context') + '.Consumer';
              case X:
                var t = e.render;
                return (
                  (e = e.displayName),
                  e ||
                    ((e = t.displayName || t.name || ''),
                    (e = e !== '' ? 'ForwardRef(' + e + ')' : 'ForwardRef')),
                  e
                );
              case k:
                return (
                  (t = e.displayName || null),
                  t !== null ? t : ve(e.type) || 'Memo'
                );
              case V:
                ((t = e._payload), (e = e._init));
                try {
                  return ve(e(t));
                } catch {}
            }
          return null;
        }
        var be = Array.isArray,
          L = a.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
          Z = s.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
          $ = { pending: !1, data: null, method: null, action: null },
          ne = [],
          x = -1;
        function j(e) {
          return { current: e };
        }
        function P(e) {
          0 > x || ((e.current = ne[x]), (ne[x] = null), x--);
        }
        function F(e, t) {
          (x++, (ne[x] = e.current), (e.current = t));
        }
        var le = j(null),
          Se = j(null),
          ce = j(null),
          dt = j(null);
        function ze(e, t) {
          switch ((F(ce, t), F(Se, e), F(le, null), t.nodeType)) {
            case 9:
            case 11:
              e = (e = t.documentElement) && (e = e.namespaceURI) ? Pd(e) : 0;
              break;
            default:
              if (((e = t.tagName), (t = t.namespaceURI)))
                ((t = Pd(t)), (e = Id(t, e)));
              else
                switch (e) {
                  case 'svg':
                    e = 1;
                    break;
                  case 'math':
                    e = 2;
                    break;
                  default:
                    e = 0;
                }
          }
          (P(le), F(le, e));
        }
        function oi() {
          (P(le), P(Se), P(ce));
        }
        function zs(e) {
          e.memoizedState !== null && F(dt, e);
          var t = le.current,
            i = Id(t, e.type);
          t !== i && (F(Se, e), F(le, i));
        }
        function nl(e) {
          (Se.current === e && (P(le), P(Se)),
            dt.current === e && (P(dt), (Xa._currentValue = $)));
        }
        var Rs = Object.prototype.hasOwnProperty,
          Ds = l.unstable_scheduleCallback,
          Ls = l.unstable_cancelCallback,
          fm = l.unstable_shouldYield,
          dm = l.unstable_requestPaint,
          Ht = l.unstable_now,
          hm = l.unstable_getCurrentPriorityLevel,
          Nu = l.unstable_ImmediatePriority,
          zu = l.unstable_UserBlockingPriority,
          al = l.unstable_NormalPriority,
          pm = l.unstable_LowPriority,
          Ru = l.unstable_IdlePriority,
          mm = l.log,
          gm = l.unstable_setDisableYieldValue,
          Wn = null,
          ht = null;
        function ui(e) {
          if (
            (typeof mm == 'function' && gm(e),
            ht && typeof ht.setStrictMode == 'function')
          )
            try {
              ht.setStrictMode(Wn, e);
            } catch {}
        }
        var pt = Math.clz32 ? Math.clz32 : bm,
          vm = Math.log,
          ym = Math.LN2;
        function bm(e) {
          return ((e >>>= 0), e === 0 ? 32 : (31 - ((vm(e) / ym) | 0)) | 0);
        }
        var ll = 256,
          sl = 4194304;
        function Ui(e) {
          var t = e & 42;
          if (t !== 0) return t;
          switch (e & -e) {
            case 1:
              return 1;
            case 2:
              return 2;
            case 4:
              return 4;
            case 8:
              return 8;
            case 16:
              return 16;
            case 32:
              return 32;
            case 64:
              return 64;
            case 128:
              return 128;
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
              return e & 4194048;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
              return e & 62914560;
            case 67108864:
              return 67108864;
            case 134217728:
              return 134217728;
            case 268435456:
              return 268435456;
            case 536870912:
              return 536870912;
            case 1073741824:
              return 0;
            default:
              return e;
          }
        }
        function rl(e, t, i) {
          var n = e.pendingLanes;
          if (n === 0) return 0;
          var o = 0,
            c = e.suspendedLanes,
            m = e.pingedLanes;
          e = e.warmLanes;
          var v = n & 134217727;
          return (
            v !== 0
              ? ((n = v & ~c),
                n !== 0
                  ? (o = Ui(n))
                  : ((m &= v),
                    m !== 0
                      ? (o = Ui(m))
                      : i || ((i = v & ~e), i !== 0 && (o = Ui(i)))))
              : ((v = n & ~c),
                v !== 0
                  ? (o = Ui(v))
                  : m !== 0
                    ? (o = Ui(m))
                    : i || ((i = n & ~e), i !== 0 && (o = Ui(i)))),
            o === 0
              ? 0
              : t !== 0 &&
                  t !== o &&
                  (t & c) === 0 &&
                  ((c = o & -o),
                  (i = t & -t),
                  c >= i || (c === 32 && (i & 4194048) !== 0))
                ? t
                : o
          );
        }
        function ea(e, t) {
          return (
            (e.pendingLanes & ~(e.suspendedLanes & ~e.pingedLanes) & t) === 0
          );
        }
        function Sm(e, t) {
          switch (e) {
            case 1:
            case 2:
            case 4:
            case 8:
            case 64:
              return t + 250;
            case 16:
            case 32:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
              return t + 5e3;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
              return -1;
            case 67108864:
            case 134217728:
            case 268435456:
            case 536870912:
            case 1073741824:
              return -1;
            default:
              return -1;
          }
        }
        function Du() {
          var e = ll;
          return ((ll <<= 1), (ll & 4194048) === 0 && (ll = 256), e);
        }
        function Lu() {
          var e = sl;
          return ((sl <<= 1), (sl & 62914560) === 0 && (sl = 4194304), e);
        }
        function js(e) {
          for (var t = [], i = 0; 31 > i; i++) t.push(e);
          return t;
        }
        function ta(e, t) {
          ((e.pendingLanes |= t),
            t !== 268435456 &&
              ((e.suspendedLanes = 0), (e.pingedLanes = 0), (e.warmLanes = 0)));
        }
        function xm(e, t, i, n, o, c) {
          var m = e.pendingLanes;
          ((e.pendingLanes = i),
            (e.suspendedLanes = 0),
            (e.pingedLanes = 0),
            (e.warmLanes = 0),
            (e.expiredLanes &= i),
            (e.entangledLanes &= i),
            (e.errorRecoveryDisabledLanes &= i),
            (e.shellSuspendCounter = 0));
          var v = e.entanglements,
            S = e.expirationTimes,
            N = e.hiddenUpdates;
          for (i = m & ~i; 0 < i; ) {
            var H = 31 - pt(i),
              K = 1 << H;
            ((v[H] = 0), (S[H] = -1));
            var z = N[H];
            if (z !== null)
              for (N[H] = null, H = 0; H < z.length; H++) {
                var R = z[H];
                R !== null && (R.lane &= -536870913);
              }
            i &= ~K;
          }
          (n !== 0 && ju(e, n, 0),
            c !== 0 &&
              o === 0 &&
              e.tag !== 0 &&
              (e.suspendedLanes |= c & ~(m & ~t)));
        }
        function ju(e, t, i) {
          ((e.pendingLanes |= t), (e.suspendedLanes &= ~t));
          var n = 31 - pt(t);
          ((e.entangledLanes |= t),
            (e.entanglements[n] =
              e.entanglements[n] | 1073741824 | (i & 4194090)));
        }
        function Hu(e, t) {
          var i = (e.entangledLanes |= t);
          for (e = e.entanglements; i; ) {
            var n = 31 - pt(i),
              o = 1 << n;
            ((o & t) | (e[n] & t) && (e[n] |= t), (i &= ~o));
          }
        }
        function Hs(e) {
          switch (e) {
            case 2:
              e = 1;
              break;
            case 8:
              e = 4;
              break;
            case 32:
              e = 16;
              break;
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
              e = 128;
              break;
            case 268435456:
              e = 134217728;
              break;
            default:
              e = 0;
          }
          return e;
        }
        function Us(e) {
          return (
            (e &= -e),
            2 < e ? (8 < e ? ((e & 134217727) !== 0 ? 32 : 268435456) : 8) : 2
          );
        }
        function Uu() {
          var e = Z.p;
          return e !== 0
            ? e
            : ((e = window.event), e === void 0 ? 32 : vh(e.type));
        }
        function Tm(e, t) {
          var i = Z.p;
          try {
            return ((Z.p = e), t());
          } finally {
            Z.p = i;
          }
        }
        var ci = Math.random().toString(36).slice(2),
          We = '__reactFiber$' + ci,
          lt = '__reactProps$' + ci,
          un = '__reactContainer$' + ci,
          Bs = '__reactEvents$' + ci,
          Em = '__reactListeners$' + ci,
          wm = '__reactHandles$' + ci,
          Bu = '__reactResources$' + ci,
          ia = '__reactMarker$' + ci;
        function Gs(e) {
          (delete e[We],
            delete e[lt],
            delete e[Bs],
            delete e[Em],
            delete e[wm]);
        }
        function cn(e) {
          var t = e[We];
          if (t) return t;
          for (var i = e.parentNode; i; ) {
            if ((t = i[un] || i[We])) {
              if (
                ((i = t.alternate),
                t.child !== null || (i !== null && i.child !== null))
              )
                for (e = ih(e); e !== null; ) {
                  if ((i = e[We])) return i;
                  e = ih(e);
                }
              return t;
            }
            ((e = i), (i = e.parentNode));
          }
          return null;
        }
        function fn(e) {
          if ((e = e[We] || e[un])) {
            var t = e.tag;
            if (
              t === 5 ||
              t === 6 ||
              t === 13 ||
              t === 26 ||
              t === 27 ||
              t === 3
            )
              return e;
          }
          return null;
        }
        function na(e) {
          var t = e.tag;
          if (t === 5 || t === 26 || t === 27 || t === 6) return e.stateNode;
          throw Error(r(33));
        }
        function dn(e) {
          var t = e[Bu];
          return (
            t ||
              (t = e[Bu] =
                { hoistableStyles: new Map(), hoistableScripts: new Map() }),
            t
          );
        }
        function $e(e) {
          e[ia] = !0;
        }
        var Gu = new Set(),
          Vu = {};
        function Bi(e, t) {
          (hn(e, t), hn(e + 'Capture', t));
        }
        function hn(e, t) {
          for (Vu[e] = t, e = 0; e < t.length; e++) Gu.add(t[e]);
        }
        var Mm = RegExp(
            '^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$'
          ),
          Ku = {},
          qu = {};
        function Am(e) {
          return Rs.call(qu, e)
            ? !0
            : Rs.call(Ku, e)
              ? !1
              : Mm.test(e)
                ? (qu[e] = !0)
                : ((Ku[e] = !0), !1);
        }
        function ol(e, t, i) {
          if (Am(t))
            if (i === null) e.removeAttribute(t);
            else {
              switch (typeof i) {
                case 'undefined':
                case 'function':
                case 'symbol':
                  e.removeAttribute(t);
                  return;
                case 'boolean':
                  var n = t.toLowerCase().slice(0, 5);
                  if (n !== 'data-' && n !== 'aria-') {
                    e.removeAttribute(t);
                    return;
                  }
              }
              e.setAttribute(t, '' + i);
            }
        }
        function ul(e, t, i) {
          if (i === null) e.removeAttribute(t);
          else {
            switch (typeof i) {
              case 'undefined':
              case 'function':
              case 'symbol':
              case 'boolean':
                e.removeAttribute(t);
                return;
            }
            e.setAttribute(t, '' + i);
          }
        }
        function Yt(e, t, i, n) {
          if (n === null) e.removeAttribute(i);
          else {
            switch (typeof n) {
              case 'undefined':
              case 'function':
              case 'symbol':
              case 'boolean':
                e.removeAttribute(i);
                return;
            }
            e.setAttributeNS(t, i, '' + n);
          }
        }
        var Vs, Yu;
        function pn(e) {
          if (Vs === void 0)
            try {
              throw Error();
            } catch (i) {
              var t = i.stack.trim().match(/\n( *(at )?)/);
              ((Vs = (t && t[1]) || ''),
                (Yu =
                  -1 <
                  i.stack.indexOf(`
    at`)
                    ? ' (<anonymous>)'
                    : -1 < i.stack.indexOf('@')
                      ? '@unknown:0:0'
                      : ''));
            }
          return (
            `
` +
            Vs +
            e +
            Yu
          );
        }
        var Ks = !1;
        function qs(e, t) {
          if (!e || Ks) return '';
          Ks = !0;
          var i = Error.prepareStackTrace;
          Error.prepareStackTrace = void 0;
          try {
            var n = {
              DetermineComponentFrameRoot: function () {
                try {
                  if (t) {
                    var K = function () {
                      throw Error();
                    };
                    if (
                      (Object.defineProperty(K.prototype, 'props', {
                        set: function () {
                          throw Error();
                        },
                      }),
                      typeof Reflect == 'object' && Reflect.construct)
                    ) {
                      try {
                        Reflect.construct(K, []);
                      } catch (R) {
                        var z = R;
                      }
                      Reflect.construct(e, [], K);
                    } else {
                      try {
                        K.call();
                      } catch (R) {
                        z = R;
                      }
                      e.call(K.prototype);
                    }
                  } else {
                    try {
                      throw Error();
                    } catch (R) {
                      z = R;
                    }
                    (K = e()) &&
                      typeof K.catch == 'function' &&
                      K.catch(function () {});
                  }
                } catch (R) {
                  if (R && z && typeof R.stack == 'string')
                    return [R.stack, z.stack];
                }
                return [null, null];
              },
            };
            n.DetermineComponentFrameRoot.displayName =
              'DetermineComponentFrameRoot';
            var o = Object.getOwnPropertyDescriptor(
              n.DetermineComponentFrameRoot,
              'name'
            );
            o &&
              o.configurable &&
              Object.defineProperty(n.DetermineComponentFrameRoot, 'name', {
                value: 'DetermineComponentFrameRoot',
              });
            var c = n.DetermineComponentFrameRoot(),
              m = c[0],
              v = c[1];
            if (m && v) {
              var S = m.split(`
`),
                N = v.split(`
`);
              for (
                o = n = 0;
                n < S.length && !S[n].includes('DetermineComponentFrameRoot');
              )
                n++;
              for (
                ;
                o < N.length && !N[o].includes('DetermineComponentFrameRoot');
              )
                o++;
              if (n === S.length || o === N.length)
                for (
                  n = S.length - 1, o = N.length - 1;
                  1 <= n && 0 <= o && S[n] !== N[o];
                )
                  o--;
              for (; 1 <= n && 0 <= o; n--, o--)
                if (S[n] !== N[o]) {
                  if (n !== 1 || o !== 1)
                    do
                      if ((n--, o--, 0 > o || S[n] !== N[o])) {
                        var H =
                          `
` + S[n].replace(' at new ', ' at ');
                        return (
                          e.displayName &&
                            H.includes('<anonymous>') &&
                            (H = H.replace('<anonymous>', e.displayName)),
                          H
                        );
                      }
                    while (1 <= n && 0 <= o);
                  break;
                }
            }
          } finally {
            ((Ks = !1), (Error.prepareStackTrace = i));
          }
          return (i = e ? e.displayName || e.name : '') ? pn(i) : '';
        }
        function Om(e) {
          switch (e.tag) {
            case 26:
            case 27:
            case 5:
              return pn(e.type);
            case 16:
              return pn('Lazy');
            case 13:
              return pn('Suspense');
            case 19:
              return pn('SuspenseList');
            case 0:
            case 15:
              return qs(e.type, !1);
            case 11:
              return qs(e.type.render, !1);
            case 1:
              return qs(e.type, !0);
            case 31:
              return pn('Activity');
            default:
              return '';
          }
        }
        function $u(e) {
          try {
            var t = '';
            do ((t += Om(e)), (e = e.return));
            while (e);
            return t;
          } catch (i) {
            return (
              `
Error generating stack: ` +
              i.message +
              `
` +
              i.stack
            );
          }
        }
        function wt(e) {
          switch (typeof e) {
            case 'bigint':
            case 'boolean':
            case 'number':
            case 'string':
            case 'undefined':
              return e;
            case 'object':
              return e;
            default:
              return '';
          }
        }
        function Xu(e) {
          var t = e.type;
          return (
            (e = e.nodeName) &&
            e.toLowerCase() === 'input' &&
            (t === 'checkbox' || t === 'radio')
          );
        }
        function _m(e) {
          var t = Xu(e) ? 'checked' : 'value',
            i = Object.getOwnPropertyDescriptor(e.constructor.prototype, t),
            n = '' + e[t];
          if (
            !e.hasOwnProperty(t) &&
            typeof i < 'u' &&
            typeof i.get == 'function' &&
            typeof i.set == 'function'
          ) {
            var o = i.get,
              c = i.set;
            return (
              Object.defineProperty(e, t, {
                configurable: !0,
                get: function () {
                  return o.call(this);
                },
                set: function (m) {
                  ((n = '' + m), c.call(this, m));
                },
              }),
              Object.defineProperty(e, t, { enumerable: i.enumerable }),
              {
                getValue: function () {
                  return n;
                },
                setValue: function (m) {
                  n = '' + m;
                },
                stopTracking: function () {
                  ((e._valueTracker = null), delete e[t]);
                },
              }
            );
          }
        }
        function cl(e) {
          e._valueTracker || (e._valueTracker = _m(e));
        }
        function Qu(e) {
          if (!e) return !1;
          var t = e._valueTracker;
          if (!t) return !0;
          var i = t.getValue(),
            n = '';
          return (
            e && (n = Xu(e) ? (e.checked ? 'true' : 'false') : e.value),
            (e = n),
            e !== i ? (t.setValue(e), !0) : !1
          );
        }
        function fl(e) {
          if (
            ((e = e || (typeof document < 'u' ? document : void 0)),
            typeof e > 'u')
          )
            return null;
          try {
            return e.activeElement || e.body;
          } catch {
            return e.body;
          }
        }
        var Cm = /[\n"\\]/g;
        function Mt(e) {
          return e.replace(Cm, function (t) {
            return '\\' + t.charCodeAt(0).toString(16) + ' ';
          });
        }
        function Ys(e, t, i, n, o, c, m, v) {
          ((e.name = ''),
            m != null &&
            typeof m != 'function' &&
            typeof m != 'symbol' &&
            typeof m != 'boolean'
              ? (e.type = m)
              : e.removeAttribute('type'),
            t != null
              ? m === 'number'
                ? ((t === 0 && e.value === '') || e.value != t) &&
                  (e.value = '' + wt(t))
                : e.value !== '' + wt(t) && (e.value = '' + wt(t))
              : (m !== 'submit' && m !== 'reset') || e.removeAttribute('value'),
            t != null
              ? $s(e, m, wt(t))
              : i != null
                ? $s(e, m, wt(i))
                : n != null && e.removeAttribute('value'),
            o == null && c != null && (e.defaultChecked = !!c),
            o != null &&
              (e.checked = o && typeof o != 'function' && typeof o != 'symbol'),
            v != null &&
            typeof v != 'function' &&
            typeof v != 'symbol' &&
            typeof v != 'boolean'
              ? (e.name = '' + wt(v))
              : e.removeAttribute('name'));
        }
        function Zu(e, t, i, n, o, c, m, v) {
          if (
            (c != null &&
              typeof c != 'function' &&
              typeof c != 'symbol' &&
              typeof c != 'boolean' &&
              (e.type = c),
            t != null || i != null)
          ) {
            if (!((c !== 'submit' && c !== 'reset') || t != null)) return;
            ((i = i != null ? '' + wt(i) : ''),
              (t = t != null ? '' + wt(t) : i),
              v || t === e.value || (e.value = t),
              (e.defaultValue = t));
          }
          ((n = n ?? o),
            (n = typeof n != 'function' && typeof n != 'symbol' && !!n),
            (e.checked = v ? e.checked : !!n),
            (e.defaultChecked = !!n),
            m != null &&
              typeof m != 'function' &&
              typeof m != 'symbol' &&
              typeof m != 'boolean' &&
              (e.name = m));
        }
        function $s(e, t, i) {
          (t === 'number' && fl(e.ownerDocument) === e) ||
            e.defaultValue === '' + i ||
            (e.defaultValue = '' + i);
        }
        function mn(e, t, i, n) {
          if (((e = e.options), t)) {
            t = {};
            for (var o = 0; o < i.length; o++) t['$' + i[o]] = !0;
            for (i = 0; i < e.length; i++)
              ((o = t.hasOwnProperty('$' + e[i].value)),
                e[i].selected !== o && (e[i].selected = o),
                o && n && (e[i].defaultSelected = !0));
          } else {
            for (i = '' + wt(i), t = null, o = 0; o < e.length; o++) {
              if (e[o].value === i) {
                ((e[o].selected = !0), n && (e[o].defaultSelected = !0));
                return;
              }
              t !== null || e[o].disabled || (t = e[o]);
            }
            t !== null && (t.selected = !0);
          }
        }
        function ku(e, t, i) {
          if (
            t != null &&
            ((t = '' + wt(t)), t !== e.value && (e.value = t), i == null)
          ) {
            e.defaultValue !== t && (e.defaultValue = t);
            return;
          }
          e.defaultValue = i != null ? '' + wt(i) : '';
        }
        function Ju(e, t, i, n) {
          if (t == null) {
            if (n != null) {
              if (i != null) throw Error(r(92));
              if (be(n)) {
                if (1 < n.length) throw Error(r(93));
                n = n[0];
              }
              i = n;
            }
            (i == null && (i = ''), (t = i));
          }
          ((i = wt(t)),
            (e.defaultValue = i),
            (n = e.textContent),
            n === i && n !== '' && n !== null && (e.value = n));
        }
        function gn(e, t) {
          if (t) {
            var i = e.firstChild;
            if (i && i === e.lastChild && i.nodeType === 3) {
              i.nodeValue = t;
              return;
            }
          }
          e.textContent = t;
        }
        var Nm = new Set(
          'animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp'.split(
            ' '
          )
        );
        function Fu(e, t, i) {
          var n = t.indexOf('--') === 0;
          i == null || typeof i == 'boolean' || i === ''
            ? n
              ? e.setProperty(t, '')
              : t === 'float'
                ? (e.cssFloat = '')
                : (e[t] = '')
            : n
              ? e.setProperty(t, i)
              : typeof i != 'number' || i === 0 || Nm.has(t)
                ? t === 'float'
                  ? (e.cssFloat = i)
                  : (e[t] = ('' + i).trim())
                : (e[t] = i + 'px');
        }
        function Pu(e, t, i) {
          if (t != null && typeof t != 'object') throw Error(r(62));
          if (((e = e.style), i != null)) {
            for (var n in i)
              !i.hasOwnProperty(n) ||
                (t != null && t.hasOwnProperty(n)) ||
                (n.indexOf('--') === 0
                  ? e.setProperty(n, '')
                  : n === 'float'
                    ? (e.cssFloat = '')
                    : (e[n] = ''));
            for (var o in t)
              ((n = t[o]), t.hasOwnProperty(o) && i[o] !== n && Fu(e, o, n));
          } else for (var c in t) t.hasOwnProperty(c) && Fu(e, c, t[c]);
        }
        function Xs(e) {
          if (e.indexOf('-') === -1) return !1;
          switch (e) {
            case 'annotation-xml':
            case 'color-profile':
            case 'font-face':
            case 'font-face-src':
            case 'font-face-uri':
            case 'font-face-format':
            case 'font-face-name':
            case 'missing-glyph':
              return !1;
            default:
              return !0;
          }
        }
        var zm = new Map([
            ['acceptCharset', 'accept-charset'],
            ['htmlFor', 'for'],
            ['httpEquiv', 'http-equiv'],
            ['crossOrigin', 'crossorigin'],
            ['accentHeight', 'accent-height'],
            ['alignmentBaseline', 'alignment-baseline'],
            ['arabicForm', 'arabic-form'],
            ['baselineShift', 'baseline-shift'],
            ['capHeight', 'cap-height'],
            ['clipPath', 'clip-path'],
            ['clipRule', 'clip-rule'],
            ['colorInterpolation', 'color-interpolation'],
            ['colorInterpolationFilters', 'color-interpolation-filters'],
            ['colorProfile', 'color-profile'],
            ['colorRendering', 'color-rendering'],
            ['dominantBaseline', 'dominant-baseline'],
            ['enableBackground', 'enable-background'],
            ['fillOpacity', 'fill-opacity'],
            ['fillRule', 'fill-rule'],
            ['floodColor', 'flood-color'],
            ['floodOpacity', 'flood-opacity'],
            ['fontFamily', 'font-family'],
            ['fontSize', 'font-size'],
            ['fontSizeAdjust', 'font-size-adjust'],
            ['fontStretch', 'font-stretch'],
            ['fontStyle', 'font-style'],
            ['fontVariant', 'font-variant'],
            ['fontWeight', 'font-weight'],
            ['glyphName', 'glyph-name'],
            ['glyphOrientationHorizontal', 'glyph-orientation-horizontal'],
            ['glyphOrientationVertical', 'glyph-orientation-vertical'],
            ['horizAdvX', 'horiz-adv-x'],
            ['horizOriginX', 'horiz-origin-x'],
            ['imageRendering', 'image-rendering'],
            ['letterSpacing', 'letter-spacing'],
            ['lightingColor', 'lighting-color'],
            ['markerEnd', 'marker-end'],
            ['markerMid', 'marker-mid'],
            ['markerStart', 'marker-start'],
            ['overlinePosition', 'overline-position'],
            ['overlineThickness', 'overline-thickness'],
            ['paintOrder', 'paint-order'],
            ['panose-1', 'panose-1'],
            ['pointerEvents', 'pointer-events'],
            ['renderingIntent', 'rendering-intent'],
            ['shapeRendering', 'shape-rendering'],
            ['stopColor', 'stop-color'],
            ['stopOpacity', 'stop-opacity'],
            ['strikethroughPosition', 'strikethrough-position'],
            ['strikethroughThickness', 'strikethrough-thickness'],
            ['strokeDasharray', 'stroke-dasharray'],
            ['strokeDashoffset', 'stroke-dashoffset'],
            ['strokeLinecap', 'stroke-linecap'],
            ['strokeLinejoin', 'stroke-linejoin'],
            ['strokeMiterlimit', 'stroke-miterlimit'],
            ['strokeOpacity', 'stroke-opacity'],
            ['strokeWidth', 'stroke-width'],
            ['textAnchor', 'text-anchor'],
            ['textDecoration', 'text-decoration'],
            ['textRendering', 'text-rendering'],
            ['transformOrigin', 'transform-origin'],
            ['underlinePosition', 'underline-position'],
            ['underlineThickness', 'underline-thickness'],
            ['unicodeBidi', 'unicode-bidi'],
            ['unicodeRange', 'unicode-range'],
            ['unitsPerEm', 'units-per-em'],
            ['vAlphabetic', 'v-alphabetic'],
            ['vHanging', 'v-hanging'],
            ['vIdeographic', 'v-ideographic'],
            ['vMathematical', 'v-mathematical'],
            ['vectorEffect', 'vector-effect'],
            ['vertAdvY', 'vert-adv-y'],
            ['vertOriginX', 'vert-origin-x'],
            ['vertOriginY', 'vert-origin-y'],
            ['wordSpacing', 'word-spacing'],
            ['writingMode', 'writing-mode'],
            ['xmlnsXlink', 'xmlns:xlink'],
            ['xHeight', 'x-height'],
          ]),
          Rm =
            /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
        function dl(e) {
          return Rm.test('' + e)
            ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')"
            : e;
        }
        var Qs = null;
        function Zs(e) {
          return (
            (e = e.target || e.srcElement || window),
            e.correspondingUseElement && (e = e.correspondingUseElement),
            e.nodeType === 3 ? e.parentNode : e
          );
        }
        var vn = null,
          yn = null;
        function Iu(e) {
          var t = fn(e);
          if (t && (e = t.stateNode)) {
            var i = e[lt] || null;
            e: switch (((e = t.stateNode), t.type)) {
              case 'input':
                if (
                  (Ys(
                    e,
                    i.value,
                    i.defaultValue,
                    i.defaultValue,
                    i.checked,
                    i.defaultChecked,
                    i.type,
                    i.name
                  ),
                  (t = i.name),
                  i.type === 'radio' && t != null)
                ) {
                  for (i = e; i.parentNode; ) i = i.parentNode;
                  for (
                    i = i.querySelectorAll(
                      'input[name="' + Mt('' + t) + '"][type="radio"]'
                    ),
                      t = 0;
                    t < i.length;
                    t++
                  ) {
                    var n = i[t];
                    if (n !== e && n.form === e.form) {
                      var o = n[lt] || null;
                      if (!o) throw Error(r(90));
                      Ys(
                        n,
                        o.value,
                        o.defaultValue,
                        o.defaultValue,
                        o.checked,
                        o.defaultChecked,
                        o.type,
                        o.name
                      );
                    }
                  }
                  for (t = 0; t < i.length; t++)
                    ((n = i[t]), n.form === e.form && Qu(n));
                }
                break e;
              case 'textarea':
                ku(e, i.value, i.defaultValue);
                break e;
              case 'select':
                ((t = i.value), t != null && mn(e, !!i.multiple, t, !1));
            }
          }
        }
        var ks = !1;
        function Wu(e, t, i) {
          if (ks) return e(t, i);
          ks = !0;
          try {
            var n = e(t);
            return n;
          } finally {
            if (
              ((ks = !1),
              (vn !== null || yn !== null) &&
                (Pl(), vn && ((t = vn), (e = yn), (yn = vn = null), Iu(t), e)))
            )
              for (t = 0; t < e.length; t++) Iu(e[t]);
          }
        }
        function aa(e, t) {
          var i = e.stateNode;
          if (i === null) return null;
          var n = i[lt] || null;
          if (n === null) return null;
          i = n[t];
          e: switch (t) {
            case 'onClick':
            case 'onClickCapture':
            case 'onDoubleClick':
            case 'onDoubleClickCapture':
            case 'onMouseDown':
            case 'onMouseDownCapture':
            case 'onMouseMove':
            case 'onMouseMoveCapture':
            case 'onMouseUp':
            case 'onMouseUpCapture':
            case 'onMouseEnter':
              ((n = !n.disabled) ||
                ((e = e.type),
                (n = !(
                  e === 'button' ||
                  e === 'input' ||
                  e === 'select' ||
                  e === 'textarea'
                ))),
                (e = !n));
              break e;
            default:
              e = !1;
          }
          if (e) return null;
          if (i && typeof i != 'function') throw Error(r(231, t, typeof i));
          return i;
        }
        var $t = !(
            typeof window > 'u' ||
            typeof window.document > 'u' ||
            typeof window.document.createElement > 'u'
          ),
          Js = !1;
        if ($t)
          try {
            var la = {};
            (Object.defineProperty(la, 'passive', {
              get: function () {
                Js = !0;
              },
            }),
              window.addEventListener('test', la, la),
              window.removeEventListener('test', la, la));
          } catch {
            Js = !1;
          }
        var fi = null,
          Fs = null,
          hl = null;
        function ec() {
          if (hl) return hl;
          var e,
            t = Fs,
            i = t.length,
            n,
            o = 'value' in fi ? fi.value : fi.textContent,
            c = o.length;
          for (e = 0; e < i && t[e] === o[e]; e++);
          var m = i - e;
          for (n = 1; n <= m && t[i - n] === o[c - n]; n++);
          return (hl = o.slice(e, 1 < n ? 1 - n : void 0));
        }
        function pl(e) {
          var t = e.keyCode;
          return (
            'charCode' in e
              ? ((e = e.charCode), e === 0 && t === 13 && (e = 13))
              : (e = t),
            e === 10 && (e = 13),
            32 <= e || e === 13 ? e : 0
          );
        }
        function ml() {
          return !0;
        }
        function tc() {
          return !1;
        }
        function st(e) {
          function t(i, n, o, c, m) {
            ((this._reactName = i),
              (this._targetInst = o),
              (this.type = n),
              (this.nativeEvent = c),
              (this.target = m),
              (this.currentTarget = null));
            for (var v in e)
              e.hasOwnProperty(v) && ((i = e[v]), (this[v] = i ? i(c) : c[v]));
            return (
              (this.isDefaultPrevented = (
                c.defaultPrevented != null
                  ? c.defaultPrevented
                  : c.returnValue === !1
              )
                ? ml
                : tc),
              (this.isPropagationStopped = tc),
              this
            );
          }
          return (
            y(t.prototype, {
              preventDefault: function () {
                this.defaultPrevented = !0;
                var i = this.nativeEvent;
                i &&
                  (i.preventDefault
                    ? i.preventDefault()
                    : typeof i.returnValue != 'unknown' && (i.returnValue = !1),
                  (this.isDefaultPrevented = ml));
              },
              stopPropagation: function () {
                var i = this.nativeEvent;
                i &&
                  (i.stopPropagation
                    ? i.stopPropagation()
                    : typeof i.cancelBubble != 'unknown' &&
                      (i.cancelBubble = !0),
                  (this.isPropagationStopped = ml));
              },
              persist: function () {},
              isPersistent: ml,
            }),
            t
          );
        }
        var Gi = {
            eventPhase: 0,
            bubbles: 0,
            cancelable: 0,
            timeStamp: function (e) {
              return e.timeStamp || Date.now();
            },
            defaultPrevented: 0,
            isTrusted: 0,
          },
          gl = st(Gi),
          sa = y({}, Gi, { view: 0, detail: 0 }),
          Dm = st(sa),
          Ps,
          Is,
          ra,
          vl = y({}, sa, {
            screenX: 0,
            screenY: 0,
            clientX: 0,
            clientY: 0,
            pageX: 0,
            pageY: 0,
            ctrlKey: 0,
            shiftKey: 0,
            altKey: 0,
            metaKey: 0,
            getModifierState: er,
            button: 0,
            buttons: 0,
            relatedTarget: function (e) {
              return e.relatedTarget === void 0
                ? e.fromElement === e.srcElement
                  ? e.toElement
                  : e.fromElement
                : e.relatedTarget;
            },
            movementX: function (e) {
              return 'movementX' in e
                ? e.movementX
                : (e !== ra &&
                    (ra && e.type === 'mousemove'
                      ? ((Ps = e.screenX - ra.screenX),
                        (Is = e.screenY - ra.screenY))
                      : (Is = Ps = 0),
                    (ra = e)),
                  Ps);
            },
            movementY: function (e) {
              return 'movementY' in e ? e.movementY : Is;
            },
          }),
          ic = st(vl),
          Lm = y({}, vl, { dataTransfer: 0 }),
          jm = st(Lm),
          Hm = y({}, sa, { relatedTarget: 0 }),
          Ws = st(Hm),
          Um = y({}, Gi, {
            animationName: 0,
            elapsedTime: 0,
            pseudoElement: 0,
          }),
          Bm = st(Um),
          Gm = y({}, Gi, {
            clipboardData: function (e) {
              return 'clipboardData' in e
                ? e.clipboardData
                : window.clipboardData;
            },
          }),
          Vm = st(Gm),
          Km = y({}, Gi, { data: 0 }),
          nc = st(Km),
          qm = {
            Esc: 'Escape',
            Spacebar: ' ',
            Left: 'ArrowLeft',
            Up: 'ArrowUp',
            Right: 'ArrowRight',
            Down: 'ArrowDown',
            Del: 'Delete',
            Win: 'OS',
            Menu: 'ContextMenu',
            Apps: 'ContextMenu',
            Scroll: 'ScrollLock',
            MozPrintableKey: 'Unidentified',
          },
          Ym = {
            8: 'Backspace',
            9: 'Tab',
            12: 'Clear',
            13: 'Enter',
            16: 'Shift',
            17: 'Control',
            18: 'Alt',
            19: 'Pause',
            20: 'CapsLock',
            27: 'Escape',
            32: ' ',
            33: 'PageUp',
            34: 'PageDown',
            35: 'End',
            36: 'Home',
            37: 'ArrowLeft',
            38: 'ArrowUp',
            39: 'ArrowRight',
            40: 'ArrowDown',
            45: 'Insert',
            46: 'Delete',
            112: 'F1',
            113: 'F2',
            114: 'F3',
            115: 'F4',
            116: 'F5',
            117: 'F6',
            118: 'F7',
            119: 'F8',
            120: 'F9',
            121: 'F10',
            122: 'F11',
            123: 'F12',
            144: 'NumLock',
            145: 'ScrollLock',
            224: 'Meta',
          },
          $m = {
            Alt: 'altKey',
            Control: 'ctrlKey',
            Meta: 'metaKey',
            Shift: 'shiftKey',
          };
        function Xm(e) {
          var t = this.nativeEvent;
          return t.getModifierState
            ? t.getModifierState(e)
            : (e = $m[e])
              ? !!t[e]
              : !1;
        }
        function er() {
          return Xm;
        }
        var Qm = y({}, sa, {
            key: function (e) {
              if (e.key) {
                var t = qm[e.key] || e.key;
                if (t !== 'Unidentified') return t;
              }
              return e.type === 'keypress'
                ? ((e = pl(e)), e === 13 ? 'Enter' : String.fromCharCode(e))
                : e.type === 'keydown' || e.type === 'keyup'
                  ? Ym[e.keyCode] || 'Unidentified'
                  : '';
            },
            code: 0,
            location: 0,
            ctrlKey: 0,
            shiftKey: 0,
            altKey: 0,
            metaKey: 0,
            repeat: 0,
            locale: 0,
            getModifierState: er,
            charCode: function (e) {
              return e.type === 'keypress' ? pl(e) : 0;
            },
            keyCode: function (e) {
              return e.type === 'keydown' || e.type === 'keyup' ? e.keyCode : 0;
            },
            which: function (e) {
              return e.type === 'keypress'
                ? pl(e)
                : e.type === 'keydown' || e.type === 'keyup'
                  ? e.keyCode
                  : 0;
            },
          }),
          Zm = st(Qm),
          km = y({}, vl, {
            pointerId: 0,
            width: 0,
            height: 0,
            pressure: 0,
            tangentialPressure: 0,
            tiltX: 0,
            tiltY: 0,
            twist: 0,
            pointerType: 0,
            isPrimary: 0,
          }),
          ac = st(km),
          Jm = y({}, sa, {
            touches: 0,
            targetTouches: 0,
            changedTouches: 0,
            altKey: 0,
            metaKey: 0,
            ctrlKey: 0,
            shiftKey: 0,
            getModifierState: er,
          }),
          Fm = st(Jm),
          Pm = y({}, Gi, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }),
          Im = st(Pm),
          Wm = y({}, vl, {
            deltaX: function (e) {
              return 'deltaX' in e
                ? e.deltaX
                : 'wheelDeltaX' in e
                  ? -e.wheelDeltaX
                  : 0;
            },
            deltaY: function (e) {
              return 'deltaY' in e
                ? e.deltaY
                : 'wheelDeltaY' in e
                  ? -e.wheelDeltaY
                  : 'wheelDelta' in e
                    ? -e.wheelDelta
                    : 0;
            },
            deltaZ: 0,
            deltaMode: 0,
          }),
          eg = st(Wm),
          tg = y({}, Gi, { newState: 0, oldState: 0 }),
          ig = st(tg),
          ng = [9, 13, 27, 32],
          tr = $t && 'CompositionEvent' in window,
          oa = null;
        $t && 'documentMode' in document && (oa = document.documentMode);
        var ag = $t && 'TextEvent' in window && !oa,
          lc = $t && (!tr || (oa && 8 < oa && 11 >= oa)),
          sc = ' ',
          rc = !1;
        function oc(e, t) {
          switch (e) {
            case 'keyup':
              return ng.indexOf(t.keyCode) !== -1;
            case 'keydown':
              return t.keyCode !== 229;
            case 'keypress':
            case 'mousedown':
            case 'focusout':
              return !0;
            default:
              return !1;
          }
        }
        function uc(e) {
          return (
            (e = e.detail),
            typeof e == 'object' && 'data' in e ? e.data : null
          );
        }
        var bn = !1;
        function lg(e, t) {
          switch (e) {
            case 'compositionend':
              return uc(t);
            case 'keypress':
              return t.which !== 32 ? null : ((rc = !0), sc);
            case 'textInput':
              return ((e = t.data), e === sc && rc ? null : e);
            default:
              return null;
          }
        }
        function sg(e, t) {
          if (bn)
            return e === 'compositionend' || (!tr && oc(e, t))
              ? ((e = ec()), (hl = Fs = fi = null), (bn = !1), e)
              : null;
          switch (e) {
            case 'paste':
              return null;
            case 'keypress':
              if (
                !(t.ctrlKey || t.altKey || t.metaKey) ||
                (t.ctrlKey && t.altKey)
              ) {
                if (t.char && 1 < t.char.length) return t.char;
                if (t.which) return String.fromCharCode(t.which);
              }
              return null;
            case 'compositionend':
              return lc && t.locale !== 'ko' ? null : t.data;
            default:
              return null;
          }
        }
        var rg = {
          color: !0,
          date: !0,
          datetime: !0,
          'datetime-local': !0,
          email: !0,
          month: !0,
          number: !0,
          password: !0,
          range: !0,
          search: !0,
          tel: !0,
          text: !0,
          time: !0,
          url: !0,
          week: !0,
        };
        function cc(e) {
          var t = e && e.nodeName && e.nodeName.toLowerCase();
          return t === 'input' ? !!rg[e.type] : t === 'textarea';
        }
        function fc(e, t, i, n) {
          (vn ? (yn ? yn.push(n) : (yn = [n])) : (vn = n),
            (t = ns(t, 'onChange')),
            0 < t.length &&
              ((i = new gl('onChange', 'change', null, i, n)),
              e.push({ event: i, listeners: t })));
        }
        var ua = null,
          ca = null;
        function og(e) {
          Qd(e, 0);
        }
        function yl(e) {
          var t = na(e);
          if (Qu(t)) return e;
        }
        function dc(e, t) {
          if (e === 'change') return t;
        }
        var hc = !1;
        if ($t) {
          var ir;
          if ($t) {
            var nr = 'oninput' in document;
            if (!nr) {
              var pc = document.createElement('div');
              (pc.setAttribute('oninput', 'return;'),
                (nr = typeof pc.oninput == 'function'));
            }
            ir = nr;
          } else ir = !1;
          hc = ir && (!document.documentMode || 9 < document.documentMode);
        }
        function mc() {
          ua && (ua.detachEvent('onpropertychange', gc), (ca = ua = null));
        }
        function gc(e) {
          if (e.propertyName === 'value' && yl(ca)) {
            var t = [];
            (fc(t, ca, e, Zs(e)), Wu(og, t));
          }
        }
        function ug(e, t, i) {
          e === 'focusin'
            ? (mc(), (ua = t), (ca = i), ua.attachEvent('onpropertychange', gc))
            : e === 'focusout' && mc();
        }
        function cg(e) {
          if (e === 'selectionchange' || e === 'keyup' || e === 'keydown')
            return yl(ca);
        }
        function fg(e, t) {
          if (e === 'click') return yl(t);
        }
        function dg(e, t) {
          if (e === 'input' || e === 'change') return yl(t);
        }
        function hg(e, t) {
          return (
            (e === t && (e !== 0 || 1 / e === 1 / t)) || (e !== e && t !== t)
          );
        }
        var mt = typeof Object.is == 'function' ? Object.is : hg;
        function fa(e, t) {
          if (mt(e, t)) return !0;
          if (
            typeof e != 'object' ||
            e === null ||
            typeof t != 'object' ||
            t === null
          )
            return !1;
          var i = Object.keys(e),
            n = Object.keys(t);
          if (i.length !== n.length) return !1;
          for (n = 0; n < i.length; n++) {
            var o = i[n];
            if (!Rs.call(t, o) || !mt(e[o], t[o])) return !1;
          }
          return !0;
        }
        function vc(e) {
          for (; e && e.firstChild; ) e = e.firstChild;
          return e;
        }
        function yc(e, t) {
          var i = vc(e);
          e = 0;
          for (var n; i; ) {
            if (i.nodeType === 3) {
              if (((n = e + i.textContent.length), e <= t && n >= t))
                return { node: i, offset: t - e };
              e = n;
            }
            e: {
              for (; i; ) {
                if (i.nextSibling) {
                  i = i.nextSibling;
                  break e;
                }
                i = i.parentNode;
              }
              i = void 0;
            }
            i = vc(i);
          }
        }
        function bc(e, t) {
          return e && t
            ? e === t
              ? !0
              : e && e.nodeType === 3
                ? !1
                : t && t.nodeType === 3
                  ? bc(e, t.parentNode)
                  : 'contains' in e
                    ? e.contains(t)
                    : e.compareDocumentPosition
                      ? !!(e.compareDocumentPosition(t) & 16)
                      : !1
            : !1;
        }
        function Sc(e) {
          e =
            e != null &&
            e.ownerDocument != null &&
            e.ownerDocument.defaultView != null
              ? e.ownerDocument.defaultView
              : window;
          for (var t = fl(e.document); t instanceof e.HTMLIFrameElement; ) {
            try {
              var i = typeof t.contentWindow.location.href == 'string';
            } catch {
              i = !1;
            }
            if (i) e = t.contentWindow;
            else break;
            t = fl(e.document);
          }
          return t;
        }
        function ar(e) {
          var t = e && e.nodeName && e.nodeName.toLowerCase();
          return (
            t &&
            ((t === 'input' &&
              (e.type === 'text' ||
                e.type === 'search' ||
                e.type === 'tel' ||
                e.type === 'url' ||
                e.type === 'password')) ||
              t === 'textarea' ||
              e.contentEditable === 'true')
          );
        }
        var pg =
            $t && 'documentMode' in document && 11 >= document.documentMode,
          Sn = null,
          lr = null,
          da = null,
          sr = !1;
        function xc(e, t, i) {
          var n =
            i.window === i
              ? i.document
              : i.nodeType === 9
                ? i
                : i.ownerDocument;
          sr ||
            Sn == null ||
            Sn !== fl(n) ||
            ((n = Sn),
            'selectionStart' in n && ar(n)
              ? (n = { start: n.selectionStart, end: n.selectionEnd })
              : ((n = (
                  (n.ownerDocument && n.ownerDocument.defaultView) ||
                  window
                ).getSelection()),
                (n = {
                  anchorNode: n.anchorNode,
                  anchorOffset: n.anchorOffset,
                  focusNode: n.focusNode,
                  focusOffset: n.focusOffset,
                })),
            (da && fa(da, n)) ||
              ((da = n),
              (n = ns(lr, 'onSelect')),
              0 < n.length &&
                ((t = new gl('onSelect', 'select', null, t, i)),
                e.push({ event: t, listeners: n }),
                (t.target = Sn))));
        }
        function Vi(e, t) {
          var i = {};
          return (
            (i[e.toLowerCase()] = t.toLowerCase()),
            (i['Webkit' + e] = 'webkit' + t),
            (i['Moz' + e] = 'moz' + t),
            i
          );
        }
        var xn = {
            animationend: Vi('Animation', 'AnimationEnd'),
            animationiteration: Vi('Animation', 'AnimationIteration'),
            animationstart: Vi('Animation', 'AnimationStart'),
            transitionrun: Vi('Transition', 'TransitionRun'),
            transitionstart: Vi('Transition', 'TransitionStart'),
            transitioncancel: Vi('Transition', 'TransitionCancel'),
            transitionend: Vi('Transition', 'TransitionEnd'),
          },
          rr = {},
          Tc = {};
        $t &&
          ((Tc = document.createElement('div').style),
          'AnimationEvent' in window ||
            (delete xn.animationend.animation,
            delete xn.animationiteration.animation,
            delete xn.animationstart.animation),
          'TransitionEvent' in window || delete xn.transitionend.transition);
        function Ki(e) {
          if (rr[e]) return rr[e];
          if (!xn[e]) return e;
          var t = xn[e],
            i;
          for (i in t)
            if (t.hasOwnProperty(i) && i in Tc) return (rr[e] = t[i]);
          return e;
        }
        var Ec = Ki('animationend'),
          wc = Ki('animationiteration'),
          Mc = Ki('animationstart'),
          mg = Ki('transitionrun'),
          gg = Ki('transitionstart'),
          vg = Ki('transitioncancel'),
          Ac = Ki('transitionend'),
          Oc = new Map(),
          or =
            'abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel'.split(
              ' '
            );
        or.push('scrollEnd');
        function Dt(e, t) {
          (Oc.set(e, t), Bi(t, [e]));
        }
        var _c = new WeakMap();
        function At(e, t) {
          if (typeof e == 'object' && e !== null) {
            var i = _c.get(e);
            return i !== void 0
              ? i
              : ((t = { value: e, source: t, stack: $u(t) }), _c.set(e, t), t);
          }
          return { value: e, source: t, stack: $u(t) };
        }
        var Ot = [],
          Tn = 0,
          ur = 0;
        function bl() {
          for (var e = Tn, t = (ur = Tn = 0); t < e; ) {
            var i = Ot[t];
            Ot[t++] = null;
            var n = Ot[t];
            Ot[t++] = null;
            var o = Ot[t];
            Ot[t++] = null;
            var c = Ot[t];
            if (((Ot[t++] = null), n !== null && o !== null)) {
              var m = n.pending;
              (m === null ? (o.next = o) : ((o.next = m.next), (m.next = o)),
                (n.pending = o));
            }
            c !== 0 && Cc(i, o, c);
          }
        }
        function Sl(e, t, i, n) {
          ((Ot[Tn++] = e),
            (Ot[Tn++] = t),
            (Ot[Tn++] = i),
            (Ot[Tn++] = n),
            (ur |= n),
            (e.lanes |= n),
            (e = e.alternate),
            e !== null && (e.lanes |= n));
        }
        function cr(e, t, i, n) {
          return (Sl(e, t, i, n), xl(e));
        }
        function En(e, t) {
          return (Sl(e, null, null, t), xl(e));
        }
        function Cc(e, t, i) {
          e.lanes |= i;
          var n = e.alternate;
          n !== null && (n.lanes |= i);
          for (var o = !1, c = e.return; c !== null; )
            ((c.childLanes |= i),
              (n = c.alternate),
              n !== null && (n.childLanes |= i),
              c.tag === 22 &&
                ((e = c.stateNode),
                e === null || e._visibility & 1 || (o = !0)),
              (e = c),
              (c = c.return));
          return e.tag === 3
            ? ((c = e.stateNode),
              o &&
                t !== null &&
                ((o = 31 - pt(i)),
                (e = c.hiddenUpdates),
                (n = e[o]),
                n === null ? (e[o] = [t]) : n.push(t),
                (t.lane = i | 536870912)),
              c)
            : null;
        }
        function xl(e) {
          if (50 < Ua) throw ((Ua = 0), (vo = null), Error(r(185)));
          for (var t = e.return; t !== null; ) ((e = t), (t = e.return));
          return e.tag === 3 ? e.stateNode : null;
        }
        var wn = {};
        function yg(e, t, i, n) {
          ((this.tag = e),
            (this.key = i),
            (this.sibling =
              this.child =
              this.return =
              this.stateNode =
              this.type =
              this.elementType =
                null),
            (this.index = 0),
            (this.refCleanup = this.ref = null),
            (this.pendingProps = t),
            (this.dependencies =
              this.memoizedState =
              this.updateQueue =
              this.memoizedProps =
                null),
            (this.mode = n),
            (this.subtreeFlags = this.flags = 0),
            (this.deletions = null),
            (this.childLanes = this.lanes = 0),
            (this.alternate = null));
        }
        function gt(e, t, i, n) {
          return new yg(e, t, i, n);
        }
        function fr(e) {
          return ((e = e.prototype), !(!e || !e.isReactComponent));
        }
        function Xt(e, t) {
          var i = e.alternate;
          return (
            i === null
              ? ((i = gt(e.tag, t, e.key, e.mode)),
                (i.elementType = e.elementType),
                (i.type = e.type),
                (i.stateNode = e.stateNode),
                (i.alternate = e),
                (e.alternate = i))
              : ((i.pendingProps = t),
                (i.type = e.type),
                (i.flags = 0),
                (i.subtreeFlags = 0),
                (i.deletions = null)),
            (i.flags = e.flags & 65011712),
            (i.childLanes = e.childLanes),
            (i.lanes = e.lanes),
            (i.child = e.child),
            (i.memoizedProps = e.memoizedProps),
            (i.memoizedState = e.memoizedState),
            (i.updateQueue = e.updateQueue),
            (t = e.dependencies),
            (i.dependencies =
              t === null
                ? null
                : { lanes: t.lanes, firstContext: t.firstContext }),
            (i.sibling = e.sibling),
            (i.index = e.index),
            (i.ref = e.ref),
            (i.refCleanup = e.refCleanup),
            i
          );
        }
        function Nc(e, t) {
          e.flags &= 65011714;
          var i = e.alternate;
          return (
            i === null
              ? ((e.childLanes = 0),
                (e.lanes = t),
                (e.child = null),
                (e.subtreeFlags = 0),
                (e.memoizedProps = null),
                (e.memoizedState = null),
                (e.updateQueue = null),
                (e.dependencies = null),
                (e.stateNode = null))
              : ((e.childLanes = i.childLanes),
                (e.lanes = i.lanes),
                (e.child = i.child),
                (e.subtreeFlags = 0),
                (e.deletions = null),
                (e.memoizedProps = i.memoizedProps),
                (e.memoizedState = i.memoizedState),
                (e.updateQueue = i.updateQueue),
                (e.type = i.type),
                (t = i.dependencies),
                (e.dependencies =
                  t === null
                    ? null
                    : { lanes: t.lanes, firstContext: t.firstContext })),
            e
          );
        }
        function Tl(e, t, i, n, o, c) {
          var m = 0;
          if (((n = e), typeof e == 'function')) fr(e) && (m = 1);
          else if (typeof e == 'string')
            m = Sv(e, i, le.current)
              ? 26
              : e === 'html' || e === 'head' || e === 'body'
                ? 27
                : 5;
          else
            e: switch (e) {
              case ee:
                return (
                  (e = gt(31, i, t, o)),
                  (e.elementType = ee),
                  (e.lanes = c),
                  e
                );
              case _:
                return qi(i.children, o, c, t);
              case O:
                ((m = 8), (o |= 24));
                break;
              case D:
                return (
                  (e = gt(12, i, t, o | 2)),
                  (e.elementType = D),
                  (e.lanes = c),
                  e
                );
              case B:
                return (
                  (e = gt(13, i, t, o)),
                  (e.elementType = B),
                  (e.lanes = c),
                  e
                );
              case W:
                return (
                  (e = gt(19, i, t, o)),
                  (e.elementType = W),
                  (e.lanes = c),
                  e
                );
              default:
                if (typeof e == 'object' && e !== null)
                  switch (e.$$typeof) {
                    case q:
                    case Y:
                      m = 10;
                      break e;
                    case U:
                      m = 9;
                      break e;
                    case X:
                      m = 11;
                      break e;
                    case k:
                      m = 14;
                      break e;
                    case V:
                      ((m = 16), (n = null));
                      break e;
                  }
                ((m = 29),
                  (i = Error(r(130, e === null ? 'null' : typeof e, ''))),
                  (n = null));
            }
          return (
            (t = gt(m, i, t, o)),
            (t.elementType = e),
            (t.type = n),
            (t.lanes = c),
            t
          );
        }
        function qi(e, t, i, n) {
          return ((e = gt(7, e, n, t)), (e.lanes = i), e);
        }
        function dr(e, t, i) {
          return ((e = gt(6, e, null, t)), (e.lanes = i), e);
        }
        function hr(e, t, i) {
          return (
            (t = gt(4, e.children !== null ? e.children : [], e.key, t)),
            (t.lanes = i),
            (t.stateNode = {
              containerInfo: e.containerInfo,
              pendingChildren: null,
              implementation: e.implementation,
            }),
            t
          );
        }
        var Mn = [],
          An = 0,
          El = null,
          wl = 0,
          _t = [],
          Ct = 0,
          Yi = null,
          Qt = 1,
          Zt = '';
        function $i(e, t) {
          ((Mn[An++] = wl), (Mn[An++] = El), (El = e), (wl = t));
        }
        function zc(e, t, i) {
          ((_t[Ct++] = Qt), (_t[Ct++] = Zt), (_t[Ct++] = Yi), (Yi = e));
          var n = Qt;
          e = Zt;
          var o = 32 - pt(n) - 1;
          ((n &= ~(1 << o)), (i += 1));
          var c = 32 - pt(t) + o;
          if (30 < c) {
            var m = o - (o % 5);
            ((c = (n & ((1 << m) - 1)).toString(32)),
              (n >>= m),
              (o -= m),
              (Qt = (1 << (32 - pt(t) + o)) | (i << o) | n),
              (Zt = c + e));
          } else ((Qt = (1 << c) | (i << o) | n), (Zt = e));
        }
        function pr(e) {
          e.return !== null && ($i(e, 1), zc(e, 1, 0));
        }
        function mr(e) {
          for (; e === El; )
            ((El = Mn[--An]),
              (Mn[An] = null),
              (wl = Mn[--An]),
              (Mn[An] = null));
          for (; e === Yi; )
            ((Yi = _t[--Ct]),
              (_t[Ct] = null),
              (Zt = _t[--Ct]),
              (_t[Ct] = null),
              (Qt = _t[--Ct]),
              (_t[Ct] = null));
        }
        var it = null,
          Le = null,
          Te = !1,
          Xi = null,
          Ut = !1,
          gr = Error(r(519));
        function Qi(e) {
          var t = Error(r(418, ''));
          throw (ma(At(t, e)), gr);
        }
        function Rc(e) {
          var t = e.stateNode,
            i = e.type,
            n = e.memoizedProps;
          switch (((t[We] = e), (t[lt] = n), i)) {
            case 'dialog':
              (ge('cancel', t), ge('close', t));
              break;
            case 'iframe':
            case 'object':
            case 'embed':
              ge('load', t);
              break;
            case 'video':
            case 'audio':
              for (i = 0; i < Ga.length; i++) ge(Ga[i], t);
              break;
            case 'source':
              ge('error', t);
              break;
            case 'img':
            case 'image':
            case 'link':
              (ge('error', t), ge('load', t));
              break;
            case 'details':
              ge('toggle', t);
              break;
            case 'input':
              (ge('invalid', t),
                Zu(
                  t,
                  n.value,
                  n.defaultValue,
                  n.checked,
                  n.defaultChecked,
                  n.type,
                  n.name,
                  !0
                ),
                cl(t));
              break;
            case 'select':
              ge('invalid', t);
              break;
            case 'textarea':
              (ge('invalid', t),
                Ju(t, n.value, n.defaultValue, n.children),
                cl(t));
          }
          ((i = n.children),
            (typeof i != 'string' &&
              typeof i != 'number' &&
              typeof i != 'bigint') ||
            t.textContent === '' + i ||
            n.suppressHydrationWarning === !0 ||
            Fd(t.textContent, i)
              ? (n.popover != null && (ge('beforetoggle', t), ge('toggle', t)),
                n.onScroll != null && ge('scroll', t),
                n.onScrollEnd != null && ge('scrollend', t),
                n.onClick != null && (t.onclick = as),
                (t = !0))
              : (t = !1),
            t || Qi(e));
        }
        function Dc(e) {
          for (it = e.return; it; )
            switch (it.tag) {
              case 5:
              case 13:
                Ut = !1;
                return;
              case 27:
              case 3:
                Ut = !0;
                return;
              default:
                it = it.return;
            }
        }
        function ha(e) {
          if (e !== it) return !1;
          if (!Te) return (Dc(e), (Te = !0), !1);
          var t = e.tag,
            i;
          if (
            ((i = t !== 3 && t !== 27) &&
              ((i = t === 5) &&
                ((i = e.type),
                (i =
                  !(i !== 'form' && i !== 'button') ||
                  Do(e.type, e.memoizedProps))),
              (i = !i)),
            i && Le && Qi(e),
            Dc(e),
            t === 13)
          ) {
            if (
              ((e = e.memoizedState),
              (e = e !== null ? e.dehydrated : null),
              !e)
            )
              throw Error(r(317));
            e: {
              for (e = e.nextSibling, t = 0; e; ) {
                if (e.nodeType === 8)
                  if (((i = e.data), i === '/$')) {
                    if (t === 0) {
                      Le = jt(e.nextSibling);
                      break e;
                    }
                    t--;
                  } else (i !== '$' && i !== '$!' && i !== '$?') || t++;
                e = e.nextSibling;
              }
              Le = null;
            }
          } else
            t === 27
              ? ((t = Le),
                Oi(e.type) ? ((e = Uo), (Uo = null), (Le = e)) : (Le = t))
              : (Le = it ? jt(e.stateNode.nextSibling) : null);
          return !0;
        }
        function pa() {
          ((Le = it = null), (Te = !1));
        }
        function Lc() {
          var e = Xi;
          return (
            e !== null &&
              (ut === null ? (ut = e) : ut.push.apply(ut, e), (Xi = null)),
            e
          );
        }
        function ma(e) {
          Xi === null ? (Xi = [e]) : Xi.push(e);
        }
        var vr = j(null),
          Zi = null,
          kt = null;
        function di(e, t, i) {
          (F(vr, t._currentValue), (t._currentValue = i));
        }
        function Jt(e) {
          ((e._currentValue = vr.current), P(vr));
        }
        function yr(e, t, i) {
          for (; e !== null; ) {
            var n = e.alternate;
            if (
              ((e.childLanes & t) !== t
                ? ((e.childLanes |= t), n !== null && (n.childLanes |= t))
                : n !== null && (n.childLanes & t) !== t && (n.childLanes |= t),
              e === i)
            )
              break;
            e = e.return;
          }
        }
        function br(e, t, i, n) {
          var o = e.child;
          for (o !== null && (o.return = e); o !== null; ) {
            var c = o.dependencies;
            if (c !== null) {
              var m = o.child;
              c = c.firstContext;
              e: for (; c !== null; ) {
                var v = c;
                c = o;
                for (var S = 0; S < t.length; S++)
                  if (v.context === t[S]) {
                    ((c.lanes |= i),
                      (v = c.alternate),
                      v !== null && (v.lanes |= i),
                      yr(c.return, i, e),
                      n || (m = null));
                    break e;
                  }
                c = v.next;
              }
            } else if (o.tag === 18) {
              if (((m = o.return), m === null)) throw Error(r(341));
              ((m.lanes |= i),
                (c = m.alternate),
                c !== null && (c.lanes |= i),
                yr(m, i, e),
                (m = null));
            } else m = o.child;
            if (m !== null) m.return = o;
            else
              for (m = o; m !== null; ) {
                if (m === e) {
                  m = null;
                  break;
                }
                if (((o = m.sibling), o !== null)) {
                  ((o.return = m.return), (m = o));
                  break;
                }
                m = m.return;
              }
            o = m;
          }
        }
        function ga(e, t, i, n) {
          e = null;
          for (var o = t, c = !1; o !== null; ) {
            if (!c) {
              if ((o.flags & 524288) !== 0) c = !0;
              else if ((o.flags & 262144) !== 0) break;
            }
            if (o.tag === 10) {
              var m = o.alternate;
              if (m === null) throw Error(r(387));
              if (((m = m.memoizedProps), m !== null)) {
                var v = o.type;
                mt(o.pendingProps.value, m.value) ||
                  (e !== null ? e.push(v) : (e = [v]));
              }
            } else if (o === dt.current) {
              if (((m = o.alternate), m === null)) throw Error(r(387));
              m.memoizedState.memoizedState !== o.memoizedState.memoizedState &&
                (e !== null ? e.push(Xa) : (e = [Xa]));
            }
            o = o.return;
          }
          (e !== null && br(t, e, i, n), (t.flags |= 262144));
        }
        function Ml(e) {
          for (e = e.firstContext; e !== null; ) {
            if (!mt(e.context._currentValue, e.memoizedValue)) return !0;
            e = e.next;
          }
          return !1;
        }
        function ki(e) {
          ((Zi = e),
            (kt = null),
            (e = e.dependencies),
            e !== null && (e.firstContext = null));
        }
        function et(e) {
          return jc(Zi, e);
        }
        function Al(e, t) {
          return (Zi === null && ki(e), jc(e, t));
        }
        function jc(e, t) {
          var i = t._currentValue;
          if (
            ((t = { context: t, memoizedValue: i, next: null }), kt === null)
          ) {
            if (e === null) throw Error(r(308));
            ((kt = t),
              (e.dependencies = { lanes: 0, firstContext: t }),
              (e.flags |= 524288));
          } else kt = kt.next = t;
          return i;
        }
        var bg =
            typeof AbortController < 'u'
              ? AbortController
              : function () {
                  var e = [],
                    t = (this.signal = {
                      aborted: !1,
                      addEventListener: function (i, n) {
                        e.push(n);
                      },
                    });
                  this.abort = function () {
                    ((t.aborted = !0),
                      e.forEach(function (i) {
                        return i();
                      }));
                  };
                },
          Sg = l.unstable_scheduleCallback,
          xg = l.unstable_NormalPriority,
          Ke = {
            $$typeof: Y,
            Consumer: null,
            Provider: null,
            _currentValue: null,
            _currentValue2: null,
            _threadCount: 0,
          };
        function Sr() {
          return { controller: new bg(), data: new Map(), refCount: 0 };
        }
        function va(e) {
          (e.refCount--,
            e.refCount === 0 &&
              Sg(xg, function () {
                e.controller.abort();
              }));
        }
        var ya = null,
          xr = 0,
          On = 0,
          _n = null;
        function Tg(e, t) {
          if (ya === null) {
            var i = (ya = []);
            ((xr = 0),
              (On = wo()),
              (_n = {
                status: 'pending',
                value: void 0,
                then: function (n) {
                  i.push(n);
                },
              }));
          }
          return (xr++, t.then(Hc, Hc), t);
        }
        function Hc() {
          if (--xr === 0 && ya !== null) {
            _n !== null && (_n.status = 'fulfilled');
            var e = ya;
            ((ya = null), (On = 0), (_n = null));
            for (var t = 0; t < e.length; t++) (0, e[t])();
          }
        }
        function Eg(e, t) {
          var i = [],
            n = {
              status: 'pending',
              value: null,
              reason: null,
              then: function (o) {
                i.push(o);
              },
            };
          return (
            e.then(
              function () {
                ((n.status = 'fulfilled'), (n.value = t));
                for (var o = 0; o < i.length; o++) (0, i[o])(t);
              },
              function (o) {
                for (
                  n.status = 'rejected', n.reason = o, o = 0;
                  o < i.length;
                  o++
                )
                  (0, i[o])(void 0);
              }
            ),
            n
          );
        }
        var Uc = L.S;
        L.S = function (e, t) {
          (typeof t == 'object' &&
            t !== null &&
            typeof t.then == 'function' &&
            Tg(e, t),
            Uc !== null && Uc(e, t));
        };
        var Ji = j(null);
        function Tr() {
          var e = Ji.current;
          return e !== null ? e : Ne.pooledCache;
        }
        function Ol(e, t) {
          t === null ? F(Ji, Ji.current) : F(Ji, t.pool);
        }
        function Bc() {
          var e = Tr();
          return e === null ? null : { parent: Ke._currentValue, pool: e };
        }
        var ba = Error(r(460)),
          Gc = Error(r(474)),
          _l = Error(r(542)),
          Er = { then: function () {} };
        function Vc(e) {
          return ((e = e.status), e === 'fulfilled' || e === 'rejected');
        }
        function Cl() {}
        function Kc(e, t, i) {
          switch (
            ((i = e[i]),
            i === void 0 ? e.push(t) : i !== t && (t.then(Cl, Cl), (t = i)),
            t.status)
          ) {
            case 'fulfilled':
              return t.value;
            case 'rejected':
              throw ((e = t.reason), Yc(e), e);
            default:
              if (typeof t.status == 'string') t.then(Cl, Cl);
              else {
                if (((e = Ne), e !== null && 100 < e.shellSuspendCounter))
                  throw Error(r(482));
                ((e = t),
                  (e.status = 'pending'),
                  e.then(
                    function (n) {
                      if (t.status === 'pending') {
                        var o = t;
                        ((o.status = 'fulfilled'), (o.value = n));
                      }
                    },
                    function (n) {
                      if (t.status === 'pending') {
                        var o = t;
                        ((o.status = 'rejected'), (o.reason = n));
                      }
                    }
                  ));
              }
              switch (t.status) {
                case 'fulfilled':
                  return t.value;
                case 'rejected':
                  throw ((e = t.reason), Yc(e), e);
              }
              throw ((Sa = t), ba);
          }
        }
        var Sa = null;
        function qc() {
          if (Sa === null) throw Error(r(459));
          var e = Sa;
          return ((Sa = null), e);
        }
        function Yc(e) {
          if (e === ba || e === _l) throw Error(r(483));
        }
        var hi = !1;
        function wr(e) {
          e.updateQueue = {
            baseState: e.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: { pending: null, lanes: 0, hiddenCallbacks: null },
            callbacks: null,
          };
        }
        function Mr(e, t) {
          ((e = e.updateQueue),
            t.updateQueue === e &&
              (t.updateQueue = {
                baseState: e.baseState,
                firstBaseUpdate: e.firstBaseUpdate,
                lastBaseUpdate: e.lastBaseUpdate,
                shared: e.shared,
                callbacks: null,
              }));
        }
        function pi(e) {
          return { lane: e, tag: 0, payload: null, callback: null, next: null };
        }
        function mi(e, t, i) {
          var n = e.updateQueue;
          if (n === null) return null;
          if (((n = n.shared), (Ee & 2) !== 0)) {
            var o = n.pending;
            return (
              o === null ? (t.next = t) : ((t.next = o.next), (o.next = t)),
              (n.pending = t),
              (t = xl(e)),
              Cc(e, null, i),
              t
            );
          }
          return (Sl(e, n, t, i), xl(e));
        }
        function xa(e, t, i) {
          if (
            ((t = t.updateQueue),
            t !== null && ((t = t.shared), (i & 4194048) !== 0))
          ) {
            var n = t.lanes;
            ((n &= e.pendingLanes), (i |= n), (t.lanes = i), Hu(e, i));
          }
        }
        function Ar(e, t) {
          var i = e.updateQueue,
            n = e.alternate;
          if (n !== null && ((n = n.updateQueue), i === n)) {
            var o = null,
              c = null;
            if (((i = i.firstBaseUpdate), i !== null)) {
              do {
                var m = {
                  lane: i.lane,
                  tag: i.tag,
                  payload: i.payload,
                  callback: null,
                  next: null,
                };
                (c === null ? (o = c = m) : (c = c.next = m), (i = i.next));
              } while (i !== null);
              c === null ? (o = c = t) : (c = c.next = t);
            } else o = c = t;
            ((i = {
              baseState: n.baseState,
              firstBaseUpdate: o,
              lastBaseUpdate: c,
              shared: n.shared,
              callbacks: n.callbacks,
            }),
              (e.updateQueue = i));
            return;
          }
          ((e = i.lastBaseUpdate),
            e === null ? (i.firstBaseUpdate = t) : (e.next = t),
            (i.lastBaseUpdate = t));
        }
        var Or = !1;
        function Ta() {
          if (Or) {
            var e = _n;
            if (e !== null) throw e;
          }
        }
        function Ea(e, t, i, n) {
          Or = !1;
          var o = e.updateQueue;
          hi = !1;
          var c = o.firstBaseUpdate,
            m = o.lastBaseUpdate,
            v = o.shared.pending;
          if (v !== null) {
            o.shared.pending = null;
            var S = v,
              N = S.next;
            ((S.next = null), m === null ? (c = N) : (m.next = N), (m = S));
            var H = e.alternate;
            H !== null &&
              ((H = H.updateQueue),
              (v = H.lastBaseUpdate),
              v !== m &&
                (v === null ? (H.firstBaseUpdate = N) : (v.next = N),
                (H.lastBaseUpdate = S)));
          }
          if (c !== null) {
            var K = o.baseState;
            ((m = 0), (H = N = S = null), (v = c));
            do {
              var z = v.lane & -536870913,
                R = z !== v.lane;
              if (R ? (ye & z) === z : (n & z) === z) {
                (z !== 0 && z === On && (Or = !0),
                  H !== null &&
                    (H = H.next =
                      {
                        lane: 0,
                        tag: v.tag,
                        payload: v.payload,
                        callback: null,
                        next: null,
                      }));
                e: {
                  var oe = e,
                    se = v;
                  z = t;
                  var Oe = i;
                  switch (se.tag) {
                    case 1:
                      if (((oe = se.payload), typeof oe == 'function')) {
                        K = oe.call(Oe, K, z);
                        break e;
                      }
                      K = oe;
                      break e;
                    case 3:
                      oe.flags = (oe.flags & -65537) | 128;
                    case 0:
                      if (
                        ((oe = se.payload),
                        (z = typeof oe == 'function' ? oe.call(Oe, K, z) : oe),
                        z == null)
                      )
                        break e;
                      K = y({}, K, z);
                      break e;
                    case 2:
                      hi = !0;
                  }
                }
                ((z = v.callback),
                  z !== null &&
                    ((e.flags |= 64),
                    R && (e.flags |= 8192),
                    (R = o.callbacks),
                    R === null ? (o.callbacks = [z]) : R.push(z)));
              } else
                ((R = {
                  lane: z,
                  tag: v.tag,
                  payload: v.payload,
                  callback: v.callback,
                  next: null,
                }),
                  H === null ? ((N = H = R), (S = K)) : (H = H.next = R),
                  (m |= z));
              if (((v = v.next), v === null)) {
                if (((v = o.shared.pending), v === null)) break;
                ((R = v),
                  (v = R.next),
                  (R.next = null),
                  (o.lastBaseUpdate = R),
                  (o.shared.pending = null));
              }
            } while (!0);
            (H === null && (S = K),
              (o.baseState = S),
              (o.firstBaseUpdate = N),
              (o.lastBaseUpdate = H),
              c === null && (o.shared.lanes = 0),
              (Ei |= m),
              (e.lanes = m),
              (e.memoizedState = K));
          }
        }
        function $c(e, t) {
          if (typeof e != 'function') throw Error(r(191, e));
          e.call(t);
        }
        function Xc(e, t) {
          var i = e.callbacks;
          if (i !== null)
            for (e.callbacks = null, e = 0; e < i.length; e++) $c(i[e], t);
        }
        var Cn = j(null),
          Nl = j(0);
        function Qc(e, t) {
          ((e = ii), F(Nl, e), F(Cn, t), (ii = e | t.baseLanes));
        }
        function _r() {
          (F(Nl, ii), F(Cn, Cn.current));
        }
        function Cr() {
          ((ii = Nl.current), P(Cn), P(Nl));
        }
        var gi = 0,
          he = null,
          Me = null,
          Ge = null,
          zl = !1,
          Nn = !1,
          Fi = !1,
          Rl = 0,
          wa = 0,
          zn = null,
          wg = 0;
        function Ue() {
          throw Error(r(321));
        }
        function Nr(e, t) {
          if (t === null) return !1;
          for (var i = 0; i < t.length && i < e.length; i++)
            if (!mt(e[i], t[i])) return !1;
          return !0;
        }
        function zr(e, t, i, n, o, c) {
          return (
            (gi = c),
            (he = t),
            (t.memoizedState = null),
            (t.updateQueue = null),
            (t.lanes = 0),
            (L.H = e === null || e.memoizedState === null ? Nf : zf),
            (Fi = !1),
            (c = i(n, o)),
            (Fi = !1),
            Nn && (c = kc(t, i, n, o)),
            Zc(e),
            c
          );
        }
        function Zc(e) {
          L.H = Bl;
          var t = Me !== null && Me.next !== null;
          if (
            ((gi = 0),
            (Ge = Me = he = null),
            (zl = !1),
            (wa = 0),
            (zn = null),
            t)
          )
            throw Error(r(300));
          e === null ||
            Xe ||
            ((e = e.dependencies), e !== null && Ml(e) && (Xe = !0));
        }
        function kc(e, t, i, n) {
          he = e;
          var o = 0;
          do {
            if ((Nn && (zn = null), (wa = 0), (Nn = !1), 25 <= o))
              throw Error(r(301));
            if (((o += 1), (Ge = Me = null), e.updateQueue != null)) {
              var c = e.updateQueue;
              ((c.lastEffect = null),
                (c.events = null),
                (c.stores = null),
                c.memoCache != null && (c.memoCache.index = 0));
            }
            ((L.H = zg), (c = t(i, n)));
          } while (Nn);
          return c;
        }
        function Mg() {
          var e = L.H,
            t = e.useState()[0];
          return (
            (t = typeof t.then == 'function' ? Ma(t) : t),
            (e = e.useState()[0]),
            (Me !== null ? Me.memoizedState : null) !== e && (he.flags |= 1024),
            t
          );
        }
        function Rr() {
          var e = Rl !== 0;
          return ((Rl = 0), e);
        }
        function Dr(e, t, i) {
          ((t.updateQueue = e.updateQueue),
            (t.flags &= -2053),
            (e.lanes &= ~i));
        }
        function Lr(e) {
          if (zl) {
            for (e = e.memoizedState; e !== null; ) {
              var t = e.queue;
              (t !== null && (t.pending = null), (e = e.next));
            }
            zl = !1;
          }
          ((gi = 0),
            (Ge = Me = he = null),
            (Nn = !1),
            (wa = Rl = 0),
            (zn = null));
        }
        function rt() {
          var e = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null,
          };
          return (
            Ge === null ? (he.memoizedState = Ge = e) : (Ge = Ge.next = e),
            Ge
          );
        }
        function Ve() {
          if (Me === null) {
            var e = he.alternate;
            e = e !== null ? e.memoizedState : null;
          } else e = Me.next;
          var t = Ge === null ? he.memoizedState : Ge.next;
          if (t !== null) ((Ge = t), (Me = e));
          else {
            if (e === null)
              throw he.alternate === null ? Error(r(467)) : Error(r(310));
            ((Me = e),
              (e = {
                memoizedState: Me.memoizedState,
                baseState: Me.baseState,
                baseQueue: Me.baseQueue,
                queue: Me.queue,
                next: null,
              }),
              Ge === null ? (he.memoizedState = Ge = e) : (Ge = Ge.next = e));
          }
          return Ge;
        }
        function jr() {
          return {
            lastEffect: null,
            events: null,
            stores: null,
            memoCache: null,
          };
        }
        function Ma(e) {
          var t = wa;
          return (
            (wa += 1),
            zn === null && (zn = []),
            (e = Kc(zn, e, t)),
            (t = he),
            (Ge === null ? t.memoizedState : Ge.next) === null &&
              ((t = t.alternate),
              (L.H = t === null || t.memoizedState === null ? Nf : zf)),
            e
          );
        }
        function Dl(e) {
          if (e !== null && typeof e == 'object') {
            if (typeof e.then == 'function') return Ma(e);
            if (e.$$typeof === Y) return et(e);
          }
          throw Error(r(438, String(e)));
        }
        function Hr(e) {
          var t = null,
            i = he.updateQueue;
          if ((i !== null && (t = i.memoCache), t == null)) {
            var n = he.alternate;
            n !== null &&
              ((n = n.updateQueue),
              n !== null &&
                ((n = n.memoCache),
                n != null &&
                  (t = {
                    data: n.data.map(function (o) {
                      return o.slice();
                    }),
                    index: 0,
                  })));
          }
          if (
            (t == null && (t = { data: [], index: 0 }),
            i === null && ((i = jr()), (he.updateQueue = i)),
            (i.memoCache = t),
            (i = t.data[t.index]),
            i === void 0)
          )
            for (i = t.data[t.index] = Array(e), n = 0; n < e; n++) i[n] = Q;
          return (t.index++, i);
        }
        function Ft(e, t) {
          return typeof t == 'function' ? t(e) : t;
        }
        function Ll(e) {
          var t = Ve();
          return Ur(t, Me, e);
        }
        function Ur(e, t, i) {
          var n = e.queue;
          if (n === null) throw Error(r(311));
          n.lastRenderedReducer = i;
          var o = e.baseQueue,
            c = n.pending;
          if (c !== null) {
            if (o !== null) {
              var m = o.next;
              ((o.next = c.next), (c.next = m));
            }
            ((t.baseQueue = o = c), (n.pending = null));
          }
          if (((c = e.baseState), o === null)) e.memoizedState = c;
          else {
            t = o.next;
            var v = (m = null),
              S = null,
              N = t,
              H = !1;
            do {
              var K = N.lane & -536870913;
              if (K !== N.lane ? (ye & K) === K : (gi & K) === K) {
                var z = N.revertLane;
                if (z === 0)
                  (S !== null &&
                    (S = S.next =
                      {
                        lane: 0,
                        revertLane: 0,
                        action: N.action,
                        hasEagerState: N.hasEagerState,
                        eagerState: N.eagerState,
                        next: null,
                      }),
                    K === On && (H = !0));
                else if ((gi & z) === z) {
                  ((N = N.next), z === On && (H = !0));
                  continue;
                } else
                  ((K = {
                    lane: 0,
                    revertLane: N.revertLane,
                    action: N.action,
                    hasEagerState: N.hasEagerState,
                    eagerState: N.eagerState,
                    next: null,
                  }),
                    S === null ? ((v = S = K), (m = c)) : (S = S.next = K),
                    (he.lanes |= z),
                    (Ei |= z));
                ((K = N.action),
                  Fi && i(c, K),
                  (c = N.hasEagerState ? N.eagerState : i(c, K)));
              } else
                ((z = {
                  lane: K,
                  revertLane: N.revertLane,
                  action: N.action,
                  hasEagerState: N.hasEagerState,
                  eagerState: N.eagerState,
                  next: null,
                }),
                  S === null ? ((v = S = z), (m = c)) : (S = S.next = z),
                  (he.lanes |= K),
                  (Ei |= K));
              N = N.next;
            } while (N !== null && N !== t);
            if (
              (S === null ? (m = c) : (S.next = v),
              !mt(c, e.memoizedState) &&
                ((Xe = !0), H && ((i = _n), i !== null)))
            )
              throw i;
            ((e.memoizedState = c),
              (e.baseState = m),
              (e.baseQueue = S),
              (n.lastRenderedState = c));
          }
          return (o === null && (n.lanes = 0), [e.memoizedState, n.dispatch]);
        }
        function Br(e) {
          var t = Ve(),
            i = t.queue;
          if (i === null) throw Error(r(311));
          i.lastRenderedReducer = e;
          var n = i.dispatch,
            o = i.pending,
            c = t.memoizedState;
          if (o !== null) {
            i.pending = null;
            var m = (o = o.next);
            do ((c = e(c, m.action)), (m = m.next));
            while (m !== o);
            (mt(c, t.memoizedState) || (Xe = !0),
              (t.memoizedState = c),
              t.baseQueue === null && (t.baseState = c),
              (i.lastRenderedState = c));
          }
          return [c, n];
        }
        function Jc(e, t, i) {
          var n = he,
            o = Ve(),
            c = Te;
          if (c) {
            if (i === void 0) throw Error(r(407));
            i = i();
          } else i = t();
          var m = !mt((Me || o).memoizedState, i);
          (m && ((o.memoizedState = i), (Xe = !0)), (o = o.queue));
          var v = Ic.bind(null, n, o, e);
          if (
            (Aa(2048, 8, v, [e]),
            o.getSnapshot !== t ||
              m ||
              (Ge !== null && Ge.memoizedState.tag & 1))
          ) {
            if (
              ((n.flags |= 2048),
              Rn(9, jl(), Pc.bind(null, n, o, i, t), null),
              Ne === null)
            )
              throw Error(r(349));
            c || (gi & 124) !== 0 || Fc(n, t, i);
          }
          return i;
        }
        function Fc(e, t, i) {
          ((e.flags |= 16384),
            (e = { getSnapshot: t, value: i }),
            (t = he.updateQueue),
            t === null
              ? ((t = jr()), (he.updateQueue = t), (t.stores = [e]))
              : ((i = t.stores), i === null ? (t.stores = [e]) : i.push(e)));
        }
        function Pc(e, t, i, n) {
          ((t.value = i), (t.getSnapshot = n), Wc(t) && ef(e));
        }
        function Ic(e, t, i) {
          return i(function () {
            Wc(t) && ef(e);
          });
        }
        function Wc(e) {
          var t = e.getSnapshot;
          e = e.value;
          try {
            var i = t();
            return !mt(e, i);
          } catch {
            return !0;
          }
        }
        function ef(e) {
          var t = En(e, 2);
          t !== null && xt(t, e, 2);
        }
        function Gr(e) {
          var t = rt();
          if (typeof e == 'function') {
            var i = e;
            if (((e = i()), Fi)) {
              ui(!0);
              try {
                i();
              } finally {
                ui(!1);
              }
            }
          }
          return (
            (t.memoizedState = t.baseState = e),
            (t.queue = {
              pending: null,
              lanes: 0,
              dispatch: null,
              lastRenderedReducer: Ft,
              lastRenderedState: e,
            }),
            t
          );
        }
        function tf(e, t, i, n) {
          return (
            (e.baseState = i),
            Ur(e, Me, typeof n == 'function' ? n : Ft)
          );
        }
        function Ag(e, t, i, n, o) {
          if (Ul(e)) throw Error(r(485));
          if (((e = t.action), e !== null)) {
            var c = {
              payload: o,
              action: e,
              next: null,
              isTransition: !0,
              status: 'pending',
              value: null,
              reason: null,
              listeners: [],
              then: function (m) {
                c.listeners.push(m);
              },
            };
            (L.T !== null ? i(!0) : (c.isTransition = !1),
              n(c),
              (i = t.pending),
              i === null
                ? ((c.next = t.pending = c), nf(t, c))
                : ((c.next = i.next), (t.pending = i.next = c)));
          }
        }
        function nf(e, t) {
          var i = t.action,
            n = t.payload,
            o = e.state;
          if (t.isTransition) {
            var c = L.T,
              m = {};
            L.T = m;
            try {
              var v = i(o, n),
                S = L.S;
              (S !== null && S(m, v), af(e, t, v));
            } catch (N) {
              Vr(e, t, N);
            } finally {
              L.T = c;
            }
          } else
            try {
              ((c = i(o, n)), af(e, t, c));
            } catch (N) {
              Vr(e, t, N);
            }
        }
        function af(e, t, i) {
          i !== null && typeof i == 'object' && typeof i.then == 'function'
            ? i.then(
                function (n) {
                  lf(e, t, n);
                },
                function (n) {
                  return Vr(e, t, n);
                }
              )
            : lf(e, t, i);
        }
        function lf(e, t, i) {
          ((t.status = 'fulfilled'),
            (t.value = i),
            sf(t),
            (e.state = i),
            (t = e.pending),
            t !== null &&
              ((i = t.next),
              i === t
                ? (e.pending = null)
                : ((i = i.next), (t.next = i), nf(e, i))));
        }
        function Vr(e, t, i) {
          var n = e.pending;
          if (((e.pending = null), n !== null)) {
            n = n.next;
            do ((t.status = 'rejected'), (t.reason = i), sf(t), (t = t.next));
            while (t !== n);
          }
          e.action = null;
        }
        function sf(e) {
          e = e.listeners;
          for (var t = 0; t < e.length; t++) (0, e[t])();
        }
        function rf(e, t) {
          return t;
        }
        function of(e, t) {
          if (Te) {
            var i = Ne.formState;
            if (i !== null) {
              e: {
                var n = he;
                if (Te) {
                  if (Le) {
                    t: {
                      for (var o = Le, c = Ut; o.nodeType !== 8; ) {
                        if (!c) {
                          o = null;
                          break t;
                        }
                        if (((o = jt(o.nextSibling)), o === null)) {
                          o = null;
                          break t;
                        }
                      }
                      ((c = o.data), (o = c === 'F!' || c === 'F' ? o : null));
                    }
                    if (o) {
                      ((Le = jt(o.nextSibling)), (n = o.data === 'F!'));
                      break e;
                    }
                  }
                  Qi(n);
                }
                n = !1;
              }
              n && (t = i[0]);
            }
          }
          return (
            (i = rt()),
            (i.memoizedState = i.baseState = t),
            (n = {
              pending: null,
              lanes: 0,
              dispatch: null,
              lastRenderedReducer: rf,
              lastRenderedState: t,
            }),
            (i.queue = n),
            (i = Of.bind(null, he, n)),
            (n.dispatch = i),
            (n = Gr(!1)),
            (c = Xr.bind(null, he, !1, n.queue)),
            (n = rt()),
            (o = { state: t, dispatch: null, action: e, pending: null }),
            (n.queue = o),
            (i = Ag.bind(null, he, o, c, i)),
            (o.dispatch = i),
            (n.memoizedState = e),
            [t, i, !1]
          );
        }
        function uf(e) {
          var t = Ve();
          return cf(t, Me, e);
        }
        function cf(e, t, i) {
          if (
            ((t = Ur(e, t, rf)[0]),
            (e = Ll(Ft)[0]),
            typeof t == 'object' && t !== null && typeof t.then == 'function')
          )
            try {
              var n = Ma(t);
            } catch (m) {
              throw m === ba ? _l : m;
            }
          else n = t;
          t = Ve();
          var o = t.queue,
            c = o.dispatch;
          return (
            i !== t.memoizedState &&
              ((he.flags |= 2048), Rn(9, jl(), Og.bind(null, o, i), null)),
            [n, c, e]
          );
        }
        function Og(e, t) {
          e.action = t;
        }
        function ff(e) {
          var t = Ve(),
            i = Me;
          if (i !== null) return cf(t, i, e);
          (Ve(), (t = t.memoizedState), (i = Ve()));
          var n = i.queue.dispatch;
          return ((i.memoizedState = e), [t, n, !1]);
        }
        function Rn(e, t, i, n) {
          return (
            (e = { tag: e, create: i, deps: n, inst: t, next: null }),
            (t = he.updateQueue),
            t === null && ((t = jr()), (he.updateQueue = t)),
            (i = t.lastEffect),
            i === null
              ? (t.lastEffect = e.next = e)
              : ((n = i.next), (i.next = e), (e.next = n), (t.lastEffect = e)),
            e
          );
        }
        function jl() {
          return { destroy: void 0, resource: void 0 };
        }
        function df() {
          return Ve().memoizedState;
        }
        function Hl(e, t, i, n) {
          var o = rt();
          ((n = n === void 0 ? null : n),
            (he.flags |= e),
            (o.memoizedState = Rn(1 | t, jl(), i, n)));
        }
        function Aa(e, t, i, n) {
          var o = Ve();
          n = n === void 0 ? null : n;
          var c = o.memoizedState.inst;
          Me !== null && n !== null && Nr(n, Me.memoizedState.deps)
            ? (o.memoizedState = Rn(t, c, i, n))
            : ((he.flags |= e), (o.memoizedState = Rn(1 | t, c, i, n)));
        }
        function hf(e, t) {
          Hl(8390656, 8, e, t);
        }
        function pf(e, t) {
          Aa(2048, 8, e, t);
        }
        function mf(e, t) {
          return Aa(4, 2, e, t);
        }
        function gf(e, t) {
          return Aa(4, 4, e, t);
        }
        function vf(e, t) {
          if (typeof t == 'function') {
            e = e();
            var i = t(e);
            return function () {
              typeof i == 'function' ? i() : t(null);
            };
          }
          if (t != null)
            return (
              (e = e()),
              (t.current = e),
              function () {
                t.current = null;
              }
            );
        }
        function yf(e, t, i) {
          ((i = i != null ? i.concat([e]) : null),
            Aa(4, 4, vf.bind(null, t, e), i));
        }
        function Kr() {}
        function bf(e, t) {
          var i = Ve();
          t = t === void 0 ? null : t;
          var n = i.memoizedState;
          return t !== null && Nr(t, n[1])
            ? n[0]
            : ((i.memoizedState = [e, t]), e);
        }
        function Sf(e, t) {
          var i = Ve();
          t = t === void 0 ? null : t;
          var n = i.memoizedState;
          if (t !== null && Nr(t, n[1])) return n[0];
          if (((n = e()), Fi)) {
            ui(!0);
            try {
              e();
            } finally {
              ui(!1);
            }
          }
          return ((i.memoizedState = [n, t]), n);
        }
        function qr(e, t, i) {
          return i === void 0 || (gi & 1073741824) !== 0
            ? (e.memoizedState = t)
            : ((e.memoizedState = i),
              (e = Ed()),
              (he.lanes |= e),
              (Ei |= e),
              i);
        }
        function xf(e, t, i, n) {
          return mt(i, t)
            ? i
            : Cn.current !== null
              ? ((e = qr(e, i, n)), mt(e, t) || (Xe = !0), e)
              : (gi & 42) === 0
                ? ((Xe = !0), (e.memoizedState = i))
                : ((e = Ed()), (he.lanes |= e), (Ei |= e), t);
        }
        function Tf(e, t, i, n, o) {
          var c = Z.p;
          Z.p = c !== 0 && 8 > c ? c : 8;
          var m = L.T,
            v = {};
          ((L.T = v), Xr(e, !1, t, i));
          try {
            var S = o(),
              N = L.S;
            if (
              (N !== null && N(v, S),
              S !== null && typeof S == 'object' && typeof S.then == 'function')
            ) {
              var H = Eg(S, n);
              Oa(e, t, H, St());
            } else Oa(e, t, n, St());
          } catch (K) {
            Oa(
              e,
              t,
              { then: function () {}, status: 'rejected', reason: K },
              St()
            );
          } finally {
            ((Z.p = c), (L.T = m));
          }
        }
        function _g() {}
        function Yr(e, t, i, n) {
          if (e.tag !== 5) throw Error(r(476));
          var o = Ef(e).queue;
          Tf(
            e,
            o,
            t,
            $,
            i === null
              ? _g
              : function () {
                  return (wf(e), i(n));
                }
          );
        }
        function Ef(e) {
          var t = e.memoizedState;
          if (t !== null) return t;
          t = {
            memoizedState: $,
            baseState: $,
            baseQueue: null,
            queue: {
              pending: null,
              lanes: 0,
              dispatch: null,
              lastRenderedReducer: Ft,
              lastRenderedState: $,
            },
            next: null,
          };
          var i = {};
          return (
            (t.next = {
              memoizedState: i,
              baseState: i,
              baseQueue: null,
              queue: {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: Ft,
                lastRenderedState: i,
              },
              next: null,
            }),
            (e.memoizedState = t),
            (e = e.alternate),
            e !== null && (e.memoizedState = t),
            t
          );
        }
        function wf(e) {
          var t = Ef(e).next.queue;
          Oa(e, t, {}, St());
        }
        function $r() {
          return et(Xa);
        }
        function Mf() {
          return Ve().memoizedState;
        }
        function Af() {
          return Ve().memoizedState;
        }
        function Cg(e) {
          for (var t = e.return; t !== null; ) {
            switch (t.tag) {
              case 24:
              case 3:
                var i = St();
                e = pi(i);
                var n = mi(t, e, i);
                (n !== null && (xt(n, t, i), xa(n, t, i)),
                  (t = { cache: Sr() }),
                  (e.payload = t));
                return;
            }
            t = t.return;
          }
        }
        function Ng(e, t, i) {
          var n = St();
          ((i = {
            lane: n,
            revertLane: 0,
            action: i,
            hasEagerState: !1,
            eagerState: null,
            next: null,
          }),
            Ul(e)
              ? _f(t, i)
              : ((i = cr(e, t, i, n)),
                i !== null && (xt(i, e, n), Cf(i, t, n))));
        }
        function Of(e, t, i) {
          var n = St();
          Oa(e, t, i, n);
        }
        function Oa(e, t, i, n) {
          var o = {
            lane: n,
            revertLane: 0,
            action: i,
            hasEagerState: !1,
            eagerState: null,
            next: null,
          };
          if (Ul(e)) _f(t, o);
          else {
            var c = e.alternate;
            if (
              e.lanes === 0 &&
              (c === null || c.lanes === 0) &&
              ((c = t.lastRenderedReducer), c !== null)
            )
              try {
                var m = t.lastRenderedState,
                  v = c(m, i);
                if (((o.hasEagerState = !0), (o.eagerState = v), mt(v, m)))
                  return (Sl(e, t, o, 0), Ne === null && bl(), !1);
              } catch {
              } finally {
              }
            if (((i = cr(e, t, o, n)), i !== null))
              return (xt(i, e, n), Cf(i, t, n), !0);
          }
          return !1;
        }
        function Xr(e, t, i, n) {
          if (
            ((n = {
              lane: 2,
              revertLane: wo(),
              action: n,
              hasEagerState: !1,
              eagerState: null,
              next: null,
            }),
            Ul(e))
          ) {
            if (t) throw Error(r(479));
          } else ((t = cr(e, i, n, 2)), t !== null && xt(t, e, 2));
        }
        function Ul(e) {
          var t = e.alternate;
          return e === he || (t !== null && t === he);
        }
        function _f(e, t) {
          Nn = zl = !0;
          var i = e.pending;
          (i === null ? (t.next = t) : ((t.next = i.next), (i.next = t)),
            (e.pending = t));
        }
        function Cf(e, t, i) {
          if ((i & 4194048) !== 0) {
            var n = t.lanes;
            ((n &= e.pendingLanes), (i |= n), (t.lanes = i), Hu(e, i));
          }
        }
        var Bl = {
            readContext: et,
            use: Dl,
            useCallback: Ue,
            useContext: Ue,
            useEffect: Ue,
            useImperativeHandle: Ue,
            useLayoutEffect: Ue,
            useInsertionEffect: Ue,
            useMemo: Ue,
            useReducer: Ue,
            useRef: Ue,
            useState: Ue,
            useDebugValue: Ue,
            useDeferredValue: Ue,
            useTransition: Ue,
            useSyncExternalStore: Ue,
            useId: Ue,
            useHostTransitionStatus: Ue,
            useFormState: Ue,
            useActionState: Ue,
            useOptimistic: Ue,
            useMemoCache: Ue,
            useCacheRefresh: Ue,
          },
          Nf = {
            readContext: et,
            use: Dl,
            useCallback: function (e, t) {
              return ((rt().memoizedState = [e, t === void 0 ? null : t]), e);
            },
            useContext: et,
            useEffect: hf,
            useImperativeHandle: function (e, t, i) {
              ((i = i != null ? i.concat([e]) : null),
                Hl(4194308, 4, vf.bind(null, t, e), i));
            },
            useLayoutEffect: function (e, t) {
              return Hl(4194308, 4, e, t);
            },
            useInsertionEffect: function (e, t) {
              Hl(4, 2, e, t);
            },
            useMemo: function (e, t) {
              var i = rt();
              t = t === void 0 ? null : t;
              var n = e();
              if (Fi) {
                ui(!0);
                try {
                  e();
                } finally {
                  ui(!1);
                }
              }
              return ((i.memoizedState = [n, t]), n);
            },
            useReducer: function (e, t, i) {
              var n = rt();
              if (i !== void 0) {
                var o = i(t);
                if (Fi) {
                  ui(!0);
                  try {
                    i(t);
                  } finally {
                    ui(!1);
                  }
                }
              } else o = t;
              return (
                (n.memoizedState = n.baseState = o),
                (e = {
                  pending: null,
                  lanes: 0,
                  dispatch: null,
                  lastRenderedReducer: e,
                  lastRenderedState: o,
                }),
                (n.queue = e),
                (e = e.dispatch = Ng.bind(null, he, e)),
                [n.memoizedState, e]
              );
            },
            useRef: function (e) {
              var t = rt();
              return ((e = { current: e }), (t.memoizedState = e));
            },
            useState: function (e) {
              e = Gr(e);
              var t = e.queue,
                i = Of.bind(null, he, t);
              return ((t.dispatch = i), [e.memoizedState, i]);
            },
            useDebugValue: Kr,
            useDeferredValue: function (e, t) {
              var i = rt();
              return qr(i, e, t);
            },
            useTransition: function () {
              var e = Gr(!1);
              return (
                (e = Tf.bind(null, he, e.queue, !0, !1)),
                (rt().memoizedState = e),
                [!1, e]
              );
            },
            useSyncExternalStore: function (e, t, i) {
              var n = he,
                o = rt();
              if (Te) {
                if (i === void 0) throw Error(r(407));
                i = i();
              } else {
                if (((i = t()), Ne === null)) throw Error(r(349));
                (ye & 124) !== 0 || Fc(n, t, i);
              }
              o.memoizedState = i;
              var c = { value: i, getSnapshot: t };
              return (
                (o.queue = c),
                hf(Ic.bind(null, n, c, e), [e]),
                (n.flags |= 2048),
                Rn(9, jl(), Pc.bind(null, n, c, i, t), null),
                i
              );
            },
            useId: function () {
              var e = rt(),
                t = Ne.identifierPrefix;
              if (Te) {
                var i = Zt,
                  n = Qt;
                ((i = (n & ~(1 << (32 - pt(n) - 1))).toString(32) + i),
                  (t = '«' + t + 'R' + i),
                  (i = Rl++),
                  0 < i && (t += 'H' + i.toString(32)),
                  (t += '»'));
              } else ((i = wg++), (t = '«' + t + 'r' + i.toString(32) + '»'));
              return (e.memoizedState = t);
            },
            useHostTransitionStatus: $r,
            useFormState: of,
            useActionState: of,
            useOptimistic: function (e) {
              var t = rt();
              t.memoizedState = t.baseState = e;
              var i = {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: null,
                lastRenderedState: null,
              };
              return (
                (t.queue = i),
                (t = Xr.bind(null, he, !0, i)),
                (i.dispatch = t),
                [e, t]
              );
            },
            useMemoCache: Hr,
            useCacheRefresh: function () {
              return (rt().memoizedState = Cg.bind(null, he));
            },
          },
          zf = {
            readContext: et,
            use: Dl,
            useCallback: bf,
            useContext: et,
            useEffect: pf,
            useImperativeHandle: yf,
            useInsertionEffect: mf,
            useLayoutEffect: gf,
            useMemo: Sf,
            useReducer: Ll,
            useRef: df,
            useState: function () {
              return Ll(Ft);
            },
            useDebugValue: Kr,
            useDeferredValue: function (e, t) {
              var i = Ve();
              return xf(i, Me.memoizedState, e, t);
            },
            useTransition: function () {
              var e = Ll(Ft)[0],
                t = Ve().memoizedState;
              return [typeof e == 'boolean' ? e : Ma(e), t];
            },
            useSyncExternalStore: Jc,
            useId: Mf,
            useHostTransitionStatus: $r,
            useFormState: uf,
            useActionState: uf,
            useOptimistic: function (e, t) {
              var i = Ve();
              return tf(i, Me, e, t);
            },
            useMemoCache: Hr,
            useCacheRefresh: Af,
          },
          zg = {
            readContext: et,
            use: Dl,
            useCallback: bf,
            useContext: et,
            useEffect: pf,
            useImperativeHandle: yf,
            useInsertionEffect: mf,
            useLayoutEffect: gf,
            useMemo: Sf,
            useReducer: Br,
            useRef: df,
            useState: function () {
              return Br(Ft);
            },
            useDebugValue: Kr,
            useDeferredValue: function (e, t) {
              var i = Ve();
              return Me === null ? qr(i, e, t) : xf(i, Me.memoizedState, e, t);
            },
            useTransition: function () {
              var e = Br(Ft)[0],
                t = Ve().memoizedState;
              return [typeof e == 'boolean' ? e : Ma(e), t];
            },
            useSyncExternalStore: Jc,
            useId: Mf,
            useHostTransitionStatus: $r,
            useFormState: ff,
            useActionState: ff,
            useOptimistic: function (e, t) {
              var i = Ve();
              return Me !== null
                ? tf(i, Me, e, t)
                : ((i.baseState = e), [e, i.queue.dispatch]);
            },
            useMemoCache: Hr,
            useCacheRefresh: Af,
          },
          Dn = null,
          _a = 0;
        function Gl(e) {
          var t = _a;
          return ((_a += 1), Dn === null && (Dn = []), Kc(Dn, e, t));
        }
        function Ca(e, t) {
          ((t = t.props.ref), (e.ref = t !== void 0 ? t : null));
        }
        function Vl(e, t) {
          throw t.$$typeof === b
            ? Error(r(525))
            : ((e = Object.prototype.toString.call(t)),
              Error(
                r(
                  31,
                  e === '[object Object]'
                    ? 'object with keys {' + Object.keys(t).join(', ') + '}'
                    : e
                )
              ));
        }
        function Rf(e) {
          var t = e._init;
          return t(e._payload);
        }
        function Df(e) {
          function t(M, E) {
            if (e) {
              var C = M.deletions;
              C === null ? ((M.deletions = [E]), (M.flags |= 16)) : C.push(E);
            }
          }
          function i(M, E) {
            if (!e) return null;
            for (; E !== null; ) (t(M, E), (E = E.sibling));
            return null;
          }
          function n(M) {
            for (var E = new Map(); M !== null; )
              (M.key !== null ? E.set(M.key, M) : E.set(M.index, M),
                (M = M.sibling));
            return E;
          }
          function o(M, E) {
            return ((M = Xt(M, E)), (M.index = 0), (M.sibling = null), M);
          }
          function c(M, E, C) {
            return (
              (M.index = C),
              e
                ? ((C = M.alternate),
                  C !== null
                    ? ((C = C.index), C < E ? ((M.flags |= 67108866), E) : C)
                    : ((M.flags |= 67108866), E))
                : ((M.flags |= 1048576), E)
            );
          }
          function m(M) {
            return (e && M.alternate === null && (M.flags |= 67108866), M);
          }
          function v(M, E, C, G) {
            return E === null || E.tag !== 6
              ? ((E = dr(C, M.mode, G)), (E.return = M), E)
              : ((E = o(E, C)), (E.return = M), E);
          }
          function S(M, E, C, G) {
            var te = C.type;
            return te === _
              ? H(M, E, C.props.children, G, C.key)
              : E !== null &&
                  (E.elementType === te ||
                    (typeof te == 'object' &&
                      te !== null &&
                      te.$$typeof === V &&
                      Rf(te) === E.type))
                ? ((E = o(E, C.props)), Ca(E, C), (E.return = M), E)
                : ((E = Tl(C.type, C.key, C.props, null, M.mode, G)),
                  Ca(E, C),
                  (E.return = M),
                  E);
          }
          function N(M, E, C, G) {
            return E === null ||
              E.tag !== 4 ||
              E.stateNode.containerInfo !== C.containerInfo ||
              E.stateNode.implementation !== C.implementation
              ? ((E = hr(C, M.mode, G)), (E.return = M), E)
              : ((E = o(E, C.children || [])), (E.return = M), E);
          }
          function H(M, E, C, G, te) {
            return E === null || E.tag !== 7
              ? ((E = qi(C, M.mode, G, te)), (E.return = M), E)
              : ((E = o(E, C)), (E.return = M), E);
          }
          function K(M, E, C) {
            if (
              (typeof E == 'string' && E !== '') ||
              typeof E == 'number' ||
              typeof E == 'bigint'
            )
              return ((E = dr('' + E, M.mode, C)), (E.return = M), E);
            if (typeof E == 'object' && E !== null) {
              switch (E.$$typeof) {
                case w:
                  return (
                    (C = Tl(E.type, E.key, E.props, null, M.mode, C)),
                    Ca(C, E),
                    (C.return = M),
                    C
                  );
                case T:
                  return ((E = hr(E, M.mode, C)), (E.return = M), E);
                case V:
                  var G = E._init;
                  return ((E = G(E._payload)), K(M, E, C));
              }
              if (be(E) || ie(E))
                return ((E = qi(E, M.mode, C, null)), (E.return = M), E);
              if (typeof E.then == 'function') return K(M, Gl(E), C);
              if (E.$$typeof === Y) return K(M, Al(M, E), C);
              Vl(M, E);
            }
            return null;
          }
          function z(M, E, C, G) {
            var te = E !== null ? E.key : null;
            if (
              (typeof C == 'string' && C !== '') ||
              typeof C == 'number' ||
              typeof C == 'bigint'
            )
              return te !== null ? null : v(M, E, '' + C, G);
            if (typeof C == 'object' && C !== null) {
              switch (C.$$typeof) {
                case w:
                  return C.key === te ? S(M, E, C, G) : null;
                case T:
                  return C.key === te ? N(M, E, C, G) : null;
                case V:
                  return ((te = C._init), (C = te(C._payload)), z(M, E, C, G));
              }
              if (be(C) || ie(C))
                return te !== null ? null : H(M, E, C, G, null);
              if (typeof C.then == 'function') return z(M, E, Gl(C), G);
              if (C.$$typeof === Y) return z(M, E, Al(M, C), G);
              Vl(M, C);
            }
            return null;
          }
          function R(M, E, C, G, te) {
            if (
              (typeof G == 'string' && G !== '') ||
              typeof G == 'number' ||
              typeof G == 'bigint'
            )
              return ((M = M.get(C) || null), v(E, M, '' + G, te));
            if (typeof G == 'object' && G !== null) {
              switch (G.$$typeof) {
                case w:
                  return (
                    (M = M.get(G.key === null ? C : G.key) || null),
                    S(E, M, G, te)
                  );
                case T:
                  return (
                    (M = M.get(G.key === null ? C : G.key) || null),
                    N(E, M, G, te)
                  );
                case V:
                  var pe = G._init;
                  return ((G = pe(G._payload)), R(M, E, C, G, te));
              }
              if (be(G) || ie(G))
                return ((M = M.get(C) || null), H(E, M, G, te, null));
              if (typeof G.then == 'function') return R(M, E, C, Gl(G), te);
              if (G.$$typeof === Y) return R(M, E, C, Al(E, G), te);
              Vl(E, G);
            }
            return null;
          }
          function oe(M, E, C, G) {
            for (
              var te = null, pe = null, ae = E, re = (E = 0), Ze = null;
              ae !== null && re < C.length;
              re++
            ) {
              ae.index > re ? ((Ze = ae), (ae = null)) : (Ze = ae.sibling);
              var xe = z(M, ae, C[re], G);
              if (xe === null) {
                ae === null && (ae = Ze);
                break;
              }
              (e && ae && xe.alternate === null && t(M, ae),
                (E = c(xe, E, re)),
                pe === null ? (te = xe) : (pe.sibling = xe),
                (pe = xe),
                (ae = Ze));
            }
            if (re === C.length) return (i(M, ae), Te && $i(M, re), te);
            if (ae === null) {
              for (; re < C.length; re++)
                ((ae = K(M, C[re], G)),
                  ae !== null &&
                    ((E = c(ae, E, re)),
                    pe === null ? (te = ae) : (pe.sibling = ae),
                    (pe = ae)));
              return (Te && $i(M, re), te);
            }
            for (ae = n(ae); re < C.length; re++)
              ((Ze = R(ae, M, re, C[re], G)),
                Ze !== null &&
                  (e &&
                    Ze.alternate !== null &&
                    ae.delete(Ze.key === null ? re : Ze.key),
                  (E = c(Ze, E, re)),
                  pe === null ? (te = Ze) : (pe.sibling = Ze),
                  (pe = Ze)));
            return (
              e &&
                ae.forEach(function (Ri) {
                  return t(M, Ri);
                }),
              Te && $i(M, re),
              te
            );
          }
          function se(M, E, C, G) {
            if (C == null) throw Error(r(151));
            for (
              var te = null,
                pe = null,
                ae = E,
                re = (E = 0),
                Ze = null,
                xe = C.next();
              ae !== null && !xe.done;
              re++, xe = C.next()
            ) {
              ae.index > re ? ((Ze = ae), (ae = null)) : (Ze = ae.sibling);
              var Ri = z(M, ae, xe.value, G);
              if (Ri === null) {
                ae === null && (ae = Ze);
                break;
              }
              (e && ae && Ri.alternate === null && t(M, ae),
                (E = c(Ri, E, re)),
                pe === null ? (te = Ri) : (pe.sibling = Ri),
                (pe = Ri),
                (ae = Ze));
            }
            if (xe.done) return (i(M, ae), Te && $i(M, re), te);
            if (ae === null) {
              for (; !xe.done; re++, xe = C.next())
                ((xe = K(M, xe.value, G)),
                  xe !== null &&
                    ((E = c(xe, E, re)),
                    pe === null ? (te = xe) : (pe.sibling = xe),
                    (pe = xe)));
              return (Te && $i(M, re), te);
            }
            for (ae = n(ae); !xe.done; re++, xe = C.next())
              ((xe = R(ae, M, re, xe.value, G)),
                xe !== null &&
                  (e &&
                    xe.alternate !== null &&
                    ae.delete(xe.key === null ? re : xe.key),
                  (E = c(xe, E, re)),
                  pe === null ? (te = xe) : (pe.sibling = xe),
                  (pe = xe)));
            return (
              e &&
                ae.forEach(function (Rv) {
                  return t(M, Rv);
                }),
              Te && $i(M, re),
              te
            );
          }
          function Oe(M, E, C, G) {
            if (
              (typeof C == 'object' &&
                C !== null &&
                C.type === _ &&
                C.key === null &&
                (C = C.props.children),
              typeof C == 'object' && C !== null)
            ) {
              switch (C.$$typeof) {
                case w:
                  e: {
                    for (var te = C.key; E !== null; ) {
                      if (E.key === te) {
                        if (((te = C.type), te === _)) {
                          if (E.tag === 7) {
                            (i(M, E.sibling),
                              (G = o(E, C.props.children)),
                              (G.return = M),
                              (M = G));
                            break e;
                          }
                        } else if (
                          E.elementType === te ||
                          (typeof te == 'object' &&
                            te !== null &&
                            te.$$typeof === V &&
                            Rf(te) === E.type)
                        ) {
                          (i(M, E.sibling),
                            (G = o(E, C.props)),
                            Ca(G, C),
                            (G.return = M),
                            (M = G));
                          break e;
                        }
                        i(M, E);
                        break;
                      } else t(M, E);
                      E = E.sibling;
                    }
                    C.type === _
                      ? ((G = qi(C.props.children, M.mode, G, C.key)),
                        (G.return = M),
                        (M = G))
                      : ((G = Tl(C.type, C.key, C.props, null, M.mode, G)),
                        Ca(G, C),
                        (G.return = M),
                        (M = G));
                  }
                  return m(M);
                case T:
                  e: {
                    for (te = C.key; E !== null; ) {
                      if (E.key === te)
                        if (
                          E.tag === 4 &&
                          E.stateNode.containerInfo === C.containerInfo &&
                          E.stateNode.implementation === C.implementation
                        ) {
                          (i(M, E.sibling),
                            (G = o(E, C.children || [])),
                            (G.return = M),
                            (M = G));
                          break e;
                        } else {
                          i(M, E);
                          break;
                        }
                      else t(M, E);
                      E = E.sibling;
                    }
                    ((G = hr(C, M.mode, G)), (G.return = M), (M = G));
                  }
                  return m(M);
                case V:
                  return ((te = C._init), (C = te(C._payload)), Oe(M, E, C, G));
              }
              if (be(C)) return oe(M, E, C, G);
              if (ie(C)) {
                if (((te = ie(C)), typeof te != 'function'))
                  throw Error(r(150));
                return ((C = te.call(C)), se(M, E, C, G));
              }
              if (typeof C.then == 'function') return Oe(M, E, Gl(C), G);
              if (C.$$typeof === Y) return Oe(M, E, Al(M, C), G);
              Vl(M, C);
            }
            return (typeof C == 'string' && C !== '') ||
              typeof C == 'number' ||
              typeof C == 'bigint'
              ? ((C = '' + C),
                E !== null && E.tag === 6
                  ? (i(M, E.sibling), (G = o(E, C)), (G.return = M), (M = G))
                  : (i(M, E), (G = dr(C, M.mode, G)), (G.return = M), (M = G)),
                m(M))
              : i(M, E);
          }
          return function (M, E, C, G) {
            try {
              _a = 0;
              var te = Oe(M, E, C, G);
              return ((Dn = null), te);
            } catch (ae) {
              if (ae === ba || ae === _l) throw ae;
              var pe = gt(29, ae, null, M.mode);
              return ((pe.lanes = G), (pe.return = M), pe);
            } finally {
            }
          };
        }
        var Ln = Df(!0),
          Lf = Df(!1),
          Nt = j(null),
          Bt = null;
        function vi(e) {
          var t = e.alternate;
          (F(qe, qe.current & 1),
            F(Nt, e),
            Bt === null &&
              (t === null || Cn.current !== null || t.memoizedState !== null) &&
              (Bt = e));
        }
        function jf(e) {
          if (e.tag === 22) {
            if ((F(qe, qe.current), F(Nt, e), Bt === null)) {
              var t = e.alternate;
              t !== null && t.memoizedState !== null && (Bt = e);
            }
          } else yi();
        }
        function yi() {
          (F(qe, qe.current), F(Nt, Nt.current));
        }
        function Pt(e) {
          (P(Nt), Bt === e && (Bt = null), P(qe));
        }
        var qe = j(0);
        function Kl(e) {
          for (var t = e; t !== null; ) {
            if (t.tag === 13) {
              var i = t.memoizedState;
              if (
                i !== null &&
                ((i = i.dehydrated), i === null || i.data === '$?' || Ho(i))
              )
                return t;
            } else if (t.tag === 19 && t.memoizedProps.revealOrder !== void 0) {
              if ((t.flags & 128) !== 0) return t;
            } else if (t.child !== null) {
              ((t.child.return = t), (t = t.child));
              continue;
            }
            if (t === e) break;
            for (; t.sibling === null; ) {
              if (t.return === null || t.return === e) return null;
              t = t.return;
            }
            ((t.sibling.return = t.return), (t = t.sibling));
          }
          return null;
        }
        function Qr(e, t, i, n) {
          ((t = e.memoizedState),
            (i = i(n, t)),
            (i = i == null ? t : y({}, t, i)),
            (e.memoizedState = i),
            e.lanes === 0 && (e.updateQueue.baseState = i));
        }
        var Zr = {
          enqueueSetState: function (e, t, i) {
            e = e._reactInternals;
            var n = St(),
              o = pi(n);
            ((o.payload = t),
              i != null && (o.callback = i),
              (t = mi(e, o, n)),
              t !== null && (xt(t, e, n), xa(t, e, n)));
          },
          enqueueReplaceState: function (e, t, i) {
            e = e._reactInternals;
            var n = St(),
              o = pi(n);
            ((o.tag = 1),
              (o.payload = t),
              i != null && (o.callback = i),
              (t = mi(e, o, n)),
              t !== null && (xt(t, e, n), xa(t, e, n)));
          },
          enqueueForceUpdate: function (e, t) {
            e = e._reactInternals;
            var i = St(),
              n = pi(i);
            ((n.tag = 2),
              t != null && (n.callback = t),
              (t = mi(e, n, i)),
              t !== null && (xt(t, e, i), xa(t, e, i)));
          },
        };
        function Hf(e, t, i, n, o, c, m) {
          return (
            (e = e.stateNode),
            typeof e.shouldComponentUpdate == 'function'
              ? e.shouldComponentUpdate(n, c, m)
              : t.prototype && t.prototype.isPureReactComponent
                ? !fa(i, n) || !fa(o, c)
                : !0
          );
        }
        function Uf(e, t, i, n) {
          ((e = t.state),
            typeof t.componentWillReceiveProps == 'function' &&
              t.componentWillReceiveProps(i, n),
            typeof t.UNSAFE_componentWillReceiveProps == 'function' &&
              t.UNSAFE_componentWillReceiveProps(i, n),
            t.state !== e && Zr.enqueueReplaceState(t, t.state, null));
        }
        function Pi(e, t) {
          var i = t;
          if ('ref' in t) {
            i = {};
            for (var n in t) n !== 'ref' && (i[n] = t[n]);
          }
          if ((e = e.defaultProps)) {
            i === t && (i = y({}, i));
            for (var o in e) i[o] === void 0 && (i[o] = e[o]);
          }
          return i;
        }
        var ql =
          typeof reportError == 'function'
            ? reportError
            : function (e) {
                if (
                  typeof window == 'object' &&
                  typeof window.ErrorEvent == 'function'
                ) {
                  var t = new window.ErrorEvent('error', {
                    bubbles: !0,
                    cancelable: !0,
                    message:
                      typeof e == 'object' &&
                      e !== null &&
                      typeof e.message == 'string'
                        ? String(e.message)
                        : String(e),
                    error: e,
                  });
                  if (!window.dispatchEvent(t)) return;
                } else if (
                  typeof process == 'object' &&
                  typeof process.emit == 'function'
                ) {
                  process.emit('uncaughtException', e);
                  return;
                }
                console.error(e);
              };
        function Bf(e) {
          ql(e);
        }
        function Gf(e) {
          console.error(e);
        }
        function Vf(e) {
          ql(e);
        }
        function Yl(e, t) {
          try {
            var i = e.onUncaughtError;
            i(t.value, { componentStack: t.stack });
          } catch (n) {
            setTimeout(function () {
              throw n;
            });
          }
        }
        function Kf(e, t, i) {
          try {
            var n = e.onCaughtError;
            n(i.value, {
              componentStack: i.stack,
              errorBoundary: t.tag === 1 ? t.stateNode : null,
            });
          } catch (o) {
            setTimeout(function () {
              throw o;
            });
          }
        }
        function kr(e, t, i) {
          return (
            (i = pi(i)),
            (i.tag = 3),
            (i.payload = { element: null }),
            (i.callback = function () {
              Yl(e, t);
            }),
            i
          );
        }
        function qf(e) {
          return ((e = pi(e)), (e.tag = 3), e);
        }
        function Yf(e, t, i, n) {
          var o = i.type.getDerivedStateFromError;
          if (typeof o == 'function') {
            var c = n.value;
            ((e.payload = function () {
              return o(c);
            }),
              (e.callback = function () {
                Kf(t, i, n);
              }));
          }
          var m = i.stateNode;
          m !== null &&
            typeof m.componentDidCatch == 'function' &&
            (e.callback = function () {
              (Kf(t, i, n),
                typeof o != 'function' &&
                  (wi === null ? (wi = new Set([this])) : wi.add(this)));
              var v = n.stack;
              this.componentDidCatch(n.value, {
                componentStack: v !== null ? v : '',
              });
            });
        }
        function Rg(e, t, i, n, o) {
          if (
            ((i.flags |= 32768),
            n !== null && typeof n == 'object' && typeof n.then == 'function')
          ) {
            if (
              ((t = i.alternate),
              t !== null && ga(t, i, o, !0),
              (i = Nt.current),
              i !== null)
            ) {
              switch (i.tag) {
                case 13:
                  return (
                    Bt === null
                      ? bo()
                      : i.alternate === null && je === 0 && (je = 3),
                    (i.flags &= -257),
                    (i.flags |= 65536),
                    (i.lanes = o),
                    n === Er
                      ? (i.flags |= 16384)
                      : ((t = i.updateQueue),
                        t === null ? (i.updateQueue = new Set([n])) : t.add(n),
                        xo(e, n, o)),
                    !1
                  );
                case 22:
                  return (
                    (i.flags |= 65536),
                    n === Er
                      ? (i.flags |= 16384)
                      : ((t = i.updateQueue),
                        t === null
                          ? ((t = {
                              transitions: null,
                              markerInstances: null,
                              retryQueue: new Set([n]),
                            }),
                            (i.updateQueue = t))
                          : ((i = t.retryQueue),
                            i === null
                              ? (t.retryQueue = new Set([n]))
                              : i.add(n)),
                        xo(e, n, o)),
                    !1
                  );
              }
              throw Error(r(435, i.tag));
            }
            return (xo(e, n, o), bo(), !1);
          }
          if (Te)
            return (
              (t = Nt.current),
              t !== null
                ? ((t.flags & 65536) === 0 && (t.flags |= 256),
                  (t.flags |= 65536),
                  (t.lanes = o),
                  n !== gr && ((e = Error(r(422), { cause: n })), ma(At(e, i))))
                : (n !== gr &&
                    ((t = Error(r(423), { cause: n })), ma(At(t, i))),
                  (e = e.current.alternate),
                  (e.flags |= 65536),
                  (o &= -o),
                  (e.lanes |= o),
                  (n = At(n, i)),
                  (o = kr(e.stateNode, n, o)),
                  Ar(e, o),
                  je !== 4 && (je = 2)),
              !1
            );
          var c = Error(r(520), { cause: n });
          if (
            ((c = At(c, i)),
            Ha === null ? (Ha = [c]) : Ha.push(c),
            je !== 4 && (je = 2),
            t === null)
          )
            return !0;
          ((n = At(n, i)), (i = t));
          do {
            switch (i.tag) {
              case 3:
                return (
                  (i.flags |= 65536),
                  (e = o & -o),
                  (i.lanes |= e),
                  (e = kr(i.stateNode, n, e)),
                  Ar(i, e),
                  !1
                );
              case 1:
                if (
                  ((t = i.type),
                  (c = i.stateNode),
                  (i.flags & 128) === 0 &&
                    (typeof t.getDerivedStateFromError == 'function' ||
                      (c !== null &&
                        typeof c.componentDidCatch == 'function' &&
                        (wi === null || !wi.has(c)))))
                )
                  return (
                    (i.flags |= 65536),
                    (o &= -o),
                    (i.lanes |= o),
                    (o = qf(o)),
                    Yf(o, e, i, n),
                    Ar(i, o),
                    !1
                  );
            }
            i = i.return;
          } while (i !== null);
          return !1;
        }
        var $f = Error(r(461)),
          Xe = !1;
        function Fe(e, t, i, n) {
          t.child = e === null ? Lf(t, null, i, n) : Ln(t, e.child, i, n);
        }
        function Xf(e, t, i, n, o) {
          i = i.render;
          var c = t.ref;
          if ('ref' in n) {
            var m = {};
            for (var v in n) v !== 'ref' && (m[v] = n[v]);
          } else m = n;
          return (
            ki(t),
            (n = zr(e, t, i, m, c, o)),
            (v = Rr()),
            e !== null && !Xe
              ? (Dr(e, t, o), It(e, t, o))
              : (Te && v && pr(t), (t.flags |= 1), Fe(e, t, n, o), t.child)
          );
        }
        function Qf(e, t, i, n, o) {
          if (e === null) {
            var c = i.type;
            return typeof c == 'function' &&
              !fr(c) &&
              c.defaultProps === void 0 &&
              i.compare === null
              ? ((t.tag = 15), (t.type = c), Zf(e, t, c, n, o))
              : ((e = Tl(i.type, null, n, t, t.mode, o)),
                (e.ref = t.ref),
                (e.return = t),
                (t.child = e));
          }
          if (((c = e.child), !io(e, o))) {
            var m = c.memoizedProps;
            if (
              ((i = i.compare),
              (i = i !== null ? i : fa),
              i(m, n) && e.ref === t.ref)
            )
              return It(e, t, o);
          }
          return (
            (t.flags |= 1),
            (e = Xt(c, n)),
            (e.ref = t.ref),
            (e.return = t),
            (t.child = e)
          );
        }
        function Zf(e, t, i, n, o) {
          if (e !== null) {
            var c = e.memoizedProps;
            if (fa(c, n) && e.ref === t.ref)
              if (((Xe = !1), (t.pendingProps = n = c), io(e, o)))
                (e.flags & 131072) !== 0 && (Xe = !0);
              else return ((t.lanes = e.lanes), It(e, t, o));
          }
          return Jr(e, t, i, n, o);
        }
        function kf(e, t, i) {
          var n = t.pendingProps,
            o = n.children,
            c = e !== null ? e.memoizedState : null;
          if (n.mode === 'hidden') {
            if ((t.flags & 128) !== 0) {
              if (((n = c !== null ? c.baseLanes | i : i), e !== null)) {
                for (o = t.child = e.child, c = 0; o !== null; )
                  ((c = c | o.lanes | o.childLanes), (o = o.sibling));
                t.childLanes = c & ~n;
              } else ((t.childLanes = 0), (t.child = null));
              return Jf(e, t, n, i);
            }
            if ((i & 536870912) !== 0)
              ((t.memoizedState = { baseLanes: 0, cachePool: null }),
                e !== null && Ol(t, c !== null ? c.cachePool : null),
                c !== null ? Qc(t, c) : _r(),
                jf(t));
            else
              return (
                (t.lanes = t.childLanes = 536870912),
                Jf(e, t, c !== null ? c.baseLanes | i : i, i)
              );
          } else
            c !== null
              ? (Ol(t, c.cachePool), Qc(t, c), yi(), (t.memoizedState = null))
              : (e !== null && Ol(t, null), _r(), yi());
          return (Fe(e, t, o, i), t.child);
        }
        function Jf(e, t, i, n) {
          var o = Tr();
          return (
            (o = o === null ? null : { parent: Ke._currentValue, pool: o }),
            (t.memoizedState = { baseLanes: i, cachePool: o }),
            e !== null && Ol(t, null),
            _r(),
            jf(t),
            e !== null && ga(e, t, n, !0),
            null
          );
        }
        function $l(e, t) {
          var i = t.ref;
          if (i === null) e !== null && e.ref !== null && (t.flags |= 4194816);
          else {
            if (typeof i != 'function' && typeof i != 'object')
              throw Error(r(284));
            (e === null || e.ref !== i) && (t.flags |= 4194816);
          }
        }
        function Jr(e, t, i, n, o) {
          return (
            ki(t),
            (i = zr(e, t, i, n, void 0, o)),
            (n = Rr()),
            e !== null && !Xe
              ? (Dr(e, t, o), It(e, t, o))
              : (Te && n && pr(t), (t.flags |= 1), Fe(e, t, i, o), t.child)
          );
        }
        function Ff(e, t, i, n, o, c) {
          return (
            ki(t),
            (t.updateQueue = null),
            (i = kc(t, n, i, o)),
            Zc(e),
            (n = Rr()),
            e !== null && !Xe
              ? (Dr(e, t, c), It(e, t, c))
              : (Te && n && pr(t), (t.flags |= 1), Fe(e, t, i, c), t.child)
          );
        }
        function Pf(e, t, i, n, o) {
          if ((ki(t), t.stateNode === null)) {
            var c = wn,
              m = i.contextType;
            (typeof m == 'object' && m !== null && (c = et(m)),
              (c = new i(n, c)),
              (t.memoizedState =
                c.state !== null && c.state !== void 0 ? c.state : null),
              (c.updater = Zr),
              (t.stateNode = c),
              (c._reactInternals = t),
              (c = t.stateNode),
              (c.props = n),
              (c.state = t.memoizedState),
              (c.refs = {}),
              wr(t),
              (m = i.contextType),
              (c.context = typeof m == 'object' && m !== null ? et(m) : wn),
              (c.state = t.memoizedState),
              (m = i.getDerivedStateFromProps),
              typeof m == 'function' &&
                (Qr(t, i, m, n), (c.state = t.memoizedState)),
              typeof i.getDerivedStateFromProps == 'function' ||
                typeof c.getSnapshotBeforeUpdate == 'function' ||
                (typeof c.UNSAFE_componentWillMount != 'function' &&
                  typeof c.componentWillMount != 'function') ||
                ((m = c.state),
                typeof c.componentWillMount == 'function' &&
                  c.componentWillMount(),
                typeof c.UNSAFE_componentWillMount == 'function' &&
                  c.UNSAFE_componentWillMount(),
                m !== c.state && Zr.enqueueReplaceState(c, c.state, null),
                Ea(t, n, c, o),
                Ta(),
                (c.state = t.memoizedState)),
              typeof c.componentDidMount == 'function' && (t.flags |= 4194308),
              (n = !0));
          } else if (e === null) {
            c = t.stateNode;
            var v = t.memoizedProps,
              S = Pi(i, v);
            c.props = S;
            var N = c.context,
              H = i.contextType;
            ((m = wn), typeof H == 'object' && H !== null && (m = et(H)));
            var K = i.getDerivedStateFromProps;
            ((H =
              typeof K == 'function' ||
              typeof c.getSnapshotBeforeUpdate == 'function'),
              (v = t.pendingProps !== v),
              H ||
                (typeof c.UNSAFE_componentWillReceiveProps != 'function' &&
                  typeof c.componentWillReceiveProps != 'function') ||
                ((v || N !== m) && Uf(t, c, n, m)),
              (hi = !1));
            var z = t.memoizedState;
            ((c.state = z),
              Ea(t, n, c, o),
              Ta(),
              (N = t.memoizedState),
              v || z !== N || hi
                ? (typeof K == 'function' &&
                    (Qr(t, i, K, n), (N = t.memoizedState)),
                  (S = hi || Hf(t, i, S, n, z, N, m))
                    ? (H ||
                        (typeof c.UNSAFE_componentWillMount != 'function' &&
                          typeof c.componentWillMount != 'function') ||
                        (typeof c.componentWillMount == 'function' &&
                          c.componentWillMount(),
                        typeof c.UNSAFE_componentWillMount == 'function' &&
                          c.UNSAFE_componentWillMount()),
                      typeof c.componentDidMount == 'function' &&
                        (t.flags |= 4194308))
                    : (typeof c.componentDidMount == 'function' &&
                        (t.flags |= 4194308),
                      (t.memoizedProps = n),
                      (t.memoizedState = N)),
                  (c.props = n),
                  (c.state = N),
                  (c.context = m),
                  (n = S))
                : (typeof c.componentDidMount == 'function' &&
                    (t.flags |= 4194308),
                  (n = !1)));
          } else {
            ((c = t.stateNode),
              Mr(e, t),
              (m = t.memoizedProps),
              (H = Pi(i, m)),
              (c.props = H),
              (K = t.pendingProps),
              (z = c.context),
              (N = i.contextType),
              (S = wn),
              typeof N == 'object' && N !== null && (S = et(N)),
              (v = i.getDerivedStateFromProps),
              (N =
                typeof v == 'function' ||
                typeof c.getSnapshotBeforeUpdate == 'function') ||
                (typeof c.UNSAFE_componentWillReceiveProps != 'function' &&
                  typeof c.componentWillReceiveProps != 'function') ||
                ((m !== K || z !== S) && Uf(t, c, n, S)),
              (hi = !1),
              (z = t.memoizedState),
              (c.state = z),
              Ea(t, n, c, o),
              Ta());
            var R = t.memoizedState;
            m !== K ||
            z !== R ||
            hi ||
            (e !== null && e.dependencies !== null && Ml(e.dependencies))
              ? (typeof v == 'function' &&
                  (Qr(t, i, v, n), (R = t.memoizedState)),
                (H =
                  hi ||
                  Hf(t, i, H, n, z, R, S) ||
                  (e !== null && e.dependencies !== null && Ml(e.dependencies)))
                  ? (N ||
                      (typeof c.UNSAFE_componentWillUpdate != 'function' &&
                        typeof c.componentWillUpdate != 'function') ||
                      (typeof c.componentWillUpdate == 'function' &&
                        c.componentWillUpdate(n, R, S),
                      typeof c.UNSAFE_componentWillUpdate == 'function' &&
                        c.UNSAFE_componentWillUpdate(n, R, S)),
                    typeof c.componentDidUpdate == 'function' && (t.flags |= 4),
                    typeof c.getSnapshotBeforeUpdate == 'function' &&
                      (t.flags |= 1024))
                  : (typeof c.componentDidUpdate != 'function' ||
                      (m === e.memoizedProps && z === e.memoizedState) ||
                      (t.flags |= 4),
                    typeof c.getSnapshotBeforeUpdate != 'function' ||
                      (m === e.memoizedProps && z === e.memoizedState) ||
                      (t.flags |= 1024),
                    (t.memoizedProps = n),
                    (t.memoizedState = R)),
                (c.props = n),
                (c.state = R),
                (c.context = S),
                (n = H))
              : (typeof c.componentDidUpdate != 'function' ||
                  (m === e.memoizedProps && z === e.memoizedState) ||
                  (t.flags |= 4),
                typeof c.getSnapshotBeforeUpdate != 'function' ||
                  (m === e.memoizedProps && z === e.memoizedState) ||
                  (t.flags |= 1024),
                (n = !1));
          }
          return (
            (c = n),
            $l(e, t),
            (n = (t.flags & 128) !== 0),
            c || n
              ? ((c = t.stateNode),
                (i =
                  n && typeof i.getDerivedStateFromError != 'function'
                    ? null
                    : c.render()),
                (t.flags |= 1),
                e !== null && n
                  ? ((t.child = Ln(t, e.child, null, o)),
                    (t.child = Ln(t, null, i, o)))
                  : Fe(e, t, i, o),
                (t.memoizedState = c.state),
                (e = t.child))
              : (e = It(e, t, o)),
            e
          );
        }
        function If(e, t, i, n) {
          return (pa(), (t.flags |= 256), Fe(e, t, i, n), t.child);
        }
        var Fr = {
          dehydrated: null,
          treeContext: null,
          retryLane: 0,
          hydrationErrors: null,
        };
        function Pr(e) {
          return { baseLanes: e, cachePool: Bc() };
        }
        function Ir(e, t, i) {
          return ((e = e !== null ? e.childLanes & ~i : 0), t && (e |= zt), e);
        }
        function Wf(e, t, i) {
          var n = t.pendingProps,
            o = !1,
            c = (t.flags & 128) !== 0,
            m;
          if (
            ((m = c) ||
              (m =
                e !== null && e.memoizedState === null
                  ? !1
                  : (qe.current & 2) !== 0),
            m && ((o = !0), (t.flags &= -129)),
            (m = (t.flags & 32) !== 0),
            (t.flags &= -33),
            e === null)
          ) {
            if (Te) {
              if ((o ? vi(t) : yi(), Te)) {
                var v = Le,
                  S;
                if ((S = v)) {
                  e: {
                    for (S = v, v = Ut; S.nodeType !== 8; ) {
                      if (!v) {
                        v = null;
                        break e;
                      }
                      if (((S = jt(S.nextSibling)), S === null)) {
                        v = null;
                        break e;
                      }
                    }
                    v = S;
                  }
                  v !== null
                    ? ((t.memoizedState = {
                        dehydrated: v,
                        treeContext:
                          Yi !== null ? { id: Qt, overflow: Zt } : null,
                        retryLane: 536870912,
                        hydrationErrors: null,
                      }),
                      (S = gt(18, null, null, 0)),
                      (S.stateNode = v),
                      (S.return = t),
                      (t.child = S),
                      (it = t),
                      (Le = null),
                      (S = !0))
                    : (S = !1);
                }
                S || Qi(t);
              }
              if (
                ((v = t.memoizedState),
                v !== null && ((v = v.dehydrated), v !== null))
              )
                return (Ho(v) ? (t.lanes = 32) : (t.lanes = 536870912), null);
              Pt(t);
            }
            return (
              (v = n.children),
              (n = n.fallback),
              o
                ? (yi(),
                  (o = t.mode),
                  (v = Xl({ mode: 'hidden', children: v }, o)),
                  (n = qi(n, o, i, null)),
                  (v.return = t),
                  (n.return = t),
                  (v.sibling = n),
                  (t.child = v),
                  (o = t.child),
                  (o.memoizedState = Pr(i)),
                  (o.childLanes = Ir(e, m, i)),
                  (t.memoizedState = Fr),
                  n)
                : (vi(t), Wr(t, v))
            );
          }
          if (
            ((S = e.memoizedState),
            S !== null && ((v = S.dehydrated), v !== null))
          ) {
            if (c)
              t.flags & 256
                ? (vi(t), (t.flags &= -257), (t = eo(e, t, i)))
                : t.memoizedState !== null
                  ? (yi(), (t.child = e.child), (t.flags |= 128), (t = null))
                  : (yi(),
                    (o = n.fallback),
                    (v = t.mode),
                    (n = Xl({ mode: 'visible', children: n.children }, v)),
                    (o = qi(o, v, i, null)),
                    (o.flags |= 2),
                    (n.return = t),
                    (o.return = t),
                    (n.sibling = o),
                    (t.child = n),
                    Ln(t, e.child, null, i),
                    (n = t.child),
                    (n.memoizedState = Pr(i)),
                    (n.childLanes = Ir(e, m, i)),
                    (t.memoizedState = Fr),
                    (t = o));
            else if ((vi(t), Ho(v))) {
              if (((m = v.nextSibling && v.nextSibling.dataset), m))
                var N = m.dgst;
              ((m = N),
                (n = Error(r(419))),
                (n.stack = ''),
                (n.digest = m),
                ma({ value: n, source: null, stack: null }),
                (t = eo(e, t, i)));
            } else if (
              (Xe || ga(e, t, i, !1), (m = (i & e.childLanes) !== 0), Xe || m)
            ) {
              if (
                ((m = Ne),
                m !== null &&
                  ((n = i & -i),
                  (n = (n & 42) !== 0 ? 1 : Hs(n)),
                  (n = (n & (m.suspendedLanes | i)) !== 0 ? 0 : n),
                  n !== 0 && n !== S.retryLane))
              )
                throw ((S.retryLane = n), En(e, n), xt(m, e, n), $f);
              (v.data === '$?' || bo(), (t = eo(e, t, i)));
            } else
              v.data === '$?'
                ? ((t.flags |= 192), (t.child = e.child), (t = null))
                : ((e = S.treeContext),
                  (Le = jt(v.nextSibling)),
                  (it = t),
                  (Te = !0),
                  (Xi = null),
                  (Ut = !1),
                  e !== null &&
                    ((_t[Ct++] = Qt),
                    (_t[Ct++] = Zt),
                    (_t[Ct++] = Yi),
                    (Qt = e.id),
                    (Zt = e.overflow),
                    (Yi = t)),
                  (t = Wr(t, n.children)),
                  (t.flags |= 4096));
            return t;
          }
          return o
            ? (yi(),
              (o = n.fallback),
              (v = t.mode),
              (S = e.child),
              (N = S.sibling),
              (n = Xt(S, { mode: 'hidden', children: n.children })),
              (n.subtreeFlags = S.subtreeFlags & 65011712),
              N !== null
                ? (o = Xt(N, o))
                : ((o = qi(o, v, i, null)), (o.flags |= 2)),
              (o.return = t),
              (n.return = t),
              (n.sibling = o),
              (t.child = n),
              (n = o),
              (o = t.child),
              (v = e.child.memoizedState),
              v === null
                ? (v = Pr(i))
                : ((S = v.cachePool),
                  S !== null
                    ? ((N = Ke._currentValue),
                      (S = S.parent !== N ? { parent: N, pool: N } : S))
                    : (S = Bc()),
                  (v = { baseLanes: v.baseLanes | i, cachePool: S })),
              (o.memoizedState = v),
              (o.childLanes = Ir(e, m, i)),
              (t.memoizedState = Fr),
              n)
            : (vi(t),
              (i = e.child),
              (e = i.sibling),
              (i = Xt(i, { mode: 'visible', children: n.children })),
              (i.return = t),
              (i.sibling = null),
              e !== null &&
                ((m = t.deletions),
                m === null
                  ? ((t.deletions = [e]), (t.flags |= 16))
                  : m.push(e)),
              (t.child = i),
              (t.memoizedState = null),
              i);
        }
        function Wr(e, t) {
          return (
            (t = Xl({ mode: 'visible', children: t }, e.mode)),
            (t.return = e),
            (e.child = t)
          );
        }
        function Xl(e, t) {
          return (
            (e = gt(22, e, null, t)),
            (e.lanes = 0),
            (e.stateNode = {
              _visibility: 1,
              _pendingMarkers: null,
              _retryCache: null,
              _transitions: null,
            }),
            e
          );
        }
        function eo(e, t, i) {
          return (
            Ln(t, e.child, null, i),
            (e = Wr(t, t.pendingProps.children)),
            (e.flags |= 2),
            (t.memoizedState = null),
            e
          );
        }
        function ed(e, t, i) {
          e.lanes |= t;
          var n = e.alternate;
          (n !== null && (n.lanes |= t), yr(e.return, t, i));
        }
        function to(e, t, i, n, o) {
          var c = e.memoizedState;
          c === null
            ? (e.memoizedState = {
                isBackwards: t,
                rendering: null,
                renderingStartTime: 0,
                last: n,
                tail: i,
                tailMode: o,
              })
            : ((c.isBackwards = t),
              (c.rendering = null),
              (c.renderingStartTime = 0),
              (c.last = n),
              (c.tail = i),
              (c.tailMode = o));
        }
        function td(e, t, i) {
          var n = t.pendingProps,
            o = n.revealOrder,
            c = n.tail;
          if ((Fe(e, t, n.children, i), (n = qe.current), (n & 2) !== 0))
            ((n = (n & 1) | 2), (t.flags |= 128));
          else {
            if (e !== null && (e.flags & 128) !== 0)
              e: for (e = t.child; e !== null; ) {
                if (e.tag === 13) e.memoizedState !== null && ed(e, i, t);
                else if (e.tag === 19) ed(e, i, t);
                else if (e.child !== null) {
                  ((e.child.return = e), (e = e.child));
                  continue;
                }
                if (e === t) break e;
                for (; e.sibling === null; ) {
                  if (e.return === null || e.return === t) break e;
                  e = e.return;
                }
                ((e.sibling.return = e.return), (e = e.sibling));
              }
            n &= 1;
          }
          switch ((F(qe, n), o)) {
            case 'forwards':
              for (i = t.child, o = null; i !== null; )
                ((e = i.alternate),
                  e !== null && Kl(e) === null && (o = i),
                  (i = i.sibling));
              ((i = o),
                i === null
                  ? ((o = t.child), (t.child = null))
                  : ((o = i.sibling), (i.sibling = null)),
                to(t, !1, o, i, c));
              break;
            case 'backwards':
              for (i = null, o = t.child, t.child = null; o !== null; ) {
                if (((e = o.alternate), e !== null && Kl(e) === null)) {
                  t.child = o;
                  break;
                }
                ((e = o.sibling), (o.sibling = i), (i = o), (o = e));
              }
              to(t, !0, i, null, c);
              break;
            case 'together':
              to(t, !1, null, null, void 0);
              break;
            default:
              t.memoizedState = null;
          }
          return t.child;
        }
        function It(e, t, i) {
          if (
            (e !== null && (t.dependencies = e.dependencies),
            (Ei |= t.lanes),
            (i & t.childLanes) === 0)
          )
            if (e !== null) {
              if ((ga(e, t, i, !1), (i & t.childLanes) === 0)) return null;
            } else return null;
          if (e !== null && t.child !== e.child) throw Error(r(153));
          if (t.child !== null) {
            for (
              e = t.child, i = Xt(e, e.pendingProps), t.child = i, i.return = t;
              e.sibling !== null;
            )
              ((e = e.sibling),
                (i = i.sibling = Xt(e, e.pendingProps)),
                (i.return = t));
            i.sibling = null;
          }
          return t.child;
        }
        function io(e, t) {
          return (e.lanes & t) !== 0
            ? !0
            : ((e = e.dependencies), !!(e !== null && Ml(e)));
        }
        function Dg(e, t, i) {
          switch (t.tag) {
            case 3:
              (ze(t, t.stateNode.containerInfo),
                di(t, Ke, e.memoizedState.cache),
                pa());
              break;
            case 27:
            case 5:
              zs(t);
              break;
            case 4:
              ze(t, t.stateNode.containerInfo);
              break;
            case 10:
              di(t, t.type, t.memoizedProps.value);
              break;
            case 13:
              var n = t.memoizedState;
              if (n !== null)
                return n.dehydrated !== null
                  ? (vi(t), (t.flags |= 128), null)
                  : (i & t.child.childLanes) !== 0
                    ? Wf(e, t, i)
                    : (vi(t), (e = It(e, t, i)), e !== null ? e.sibling : null);
              vi(t);
              break;
            case 19:
              var o = (e.flags & 128) !== 0;
              if (
                ((n = (i & t.childLanes) !== 0),
                n || (ga(e, t, i, !1), (n = (i & t.childLanes) !== 0)),
                o)
              ) {
                if (n) return td(e, t, i);
                t.flags |= 128;
              }
              if (
                ((o = t.memoizedState),
                o !== null &&
                  ((o.rendering = null),
                  (o.tail = null),
                  (o.lastEffect = null)),
                F(qe, qe.current),
                n)
              )
                break;
              return null;
            case 22:
            case 23:
              return ((t.lanes = 0), kf(e, t, i));
            case 24:
              di(t, Ke, e.memoizedState.cache);
          }
          return It(e, t, i);
        }
        function id(e, t, i) {
          if (e !== null)
            if (e.memoizedProps !== t.pendingProps) Xe = !0;
            else {
              if (!io(e, i) && (t.flags & 128) === 0)
                return ((Xe = !1), Dg(e, t, i));
              Xe = (e.flags & 131072) !== 0;
            }
          else
            ((Xe = !1), Te && (t.flags & 1048576) !== 0 && zc(t, wl, t.index));
          switch (((t.lanes = 0), t.tag)) {
            case 16:
              e: {
                e = t.pendingProps;
                var n = t.elementType,
                  o = n._init;
                if (((n = o(n._payload)), (t.type = n), typeof n == 'function'))
                  fr(n)
                    ? ((e = Pi(n, e)), (t.tag = 1), (t = Pf(null, t, n, e, i)))
                    : ((t.tag = 0), (t = Jr(null, t, n, e, i)));
                else {
                  if (n != null) {
                    if (((o = n.$$typeof), o === X)) {
                      ((t.tag = 11), (t = Xf(null, t, n, e, i)));
                      break e;
                    } else if (o === k) {
                      ((t.tag = 14), (t = Qf(null, t, n, e, i)));
                      break e;
                    }
                  }
                  throw ((t = ve(n) || n), Error(r(306, t, '')));
                }
              }
              return t;
            case 0:
              return Jr(e, t, t.type, t.pendingProps, i);
            case 1:
              return (
                (n = t.type),
                (o = Pi(n, t.pendingProps)),
                Pf(e, t, n, o, i)
              );
            case 3:
              e: {
                if ((ze(t, t.stateNode.containerInfo), e === null))
                  throw Error(r(387));
                n = t.pendingProps;
                var c = t.memoizedState;
                ((o = c.element), Mr(e, t), Ea(t, n, null, i));
                var m = t.memoizedState;
                if (
                  ((n = m.cache),
                  di(t, Ke, n),
                  n !== c.cache && br(t, [Ke], i, !0),
                  Ta(),
                  (n = m.element),
                  c.isDehydrated)
                )
                  if (
                    ((c = { element: n, isDehydrated: !1, cache: m.cache }),
                    (t.updateQueue.baseState = c),
                    (t.memoizedState = c),
                    t.flags & 256)
                  ) {
                    t = If(e, t, n, i);
                    break e;
                  } else if (n !== o) {
                    ((o = At(Error(r(424)), t)), ma(o), (t = If(e, t, n, i)));
                    break e;
                  } else {
                    switch (((e = t.stateNode.containerInfo), e.nodeType)) {
                      case 9:
                        e = e.body;
                        break;
                      default:
                        e = e.nodeName === 'HTML' ? e.ownerDocument.body : e;
                    }
                    for (
                      Le = jt(e.firstChild),
                        it = t,
                        Te = !0,
                        Xi = null,
                        Ut = !0,
                        i = Lf(t, null, n, i),
                        t.child = i;
                      i;
                    )
                      ((i.flags = (i.flags & -3) | 4096), (i = i.sibling));
                  }
                else {
                  if ((pa(), n === o)) {
                    t = It(e, t, i);
                    break e;
                  }
                  Fe(e, t, n, i);
                }
                t = t.child;
              }
              return t;
            case 26:
              return (
                $l(e, t),
                e === null
                  ? (i = sh(t.type, null, t.pendingProps, null))
                    ? (t.memoizedState = i)
                    : Te ||
                      ((i = t.type),
                      (e = t.pendingProps),
                      (n = ls(ce.current).createElement(i)),
                      (n[We] = t),
                      (n[lt] = e),
                      Ie(n, i, e),
                      $e(n),
                      (t.stateNode = n))
                  : (t.memoizedState = sh(
                      t.type,
                      e.memoizedProps,
                      t.pendingProps,
                      e.memoizedState
                    )),
                null
              );
            case 27:
              return (
                zs(t),
                e === null &&
                  Te &&
                  ((n = t.stateNode = nh(t.type, t.pendingProps, ce.current)),
                  (it = t),
                  (Ut = !0),
                  (o = Le),
                  Oi(t.type) ? ((Uo = o), (Le = jt(n.firstChild))) : (Le = o)),
                Fe(e, t, t.pendingProps.children, i),
                $l(e, t),
                e === null && (t.flags |= 4194304),
                t.child
              );
            case 5:
              return (
                e === null &&
                  Te &&
                  ((o = n = Le) &&
                    ((n = rv(n, t.type, t.pendingProps, Ut)),
                    n !== null
                      ? ((t.stateNode = n),
                        (it = t),
                        (Le = jt(n.firstChild)),
                        (Ut = !1),
                        (o = !0))
                      : (o = !1)),
                  o || Qi(t)),
                zs(t),
                (o = t.type),
                (c = t.pendingProps),
                (m = e !== null ? e.memoizedProps : null),
                (n = c.children),
                Do(o, c)
                  ? (n = null)
                  : m !== null && Do(o, m) && (t.flags |= 32),
                t.memoizedState !== null &&
                  ((o = zr(e, t, Mg, null, null, i)), (Xa._currentValue = o)),
                $l(e, t),
                Fe(e, t, n, i),
                t.child
              );
            case 6:
              return (
                e === null &&
                  Te &&
                  ((e = i = Le) &&
                    ((i = ov(i, t.pendingProps, Ut)),
                    i !== null
                      ? ((t.stateNode = i), (it = t), (Le = null), (e = !0))
                      : (e = !1)),
                  e || Qi(t)),
                null
              );
            case 13:
              return Wf(e, t, i);
            case 4:
              return (
                ze(t, t.stateNode.containerInfo),
                (n = t.pendingProps),
                e === null ? (t.child = Ln(t, null, n, i)) : Fe(e, t, n, i),
                t.child
              );
            case 11:
              return Xf(e, t, t.type, t.pendingProps, i);
            case 7:
              return (Fe(e, t, t.pendingProps, i), t.child);
            case 8:
              return (Fe(e, t, t.pendingProps.children, i), t.child);
            case 12:
              return (Fe(e, t, t.pendingProps.children, i), t.child);
            case 10:
              return (
                (n = t.pendingProps),
                di(t, t.type, n.value),
                Fe(e, t, n.children, i),
                t.child
              );
            case 9:
              return (
                (o = t.type._context),
                (n = t.pendingProps.children),
                ki(t),
                (o = et(o)),
                (n = n(o)),
                (t.flags |= 1),
                Fe(e, t, n, i),
                t.child
              );
            case 14:
              return Qf(e, t, t.type, t.pendingProps, i);
            case 15:
              return Zf(e, t, t.type, t.pendingProps, i);
            case 19:
              return td(e, t, i);
            case 31:
              return (
                (n = t.pendingProps),
                (i = t.mode),
                (n = { mode: n.mode, children: n.children }),
                e === null
                  ? ((i = Xl(n, i)),
                    (i.ref = t.ref),
                    (t.child = i),
                    (i.return = t),
                    (t = i))
                  : ((i = Xt(e.child, n)),
                    (i.ref = t.ref),
                    (t.child = i),
                    (i.return = t),
                    (t = i)),
                t
              );
            case 22:
              return kf(e, t, i);
            case 24:
              return (
                ki(t),
                (n = et(Ke)),
                e === null
                  ? ((o = Tr()),
                    o === null &&
                      ((o = Ne),
                      (c = Sr()),
                      (o.pooledCache = c),
                      c.refCount++,
                      c !== null && (o.pooledCacheLanes |= i),
                      (o = c)),
                    (t.memoizedState = { parent: n, cache: o }),
                    wr(t),
                    di(t, Ke, o))
                  : ((e.lanes & i) !== 0 &&
                      (Mr(e, t), Ea(t, null, null, i), Ta()),
                    (o = e.memoizedState),
                    (c = t.memoizedState),
                    o.parent !== n
                      ? ((o = { parent: n, cache: n }),
                        (t.memoizedState = o),
                        t.lanes === 0 &&
                          (t.memoizedState = t.updateQueue.baseState = o),
                        di(t, Ke, n))
                      : ((n = c.cache),
                        di(t, Ke, n),
                        n !== o.cache && br(t, [Ke], i, !0))),
                Fe(e, t, t.pendingProps.children, i),
                t.child
              );
            case 29:
              throw t.pendingProps;
          }
          throw Error(r(156, t.tag));
        }
        function Wt(e) {
          e.flags |= 4;
        }
        function nd(e, t) {
          if (t.type !== 'stylesheet' || (t.state.loading & 4) !== 0)
            e.flags &= -16777217;
          else if (((e.flags |= 16777216), !fh(t))) {
            if (
              ((t = Nt.current),
              t !== null &&
                ((ye & 4194048) === ye
                  ? Bt !== null
                  : ((ye & 62914560) !== ye && (ye & 536870912) === 0) ||
                    t !== Bt))
            )
              throw ((Sa = Er), Gc);
            e.flags |= 8192;
          }
        }
        function Ql(e, t) {
          (t !== null && (e.flags |= 4),
            e.flags & 16384 &&
              ((t = e.tag !== 22 ? Lu() : 536870912),
              (e.lanes |= t),
              (Bn |= t)));
        }
        function Na(e, t) {
          if (!Te)
            switch (e.tailMode) {
              case 'hidden':
                t = e.tail;
                for (var i = null; t !== null; )
                  (t.alternate !== null && (i = t), (t = t.sibling));
                i === null ? (e.tail = null) : (i.sibling = null);
                break;
              case 'collapsed':
                i = e.tail;
                for (var n = null; i !== null; )
                  (i.alternate !== null && (n = i), (i = i.sibling));
                n === null
                  ? t || e.tail === null
                    ? (e.tail = null)
                    : (e.tail.sibling = null)
                  : (n.sibling = null);
            }
        }
        function De(e) {
          var t = e.alternate !== null && e.alternate.child === e.child,
            i = 0,
            n = 0;
          if (t)
            for (var o = e.child; o !== null; )
              ((i |= o.lanes | o.childLanes),
                (n |= o.subtreeFlags & 65011712),
                (n |= o.flags & 65011712),
                (o.return = e),
                (o = o.sibling));
          else
            for (o = e.child; o !== null; )
              ((i |= o.lanes | o.childLanes),
                (n |= o.subtreeFlags),
                (n |= o.flags),
                (o.return = e),
                (o = o.sibling));
          return ((e.subtreeFlags |= n), (e.childLanes = i), t);
        }
        function Lg(e, t, i) {
          var n = t.pendingProps;
          switch ((mr(t), t.tag)) {
            case 31:
            case 16:
            case 15:
            case 0:
            case 11:
            case 7:
            case 8:
            case 12:
            case 9:
            case 14:
              return (De(t), null);
            case 1:
              return (De(t), null);
            case 3:
              return (
                (i = t.stateNode),
                (n = null),
                e !== null && (n = e.memoizedState.cache),
                t.memoizedState.cache !== n && (t.flags |= 2048),
                Jt(Ke),
                oi(),
                i.pendingContext &&
                  ((i.context = i.pendingContext), (i.pendingContext = null)),
                (e === null || e.child === null) &&
                  (ha(t)
                    ? Wt(t)
                    : e === null ||
                      (e.memoizedState.isDehydrated && (t.flags & 256) === 0) ||
                      ((t.flags |= 1024), Lc())),
                De(t),
                null
              );
            case 26:
              return (
                (i = t.memoizedState),
                e === null
                  ? (Wt(t),
                    i !== null
                      ? (De(t), nd(t, i))
                      : (De(t), (t.flags &= -16777217)))
                  : i
                    ? i !== e.memoizedState
                      ? (Wt(t), De(t), nd(t, i))
                      : (De(t), (t.flags &= -16777217))
                    : (e.memoizedProps !== n && Wt(t),
                      De(t),
                      (t.flags &= -16777217)),
                null
              );
            case 27:
              (nl(t), (i = ce.current));
              var o = t.type;
              if (e !== null && t.stateNode != null)
                e.memoizedProps !== n && Wt(t);
              else {
                if (!n) {
                  if (t.stateNode === null) throw Error(r(166));
                  return (De(t), null);
                }
                ((e = le.current),
                  ha(t)
                    ? Rc(t)
                    : ((e = nh(o, n, i)), (t.stateNode = e), Wt(t)));
              }
              return (De(t), null);
            case 5:
              if ((nl(t), (i = t.type), e !== null && t.stateNode != null))
                e.memoizedProps !== n && Wt(t);
              else {
                if (!n) {
                  if (t.stateNode === null) throw Error(r(166));
                  return (De(t), null);
                }
                if (((e = le.current), ha(t))) Rc(t);
                else {
                  switch (((o = ls(ce.current)), e)) {
                    case 1:
                      e = o.createElementNS('http://www.w3.org/2000/svg', i);
                      break;
                    case 2:
                      e = o.createElementNS(
                        'http://www.w3.org/1998/Math/MathML',
                        i
                      );
                      break;
                    default:
                      switch (i) {
                        case 'svg':
                          e = o.createElementNS(
                            'http://www.w3.org/2000/svg',
                            i
                          );
                          break;
                        case 'math':
                          e = o.createElementNS(
                            'http://www.w3.org/1998/Math/MathML',
                            i
                          );
                          break;
                        case 'script':
                          ((e = o.createElement('div')),
                            (e.innerHTML = '<script><\/script>'),
                            (e = e.removeChild(e.firstChild)));
                          break;
                        case 'select':
                          ((e =
                            typeof n.is == 'string'
                              ? o.createElement('select', { is: n.is })
                              : o.createElement('select')),
                            n.multiple
                              ? (e.multiple = !0)
                              : n.size && (e.size = n.size));
                          break;
                        default:
                          e =
                            typeof n.is == 'string'
                              ? o.createElement(i, { is: n.is })
                              : o.createElement(i);
                      }
                  }
                  ((e[We] = t), (e[lt] = n));
                  e: for (o = t.child; o !== null; ) {
                    if (o.tag === 5 || o.tag === 6) e.appendChild(o.stateNode);
                    else if (o.tag !== 4 && o.tag !== 27 && o.child !== null) {
                      ((o.child.return = o), (o = o.child));
                      continue;
                    }
                    if (o === t) break e;
                    for (; o.sibling === null; ) {
                      if (o.return === null || o.return === t) break e;
                      o = o.return;
                    }
                    ((o.sibling.return = o.return), (o = o.sibling));
                  }
                  t.stateNode = e;
                  e: switch ((Ie(e, i, n), i)) {
                    case 'button':
                    case 'input':
                    case 'select':
                    case 'textarea':
                      e = !!n.autoFocus;
                      break e;
                    case 'img':
                      e = !0;
                      break e;
                    default:
                      e = !1;
                  }
                  e && Wt(t);
                }
              }
              return (De(t), (t.flags &= -16777217), null);
            case 6:
              if (e && t.stateNode != null) e.memoizedProps !== n && Wt(t);
              else {
                if (typeof n != 'string' && t.stateNode === null)
                  throw Error(r(166));
                if (((e = ce.current), ha(t))) {
                  if (
                    ((e = t.stateNode),
                    (i = t.memoizedProps),
                    (n = null),
                    (o = it),
                    o !== null)
                  )
                    switch (o.tag) {
                      case 27:
                      case 5:
                        n = o.memoizedProps;
                    }
                  ((e[We] = t),
                    (e = !!(
                      e.nodeValue === i ||
                      (n !== null && n.suppressHydrationWarning === !0) ||
                      Fd(e.nodeValue, i)
                    )),
                    e || Qi(t));
                } else
                  ((e = ls(e).createTextNode(n)),
                    (e[We] = t),
                    (t.stateNode = e));
              }
              return (De(t), null);
            case 13:
              if (
                ((n = t.memoizedState),
                e === null ||
                  (e.memoizedState !== null &&
                    e.memoizedState.dehydrated !== null))
              ) {
                if (((o = ha(t)), n !== null && n.dehydrated !== null)) {
                  if (e === null) {
                    if (!o) throw Error(r(318));
                    if (
                      ((o = t.memoizedState),
                      (o = o !== null ? o.dehydrated : null),
                      !o)
                    )
                      throw Error(r(317));
                    o[We] = t;
                  } else
                    (pa(),
                      (t.flags & 128) === 0 && (t.memoizedState = null),
                      (t.flags |= 4));
                  (De(t), (o = !1));
                } else
                  ((o = Lc()),
                    e !== null &&
                      e.memoizedState !== null &&
                      (e.memoizedState.hydrationErrors = o),
                    (o = !0));
                if (!o) return t.flags & 256 ? (Pt(t), t) : (Pt(t), null);
              }
              if ((Pt(t), (t.flags & 128) !== 0)) return ((t.lanes = i), t);
              if (
                ((i = n !== null),
                (e = e !== null && e.memoizedState !== null),
                i)
              ) {
                ((n = t.child),
                  (o = null),
                  n.alternate !== null &&
                    n.alternate.memoizedState !== null &&
                    n.alternate.memoizedState.cachePool !== null &&
                    (o = n.alternate.memoizedState.cachePool.pool));
                var c = null;
                (n.memoizedState !== null &&
                  n.memoizedState.cachePool !== null &&
                  (c = n.memoizedState.cachePool.pool),
                  c !== o && (n.flags |= 2048));
              }
              return (
                i !== e && i && (t.child.flags |= 8192),
                Ql(t, t.updateQueue),
                De(t),
                null
              );
            case 4:
              return (
                oi(),
                e === null && _o(t.stateNode.containerInfo),
                De(t),
                null
              );
            case 10:
              return (Jt(t.type), De(t), null);
            case 19:
              if ((P(qe), (o = t.memoizedState), o === null))
                return (De(t), null);
              if (((n = (t.flags & 128) !== 0), (c = o.rendering), c === null))
                if (n) Na(o, !1);
                else {
                  if (je !== 0 || (e !== null && (e.flags & 128) !== 0))
                    for (e = t.child; e !== null; ) {
                      if (((c = Kl(e)), c !== null)) {
                        for (
                          t.flags |= 128,
                            Na(o, !1),
                            e = c.updateQueue,
                            t.updateQueue = e,
                            Ql(t, e),
                            t.subtreeFlags = 0,
                            e = i,
                            i = t.child;
                          i !== null;
                        )
                          (Nc(i, e), (i = i.sibling));
                        return (F(qe, (qe.current & 1) | 2), t.child);
                      }
                      e = e.sibling;
                    }
                  o.tail !== null &&
                    Ht() > Jl &&
                    ((t.flags |= 128),
                    (n = !0),
                    Na(o, !1),
                    (t.lanes = 4194304));
                }
              else {
                if (!n)
                  if (((e = Kl(c)), e !== null)) {
                    if (
                      ((t.flags |= 128),
                      (n = !0),
                      (e = e.updateQueue),
                      (t.updateQueue = e),
                      Ql(t, e),
                      Na(o, !0),
                      o.tail === null &&
                        o.tailMode === 'hidden' &&
                        !c.alternate &&
                        !Te)
                    )
                      return (De(t), null);
                  } else
                    2 * Ht() - o.renderingStartTime > Jl &&
                      i !== 536870912 &&
                      ((t.flags |= 128),
                      (n = !0),
                      Na(o, !1),
                      (t.lanes = 4194304));
                o.isBackwards
                  ? ((c.sibling = t.child), (t.child = c))
                  : ((e = o.last),
                    e !== null ? (e.sibling = c) : (t.child = c),
                    (o.last = c));
              }
              return o.tail !== null
                ? ((t = o.tail),
                  (o.rendering = t),
                  (o.tail = t.sibling),
                  (o.renderingStartTime = Ht()),
                  (t.sibling = null),
                  (e = qe.current),
                  F(qe, n ? (e & 1) | 2 : e & 1),
                  t)
                : (De(t), null);
            case 22:
            case 23:
              return (
                Pt(t),
                Cr(),
                (n = t.memoizedState !== null),
                e !== null
                  ? (e.memoizedState !== null) !== n && (t.flags |= 8192)
                  : n && (t.flags |= 8192),
                n
                  ? (i & 536870912) !== 0 &&
                    (t.flags & 128) === 0 &&
                    (De(t), t.subtreeFlags & 6 && (t.flags |= 8192))
                  : De(t),
                (i = t.updateQueue),
                i !== null && Ql(t, i.retryQueue),
                (i = null),
                e !== null &&
                  e.memoizedState !== null &&
                  e.memoizedState.cachePool !== null &&
                  (i = e.memoizedState.cachePool.pool),
                (n = null),
                t.memoizedState !== null &&
                  t.memoizedState.cachePool !== null &&
                  (n = t.memoizedState.cachePool.pool),
                n !== i && (t.flags |= 2048),
                e !== null && P(Ji),
                null
              );
            case 24:
              return (
                (i = null),
                e !== null && (i = e.memoizedState.cache),
                t.memoizedState.cache !== i && (t.flags |= 2048),
                Jt(Ke),
                De(t),
                null
              );
            case 25:
              return null;
            case 30:
              return null;
          }
          throw Error(r(156, t.tag));
        }
        function jg(e, t) {
          switch ((mr(t), t.tag)) {
            case 1:
              return (
                (e = t.flags),
                e & 65536 ? ((t.flags = (e & -65537) | 128), t) : null
              );
            case 3:
              return (
                Jt(Ke),
                oi(),
                (e = t.flags),
                (e & 65536) !== 0 && (e & 128) === 0
                  ? ((t.flags = (e & -65537) | 128), t)
                  : null
              );
            case 26:
            case 27:
            case 5:
              return (nl(t), null);
            case 13:
              if (
                (Pt(t),
                (e = t.memoizedState),
                e !== null && e.dehydrated !== null)
              ) {
                if (t.alternate === null) throw Error(r(340));
                pa();
              }
              return (
                (e = t.flags),
                e & 65536 ? ((t.flags = (e & -65537) | 128), t) : null
              );
            case 19:
              return (P(qe), null);
            case 4:
              return (oi(), null);
            case 10:
              return (Jt(t.type), null);
            case 22:
            case 23:
              return (
                Pt(t),
                Cr(),
                e !== null && P(Ji),
                (e = t.flags),
                e & 65536 ? ((t.flags = (e & -65537) | 128), t) : null
              );
            case 24:
              return (Jt(Ke), null);
            case 25:
              return null;
            default:
              return null;
          }
        }
        function ad(e, t) {
          switch ((mr(t), t.tag)) {
            case 3:
              (Jt(Ke), oi());
              break;
            case 26:
            case 27:
            case 5:
              nl(t);
              break;
            case 4:
              oi();
              break;
            case 13:
              Pt(t);
              break;
            case 19:
              P(qe);
              break;
            case 10:
              Jt(t.type);
              break;
            case 22:
            case 23:
              (Pt(t), Cr(), e !== null && P(Ji));
              break;
            case 24:
              Jt(Ke);
          }
        }
        function za(e, t) {
          try {
            var i = t.updateQueue,
              n = i !== null ? i.lastEffect : null;
            if (n !== null) {
              var o = n.next;
              i = o;
              do {
                if ((i.tag & e) === e) {
                  n = void 0;
                  var c = i.create,
                    m = i.inst;
                  ((n = c()), (m.destroy = n));
                }
                i = i.next;
              } while (i !== o);
            }
          } catch (v) {
            Ce(t, t.return, v);
          }
        }
        function bi(e, t, i) {
          try {
            var n = t.updateQueue,
              o = n !== null ? n.lastEffect : null;
            if (o !== null) {
              var c = o.next;
              n = c;
              do {
                if ((n.tag & e) === e) {
                  var m = n.inst,
                    v = m.destroy;
                  if (v !== void 0) {
                    ((m.destroy = void 0), (o = t));
                    var S = i,
                      N = v;
                    try {
                      N();
                    } catch (H) {
                      Ce(o, S, H);
                    }
                  }
                }
                n = n.next;
              } while (n !== c);
            }
          } catch (H) {
            Ce(t, t.return, H);
          }
        }
        function ld(e) {
          var t = e.updateQueue;
          if (t !== null) {
            var i = e.stateNode;
            try {
              Xc(t, i);
            } catch (n) {
              Ce(e, e.return, n);
            }
          }
        }
        function sd(e, t, i) {
          ((i.props = Pi(e.type, e.memoizedProps)),
            (i.state = e.memoizedState));
          try {
            i.componentWillUnmount();
          } catch (n) {
            Ce(e, t, n);
          }
        }
        function Ra(e, t) {
          try {
            var i = e.ref;
            if (i !== null) {
              switch (e.tag) {
                case 26:
                case 27:
                case 5:
                  var n = e.stateNode;
                  break;
                case 30:
                  n = e.stateNode;
                  break;
                default:
                  n = e.stateNode;
              }
              typeof i == 'function' ? (e.refCleanup = i(n)) : (i.current = n);
            }
          } catch (o) {
            Ce(e, t, o);
          }
        }
        function Gt(e, t) {
          var i = e.ref,
            n = e.refCleanup;
          if (i !== null)
            if (typeof n == 'function')
              try {
                n();
              } catch (o) {
                Ce(e, t, o);
              } finally {
                ((e.refCleanup = null),
                  (e = e.alternate),
                  e != null && (e.refCleanup = null));
              }
            else if (typeof i == 'function')
              try {
                i(null);
              } catch (o) {
                Ce(e, t, o);
              }
            else i.current = null;
        }
        function rd(e) {
          var t = e.type,
            i = e.memoizedProps,
            n = e.stateNode;
          try {
            e: switch (t) {
              case 'button':
              case 'input':
              case 'select':
              case 'textarea':
                i.autoFocus && n.focus();
                break e;
              case 'img':
                i.src ? (n.src = i.src) : i.srcSet && (n.srcset = i.srcSet);
            }
          } catch (o) {
            Ce(e, e.return, o);
          }
        }
        function no(e, t, i) {
          try {
            var n = e.stateNode;
            (iv(n, e.type, i, t), (n[lt] = t));
          } catch (o) {
            Ce(e, e.return, o);
          }
        }
        function od(e) {
          return (
            e.tag === 5 ||
            e.tag === 3 ||
            e.tag === 26 ||
            (e.tag === 27 && Oi(e.type)) ||
            e.tag === 4
          );
        }
        function ao(e) {
          e: for (;;) {
            for (; e.sibling === null; ) {
              if (e.return === null || od(e.return)) return null;
              e = e.return;
            }
            for (
              e.sibling.return = e.return, e = e.sibling;
              e.tag !== 5 && e.tag !== 6 && e.tag !== 18;
            ) {
              if (
                (e.tag === 27 && Oi(e.type)) ||
                e.flags & 2 ||
                e.child === null ||
                e.tag === 4
              )
                continue e;
              ((e.child.return = e), (e = e.child));
            }
            if (!(e.flags & 2)) return e.stateNode;
          }
        }
        function lo(e, t, i) {
          var n = e.tag;
          if (n === 5 || n === 6)
            ((e = e.stateNode),
              t
                ? (i.nodeType === 9
                    ? i.body
                    : i.nodeName === 'HTML'
                      ? i.ownerDocument.body
                      : i
                  ).insertBefore(e, t)
                : ((t =
                    i.nodeType === 9
                      ? i.body
                      : i.nodeName === 'HTML'
                        ? i.ownerDocument.body
                        : i),
                  t.appendChild(e),
                  (i = i._reactRootContainer),
                  i != null || t.onclick !== null || (t.onclick = as)));
          else if (
            n !== 4 &&
            (n === 27 && Oi(e.type) && ((i = e.stateNode), (t = null)),
            (e = e.child),
            e !== null)
          )
            for (lo(e, t, i), e = e.sibling; e !== null; )
              (lo(e, t, i), (e = e.sibling));
        }
        function Zl(e, t, i) {
          var n = e.tag;
          if (n === 5 || n === 6)
            ((e = e.stateNode), t ? i.insertBefore(e, t) : i.appendChild(e));
          else if (
            n !== 4 &&
            (n === 27 && Oi(e.type) && (i = e.stateNode),
            (e = e.child),
            e !== null)
          )
            for (Zl(e, t, i), e = e.sibling; e !== null; )
              (Zl(e, t, i), (e = e.sibling));
        }
        function ud(e) {
          var t = e.stateNode,
            i = e.memoizedProps;
          try {
            for (var n = e.type, o = t.attributes; o.length; )
              t.removeAttributeNode(o[0]);
            (Ie(t, n, i), (t[We] = e), (t[lt] = i));
          } catch (c) {
            Ce(e, e.return, c);
          }
        }
        var ei = !1,
          Be = !1,
          so = !1,
          cd = typeof WeakSet == 'function' ? WeakSet : Set,
          Qe = null;
        function Hg(e, t) {
          if (((e = e.containerInfo), (zo = fs), (e = Sc(e)), ar(e))) {
            if ('selectionStart' in e)
              var i = { start: e.selectionStart, end: e.selectionEnd };
            else {
              i = ((i = e.ownerDocument) && i.defaultView) || window;
              var n = i.getSelection && i.getSelection();
              if (n && n.rangeCount !== 0) {
                i = n.anchorNode;
                var o = n.anchorOffset,
                  c = n.focusNode;
                n = n.focusOffset;
                var m = 0,
                  v = -1,
                  S = -1,
                  N = 0,
                  H = 0,
                  K = e,
                  z = null;
                e: for (;;) {
                  for (
                    var R;
                    K !== i || (o !== 0 && K.nodeType !== 3) || (v = m + o),
                      K !== c || (n !== 0 && K.nodeType !== 3) || (S = m + n),
                      K.nodeType === 3 && (m += K.nodeValue.length),
                      (R = K.firstChild) !== null;
                  )
                    ((z = K), (K = R));
                  for (;;) {
                    if (K === e) break e;
                    if (
                      (z === i && ++N === o && (v = m),
                      z === c && ++H === n && (S = m),
                      (R = K.nextSibling) !== null)
                    )
                      break;
                    ((K = z), (z = K.parentNode));
                  }
                  K = R;
                }
                i = v === -1 || S === -1 ? null : { start: v, end: S };
              } else i = null;
            }
            i = i || { start: 0, end: 0 };
          } else i = null;
          for (
            Ro = { focusedElem: e, selectionRange: i }, fs = !1, Qe = t;
            Qe !== null;
          )
            if (
              ((t = Qe),
              (e = t.child),
              (t.subtreeFlags & 1024) !== 0 && e !== null)
            )
              ((e.return = t), (Qe = e));
            else
              for (; Qe !== null; ) {
                switch (((t = Qe), (c = t.alternate), (e = t.flags), t.tag)) {
                  case 0:
                    break;
                  case 11:
                  case 15:
                    break;
                  case 1:
                    if ((e & 1024) !== 0 && c !== null) {
                      ((e = void 0),
                        (i = t),
                        (o = c.memoizedProps),
                        (c = c.memoizedState),
                        (n = i.stateNode));
                      try {
                        var oe = Pi(i.type, o);
                        ((e = n.getSnapshotBeforeUpdate(oe, c)),
                          (n.__reactInternalSnapshotBeforeUpdate = e));
                      } catch (se) {
                        Ce(i, i.return, se);
                      }
                    }
                    break;
                  case 3:
                    if ((e & 1024) !== 0) {
                      if (
                        ((e = t.stateNode.containerInfo),
                        (i = e.nodeType),
                        i === 9)
                      )
                        jo(e);
                      else if (i === 1)
                        switch (e.nodeName) {
                          case 'HEAD':
                          case 'HTML':
                          case 'BODY':
                            jo(e);
                            break;
                          default:
                            e.textContent = '';
                        }
                    }
                    break;
                  case 5:
                  case 26:
                  case 27:
                  case 6:
                  case 4:
                  case 17:
                    break;
                  default:
                    if ((e & 1024) !== 0) throw Error(r(163));
                }
                if (((e = t.sibling), e !== null)) {
                  ((e.return = t.return), (Qe = e));
                  break;
                }
                Qe = t.return;
              }
        }
        function fd(e, t, i) {
          var n = i.flags;
          switch (i.tag) {
            case 0:
            case 11:
            case 15:
              (Si(e, i), n & 4 && za(5, i));
              break;
            case 1:
              if ((Si(e, i), n & 4))
                if (((e = i.stateNode), t === null))
                  try {
                    e.componentDidMount();
                  } catch (m) {
                    Ce(i, i.return, m);
                  }
                else {
                  var o = Pi(i.type, t.memoizedProps);
                  t = t.memoizedState;
                  try {
                    e.componentDidUpdate(
                      o,
                      t,
                      e.__reactInternalSnapshotBeforeUpdate
                    );
                  } catch (m) {
                    Ce(i, i.return, m);
                  }
                }
              (n & 64 && ld(i), n & 512 && Ra(i, i.return));
              break;
            case 3:
              if ((Si(e, i), n & 64 && ((e = i.updateQueue), e !== null))) {
                if (((t = null), i.child !== null))
                  switch (i.child.tag) {
                    case 27:
                    case 5:
                      t = i.child.stateNode;
                      break;
                    case 1:
                      t = i.child.stateNode;
                  }
                try {
                  Xc(e, t);
                } catch (m) {
                  Ce(i, i.return, m);
                }
              }
              break;
            case 27:
              t === null && n & 4 && ud(i);
            case 26:
            case 5:
              (Si(e, i),
                t === null && n & 4 && rd(i),
                n & 512 && Ra(i, i.return));
              break;
            case 12:
              Si(e, i);
              break;
            case 13:
              (Si(e, i),
                n & 4 && pd(e, i),
                n & 64 &&
                  ((e = i.memoizedState),
                  e !== null &&
                    ((e = e.dehydrated),
                    e !== null && ((i = Xg.bind(null, i)), uv(e, i)))));
              break;
            case 22:
              if (((n = i.memoizedState !== null || ei), !n)) {
                ((t = (t !== null && t.memoizedState !== null) || Be),
                  (o = ei));
                var c = Be;
                ((ei = n),
                  (Be = t) && !c
                    ? xi(e, i, (i.subtreeFlags & 8772) !== 0)
                    : Si(e, i),
                  (ei = o),
                  (Be = c));
              }
              break;
            case 30:
              break;
            default:
              Si(e, i);
          }
        }
        function dd(e) {
          var t = e.alternate;
          (t !== null && ((e.alternate = null), dd(t)),
            (e.child = null),
            (e.deletions = null),
            (e.sibling = null),
            e.tag === 5 && ((t = e.stateNode), t !== null && Gs(t)),
            (e.stateNode = null),
            (e.return = null),
            (e.dependencies = null),
            (e.memoizedProps = null),
            (e.memoizedState = null),
            (e.pendingProps = null),
            (e.stateNode = null),
            (e.updateQueue = null));
        }
        var Re = null,
          ot = !1;
        function ti(e, t, i) {
          for (i = i.child; i !== null; ) (hd(e, t, i), (i = i.sibling));
        }
        function hd(e, t, i) {
          if (ht && typeof ht.onCommitFiberUnmount == 'function')
            try {
              ht.onCommitFiberUnmount(Wn, i);
            } catch {}
          switch (i.tag) {
            case 26:
              (Be || Gt(i, t),
                ti(e, t, i),
                i.memoizedState
                  ? i.memoizedState.count--
                  : i.stateNode &&
                    ((i = i.stateNode), i.parentNode.removeChild(i)));
              break;
            case 27:
              Be || Gt(i, t);
              var n = Re,
                o = ot;
              (Oi(i.type) && ((Re = i.stateNode), (ot = !1)),
                ti(e, t, i),
                Ka(i.stateNode),
                (Re = n),
                (ot = o));
              break;
            case 5:
              Be || Gt(i, t);
            case 6:
              if (
                ((n = Re),
                (o = ot),
                (Re = null),
                ti(e, t, i),
                (Re = n),
                (ot = o),
                Re !== null)
              )
                if (ot)
                  try {
                    (Re.nodeType === 9
                      ? Re.body
                      : Re.nodeName === 'HTML'
                        ? Re.ownerDocument.body
                        : Re
                    ).removeChild(i.stateNode);
                  } catch (c) {
                    Ce(i, t, c);
                  }
                else
                  try {
                    Re.removeChild(i.stateNode);
                  } catch (c) {
                    Ce(i, t, c);
                  }
              break;
            case 18:
              Re !== null &&
                (ot
                  ? ((e = Re),
                    th(
                      e.nodeType === 9
                        ? e.body
                        : e.nodeName === 'HTML'
                          ? e.ownerDocument.body
                          : e,
                      i.stateNode
                    ),
                    Ja(e))
                  : th(Re, i.stateNode));
              break;
            case 4:
              ((n = Re),
                (o = ot),
                (Re = i.stateNode.containerInfo),
                (ot = !0),
                ti(e, t, i),
                (Re = n),
                (ot = o));
              break;
            case 0:
            case 11:
            case 14:
            case 15:
              (Be || bi(2, i, t), Be || bi(4, i, t), ti(e, t, i));
              break;
            case 1:
              (Be ||
                (Gt(i, t),
                (n = i.stateNode),
                typeof n.componentWillUnmount == 'function' && sd(i, t, n)),
                ti(e, t, i));
              break;
            case 21:
              ti(e, t, i);
              break;
            case 22:
              ((Be = (n = Be) || i.memoizedState !== null),
                ti(e, t, i),
                (Be = n));
              break;
            default:
              ti(e, t, i);
          }
        }
        function pd(e, t) {
          if (
            t.memoizedState === null &&
            ((e = t.alternate),
            e !== null &&
              ((e = e.memoizedState),
              e !== null && ((e = e.dehydrated), e !== null)))
          )
            try {
              Ja(e);
            } catch (i) {
              Ce(t, t.return, i);
            }
        }
        function Ug(e) {
          switch (e.tag) {
            case 13:
            case 19:
              var t = e.stateNode;
              return (t === null && (t = e.stateNode = new cd()), t);
            case 22:
              return (
                (e = e.stateNode),
                (t = e._retryCache),
                t === null && (t = e._retryCache = new cd()),
                t
              );
            default:
              throw Error(r(435, e.tag));
          }
        }
        function ro(e, t) {
          var i = Ug(e);
          t.forEach(function (n) {
            var o = Qg.bind(null, e, n);
            i.has(n) || (i.add(n), n.then(o, o));
          });
        }
        function vt(e, t) {
          var i = t.deletions;
          if (i !== null)
            for (var n = 0; n < i.length; n++) {
              var o = i[n],
                c = e,
                m = t,
                v = m;
              e: for (; v !== null; ) {
                switch (v.tag) {
                  case 27:
                    if (Oi(v.type)) {
                      ((Re = v.stateNode), (ot = !1));
                      break e;
                    }
                    break;
                  case 5:
                    ((Re = v.stateNode), (ot = !1));
                    break e;
                  case 3:
                  case 4:
                    ((Re = v.stateNode.containerInfo), (ot = !0));
                    break e;
                }
                v = v.return;
              }
              if (Re === null) throw Error(r(160));
              (hd(c, m, o),
                (Re = null),
                (ot = !1),
                (c = o.alternate),
                c !== null && (c.return = null),
                (o.return = null));
            }
          if (t.subtreeFlags & 13878)
            for (t = t.child; t !== null; ) (md(t, e), (t = t.sibling));
        }
        var Lt = null;
        function md(e, t) {
          var i = e.alternate,
            n = e.flags;
          switch (e.tag) {
            case 0:
            case 11:
            case 14:
            case 15:
              (vt(t, e),
                yt(e),
                n & 4 && (bi(3, e, e.return), za(3, e), bi(5, e, e.return)));
              break;
            case 1:
              (vt(t, e),
                yt(e),
                n & 512 && (Be || i === null || Gt(i, i.return)),
                n & 64 &&
                  ei &&
                  ((e = e.updateQueue),
                  e !== null &&
                    ((n = e.callbacks),
                    n !== null &&
                      ((i = e.shared.hiddenCallbacks),
                      (e.shared.hiddenCallbacks =
                        i === null ? n : i.concat(n))))));
              break;
            case 26:
              var o = Lt;
              if (
                (vt(t, e),
                yt(e),
                n & 512 && (Be || i === null || Gt(i, i.return)),
                n & 4)
              ) {
                var c = i !== null ? i.memoizedState : null;
                if (((n = e.memoizedState), i === null))
                  if (n === null)
                    if (e.stateNode === null) {
                      e: {
                        ((n = e.type),
                          (i = e.memoizedProps),
                          (o = o.ownerDocument || o));
                        t: switch (n) {
                          case 'title':
                            ((c = o.getElementsByTagName('title')[0]),
                              (!c ||
                                c[ia] ||
                                c[We] ||
                                c.namespaceURI ===
                                  'http://www.w3.org/2000/svg' ||
                                c.hasAttribute('itemprop')) &&
                                ((c = o.createElement(n)),
                                o.head.insertBefore(
                                  c,
                                  o.querySelector('head > title')
                                )),
                              Ie(c, n, i),
                              (c[We] = e),
                              $e(c),
                              (n = c));
                            break e;
                          case 'link':
                            var m = uh('link', 'href', o).get(
                              n + (i.href || '')
                            );
                            if (m) {
                              for (var v = 0; v < m.length; v++)
                                if (
                                  ((c = m[v]),
                                  c.getAttribute('href') ===
                                    (i.href == null || i.href === ''
                                      ? null
                                      : i.href) &&
                                    c.getAttribute('rel') ===
                                      (i.rel == null ? null : i.rel) &&
                                    c.getAttribute('title') ===
                                      (i.title == null ? null : i.title) &&
                                    c.getAttribute('crossorigin') ===
                                      (i.crossOrigin == null
                                        ? null
                                        : i.crossOrigin))
                                ) {
                                  m.splice(v, 1);
                                  break t;
                                }
                            }
                            ((c = o.createElement(n)),
                              Ie(c, n, i),
                              o.head.appendChild(c));
                            break;
                          case 'meta':
                            if (
                              (m = uh('meta', 'content', o).get(
                                n + (i.content || '')
                              ))
                            ) {
                              for (v = 0; v < m.length; v++)
                                if (
                                  ((c = m[v]),
                                  c.getAttribute('content') ===
                                    (i.content == null
                                      ? null
                                      : '' + i.content) &&
                                    c.getAttribute('name') ===
                                      (i.name == null ? null : i.name) &&
                                    c.getAttribute('property') ===
                                      (i.property == null
                                        ? null
                                        : i.property) &&
                                    c.getAttribute('http-equiv') ===
                                      (i.httpEquiv == null
                                        ? null
                                        : i.httpEquiv) &&
                                    c.getAttribute('charset') ===
                                      (i.charSet == null ? null : i.charSet))
                                ) {
                                  m.splice(v, 1);
                                  break t;
                                }
                            }
                            ((c = o.createElement(n)),
                              Ie(c, n, i),
                              o.head.appendChild(c));
                            break;
                          default:
                            throw Error(r(468, n));
                        }
                        ((c[We] = e), $e(c), (n = c));
                      }
                      e.stateNode = n;
                    } else ch(o, e.type, e.stateNode);
                  else e.stateNode = oh(o, n, e.memoizedProps);
                else
                  c !== n
                    ? (c === null
                        ? i.stateNode !== null &&
                          ((i = i.stateNode), i.parentNode.removeChild(i))
                        : c.count--,
                      n === null
                        ? ch(o, e.type, e.stateNode)
                        : oh(o, n, e.memoizedProps))
                    : n === null &&
                      e.stateNode !== null &&
                      no(e, e.memoizedProps, i.memoizedProps);
              }
              break;
            case 27:
              (vt(t, e),
                yt(e),
                n & 512 && (Be || i === null || Gt(i, i.return)),
                i !== null && n & 4 && no(e, e.memoizedProps, i.memoizedProps));
              break;
            case 5:
              if (
                (vt(t, e),
                yt(e),
                n & 512 && (Be || i === null || Gt(i, i.return)),
                e.flags & 32)
              ) {
                o = e.stateNode;
                try {
                  gn(o, '');
                } catch (R) {
                  Ce(e, e.return, R);
                }
              }
              (n & 4 &&
                e.stateNode != null &&
                ((o = e.memoizedProps),
                no(e, o, i !== null ? i.memoizedProps : o)),
                n & 1024 && (so = !0));
              break;
            case 6:
              if ((vt(t, e), yt(e), n & 4)) {
                if (e.stateNode === null) throw Error(r(162));
                ((n = e.memoizedProps), (i = e.stateNode));
                try {
                  i.nodeValue = n;
                } catch (R) {
                  Ce(e, e.return, R);
                }
              }
              break;
            case 3:
              if (
                ((os = null),
                (o = Lt),
                (Lt = ss(t.containerInfo)),
                vt(t, e),
                (Lt = o),
                yt(e),
                n & 4 && i !== null && i.memoizedState.isDehydrated)
              )
                try {
                  Ja(t.containerInfo);
                } catch (R) {
                  Ce(e, e.return, R);
                }
              so && ((so = !1), gd(e));
              break;
            case 4:
              ((n = Lt),
                (Lt = ss(e.stateNode.containerInfo)),
                vt(t, e),
                yt(e),
                (Lt = n));
              break;
            case 12:
              (vt(t, e), yt(e));
              break;
            case 13:
              (vt(t, e),
                yt(e),
                e.child.flags & 8192 &&
                  (e.memoizedState !== null) !=
                    (i !== null && i.memoizedState !== null) &&
                  (po = Ht()),
                n & 4 &&
                  ((n = e.updateQueue),
                  n !== null && ((e.updateQueue = null), ro(e, n))));
              break;
            case 22:
              o = e.memoizedState !== null;
              var S = i !== null && i.memoizedState !== null,
                N = ei,
                H = Be;
              if (
                ((ei = N || o),
                (Be = H || S),
                vt(t, e),
                (Be = H),
                (ei = N),
                yt(e),
                n & 8192)
              )
                e: for (
                  t = e.stateNode,
                    t._visibility = o ? t._visibility & -2 : t._visibility | 1,
                    o && (i === null || S || ei || Be || Ii(e)),
                    i = null,
                    t = e;
                  ;
                ) {
                  if (t.tag === 5 || t.tag === 26) {
                    if (i === null) {
                      S = i = t;
                      try {
                        if (((c = S.stateNode), o))
                          ((m = c.style),
                            typeof m.setProperty == 'function'
                              ? m.setProperty('display', 'none', 'important')
                              : (m.display = 'none'));
                        else {
                          v = S.stateNode;
                          var K = S.memoizedProps.style,
                            z =
                              K != null && K.hasOwnProperty('display')
                                ? K.display
                                : null;
                          v.style.display =
                            z == null || typeof z == 'boolean'
                              ? ''
                              : ('' + z).trim();
                        }
                      } catch (R) {
                        Ce(S, S.return, R);
                      }
                    }
                  } else if (t.tag === 6) {
                    if (i === null) {
                      S = t;
                      try {
                        S.stateNode.nodeValue = o ? '' : S.memoizedProps;
                      } catch (R) {
                        Ce(S, S.return, R);
                      }
                    }
                  } else if (
                    ((t.tag !== 22 && t.tag !== 23) ||
                      t.memoizedState === null ||
                      t === e) &&
                    t.child !== null
                  ) {
                    ((t.child.return = t), (t = t.child));
                    continue;
                  }
                  if (t === e) break e;
                  for (; t.sibling === null; ) {
                    if (t.return === null || t.return === e) break e;
                    (i === t && (i = null), (t = t.return));
                  }
                  (i === t && (i = null),
                    (t.sibling.return = t.return),
                    (t = t.sibling));
                }
              n & 4 &&
                ((n = e.updateQueue),
                n !== null &&
                  ((i = n.retryQueue),
                  i !== null && ((n.retryQueue = null), ro(e, i))));
              break;
            case 19:
              (vt(t, e),
                yt(e),
                n & 4 &&
                  ((n = e.updateQueue),
                  n !== null && ((e.updateQueue = null), ro(e, n))));
              break;
            case 30:
              break;
            case 21:
              break;
            default:
              (vt(t, e), yt(e));
          }
        }
        function yt(e) {
          var t = e.flags;
          if (t & 2) {
            try {
              for (var i, n = e.return; n !== null; ) {
                if (od(n)) {
                  i = n;
                  break;
                }
                n = n.return;
              }
              if (i == null) throw Error(r(160));
              switch (i.tag) {
                case 27:
                  var o = i.stateNode,
                    c = ao(e);
                  Zl(e, c, o);
                  break;
                case 5:
                  var m = i.stateNode;
                  i.flags & 32 && (gn(m, ''), (i.flags &= -33));
                  var v = ao(e);
                  Zl(e, v, m);
                  break;
                case 3:
                case 4:
                  var S = i.stateNode.containerInfo,
                    N = ao(e);
                  lo(e, N, S);
                  break;
                default:
                  throw Error(r(161));
              }
            } catch (H) {
              Ce(e, e.return, H);
            }
            e.flags &= -3;
          }
          t & 4096 && (e.flags &= -4097);
        }
        function gd(e) {
          if (e.subtreeFlags & 1024)
            for (e = e.child; e !== null; ) {
              var t = e;
              (gd(t),
                t.tag === 5 && t.flags & 1024 && t.stateNode.reset(),
                (e = e.sibling));
            }
        }
        function Si(e, t) {
          if (t.subtreeFlags & 8772)
            for (t = t.child; t !== null; )
              (fd(e, t.alternate, t), (t = t.sibling));
        }
        function Ii(e) {
          for (e = e.child; e !== null; ) {
            var t = e;
            switch (t.tag) {
              case 0:
              case 11:
              case 14:
              case 15:
                (bi(4, t, t.return), Ii(t));
                break;
              case 1:
                Gt(t, t.return);
                var i = t.stateNode;
                (typeof i.componentWillUnmount == 'function' &&
                  sd(t, t.return, i),
                  Ii(t));
                break;
              case 27:
                Ka(t.stateNode);
              case 26:
              case 5:
                (Gt(t, t.return), Ii(t));
                break;
              case 22:
                t.memoizedState === null && Ii(t);
                break;
              case 30:
                Ii(t);
                break;
              default:
                Ii(t);
            }
            e = e.sibling;
          }
        }
        function xi(e, t, i) {
          for (
            i = i && (t.subtreeFlags & 8772) !== 0, t = t.child;
            t !== null;
          ) {
            var n = t.alternate,
              o = e,
              c = t,
              m = c.flags;
            switch (c.tag) {
              case 0:
              case 11:
              case 15:
                (xi(o, c, i), za(4, c));
                break;
              case 1:
                if (
                  (xi(o, c, i),
                  (n = c),
                  (o = n.stateNode),
                  typeof o.componentDidMount == 'function')
                )
                  try {
                    o.componentDidMount();
                  } catch (N) {
                    Ce(n, n.return, N);
                  }
                if (((n = c), (o = n.updateQueue), o !== null)) {
                  var v = n.stateNode;
                  try {
                    var S = o.shared.hiddenCallbacks;
                    if (S !== null)
                      for (
                        o.shared.hiddenCallbacks = null, o = 0;
                        o < S.length;
                        o++
                      )
                        $c(S[o], v);
                  } catch (N) {
                    Ce(n, n.return, N);
                  }
                }
                (i && m & 64 && ld(c), Ra(c, c.return));
                break;
              case 27:
                ud(c);
              case 26:
              case 5:
                (xi(o, c, i),
                  i && n === null && m & 4 && rd(c),
                  Ra(c, c.return));
                break;
              case 12:
                xi(o, c, i);
                break;
              case 13:
                (xi(o, c, i), i && m & 4 && pd(o, c));
                break;
              case 22:
                (c.memoizedState === null && xi(o, c, i), Ra(c, c.return));
                break;
              case 30:
                break;
              default:
                xi(o, c, i);
            }
            t = t.sibling;
          }
        }
        function oo(e, t) {
          var i = null;
          (e !== null &&
            e.memoizedState !== null &&
            e.memoizedState.cachePool !== null &&
            (i = e.memoizedState.cachePool.pool),
            (e = null),
            t.memoizedState !== null &&
              t.memoizedState.cachePool !== null &&
              (e = t.memoizedState.cachePool.pool),
            e !== i && (e != null && e.refCount++, i != null && va(i)));
        }
        function uo(e, t) {
          ((e = null),
            t.alternate !== null && (e = t.alternate.memoizedState.cache),
            (t = t.memoizedState.cache),
            t !== e && (t.refCount++, e != null && va(e)));
        }
        function Vt(e, t, i, n) {
          if (t.subtreeFlags & 10256)
            for (t = t.child; t !== null; ) (vd(e, t, i, n), (t = t.sibling));
        }
        function vd(e, t, i, n) {
          var o = t.flags;
          switch (t.tag) {
            case 0:
            case 11:
            case 15:
              (Vt(e, t, i, n), o & 2048 && za(9, t));
              break;
            case 1:
              Vt(e, t, i, n);
              break;
            case 3:
              (Vt(e, t, i, n),
                o & 2048 &&
                  ((e = null),
                  t.alternate !== null && (e = t.alternate.memoizedState.cache),
                  (t = t.memoizedState.cache),
                  t !== e && (t.refCount++, e != null && va(e))));
              break;
            case 12:
              if (o & 2048) {
                (Vt(e, t, i, n), (e = t.stateNode));
                try {
                  var c = t.memoizedProps,
                    m = c.id,
                    v = c.onPostCommit;
                  typeof v == 'function' &&
                    v(
                      m,
                      t.alternate === null ? 'mount' : 'update',
                      e.passiveEffectDuration,
                      -0
                    );
                } catch (S) {
                  Ce(t, t.return, S);
                }
              } else Vt(e, t, i, n);
              break;
            case 13:
              Vt(e, t, i, n);
              break;
            case 23:
              break;
            case 22:
              ((c = t.stateNode),
                (m = t.alternate),
                t.memoizedState !== null
                  ? c._visibility & 2
                    ? Vt(e, t, i, n)
                    : Da(e, t)
                  : c._visibility & 2
                    ? Vt(e, t, i, n)
                    : ((c._visibility |= 2),
                      jn(e, t, i, n, (t.subtreeFlags & 10256) !== 0)),
                o & 2048 && oo(m, t));
              break;
            case 24:
              (Vt(e, t, i, n), o & 2048 && uo(t.alternate, t));
              break;
            default:
              Vt(e, t, i, n);
          }
        }
        function jn(e, t, i, n, o) {
          for (
            o = o && (t.subtreeFlags & 10256) !== 0, t = t.child;
            t !== null;
          ) {
            var c = e,
              m = t,
              v = i,
              S = n,
              N = m.flags;
            switch (m.tag) {
              case 0:
              case 11:
              case 15:
                (jn(c, m, v, S, o), za(8, m));
                break;
              case 23:
                break;
              case 22:
                var H = m.stateNode;
                (m.memoizedState !== null
                  ? H._visibility & 2
                    ? jn(c, m, v, S, o)
                    : Da(c, m)
                  : ((H._visibility |= 2), jn(c, m, v, S, o)),
                  o && N & 2048 && oo(m.alternate, m));
                break;
              case 24:
                (jn(c, m, v, S, o), o && N & 2048 && uo(m.alternate, m));
                break;
              default:
                jn(c, m, v, S, o);
            }
            t = t.sibling;
          }
        }
        function Da(e, t) {
          if (t.subtreeFlags & 10256)
            for (t = t.child; t !== null; ) {
              var i = e,
                n = t,
                o = n.flags;
              switch (n.tag) {
                case 22:
                  (Da(i, n), o & 2048 && oo(n.alternate, n));
                  break;
                case 24:
                  (Da(i, n), o & 2048 && uo(n.alternate, n));
                  break;
                default:
                  Da(i, n);
              }
              t = t.sibling;
            }
        }
        var La = 8192;
        function Hn(e) {
          if (e.subtreeFlags & La)
            for (e = e.child; e !== null; ) (yd(e), (e = e.sibling));
        }
        function yd(e) {
          switch (e.tag) {
            case 26:
              (Hn(e),
                e.flags & La &&
                  e.memoizedState !== null &&
                  Tv(Lt, e.memoizedState, e.memoizedProps));
              break;
            case 5:
              Hn(e);
              break;
            case 3:
            case 4:
              var t = Lt;
              ((Lt = ss(e.stateNode.containerInfo)), Hn(e), (Lt = t));
              break;
            case 22:
              e.memoizedState === null &&
                ((t = e.alternate),
                t !== null && t.memoizedState !== null
                  ? ((t = La), (La = 16777216), Hn(e), (La = t))
                  : Hn(e));
              break;
            default:
              Hn(e);
          }
        }
        function bd(e) {
          var t = e.alternate;
          if (t !== null && ((e = t.child), e !== null)) {
            t.child = null;
            do ((t = e.sibling), (e.sibling = null), (e = t));
            while (e !== null);
          }
        }
        function ja(e) {
          var t = e.deletions;
          if ((e.flags & 16) !== 0) {
            if (t !== null)
              for (var i = 0; i < t.length; i++) {
                var n = t[i];
                ((Qe = n), xd(n, e));
              }
            bd(e);
          }
          if (e.subtreeFlags & 10256)
            for (e = e.child; e !== null; ) (Sd(e), (e = e.sibling));
        }
        function Sd(e) {
          switch (e.tag) {
            case 0:
            case 11:
            case 15:
              (ja(e), e.flags & 2048 && bi(9, e, e.return));
              break;
            case 3:
              ja(e);
              break;
            case 12:
              ja(e);
              break;
            case 22:
              var t = e.stateNode;
              e.memoizedState !== null &&
              t._visibility & 2 &&
              (e.return === null || e.return.tag !== 13)
                ? ((t._visibility &= -3), kl(e))
                : ja(e);
              break;
            default:
              ja(e);
          }
        }
        function kl(e) {
          var t = e.deletions;
          if ((e.flags & 16) !== 0) {
            if (t !== null)
              for (var i = 0; i < t.length; i++) {
                var n = t[i];
                ((Qe = n), xd(n, e));
              }
            bd(e);
          }
          for (e = e.child; e !== null; ) {
            switch (((t = e), t.tag)) {
              case 0:
              case 11:
              case 15:
                (bi(8, t, t.return), kl(t));
                break;
              case 22:
                ((i = t.stateNode),
                  i._visibility & 2 && ((i._visibility &= -3), kl(t)));
                break;
              default:
                kl(t);
            }
            e = e.sibling;
          }
        }
        function xd(e, t) {
          for (; Qe !== null; ) {
            var i = Qe;
            switch (i.tag) {
              case 0:
              case 11:
              case 15:
                bi(8, i, t);
                break;
              case 23:
              case 22:
                if (
                  i.memoizedState !== null &&
                  i.memoizedState.cachePool !== null
                ) {
                  var n = i.memoizedState.cachePool.pool;
                  n != null && n.refCount++;
                }
                break;
              case 24:
                va(i.memoizedState.cache);
            }
            if (((n = i.child), n !== null)) ((n.return = i), (Qe = n));
            else
              e: for (i = e; Qe !== null; ) {
                n = Qe;
                var o = n.sibling,
                  c = n.return;
                if ((dd(n), n === i)) {
                  Qe = null;
                  break e;
                }
                if (o !== null) {
                  ((o.return = c), (Qe = o));
                  break e;
                }
                Qe = c;
              }
          }
        }
        var Bg = {
            getCacheForType: function (e) {
              var t = et(Ke),
                i = t.data.get(e);
              return (i === void 0 && ((i = e()), t.data.set(e, i)), i);
            },
          },
          Gg = typeof WeakMap == 'function' ? WeakMap : Map,
          Ee = 0,
          Ne = null,
          me = null,
          ye = 0,
          we = 0,
          bt = null,
          Ti = !1,
          Un = !1,
          co = !1,
          ii = 0,
          je = 0,
          Ei = 0,
          Wi = 0,
          fo = 0,
          zt = 0,
          Bn = 0,
          Ha = null,
          ut = null,
          ho = !1,
          po = 0,
          Jl = 1 / 0,
          Fl = null,
          wi = null,
          Pe = 0,
          Mi = null,
          Gn = null,
          Vn = 0,
          mo = 0,
          go = null,
          Td = null,
          Ua = 0,
          vo = null;
        function St() {
          if ((Ee & 2) !== 0 && ye !== 0) return ye & -ye;
          if (L.T !== null) {
            var e = On;
            return e !== 0 ? e : wo();
          }
          return Uu();
        }
        function Ed() {
          zt === 0 && (zt = (ye & 536870912) === 0 || Te ? Du() : 536870912);
          var e = Nt.current;
          return (e !== null && (e.flags |= 32), zt);
        }
        function xt(e, t, i) {
          (((e === Ne && (we === 2 || we === 9)) ||
            e.cancelPendingCommit !== null) &&
            (Kn(e, 0), Ai(e, ye, zt, !1)),
            ta(e, i),
            ((Ee & 2) === 0 || e !== Ne) &&
              (e === Ne &&
                ((Ee & 2) === 0 && (Wi |= i), je === 4 && Ai(e, ye, zt, !1)),
              Kt(e)));
        }
        function wd(e, t, i) {
          if ((Ee & 6) !== 0) throw Error(r(327));
          var n =
              (!i && (t & 124) === 0 && (t & e.expiredLanes) === 0) || ea(e, t),
            o = n ? qg(e, t) : So(e, t, !0),
            c = n;
          do {
            if (o === 0) {
              Un && !n && Ai(e, t, 0, !1);
              break;
            } else {
              if (((i = e.current.alternate), c && !Vg(i))) {
                ((o = So(e, t, !1)), (c = !1));
                continue;
              }
              if (o === 2) {
                if (((c = t), e.errorRecoveryDisabledLanes & c)) var m = 0;
                else
                  ((m = e.pendingLanes & -536870913),
                    (m = m !== 0 ? m : m & 536870912 ? 536870912 : 0));
                if (m !== 0) {
                  t = m;
                  e: {
                    var v = e;
                    o = Ha;
                    var S = v.current.memoizedState.isDehydrated;
                    if (
                      (S && (Kn(v, m).flags |= 256),
                      (m = So(v, m, !1)),
                      m !== 2)
                    ) {
                      if (co && !S) {
                        ((v.errorRecoveryDisabledLanes |= c),
                          (Wi |= c),
                          (o = 4));
                        break e;
                      }
                      ((c = ut),
                        (ut = o),
                        c !== null &&
                          (ut === null ? (ut = c) : ut.push.apply(ut, c)));
                    }
                    o = m;
                  }
                  if (((c = !1), o !== 2)) continue;
                }
              }
              if (o === 1) {
                (Kn(e, 0), Ai(e, t, 0, !0));
                break;
              }
              e: {
                switch (((n = e), (c = o), c)) {
                  case 0:
                  case 1:
                    throw Error(r(345));
                  case 4:
                    if ((t & 4194048) !== t) break;
                  case 6:
                    Ai(n, t, zt, !Ti);
                    break e;
                  case 2:
                    ut = null;
                    break;
                  case 3:
                  case 5:
                    break;
                  default:
                    throw Error(r(329));
                }
                if ((t & 62914560) === t && ((o = po + 300 - Ht()), 10 < o)) {
                  if ((Ai(n, t, zt, !Ti), rl(n, 0, !0) !== 0)) break e;
                  n.timeoutHandle = Wd(
                    Md.bind(
                      null,
                      n,
                      i,
                      ut,
                      Fl,
                      ho,
                      t,
                      zt,
                      Wi,
                      Bn,
                      Ti,
                      c,
                      2,
                      -0,
                      0
                    ),
                    o
                  );
                  break e;
                }
                Md(n, i, ut, Fl, ho, t, zt, Wi, Bn, Ti, c, 0, -0, 0);
              }
            }
            break;
          } while (!0);
          Kt(e);
        }
        function Md(e, t, i, n, o, c, m, v, S, N, H, K, z, R) {
          if (
            ((e.timeoutHandle = -1),
            (K = t.subtreeFlags),
            (K & 8192 || (K & 16785408) === 16785408) &&
              (($a = { stylesheets: null, count: 0, unsuspend: xv }),
              yd(t),
              (K = Ev()),
              K !== null))
          ) {
            ((e.cancelPendingCommit = K(
              Rd.bind(null, e, t, c, i, n, o, m, v, S, H, 1, z, R)
            )),
              Ai(e, c, m, !N));
            return;
          }
          Rd(e, t, c, i, n, o, m, v, S);
        }
        function Vg(e) {
          for (var t = e; ; ) {
            var i = t.tag;
            if (
              (i === 0 || i === 11 || i === 15) &&
              t.flags & 16384 &&
              ((i = t.updateQueue), i !== null && ((i = i.stores), i !== null))
            )
              for (var n = 0; n < i.length; n++) {
                var o = i[n],
                  c = o.getSnapshot;
                o = o.value;
                try {
                  if (!mt(c(), o)) return !1;
                } catch {
                  return !1;
                }
              }
            if (((i = t.child), t.subtreeFlags & 16384 && i !== null))
              ((i.return = t), (t = i));
            else {
              if (t === e) break;
              for (; t.sibling === null; ) {
                if (t.return === null || t.return === e) return !0;
                t = t.return;
              }
              ((t.sibling.return = t.return), (t = t.sibling));
            }
          }
          return !0;
        }
        function Ai(e, t, i, n) {
          ((t &= ~fo),
            (t &= ~Wi),
            (e.suspendedLanes |= t),
            (e.pingedLanes &= ~t),
            n && (e.warmLanes |= t),
            (n = e.expirationTimes));
          for (var o = t; 0 < o; ) {
            var c = 31 - pt(o),
              m = 1 << c;
            ((n[c] = -1), (o &= ~m));
          }
          i !== 0 && ju(e, i, t);
        }
        function Pl() {
          return (Ee & 6) === 0 ? (Ba(0), !1) : !0;
        }
        function yo() {
          if (me !== null) {
            if (we === 0) var e = me.return;
            else
              ((e = me),
                (kt = Zi = null),
                Lr(e),
                (Dn = null),
                (_a = 0),
                (e = me));
            for (; e !== null; ) (ad(e.alternate, e), (e = e.return));
            me = null;
          }
        }
        function Kn(e, t) {
          var i = e.timeoutHandle;
          (i !== -1 && ((e.timeoutHandle = -1), av(i)),
            (i = e.cancelPendingCommit),
            i !== null && ((e.cancelPendingCommit = null), i()),
            yo(),
            (Ne = e),
            (me = i = Xt(e.current, null)),
            (ye = t),
            (we = 0),
            (bt = null),
            (Ti = !1),
            (Un = ea(e, t)),
            (co = !1),
            (Bn = zt = fo = Wi = Ei = je = 0),
            (ut = Ha = null),
            (ho = !1),
            (t & 8) !== 0 && (t |= t & 32));
          var n = e.entangledLanes;
          if (n !== 0)
            for (e = e.entanglements, n &= t; 0 < n; ) {
              var o = 31 - pt(n),
                c = 1 << o;
              ((t |= e[o]), (n &= ~c));
            }
          return ((ii = t), bl(), i);
        }
        function Ad(e, t) {
          ((he = null),
            (L.H = Bl),
            t === ba || t === _l
              ? ((t = qc()), (we = 3))
              : t === Gc
                ? ((t = qc()), (we = 4))
                : (we =
                    t === $f
                      ? 8
                      : t !== null &&
                          typeof t == 'object' &&
                          typeof t.then == 'function'
                        ? 6
                        : 1),
            (bt = t),
            me === null && ((je = 1), Yl(e, At(t, e.current))));
        }
        function Od() {
          var e = L.H;
          return ((L.H = Bl), e === null ? Bl : e);
        }
        function _d() {
          var e = L.A;
          return ((L.A = Bg), e);
        }
        function bo() {
          ((je = 4),
            Ti || ((ye & 4194048) !== ye && Nt.current !== null) || (Un = !0),
            ((Ei & 134217727) === 0 && (Wi & 134217727) === 0) ||
              Ne === null ||
              Ai(Ne, ye, zt, !1));
        }
        function So(e, t, i) {
          var n = Ee;
          Ee |= 2;
          var o = Od(),
            c = _d();
          ((Ne !== e || ye !== t) && ((Fl = null), Kn(e, t)), (t = !1));
          var m = je;
          e: do
            try {
              if (we !== 0 && me !== null) {
                var v = me,
                  S = bt;
                switch (we) {
                  case 8:
                    (yo(), (m = 6));
                    break e;
                  case 3:
                  case 2:
                  case 9:
                  case 6:
                    Nt.current === null && (t = !0);
                    var N = we;
                    if (((we = 0), (bt = null), qn(e, v, S, N), i && Un)) {
                      m = 0;
                      break e;
                    }
                    break;
                  default:
                    ((N = we), (we = 0), (bt = null), qn(e, v, S, N));
                }
              }
              (Kg(), (m = je));
              break;
            } catch (H) {
              Ad(e, H);
            }
          while (!0);
          return (
            t && e.shellSuspendCounter++,
            (kt = Zi = null),
            (Ee = n),
            (L.H = o),
            (L.A = c),
            me === null && ((Ne = null), (ye = 0), bl()),
            m
          );
        }
        function Kg() {
          for (; me !== null; ) Cd(me);
        }
        function qg(e, t) {
          var i = Ee;
          Ee |= 2;
          var n = Od(),
            o = _d();
          Ne !== e || ye !== t
            ? ((Fl = null), (Jl = Ht() + 500), Kn(e, t))
            : (Un = ea(e, t));
          e: do
            try {
              if (we !== 0 && me !== null) {
                t = me;
                var c = bt;
                t: switch (we) {
                  case 1:
                    ((we = 0), (bt = null), qn(e, t, c, 1));
                    break;
                  case 2:
                  case 9:
                    if (Vc(c)) {
                      ((we = 0), (bt = null), Nd(t));
                      break;
                    }
                    ((t = function () {
                      ((we !== 2 && we !== 9) || Ne !== e || (we = 7), Kt(e));
                    }),
                      c.then(t, t));
                    break e;
                  case 3:
                    we = 7;
                    break e;
                  case 4:
                    we = 5;
                    break e;
                  case 7:
                    Vc(c)
                      ? ((we = 0), (bt = null), Nd(t))
                      : ((we = 0), (bt = null), qn(e, t, c, 7));
                    break;
                  case 5:
                    var m = null;
                    switch (me.tag) {
                      case 26:
                        m = me.memoizedState;
                      case 5:
                      case 27:
                        var v = me;
                        if (!m || fh(m)) {
                          ((we = 0), (bt = null));
                          var S = v.sibling;
                          if (S !== null) me = S;
                          else {
                            var N = v.return;
                            N !== null ? ((me = N), Il(N)) : (me = null);
                          }
                          break t;
                        }
                    }
                    ((we = 0), (bt = null), qn(e, t, c, 5));
                    break;
                  case 6:
                    ((we = 0), (bt = null), qn(e, t, c, 6));
                    break;
                  case 8:
                    (yo(), (je = 6));
                    break e;
                  default:
                    throw Error(r(462));
                }
              }
              Yg();
              break;
            } catch (H) {
              Ad(e, H);
            }
          while (!0);
          return (
            (kt = Zi = null),
            (L.H = n),
            (L.A = o),
            (Ee = i),
            me !== null ? 0 : ((Ne = null), (ye = 0), bl(), je)
          );
        }
        function Yg() {
          for (; me !== null && !fm(); ) Cd(me);
        }
        function Cd(e) {
          var t = id(e.alternate, e, ii);
          ((e.memoizedProps = e.pendingProps), t === null ? Il(e) : (me = t));
        }
        function Nd(e) {
          var t = e,
            i = t.alternate;
          switch (t.tag) {
            case 15:
            case 0:
              t = Ff(i, t, t.pendingProps, t.type, void 0, ye);
              break;
            case 11:
              t = Ff(i, t, t.pendingProps, t.type.render, t.ref, ye);
              break;
            case 5:
              Lr(t);
            default:
              (ad(i, t), (t = me = Nc(t, ii)), (t = id(i, t, ii)));
          }
          ((e.memoizedProps = e.pendingProps), t === null ? Il(e) : (me = t));
        }
        function qn(e, t, i, n) {
          ((kt = Zi = null), Lr(t), (Dn = null), (_a = 0));
          var o = t.return;
          try {
            if (Rg(e, o, t, i, ye)) {
              ((je = 1), Yl(e, At(i, e.current)), (me = null));
              return;
            }
          } catch (c) {
            if (o !== null) throw ((me = o), c);
            ((je = 1), Yl(e, At(i, e.current)), (me = null));
            return;
          }
          t.flags & 32768
            ? (Te || n === 1
                ? (e = !0)
                : Un || (ye & 536870912) !== 0
                  ? (e = !1)
                  : ((Ti = e = !0),
                    (n === 2 || n === 9 || n === 3 || n === 6) &&
                      ((n = Nt.current),
                      n !== null && n.tag === 13 && (n.flags |= 16384))),
              zd(t, e))
            : Il(t);
        }
        function Il(e) {
          var t = e;
          do {
            if ((t.flags & 32768) !== 0) {
              zd(t, Ti);
              return;
            }
            e = t.return;
            var i = Lg(t.alternate, t, ii);
            if (i !== null) {
              me = i;
              return;
            }
            if (((t = t.sibling), t !== null)) {
              me = t;
              return;
            }
            me = t = e;
          } while (t !== null);
          je === 0 && (je = 5);
        }
        function zd(e, t) {
          do {
            var i = jg(e.alternate, e);
            if (i !== null) {
              ((i.flags &= 32767), (me = i));
              return;
            }
            if (
              ((i = e.return),
              i !== null &&
                ((i.flags |= 32768),
                (i.subtreeFlags = 0),
                (i.deletions = null)),
              !t && ((e = e.sibling), e !== null))
            ) {
              me = e;
              return;
            }
            me = e = i;
          } while (e !== null);
          ((je = 6), (me = null));
        }
        function Rd(e, t, i, n, o, c, m, v, S) {
          e.cancelPendingCommit = null;
          do Wl();
          while (Pe !== 0);
          if ((Ee & 6) !== 0) throw Error(r(327));
          if (t !== null) {
            if (t === e.current) throw Error(r(177));
            if (
              ((c = t.lanes | t.childLanes),
              (c |= ur),
              xm(e, i, c, m, v, S),
              e === Ne && ((me = Ne = null), (ye = 0)),
              (Gn = t),
              (Mi = e),
              (Vn = i),
              (mo = c),
              (go = o),
              (Td = n),
              (t.subtreeFlags & 10256) !== 0 || (t.flags & 10256) !== 0
                ? ((e.callbackNode = null),
                  (e.callbackPriority = 0),
                  Zg(al, function () {
                    return (Ud(), null);
                  }))
                : ((e.callbackNode = null), (e.callbackPriority = 0)),
              (n = (t.flags & 13878) !== 0),
              (t.subtreeFlags & 13878) !== 0 || n)
            ) {
              ((n = L.T),
                (L.T = null),
                (o = Z.p),
                (Z.p = 2),
                (m = Ee),
                (Ee |= 4));
              try {
                Hg(e, t);
              } finally {
                ((Ee = m), (Z.p = o), (L.T = n));
              }
            }
            ((Pe = 1), Dd(), Ld(), jd());
          }
        }
        function Dd() {
          if (Pe === 1) {
            Pe = 0;
            var e = Mi,
              t = Gn,
              i = (t.flags & 13878) !== 0;
            if ((t.subtreeFlags & 13878) !== 0 || i) {
              ((i = L.T), (L.T = null));
              var n = Z.p;
              Z.p = 2;
              var o = Ee;
              Ee |= 4;
              try {
                md(t, e);
                var c = Ro,
                  m = Sc(e.containerInfo),
                  v = c.focusedElem,
                  S = c.selectionRange;
                if (
                  m !== v &&
                  v &&
                  v.ownerDocument &&
                  bc(v.ownerDocument.documentElement, v)
                ) {
                  if (S !== null && ar(v)) {
                    var N = S.start,
                      H = S.end;
                    if ((H === void 0 && (H = N), 'selectionStart' in v))
                      ((v.selectionStart = N),
                        (v.selectionEnd = Math.min(H, v.value.length)));
                    else {
                      var K = v.ownerDocument || document,
                        z = (K && K.defaultView) || window;
                      if (z.getSelection) {
                        var R = z.getSelection(),
                          oe = v.textContent.length,
                          se = Math.min(S.start, oe),
                          Oe = S.end === void 0 ? se : Math.min(S.end, oe);
                        !R.extend && se > Oe && ((m = Oe), (Oe = se), (se = m));
                        var M = yc(v, se),
                          E = yc(v, Oe);
                        if (
                          M &&
                          E &&
                          (R.rangeCount !== 1 ||
                            R.anchorNode !== M.node ||
                            R.anchorOffset !== M.offset ||
                            R.focusNode !== E.node ||
                            R.focusOffset !== E.offset)
                        ) {
                          var C = K.createRange();
                          (C.setStart(M.node, M.offset),
                            R.removeAllRanges(),
                            se > Oe
                              ? (R.addRange(C), R.extend(E.node, E.offset))
                              : (C.setEnd(E.node, E.offset), R.addRange(C)));
                        }
                      }
                    }
                  }
                  for (K = [], R = v; (R = R.parentNode); )
                    R.nodeType === 1 &&
                      K.push({
                        element: R,
                        left: R.scrollLeft,
                        top: R.scrollTop,
                      });
                  for (
                    typeof v.focus == 'function' && v.focus(), v = 0;
                    v < K.length;
                    v++
                  ) {
                    var G = K[v];
                    ((G.element.scrollLeft = G.left),
                      (G.element.scrollTop = G.top));
                  }
                }
                ((fs = !!zo), (Ro = zo = null));
              } finally {
                ((Ee = o), (Z.p = n), (L.T = i));
              }
            }
            ((e.current = t), (Pe = 2));
          }
        }
        function Ld() {
          if (Pe === 2) {
            Pe = 0;
            var e = Mi,
              t = Gn,
              i = (t.flags & 8772) !== 0;
            if ((t.subtreeFlags & 8772) !== 0 || i) {
              ((i = L.T), (L.T = null));
              var n = Z.p;
              Z.p = 2;
              var o = Ee;
              Ee |= 4;
              try {
                fd(e, t.alternate, t);
              } finally {
                ((Ee = o), (Z.p = n), (L.T = i));
              }
            }
            Pe = 3;
          }
        }
        function jd() {
          if (Pe === 4 || Pe === 3) {
            ((Pe = 0), dm());
            var e = Mi,
              t = Gn,
              i = Vn,
              n = Td;
            (t.subtreeFlags & 10256) !== 0 || (t.flags & 10256) !== 0
              ? (Pe = 5)
              : ((Pe = 0), (Gn = Mi = null), Hd(e, e.pendingLanes));
            var o = e.pendingLanes;
            if (
              (o === 0 && (wi = null),
              Us(i),
              (t = t.stateNode),
              ht && typeof ht.onCommitFiberRoot == 'function')
            )
              try {
                ht.onCommitFiberRoot(
                  Wn,
                  t,
                  void 0,
                  (t.current.flags & 128) === 128
                );
              } catch {}
            if (n !== null) {
              ((t = L.T), (o = Z.p), (Z.p = 2), (L.T = null));
              try {
                for (var c = e.onRecoverableError, m = 0; m < n.length; m++) {
                  var v = n[m];
                  c(v.value, { componentStack: v.stack });
                }
              } finally {
                ((L.T = t), (Z.p = o));
              }
            }
            ((Vn & 3) !== 0 && Wl(),
              Kt(e),
              (o = e.pendingLanes),
              (i & 4194090) !== 0 && (o & 42) !== 0
                ? e === vo
                  ? Ua++
                  : ((Ua = 0), (vo = e))
                : (Ua = 0),
              Ba(0));
          }
        }
        function Hd(e, t) {
          (e.pooledCacheLanes &= t) === 0 &&
            ((t = e.pooledCache), t != null && ((e.pooledCache = null), va(t)));
        }
        function Wl(e) {
          return (Dd(), Ld(), jd(), Ud());
        }
        function Ud() {
          if (Pe !== 5) return !1;
          var e = Mi,
            t = mo;
          mo = 0;
          var i = Us(Vn),
            n = L.T,
            o = Z.p;
          try {
            ((Z.p = 32 > i ? 32 : i), (L.T = null), (i = go), (go = null));
            var c = Mi,
              m = Vn;
            if (((Pe = 0), (Gn = Mi = null), (Vn = 0), (Ee & 6) !== 0))
              throw Error(r(331));
            var v = Ee;
            if (
              ((Ee |= 4),
              Sd(c.current),
              vd(c, c.current, m, i),
              (Ee = v),
              Ba(0),
              ht && typeof ht.onPostCommitFiberRoot == 'function')
            )
              try {
                ht.onPostCommitFiberRoot(Wn, c);
              } catch {}
            return !0;
          } finally {
            ((Z.p = o), (L.T = n), Hd(e, t));
          }
        }
        function Bd(e, t, i) {
          ((t = At(i, t)),
            (t = kr(e.stateNode, t, 2)),
            (e = mi(e, t, 2)),
            e !== null && (ta(e, 2), Kt(e)));
        }
        function Ce(e, t, i) {
          if (e.tag === 3) Bd(e, e, i);
          else
            for (; t !== null; ) {
              if (t.tag === 3) {
                Bd(t, e, i);
                break;
              } else if (t.tag === 1) {
                var n = t.stateNode;
                if (
                  typeof t.type.getDerivedStateFromError == 'function' ||
                  (typeof n.componentDidCatch == 'function' &&
                    (wi === null || !wi.has(n)))
                ) {
                  ((e = At(i, e)),
                    (i = qf(2)),
                    (n = mi(t, i, 2)),
                    n !== null && (Yf(i, n, t, e), ta(n, 2), Kt(n)));
                  break;
                }
              }
              t = t.return;
            }
        }
        function xo(e, t, i) {
          var n = e.pingCache;
          if (n === null) {
            n = e.pingCache = new Gg();
            var o = new Set();
            n.set(t, o);
          } else
            ((o = n.get(t)), o === void 0 && ((o = new Set()), n.set(t, o)));
          o.has(i) ||
            ((co = !0), o.add(i), (e = $g.bind(null, e, t, i)), t.then(e, e));
        }
        function $g(e, t, i) {
          var n = e.pingCache;
          (n !== null && n.delete(t),
            (e.pingedLanes |= e.suspendedLanes & i),
            (e.warmLanes &= ~i),
            Ne === e &&
              (ye & i) === i &&
              (je === 4 ||
              (je === 3 && (ye & 62914560) === ye && 300 > Ht() - po)
                ? (Ee & 2) === 0 && Kn(e, 0)
                : (fo |= i),
              Bn === ye && (Bn = 0)),
            Kt(e));
        }
        function Gd(e, t) {
          (t === 0 && (t = Lu()),
            (e = En(e, t)),
            e !== null && (ta(e, t), Kt(e)));
        }
        function Xg(e) {
          var t = e.memoizedState,
            i = 0;
          (t !== null && (i = t.retryLane), Gd(e, i));
        }
        function Qg(e, t) {
          var i = 0;
          switch (e.tag) {
            case 13:
              var n = e.stateNode,
                o = e.memoizedState;
              o !== null && (i = o.retryLane);
              break;
            case 19:
              n = e.stateNode;
              break;
            case 22:
              n = e.stateNode._retryCache;
              break;
            default:
              throw Error(r(314));
          }
          (n !== null && n.delete(t), Gd(e, i));
        }
        function Zg(e, t) {
          return Ds(e, t);
        }
        var es = null,
          Yn = null,
          To = !1,
          ts = !1,
          Eo = !1,
          en = 0;
        function Kt(e) {
          (e !== Yn &&
            e.next === null &&
            (Yn === null ? (es = Yn = e) : (Yn = Yn.next = e)),
            (ts = !0),
            To || ((To = !0), Jg()));
        }
        function Ba(e, t) {
          if (!Eo && ts) {
            Eo = !0;
            do
              for (var i = !1, n = es; n !== null; ) {
                if (e !== 0) {
                  var o = n.pendingLanes;
                  if (o === 0) var c = 0;
                  else {
                    var m = n.suspendedLanes,
                      v = n.pingedLanes;
                    ((c = (1 << (31 - pt(42 | e) + 1)) - 1),
                      (c &= o & ~(m & ~v)),
                      (c =
                        c & 201326741 ? (c & 201326741) | 1 : c ? c | 2 : 0));
                  }
                  c !== 0 && ((i = !0), Yd(n, c));
                } else
                  ((c = ye),
                    (c = rl(
                      n,
                      n === Ne ? c : 0,
                      n.cancelPendingCommit !== null || n.timeoutHandle !== -1
                    )),
                    (c & 3) === 0 || ea(n, c) || ((i = !0), Yd(n, c)));
                n = n.next;
              }
            while (i);
            Eo = !1;
          }
        }
        function kg() {
          Vd();
        }
        function Vd() {
          ts = To = !1;
          var e = 0;
          en !== 0 && (nv() && (e = en), (en = 0));
          for (var t = Ht(), i = null, n = es; n !== null; ) {
            var o = n.next,
              c = Kd(n, t);
            (c === 0
              ? ((n.next = null),
                i === null ? (es = o) : (i.next = o),
                o === null && (Yn = i))
              : ((i = n), (e !== 0 || (c & 3) !== 0) && (ts = !0)),
              (n = o));
          }
          Ba(e);
        }
        function Kd(e, t) {
          for (
            var i = e.suspendedLanes,
              n = e.pingedLanes,
              o = e.expirationTimes,
              c = e.pendingLanes & -62914561;
            0 < c;
          ) {
            var m = 31 - pt(c),
              v = 1 << m,
              S = o[m];
            (S === -1
              ? ((v & i) === 0 || (v & n) !== 0) && (o[m] = Sm(v, t))
              : S <= t && (e.expiredLanes |= v),
              (c &= ~v));
          }
          if (
            ((t = Ne),
            (i = ye),
            (i = rl(
              e,
              e === t ? i : 0,
              e.cancelPendingCommit !== null || e.timeoutHandle !== -1
            )),
            (n = e.callbackNode),
            i === 0 ||
              (e === t && (we === 2 || we === 9)) ||
              e.cancelPendingCommit !== null)
          )
            return (
              n !== null && n !== null && Ls(n),
              (e.callbackNode = null),
              (e.callbackPriority = 0)
            );
          if ((i & 3) === 0 || ea(e, i)) {
            if (((t = i & -i), t === e.callbackPriority)) return t;
            switch ((n !== null && Ls(n), Us(i))) {
              case 2:
              case 8:
                i = zu;
                break;
              case 32:
                i = al;
                break;
              case 268435456:
                i = Ru;
                break;
              default:
                i = al;
            }
            return (
              (n = qd.bind(null, e)),
              (i = Ds(i, n)),
              (e.callbackPriority = t),
              (e.callbackNode = i),
              t
            );
          }
          return (
            n !== null && n !== null && Ls(n),
            (e.callbackPriority = 2),
            (e.callbackNode = null),
            2
          );
        }
        function qd(e, t) {
          if (Pe !== 0 && Pe !== 5)
            return ((e.callbackNode = null), (e.callbackPriority = 0), null);
          var i = e.callbackNode;
          if (Wl() && e.callbackNode !== i) return null;
          var n = ye;
          return (
            (n = rl(
              e,
              e === Ne ? n : 0,
              e.cancelPendingCommit !== null || e.timeoutHandle !== -1
            )),
            n === 0
              ? null
              : (wd(e, n, t),
                Kd(e, Ht()),
                e.callbackNode != null && e.callbackNode === i
                  ? qd.bind(null, e)
                  : null)
          );
        }
        function Yd(e, t) {
          if (Wl()) return null;
          wd(e, t, !0);
        }
        function Jg() {
          lv(function () {
            (Ee & 6) !== 0 ? Ds(Nu, kg) : Vd();
          });
        }
        function wo() {
          return (en === 0 && (en = Du()), en);
        }
        function $d(e) {
          return e == null || typeof e == 'symbol' || typeof e == 'boolean'
            ? null
            : typeof e == 'function'
              ? e
              : dl('' + e);
        }
        function Xd(e, t) {
          var i = t.ownerDocument.createElement('input');
          return (
            (i.name = t.name),
            (i.value = t.value),
            e.id && i.setAttribute('form', e.id),
            t.parentNode.insertBefore(i, t),
            (e = new FormData(e)),
            i.parentNode.removeChild(i),
            e
          );
        }
        function Fg(e, t, i, n, o) {
          if (t === 'submit' && i && i.stateNode === o) {
            var c = $d((o[lt] || null).action),
              m = n.submitter;
            m &&
              ((t = (t = m[lt] || null)
                ? $d(t.formAction)
                : m.getAttribute('formAction')),
              t !== null && ((c = t), (m = null)));
            var v = new gl('action', 'action', null, n, o);
            e.push({
              event: v,
              listeners: [
                {
                  instance: null,
                  listener: function () {
                    if (n.defaultPrevented) {
                      if (en !== 0) {
                        var S = m ? Xd(o, m) : new FormData(o);
                        Yr(
                          i,
                          { pending: !0, data: S, method: o.method, action: c },
                          null,
                          S
                        );
                      }
                    } else
                      typeof c == 'function' &&
                        (v.preventDefault(),
                        (S = m ? Xd(o, m) : new FormData(o)),
                        Yr(
                          i,
                          { pending: !0, data: S, method: o.method, action: c },
                          c,
                          S
                        ));
                  },
                  currentTarget: o,
                },
              ],
            });
          }
        }
        for (var Mo = 0; Mo < or.length; Mo++) {
          var Ao = or[Mo],
            Pg = Ao.toLowerCase(),
            Ig = Ao[0].toUpperCase() + Ao.slice(1);
          Dt(Pg, 'on' + Ig);
        }
        (Dt(Ec, 'onAnimationEnd'),
          Dt(wc, 'onAnimationIteration'),
          Dt(Mc, 'onAnimationStart'),
          Dt('dblclick', 'onDoubleClick'),
          Dt('focusin', 'onFocus'),
          Dt('focusout', 'onBlur'),
          Dt(mg, 'onTransitionRun'),
          Dt(gg, 'onTransitionStart'),
          Dt(vg, 'onTransitionCancel'),
          Dt(Ac, 'onTransitionEnd'),
          hn('onMouseEnter', ['mouseout', 'mouseover']),
          hn('onMouseLeave', ['mouseout', 'mouseover']),
          hn('onPointerEnter', ['pointerout', 'pointerover']),
          hn('onPointerLeave', ['pointerout', 'pointerover']),
          Bi(
            'onChange',
            'change click focusin focusout input keydown keyup selectionchange'.split(
              ' '
            )
          ),
          Bi(
            'onSelect',
            'focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange'.split(
              ' '
            )
          ),
          Bi('onBeforeInput', [
            'compositionend',
            'keypress',
            'textInput',
            'paste',
          ]),
          Bi(
            'onCompositionEnd',
            'compositionend focusout keydown keypress keyup mousedown'.split(
              ' '
            )
          ),
          Bi(
            'onCompositionStart',
            'compositionstart focusout keydown keypress keyup mousedown'.split(
              ' '
            )
          ),
          Bi(
            'onCompositionUpdate',
            'compositionupdate focusout keydown keypress keyup mousedown'.split(
              ' '
            )
          ));
        var Ga =
            'abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting'.split(
              ' '
            ),
          Wg = new Set(
            'beforetoggle cancel close invalid load scroll scrollend toggle'
              .split(' ')
              .concat(Ga)
          );
        function Qd(e, t) {
          t = (t & 4) !== 0;
          for (var i = 0; i < e.length; i++) {
            var n = e[i],
              o = n.event;
            n = n.listeners;
            e: {
              var c = void 0;
              if (t)
                for (var m = n.length - 1; 0 <= m; m--) {
                  var v = n[m],
                    S = v.instance,
                    N = v.currentTarget;
                  if (((v = v.listener), S !== c && o.isPropagationStopped()))
                    break e;
                  ((c = v), (o.currentTarget = N));
                  try {
                    c(o);
                  } catch (H) {
                    ql(H);
                  }
                  ((o.currentTarget = null), (c = S));
                }
              else
                for (m = 0; m < n.length; m++) {
                  if (
                    ((v = n[m]),
                    (S = v.instance),
                    (N = v.currentTarget),
                    (v = v.listener),
                    S !== c && o.isPropagationStopped())
                  )
                    break e;
                  ((c = v), (o.currentTarget = N));
                  try {
                    c(o);
                  } catch (H) {
                    ql(H);
                  }
                  ((o.currentTarget = null), (c = S));
                }
            }
          }
        }
        function ge(e, t) {
          var i = t[Bs];
          i === void 0 && (i = t[Bs] = new Set());
          var n = e + '__bubble';
          i.has(n) || (Zd(t, e, 2, !1), i.add(n));
        }
        function Oo(e, t, i) {
          var n = 0;
          (t && (n |= 4), Zd(i, e, n, t));
        }
        var is = '_reactListening' + Math.random().toString(36).slice(2);
        function _o(e) {
          if (!e[is]) {
            ((e[is] = !0),
              Gu.forEach(function (i) {
                i !== 'selectionchange' &&
                  (Wg.has(i) || Oo(i, !1, e), Oo(i, !0, e));
              }));
            var t = e.nodeType === 9 ? e : e.ownerDocument;
            t === null || t[is] || ((t[is] = !0), Oo('selectionchange', !1, t));
          }
        }
        function Zd(e, t, i, n) {
          switch (vh(t)) {
            case 2:
              var o = Av;
              break;
            case 8:
              o = Ov;
              break;
            default:
              o = qo;
          }
          ((i = o.bind(null, t, i, e)),
            (o = void 0),
            !Js ||
              (t !== 'touchstart' && t !== 'touchmove' && t !== 'wheel') ||
              (o = !0),
            n
              ? o !== void 0
                ? e.addEventListener(t, i, { capture: !0, passive: o })
                : e.addEventListener(t, i, !0)
              : o !== void 0
                ? e.addEventListener(t, i, { passive: o })
                : e.addEventListener(t, i, !1));
        }
        function Co(e, t, i, n, o) {
          var c = n;
          if ((t & 1) === 0 && (t & 2) === 0 && n !== null)
            e: for (;;) {
              if (n === null) return;
              var m = n.tag;
              if (m === 3 || m === 4) {
                var v = n.stateNode.containerInfo;
                if (v === o) break;
                if (m === 4)
                  for (m = n.return; m !== null; ) {
                    var S = m.tag;
                    if ((S === 3 || S === 4) && m.stateNode.containerInfo === o)
                      return;
                    m = m.return;
                  }
                for (; v !== null; ) {
                  if (((m = cn(v)), m === null)) return;
                  if (
                    ((S = m.tag), S === 5 || S === 6 || S === 26 || S === 27)
                  ) {
                    n = c = m;
                    continue e;
                  }
                  v = v.parentNode;
                }
              }
              n = n.return;
            }
          Wu(function () {
            var N = c,
              H = Zs(i),
              K = [];
            e: {
              var z = Oc.get(e);
              if (z !== void 0) {
                var R = gl,
                  oe = e;
                switch (e) {
                  case 'keypress':
                    if (pl(i) === 0) break e;
                  case 'keydown':
                  case 'keyup':
                    R = Zm;
                    break;
                  case 'focusin':
                    ((oe = 'focus'), (R = Ws));
                    break;
                  case 'focusout':
                    ((oe = 'blur'), (R = Ws));
                    break;
                  case 'beforeblur':
                  case 'afterblur':
                    R = Ws;
                    break;
                  case 'click':
                    if (i.button === 2) break e;
                  case 'auxclick':
                  case 'dblclick':
                  case 'mousedown':
                  case 'mousemove':
                  case 'mouseup':
                  case 'mouseout':
                  case 'mouseover':
                  case 'contextmenu':
                    R = ic;
                    break;
                  case 'drag':
                  case 'dragend':
                  case 'dragenter':
                  case 'dragexit':
                  case 'dragleave':
                  case 'dragover':
                  case 'dragstart':
                  case 'drop':
                    R = jm;
                    break;
                  case 'touchcancel':
                  case 'touchend':
                  case 'touchmove':
                  case 'touchstart':
                    R = Fm;
                    break;
                  case Ec:
                  case wc:
                  case Mc:
                    R = Bm;
                    break;
                  case Ac:
                    R = Im;
                    break;
                  case 'scroll':
                  case 'scrollend':
                    R = Dm;
                    break;
                  case 'wheel':
                    R = eg;
                    break;
                  case 'copy':
                  case 'cut':
                  case 'paste':
                    R = Vm;
                    break;
                  case 'gotpointercapture':
                  case 'lostpointercapture':
                  case 'pointercancel':
                  case 'pointerdown':
                  case 'pointermove':
                  case 'pointerout':
                  case 'pointerover':
                  case 'pointerup':
                    R = ac;
                    break;
                  case 'toggle':
                  case 'beforetoggle':
                    R = ig;
                }
                var se = (t & 4) !== 0,
                  Oe = !se && (e === 'scroll' || e === 'scrollend'),
                  M = se ? (z !== null ? z + 'Capture' : null) : z;
                se = [];
                for (var E = N, C; E !== null; ) {
                  var G = E;
                  if (
                    ((C = G.stateNode),
                    (G = G.tag),
                    (G !== 5 && G !== 26 && G !== 27) ||
                      C === null ||
                      M === null ||
                      ((G = aa(E, M)), G != null && se.push(Va(E, G, C))),
                    Oe)
                  )
                    break;
                  E = E.return;
                }
                0 < se.length &&
                  ((z = new R(z, oe, null, i, H)),
                  K.push({ event: z, listeners: se }));
              }
            }
            if ((t & 7) === 0) {
              e: {
                if (
                  ((z = e === 'mouseover' || e === 'pointerover'),
                  (R = e === 'mouseout' || e === 'pointerout'),
                  z &&
                    i !== Qs &&
                    (oe = i.relatedTarget || i.fromElement) &&
                    (cn(oe) || oe[un]))
                )
                  break e;
                if (
                  (R || z) &&
                  ((z =
                    H.window === H
                      ? H
                      : (z = H.ownerDocument)
                        ? z.defaultView || z.parentWindow
                        : window),
                  R
                    ? ((oe = i.relatedTarget || i.toElement),
                      (R = N),
                      (oe = oe ? cn(oe) : null),
                      oe !== null &&
                        ((Oe = f(oe)),
                        (se = oe.tag),
                        oe !== Oe || (se !== 5 && se !== 27 && se !== 6)) &&
                        (oe = null))
                    : ((R = null), (oe = N)),
                  R !== oe)
                ) {
                  if (
                    ((se = ic),
                    (G = 'onMouseLeave'),
                    (M = 'onMouseEnter'),
                    (E = 'mouse'),
                    (e === 'pointerout' || e === 'pointerover') &&
                      ((se = ac),
                      (G = 'onPointerLeave'),
                      (M = 'onPointerEnter'),
                      (E = 'pointer')),
                    (Oe = R == null ? z : na(R)),
                    (C = oe == null ? z : na(oe)),
                    (z = new se(G, E + 'leave', R, i, H)),
                    (z.target = Oe),
                    (z.relatedTarget = C),
                    (G = null),
                    cn(H) === N &&
                      ((se = new se(M, E + 'enter', oe, i, H)),
                      (se.target = C),
                      (se.relatedTarget = Oe),
                      (G = se)),
                    (Oe = G),
                    R && oe)
                  )
                    t: {
                      for (se = R, M = oe, E = 0, C = se; C; C = $n(C)) E++;
                      for (C = 0, G = M; G; G = $n(G)) C++;
                      for (; 0 < E - C; ) ((se = $n(se)), E--);
                      for (; 0 < C - E; ) ((M = $n(M)), C--);
                      for (; E--; ) {
                        if (se === M || (M !== null && se === M.alternate))
                          break t;
                        ((se = $n(se)), (M = $n(M)));
                      }
                      se = null;
                    }
                  else se = null;
                  (R !== null && kd(K, z, R, se, !1),
                    oe !== null && Oe !== null && kd(K, Oe, oe, se, !0));
                }
              }
              e: {
                if (
                  ((z = N ? na(N) : window),
                  (R = z.nodeName && z.nodeName.toLowerCase()),
                  R === 'select' || (R === 'input' && z.type === 'file'))
                )
                  var te = dc;
                else if (cc(z))
                  if (hc) te = dg;
                  else {
                    te = cg;
                    var pe = ug;
                  }
                else
                  ((R = z.nodeName),
                    !R ||
                    R.toLowerCase() !== 'input' ||
                    (z.type !== 'checkbox' && z.type !== 'radio')
                      ? N && Xs(N.elementType) && (te = dc)
                      : (te = fg));
                if (te && (te = te(e, N))) {
                  fc(K, te, i, H);
                  break e;
                }
                (pe && pe(e, z, N),
                  e === 'focusout' &&
                    N &&
                    z.type === 'number' &&
                    N.memoizedProps.value != null &&
                    $s(z, 'number', z.value));
              }
              switch (((pe = N ? na(N) : window), e)) {
                case 'focusin':
                  (cc(pe) || pe.contentEditable === 'true') &&
                    ((Sn = pe), (lr = N), (da = null));
                  break;
                case 'focusout':
                  da = lr = Sn = null;
                  break;
                case 'mousedown':
                  sr = !0;
                  break;
                case 'contextmenu':
                case 'mouseup':
                case 'dragend':
                  ((sr = !1), xc(K, i, H));
                  break;
                case 'selectionchange':
                  if (pg) break;
                case 'keydown':
                case 'keyup':
                  xc(K, i, H);
              }
              var ae;
              if (tr)
                e: {
                  switch (e) {
                    case 'compositionstart':
                      var re = 'onCompositionStart';
                      break e;
                    case 'compositionend':
                      re = 'onCompositionEnd';
                      break e;
                    case 'compositionupdate':
                      re = 'onCompositionUpdate';
                      break e;
                  }
                  re = void 0;
                }
              else
                bn
                  ? oc(e, i) && (re = 'onCompositionEnd')
                  : e === 'keydown' &&
                    i.keyCode === 229 &&
                    (re = 'onCompositionStart');
              (re &&
                (lc &&
                  i.locale !== 'ko' &&
                  (bn || re !== 'onCompositionStart'
                    ? re === 'onCompositionEnd' && bn && (ae = ec())
                    : ((fi = H),
                      (Fs = 'value' in fi ? fi.value : fi.textContent),
                      (bn = !0))),
                (pe = ns(N, re)),
                0 < pe.length &&
                  ((re = new nc(re, e, null, i, H)),
                  K.push({ event: re, listeners: pe }),
                  ae
                    ? (re.data = ae)
                    : ((ae = uc(i)), ae !== null && (re.data = ae)))),
                (ae = ag ? lg(e, i) : sg(e, i)) &&
                  ((re = ns(N, 'onBeforeInput')),
                  0 < re.length &&
                    ((pe = new nc('onBeforeInput', 'beforeinput', null, i, H)),
                    K.push({ event: pe, listeners: re }),
                    (pe.data = ae))),
                Fg(K, e, N, i, H));
            }
            Qd(K, t);
          });
        }
        function Va(e, t, i) {
          return { instance: e, listener: t, currentTarget: i };
        }
        function ns(e, t) {
          for (var i = t + 'Capture', n = []; e !== null; ) {
            var o = e,
              c = o.stateNode;
            if (
              ((o = o.tag),
              (o !== 5 && o !== 26 && o !== 27) ||
                c === null ||
                ((o = aa(e, i)),
                o != null && n.unshift(Va(e, o, c)),
                (o = aa(e, t)),
                o != null && n.push(Va(e, o, c))),
              e.tag === 3)
            )
              return n;
            e = e.return;
          }
          return [];
        }
        function $n(e) {
          if (e === null) return null;
          do e = e.return;
          while (e && e.tag !== 5 && e.tag !== 27);
          return e || null;
        }
        function kd(e, t, i, n, o) {
          for (var c = t._reactName, m = []; i !== null && i !== n; ) {
            var v = i,
              S = v.alternate,
              N = v.stateNode;
            if (((v = v.tag), S !== null && S === n)) break;
            ((v !== 5 && v !== 26 && v !== 27) ||
              N === null ||
              ((S = N),
              o
                ? ((N = aa(i, c)), N != null && m.unshift(Va(i, N, S)))
                : o || ((N = aa(i, c)), N != null && m.push(Va(i, N, S)))),
              (i = i.return));
          }
          m.length !== 0 && e.push({ event: t, listeners: m });
        }
        var ev = /\r\n?/g,
          tv = /\u0000|\uFFFD/g;
        function Jd(e) {
          return (typeof e == 'string' ? e : '' + e)
            .replace(
              ev,
              `
`
            )
            .replace(tv, '');
        }
        function Fd(e, t) {
          return ((t = Jd(t)), Jd(e) === t);
        }
        function as() {}
        function Ae(e, t, i, n, o, c) {
          switch (i) {
            case 'children':
              typeof n == 'string'
                ? t === 'body' || (t === 'textarea' && n === '') || gn(e, n)
                : (typeof n == 'number' || typeof n == 'bigint') &&
                  t !== 'body' &&
                  gn(e, '' + n);
              break;
            case 'className':
              ul(e, 'class', n);
              break;
            case 'tabIndex':
              ul(e, 'tabindex', n);
              break;
            case 'dir':
            case 'role':
            case 'viewBox':
            case 'width':
            case 'height':
              ul(e, i, n);
              break;
            case 'style':
              Pu(e, n, c);
              break;
            case 'data':
              if (t !== 'object') {
                ul(e, 'data', n);
                break;
              }
            case 'src':
            case 'href':
              if (n === '' && (t !== 'a' || i !== 'href')) {
                e.removeAttribute(i);
                break;
              }
              if (
                n == null ||
                typeof n == 'function' ||
                typeof n == 'symbol' ||
                typeof n == 'boolean'
              ) {
                e.removeAttribute(i);
                break;
              }
              ((n = dl('' + n)), e.setAttribute(i, n));
              break;
            case 'action':
            case 'formAction':
              if (typeof n == 'function') {
                e.setAttribute(
                  i,
                  "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
                );
                break;
              } else
                typeof c == 'function' &&
                  (i === 'formAction'
                    ? (t !== 'input' && Ae(e, t, 'name', o.name, o, null),
                      Ae(e, t, 'formEncType', o.formEncType, o, null),
                      Ae(e, t, 'formMethod', o.formMethod, o, null),
                      Ae(e, t, 'formTarget', o.formTarget, o, null))
                    : (Ae(e, t, 'encType', o.encType, o, null),
                      Ae(e, t, 'method', o.method, o, null),
                      Ae(e, t, 'target', o.target, o, null)));
              if (n == null || typeof n == 'symbol' || typeof n == 'boolean') {
                e.removeAttribute(i);
                break;
              }
              ((n = dl('' + n)), e.setAttribute(i, n));
              break;
            case 'onClick':
              n != null && (e.onclick = as);
              break;
            case 'onScroll':
              n != null && ge('scroll', e);
              break;
            case 'onScrollEnd':
              n != null && ge('scrollend', e);
              break;
            case 'dangerouslySetInnerHTML':
              if (n != null) {
                if (typeof n != 'object' || !('__html' in n))
                  throw Error(r(61));
                if (((i = n.__html), i != null)) {
                  if (o.children != null) throw Error(r(60));
                  e.innerHTML = i;
                }
              }
              break;
            case 'multiple':
              e.multiple = n && typeof n != 'function' && typeof n != 'symbol';
              break;
            case 'muted':
              e.muted = n && typeof n != 'function' && typeof n != 'symbol';
              break;
            case 'suppressContentEditableWarning':
            case 'suppressHydrationWarning':
            case 'defaultValue':
            case 'defaultChecked':
            case 'innerHTML':
            case 'ref':
              break;
            case 'autoFocus':
              break;
            case 'xlinkHref':
              if (
                n == null ||
                typeof n == 'function' ||
                typeof n == 'boolean' ||
                typeof n == 'symbol'
              ) {
                e.removeAttribute('xlink:href');
                break;
              }
              ((i = dl('' + n)),
                e.setAttributeNS(
                  'http://www.w3.org/1999/xlink',
                  'xlink:href',
                  i
                ));
              break;
            case 'contentEditable':
            case 'spellCheck':
            case 'draggable':
            case 'value':
            case 'autoReverse':
            case 'externalResourcesRequired':
            case 'focusable':
            case 'preserveAlpha':
              n != null && typeof n != 'function' && typeof n != 'symbol'
                ? e.setAttribute(i, '' + n)
                : e.removeAttribute(i);
              break;
            case 'inert':
            case 'allowFullScreen':
            case 'async':
            case 'autoPlay':
            case 'controls':
            case 'default':
            case 'defer':
            case 'disabled':
            case 'disablePictureInPicture':
            case 'disableRemotePlayback':
            case 'formNoValidate':
            case 'hidden':
            case 'loop':
            case 'noModule':
            case 'noValidate':
            case 'open':
            case 'playsInline':
            case 'readOnly':
            case 'required':
            case 'reversed':
            case 'scoped':
            case 'seamless':
            case 'itemScope':
              n && typeof n != 'function' && typeof n != 'symbol'
                ? e.setAttribute(i, '')
                : e.removeAttribute(i);
              break;
            case 'capture':
            case 'download':
              n === !0
                ? e.setAttribute(i, '')
                : n !== !1 &&
                    n != null &&
                    typeof n != 'function' &&
                    typeof n != 'symbol'
                  ? e.setAttribute(i, n)
                  : e.removeAttribute(i);
              break;
            case 'cols':
            case 'rows':
            case 'size':
            case 'span':
              n != null &&
              typeof n != 'function' &&
              typeof n != 'symbol' &&
              !isNaN(n) &&
              1 <= n
                ? e.setAttribute(i, n)
                : e.removeAttribute(i);
              break;
            case 'rowSpan':
            case 'start':
              n == null ||
              typeof n == 'function' ||
              typeof n == 'symbol' ||
              isNaN(n)
                ? e.removeAttribute(i)
                : e.setAttribute(i, n);
              break;
            case 'popover':
              (ge('beforetoggle', e), ge('toggle', e), ol(e, 'popover', n));
              break;
            case 'xlinkActuate':
              Yt(e, 'http://www.w3.org/1999/xlink', 'xlink:actuate', n);
              break;
            case 'xlinkArcrole':
              Yt(e, 'http://www.w3.org/1999/xlink', 'xlink:arcrole', n);
              break;
            case 'xlinkRole':
              Yt(e, 'http://www.w3.org/1999/xlink', 'xlink:role', n);
              break;
            case 'xlinkShow':
              Yt(e, 'http://www.w3.org/1999/xlink', 'xlink:show', n);
              break;
            case 'xlinkTitle':
              Yt(e, 'http://www.w3.org/1999/xlink', 'xlink:title', n);
              break;
            case 'xlinkType':
              Yt(e, 'http://www.w3.org/1999/xlink', 'xlink:type', n);
              break;
            case 'xmlBase':
              Yt(e, 'http://www.w3.org/XML/1998/namespace', 'xml:base', n);
              break;
            case 'xmlLang':
              Yt(e, 'http://www.w3.org/XML/1998/namespace', 'xml:lang', n);
              break;
            case 'xmlSpace':
              Yt(e, 'http://www.w3.org/XML/1998/namespace', 'xml:space', n);
              break;
            case 'is':
              ol(e, 'is', n);
              break;
            case 'innerText':
            case 'textContent':
              break;
            default:
              (!(2 < i.length) ||
                (i[0] !== 'o' && i[0] !== 'O') ||
                (i[1] !== 'n' && i[1] !== 'N')) &&
                ((i = zm.get(i) || i), ol(e, i, n));
          }
        }
        function No(e, t, i, n, o, c) {
          switch (i) {
            case 'style':
              Pu(e, n, c);
              break;
            case 'dangerouslySetInnerHTML':
              if (n != null) {
                if (typeof n != 'object' || !('__html' in n))
                  throw Error(r(61));
                if (((i = n.__html), i != null)) {
                  if (o.children != null) throw Error(r(60));
                  e.innerHTML = i;
                }
              }
              break;
            case 'children':
              typeof n == 'string'
                ? gn(e, n)
                : (typeof n == 'number' || typeof n == 'bigint') &&
                  gn(e, '' + n);
              break;
            case 'onScroll':
              n != null && ge('scroll', e);
              break;
            case 'onScrollEnd':
              n != null && ge('scrollend', e);
              break;
            case 'onClick':
              n != null && (e.onclick = as);
              break;
            case 'suppressContentEditableWarning':
            case 'suppressHydrationWarning':
            case 'innerHTML':
            case 'ref':
              break;
            case 'innerText':
            case 'textContent':
              break;
            default:
              if (!Vu.hasOwnProperty(i))
                e: {
                  if (
                    i[0] === 'o' &&
                    i[1] === 'n' &&
                    ((o = i.endsWith('Capture')),
                    (t = i.slice(2, o ? i.length - 7 : void 0)),
                    (c = e[lt] || null),
                    (c = c != null ? c[i] : null),
                    typeof c == 'function' && e.removeEventListener(t, c, o),
                    typeof n == 'function')
                  ) {
                    (typeof c != 'function' &&
                      c !== null &&
                      (i in e
                        ? (e[i] = null)
                        : e.hasAttribute(i) && e.removeAttribute(i)),
                      e.addEventListener(t, n, o));
                    break e;
                  }
                  i in e
                    ? (e[i] = n)
                    : n === !0
                      ? e.setAttribute(i, '')
                      : ol(e, i, n);
                }
          }
        }
        function Ie(e, t, i) {
          switch (t) {
            case 'div':
            case 'span':
            case 'svg':
            case 'path':
            case 'a':
            case 'g':
            case 'p':
            case 'li':
              break;
            case 'img':
              (ge('error', e), ge('load', e));
              var n = !1,
                o = !1,
                c;
              for (c in i)
                if (i.hasOwnProperty(c)) {
                  var m = i[c];
                  if (m != null)
                    switch (c) {
                      case 'src':
                        n = !0;
                        break;
                      case 'srcSet':
                        o = !0;
                        break;
                      case 'children':
                      case 'dangerouslySetInnerHTML':
                        throw Error(r(137, t));
                      default:
                        Ae(e, t, c, m, i, null);
                    }
                }
              (o && Ae(e, t, 'srcSet', i.srcSet, i, null),
                n && Ae(e, t, 'src', i.src, i, null));
              return;
            case 'input':
              ge('invalid', e);
              var v = (c = m = o = null),
                S = null,
                N = null;
              for (n in i)
                if (i.hasOwnProperty(n)) {
                  var H = i[n];
                  if (H != null)
                    switch (n) {
                      case 'name':
                        o = H;
                        break;
                      case 'type':
                        m = H;
                        break;
                      case 'checked':
                        S = H;
                        break;
                      case 'defaultChecked':
                        N = H;
                        break;
                      case 'value':
                        c = H;
                        break;
                      case 'defaultValue':
                        v = H;
                        break;
                      case 'children':
                      case 'dangerouslySetInnerHTML':
                        if (H != null) throw Error(r(137, t));
                        break;
                      default:
                        Ae(e, t, n, H, i, null);
                    }
                }
              (Zu(e, c, v, S, N, m, o, !1), cl(e));
              return;
            case 'select':
              (ge('invalid', e), (n = m = c = null));
              for (o in i)
                if (i.hasOwnProperty(o) && ((v = i[o]), v != null))
                  switch (o) {
                    case 'value':
                      c = v;
                      break;
                    case 'defaultValue':
                      m = v;
                      break;
                    case 'multiple':
                      n = v;
                    default:
                      Ae(e, t, o, v, i, null);
                  }
              ((t = c),
                (i = m),
                (e.multiple = !!n),
                t != null ? mn(e, !!n, t, !1) : i != null && mn(e, !!n, i, !0));
              return;
            case 'textarea':
              (ge('invalid', e), (c = o = n = null));
              for (m in i)
                if (i.hasOwnProperty(m) && ((v = i[m]), v != null))
                  switch (m) {
                    case 'value':
                      n = v;
                      break;
                    case 'defaultValue':
                      o = v;
                      break;
                    case 'children':
                      c = v;
                      break;
                    case 'dangerouslySetInnerHTML':
                      if (v != null) throw Error(r(91));
                      break;
                    default:
                      Ae(e, t, m, v, i, null);
                  }
              (Ju(e, n, o, c), cl(e));
              return;
            case 'option':
              for (S in i)
                if (i.hasOwnProperty(S) && ((n = i[S]), n != null))
                  switch (S) {
                    case 'selected':
                      e.selected =
                        n && typeof n != 'function' && typeof n != 'symbol';
                      break;
                    default:
                      Ae(e, t, S, n, i, null);
                  }
              return;
            case 'dialog':
              (ge('beforetoggle', e),
                ge('toggle', e),
                ge('cancel', e),
                ge('close', e));
              break;
            case 'iframe':
            case 'object':
              ge('load', e);
              break;
            case 'video':
            case 'audio':
              for (n = 0; n < Ga.length; n++) ge(Ga[n], e);
              break;
            case 'image':
              (ge('error', e), ge('load', e));
              break;
            case 'details':
              ge('toggle', e);
              break;
            case 'embed':
            case 'source':
            case 'link':
              (ge('error', e), ge('load', e));
            case 'area':
            case 'base':
            case 'br':
            case 'col':
            case 'hr':
            case 'keygen':
            case 'meta':
            case 'param':
            case 'track':
            case 'wbr':
            case 'menuitem':
              for (N in i)
                if (i.hasOwnProperty(N) && ((n = i[N]), n != null))
                  switch (N) {
                    case 'children':
                    case 'dangerouslySetInnerHTML':
                      throw Error(r(137, t));
                    default:
                      Ae(e, t, N, n, i, null);
                  }
              return;
            default:
              if (Xs(t)) {
                for (H in i)
                  i.hasOwnProperty(H) &&
                    ((n = i[H]), n !== void 0 && No(e, t, H, n, i, void 0));
                return;
              }
          }
          for (v in i)
            i.hasOwnProperty(v) &&
              ((n = i[v]), n != null && Ae(e, t, v, n, i, null));
        }
        function iv(e, t, i, n) {
          switch (t) {
            case 'div':
            case 'span':
            case 'svg':
            case 'path':
            case 'a':
            case 'g':
            case 'p':
            case 'li':
              break;
            case 'input':
              var o = null,
                c = null,
                m = null,
                v = null,
                S = null,
                N = null,
                H = null;
              for (R in i) {
                var K = i[R];
                if (i.hasOwnProperty(R) && K != null)
                  switch (R) {
                    case 'checked':
                      break;
                    case 'value':
                      break;
                    case 'defaultValue':
                      S = K;
                    default:
                      n.hasOwnProperty(R) || Ae(e, t, R, null, n, K);
                  }
              }
              for (var z in n) {
                var R = n[z];
                if (
                  ((K = i[z]), n.hasOwnProperty(z) && (R != null || K != null))
                )
                  switch (z) {
                    case 'type':
                      c = R;
                      break;
                    case 'name':
                      o = R;
                      break;
                    case 'checked':
                      N = R;
                      break;
                    case 'defaultChecked':
                      H = R;
                      break;
                    case 'value':
                      m = R;
                      break;
                    case 'defaultValue':
                      v = R;
                      break;
                    case 'children':
                    case 'dangerouslySetInnerHTML':
                      if (R != null) throw Error(r(137, t));
                      break;
                    default:
                      R !== K && Ae(e, t, z, R, n, K);
                  }
              }
              Ys(e, m, v, S, N, H, c, o);
              return;
            case 'select':
              R = m = v = z = null;
              for (c in i)
                if (((S = i[c]), i.hasOwnProperty(c) && S != null))
                  switch (c) {
                    case 'value':
                      break;
                    case 'multiple':
                      R = S;
                    default:
                      n.hasOwnProperty(c) || Ae(e, t, c, null, n, S);
                  }
              for (o in n)
                if (
                  ((c = n[o]),
                  (S = i[o]),
                  n.hasOwnProperty(o) && (c != null || S != null))
                )
                  switch (o) {
                    case 'value':
                      z = c;
                      break;
                    case 'defaultValue':
                      v = c;
                      break;
                    case 'multiple':
                      m = c;
                    default:
                      c !== S && Ae(e, t, o, c, n, S);
                  }
              ((t = v),
                (i = m),
                (n = R),
                z != null
                  ? mn(e, !!i, z, !1)
                  : !!n != !!i &&
                    (t != null
                      ? mn(e, !!i, t, !0)
                      : mn(e, !!i, i ? [] : '', !1)));
              return;
            case 'textarea':
              R = z = null;
              for (v in i)
                if (
                  ((o = i[v]),
                  i.hasOwnProperty(v) && o != null && !n.hasOwnProperty(v))
                )
                  switch (v) {
                    case 'value':
                      break;
                    case 'children':
                      break;
                    default:
                      Ae(e, t, v, null, n, o);
                  }
              for (m in n)
                if (
                  ((o = n[m]),
                  (c = i[m]),
                  n.hasOwnProperty(m) && (o != null || c != null))
                )
                  switch (m) {
                    case 'value':
                      z = o;
                      break;
                    case 'defaultValue':
                      R = o;
                      break;
                    case 'children':
                      break;
                    case 'dangerouslySetInnerHTML':
                      if (o != null) throw Error(r(91));
                      break;
                    default:
                      o !== c && Ae(e, t, m, o, n, c);
                  }
              ku(e, z, R);
              return;
            case 'option':
              for (var oe in i)
                if (
                  ((z = i[oe]),
                  i.hasOwnProperty(oe) && z != null && !n.hasOwnProperty(oe))
                )
                  switch (oe) {
                    case 'selected':
                      e.selected = !1;
                      break;
                    default:
                      Ae(e, t, oe, null, n, z);
                  }
              for (S in n)
                if (
                  ((z = n[S]),
                  (R = i[S]),
                  n.hasOwnProperty(S) && z !== R && (z != null || R != null))
                )
                  switch (S) {
                    case 'selected':
                      e.selected =
                        z && typeof z != 'function' && typeof z != 'symbol';
                      break;
                    default:
                      Ae(e, t, S, z, n, R);
                  }
              return;
            case 'img':
            case 'link':
            case 'area':
            case 'base':
            case 'br':
            case 'col':
            case 'embed':
            case 'hr':
            case 'keygen':
            case 'meta':
            case 'param':
            case 'source':
            case 'track':
            case 'wbr':
            case 'menuitem':
              for (var se in i)
                ((z = i[se]),
                  i.hasOwnProperty(se) &&
                    z != null &&
                    !n.hasOwnProperty(se) &&
                    Ae(e, t, se, null, n, z));
              for (N in n)
                if (
                  ((z = n[N]),
                  (R = i[N]),
                  n.hasOwnProperty(N) && z !== R && (z != null || R != null))
                )
                  switch (N) {
                    case 'children':
                    case 'dangerouslySetInnerHTML':
                      if (z != null) throw Error(r(137, t));
                      break;
                    default:
                      Ae(e, t, N, z, n, R);
                  }
              return;
            default:
              if (Xs(t)) {
                for (var Oe in i)
                  ((z = i[Oe]),
                    i.hasOwnProperty(Oe) &&
                      z !== void 0 &&
                      !n.hasOwnProperty(Oe) &&
                      No(e, t, Oe, void 0, n, z));
                for (H in n)
                  ((z = n[H]),
                    (R = i[H]),
                    !n.hasOwnProperty(H) ||
                      z === R ||
                      (z === void 0 && R === void 0) ||
                      No(e, t, H, z, n, R));
                return;
              }
          }
          for (var M in i)
            ((z = i[M]),
              i.hasOwnProperty(M) &&
                z != null &&
                !n.hasOwnProperty(M) &&
                Ae(e, t, M, null, n, z));
          for (K in n)
            ((z = n[K]),
              (R = i[K]),
              !n.hasOwnProperty(K) ||
                z === R ||
                (z == null && R == null) ||
                Ae(e, t, K, z, n, R));
        }
        var zo = null,
          Ro = null;
        function ls(e) {
          return e.nodeType === 9 ? e : e.ownerDocument;
        }
        function Pd(e) {
          switch (e) {
            case 'http://www.w3.org/2000/svg':
              return 1;
            case 'http://www.w3.org/1998/Math/MathML':
              return 2;
            default:
              return 0;
          }
        }
        function Id(e, t) {
          if (e === 0)
            switch (t) {
              case 'svg':
                return 1;
              case 'math':
                return 2;
              default:
                return 0;
            }
          return e === 1 && t === 'foreignObject' ? 0 : e;
        }
        function Do(e, t) {
          return (
            e === 'textarea' ||
            e === 'noscript' ||
            typeof t.children == 'string' ||
            typeof t.children == 'number' ||
            typeof t.children == 'bigint' ||
            (typeof t.dangerouslySetInnerHTML == 'object' &&
              t.dangerouslySetInnerHTML !== null &&
              t.dangerouslySetInnerHTML.__html != null)
          );
        }
        var Lo = null;
        function nv() {
          var e = window.event;
          return e && e.type === 'popstate'
            ? e === Lo
              ? !1
              : ((Lo = e), !0)
            : ((Lo = null), !1);
        }
        var Wd = typeof setTimeout == 'function' ? setTimeout : void 0,
          av = typeof clearTimeout == 'function' ? clearTimeout : void 0,
          eh = typeof Promise == 'function' ? Promise : void 0,
          lv =
            typeof queueMicrotask == 'function'
              ? queueMicrotask
              : typeof eh < 'u'
                ? function (e) {
                    return eh.resolve(null).then(e).catch(sv);
                  }
                : Wd;
        function sv(e) {
          setTimeout(function () {
            throw e;
          });
        }
        function Oi(e) {
          return e === 'head';
        }
        function th(e, t) {
          var i = t,
            n = 0,
            o = 0;
          do {
            var c = i.nextSibling;
            if ((e.removeChild(i), c && c.nodeType === 8))
              if (((i = c.data), i === '/$')) {
                if (0 < n && 8 > n) {
                  i = n;
                  var m = e.ownerDocument;
                  if (
                    (i & 1 && Ka(m.documentElement), i & 2 && Ka(m.body), i & 4)
                  )
                    for (i = m.head, Ka(i), m = i.firstChild; m; ) {
                      var v = m.nextSibling,
                        S = m.nodeName;
                      (m[ia] ||
                        S === 'SCRIPT' ||
                        S === 'STYLE' ||
                        (S === 'LINK' &&
                          m.rel.toLowerCase() === 'stylesheet') ||
                        i.removeChild(m),
                        (m = v));
                    }
                }
                if (o === 0) {
                  (e.removeChild(c), Ja(t));
                  return;
                }
                o--;
              } else
                i === '$' || i === '$?' || i === '$!'
                  ? o++
                  : (n = i.charCodeAt(0) - 48);
            else n = 0;
            i = c;
          } while (i);
          Ja(t);
        }
        function jo(e) {
          var t = e.firstChild;
          for (t && t.nodeType === 10 && (t = t.nextSibling); t; ) {
            var i = t;
            switch (((t = t.nextSibling), i.nodeName)) {
              case 'HTML':
              case 'HEAD':
              case 'BODY':
                (jo(i), Gs(i));
                continue;
              case 'SCRIPT':
              case 'STYLE':
                continue;
              case 'LINK':
                if (i.rel.toLowerCase() === 'stylesheet') continue;
            }
            e.removeChild(i);
          }
        }
        function rv(e, t, i, n) {
          for (; e.nodeType === 1; ) {
            var o = i;
            if (e.nodeName.toLowerCase() !== t.toLowerCase()) {
              if (!n && (e.nodeName !== 'INPUT' || e.type !== 'hidden')) break;
            } else if (n) {
              if (!e[ia])
                switch (t) {
                  case 'meta':
                    if (!e.hasAttribute('itemprop')) break;
                    return e;
                  case 'link':
                    if (
                      ((c = e.getAttribute('rel')),
                      c === 'stylesheet' && e.hasAttribute('data-precedence'))
                    )
                      break;
                    if (
                      c !== o.rel ||
                      e.getAttribute('href') !==
                        (o.href == null || o.href === '' ? null : o.href) ||
                      e.getAttribute('crossorigin') !==
                        (o.crossOrigin == null ? null : o.crossOrigin) ||
                      e.getAttribute('title') !==
                        (o.title == null ? null : o.title)
                    )
                      break;
                    return e;
                  case 'style':
                    if (e.hasAttribute('data-precedence')) break;
                    return e;
                  case 'script':
                    if (
                      ((c = e.getAttribute('src')),
                      (c !== (o.src == null ? null : o.src) ||
                        e.getAttribute('type') !==
                          (o.type == null ? null : o.type) ||
                        e.getAttribute('crossorigin') !==
                          (o.crossOrigin == null ? null : o.crossOrigin)) &&
                        c &&
                        e.hasAttribute('async') &&
                        !e.hasAttribute('itemprop'))
                    )
                      break;
                    return e;
                  default:
                    return e;
                }
            } else if (t === 'input' && e.type === 'hidden') {
              var c = o.name == null ? null : '' + o.name;
              if (o.type === 'hidden' && e.getAttribute('name') === c) return e;
            } else return e;
            if (((e = jt(e.nextSibling)), e === null)) break;
          }
          return null;
        }
        function ov(e, t, i) {
          if (t === '') return null;
          for (; e.nodeType !== 3; )
            if (
              ((e.nodeType !== 1 ||
                e.nodeName !== 'INPUT' ||
                e.type !== 'hidden') &&
                !i) ||
              ((e = jt(e.nextSibling)), e === null)
            )
              return null;
          return e;
        }
        function Ho(e) {
          return (
            e.data === '$!' ||
            (e.data === '$?' && e.ownerDocument.readyState === 'complete')
          );
        }
        function uv(e, t) {
          var i = e.ownerDocument;
          if (e.data !== '$?' || i.readyState === 'complete') t();
          else {
            var n = function () {
              (t(), i.removeEventListener('DOMContentLoaded', n));
            };
            (i.addEventListener('DOMContentLoaded', n), (e._reactRetry = n));
          }
        }
        function jt(e) {
          for (; e != null; e = e.nextSibling) {
            var t = e.nodeType;
            if (t === 1 || t === 3) break;
            if (t === 8) {
              if (
                ((t = e.data),
                t === '$' ||
                  t === '$!' ||
                  t === '$?' ||
                  t === 'F!' ||
                  t === 'F')
              )
                break;
              if (t === '/$') return null;
            }
          }
          return e;
        }
        var Uo = null;
        function ih(e) {
          e = e.previousSibling;
          for (var t = 0; e; ) {
            if (e.nodeType === 8) {
              var i = e.data;
              if (i === '$' || i === '$!' || i === '$?') {
                if (t === 0) return e;
                t--;
              } else i === '/$' && t++;
            }
            e = e.previousSibling;
          }
          return null;
        }
        function nh(e, t, i) {
          switch (((t = ls(i)), e)) {
            case 'html':
              if (((e = t.documentElement), !e)) throw Error(r(452));
              return e;
            case 'head':
              if (((e = t.head), !e)) throw Error(r(453));
              return e;
            case 'body':
              if (((e = t.body), !e)) throw Error(r(454));
              return e;
            default:
              throw Error(r(451));
          }
        }
        function Ka(e) {
          for (var t = e.attributes; t.length; ) e.removeAttributeNode(t[0]);
          Gs(e);
        }
        var Rt = new Map(),
          ah = new Set();
        function ss(e) {
          return typeof e.getRootNode == 'function'
            ? e.getRootNode()
            : e.nodeType === 9
              ? e
              : e.ownerDocument;
        }
        var ni = Z.d;
        Z.d = { f: cv, r: fv, D: dv, C: hv, L: pv, m: mv, X: vv, S: gv, M: yv };
        function cv() {
          var e = ni.f(),
            t = Pl();
          return e || t;
        }
        function fv(e) {
          var t = fn(e);
          t !== null && t.tag === 5 && t.type === 'form' ? wf(t) : ni.r(e);
        }
        var Xn = typeof document > 'u' ? null : document;
        function lh(e, t, i) {
          var n = Xn;
          if (n && typeof t == 'string' && t) {
            var o = Mt(t);
            ((o = 'link[rel="' + e + '"][href="' + o + '"]'),
              typeof i == 'string' && (o += '[crossorigin="' + i + '"]'),
              ah.has(o) ||
                (ah.add(o),
                (e = { rel: e, crossOrigin: i, href: t }),
                n.querySelector(o) === null &&
                  ((t = n.createElement('link')),
                  Ie(t, 'link', e),
                  $e(t),
                  n.head.appendChild(t))));
          }
        }
        function dv(e) {
          (ni.D(e), lh('dns-prefetch', e, null));
        }
        function hv(e, t) {
          (ni.C(e, t), lh('preconnect', e, t));
        }
        function pv(e, t, i) {
          ni.L(e, t, i);
          var n = Xn;
          if (n && e && t) {
            var o = 'link[rel="preload"][as="' + Mt(t) + '"]';
            t === 'image' && i && i.imageSrcSet
              ? ((o += '[imagesrcset="' + Mt(i.imageSrcSet) + '"]'),
                typeof i.imageSizes == 'string' &&
                  (o += '[imagesizes="' + Mt(i.imageSizes) + '"]'))
              : (o += '[href="' + Mt(e) + '"]');
            var c = o;
            switch (t) {
              case 'style':
                c = Qn(e);
                break;
              case 'script':
                c = Zn(e);
            }
            Rt.has(c) ||
              ((e = y(
                {
                  rel: 'preload',
                  href: t === 'image' && i && i.imageSrcSet ? void 0 : e,
                  as: t,
                },
                i
              )),
              Rt.set(c, e),
              n.querySelector(o) !== null ||
                (t === 'style' && n.querySelector(qa(c))) ||
                (t === 'script' && n.querySelector(Ya(c))) ||
                ((t = n.createElement('link')),
                Ie(t, 'link', e),
                $e(t),
                n.head.appendChild(t)));
          }
        }
        function mv(e, t) {
          ni.m(e, t);
          var i = Xn;
          if (i && e) {
            var n = t && typeof t.as == 'string' ? t.as : 'script',
              o =
                'link[rel="modulepreload"][as="' +
                Mt(n) +
                '"][href="' +
                Mt(e) +
                '"]',
              c = o;
            switch (n) {
              case 'audioworklet':
              case 'paintworklet':
              case 'serviceworker':
              case 'sharedworker':
              case 'worker':
              case 'script':
                c = Zn(e);
            }
            if (
              !Rt.has(c) &&
              ((e = y({ rel: 'modulepreload', href: e }, t)),
              Rt.set(c, e),
              i.querySelector(o) === null)
            ) {
              switch (n) {
                case 'audioworklet':
                case 'paintworklet':
                case 'serviceworker':
                case 'sharedworker':
                case 'worker':
                case 'script':
                  if (i.querySelector(Ya(c))) return;
              }
              ((n = i.createElement('link')),
                Ie(n, 'link', e),
                $e(n),
                i.head.appendChild(n));
            }
          }
        }
        function gv(e, t, i) {
          ni.S(e, t, i);
          var n = Xn;
          if (n && e) {
            var o = dn(n).hoistableStyles,
              c = Qn(e);
            t = t || 'default';
            var m = o.get(c);
            if (!m) {
              var v = { loading: 0, preload: null };
              if ((m = n.querySelector(qa(c)))) v.loading = 5;
              else {
                ((e = y(
                  { rel: 'stylesheet', href: e, 'data-precedence': t },
                  i
                )),
                  (i = Rt.get(c)) && Bo(e, i));
                var S = (m = n.createElement('link'));
                ($e(S),
                  Ie(S, 'link', e),
                  (S._p = new Promise(function (N, H) {
                    ((S.onload = N), (S.onerror = H));
                  })),
                  S.addEventListener('load', function () {
                    v.loading |= 1;
                  }),
                  S.addEventListener('error', function () {
                    v.loading |= 2;
                  }),
                  (v.loading |= 4),
                  rs(m, t, n));
              }
              ((m = { type: 'stylesheet', instance: m, count: 1, state: v }),
                o.set(c, m));
            }
          }
        }
        function vv(e, t) {
          ni.X(e, t);
          var i = Xn;
          if (i && e) {
            var n = dn(i).hoistableScripts,
              o = Zn(e),
              c = n.get(o);
            c ||
              ((c = i.querySelector(Ya(o))),
              c ||
                ((e = y({ src: e, async: !0 }, t)),
                (t = Rt.get(o)) && Go(e, t),
                (c = i.createElement('script')),
                $e(c),
                Ie(c, 'link', e),
                i.head.appendChild(c)),
              (c = { type: 'script', instance: c, count: 1, state: null }),
              n.set(o, c));
          }
        }
        function yv(e, t) {
          ni.M(e, t);
          var i = Xn;
          if (i && e) {
            var n = dn(i).hoistableScripts,
              o = Zn(e),
              c = n.get(o);
            c ||
              ((c = i.querySelector(Ya(o))),
              c ||
                ((e = y({ src: e, async: !0, type: 'module' }, t)),
                (t = Rt.get(o)) && Go(e, t),
                (c = i.createElement('script')),
                $e(c),
                Ie(c, 'link', e),
                i.head.appendChild(c)),
              (c = { type: 'script', instance: c, count: 1, state: null }),
              n.set(o, c));
          }
        }
        function sh(e, t, i, n) {
          var o = (o = ce.current) ? ss(o) : null;
          if (!o) throw Error(r(446));
          switch (e) {
            case 'meta':
            case 'title':
              return null;
            case 'style':
              return typeof i.precedence == 'string' &&
                typeof i.href == 'string'
                ? ((t = Qn(i.href)),
                  (i = dn(o).hoistableStyles),
                  (n = i.get(t)),
                  n ||
                    ((n = {
                      type: 'style',
                      instance: null,
                      count: 0,
                      state: null,
                    }),
                    i.set(t, n)),
                  n)
                : { type: 'void', instance: null, count: 0, state: null };
            case 'link':
              if (
                i.rel === 'stylesheet' &&
                typeof i.href == 'string' &&
                typeof i.precedence == 'string'
              ) {
                e = Qn(i.href);
                var c = dn(o).hoistableStyles,
                  m = c.get(e);
                if (
                  (m ||
                    ((o = o.ownerDocument || o),
                    (m = {
                      type: 'stylesheet',
                      instance: null,
                      count: 0,
                      state: { loading: 0, preload: null },
                    }),
                    c.set(e, m),
                    (c = o.querySelector(qa(e))) &&
                      !c._p &&
                      ((m.instance = c), (m.state.loading = 5)),
                    Rt.has(e) ||
                      ((i = {
                        rel: 'preload',
                        as: 'style',
                        href: i.href,
                        crossOrigin: i.crossOrigin,
                        integrity: i.integrity,
                        media: i.media,
                        hrefLang: i.hrefLang,
                        referrerPolicy: i.referrerPolicy,
                      }),
                      Rt.set(e, i),
                      c || bv(o, e, i, m.state))),
                  t && n === null)
                )
                  throw Error(r(528, ''));
                return m;
              }
              if (t && n !== null) throw Error(r(529, ''));
              return null;
            case 'script':
              return (
                (t = i.async),
                (i = i.src),
                typeof i == 'string' &&
                t &&
                typeof t != 'function' &&
                typeof t != 'symbol'
                  ? ((t = Zn(i)),
                    (i = dn(o).hoistableScripts),
                    (n = i.get(t)),
                    n ||
                      ((n = {
                        type: 'script',
                        instance: null,
                        count: 0,
                        state: null,
                      }),
                      i.set(t, n)),
                    n)
                  : { type: 'void', instance: null, count: 0, state: null }
              );
            default:
              throw Error(r(444, e));
          }
        }
        function Qn(e) {
          return 'href="' + Mt(e) + '"';
        }
        function qa(e) {
          return 'link[rel="stylesheet"][' + e + ']';
        }
        function rh(e) {
          return y({}, e, {
            'data-precedence': e.precedence,
            precedence: null,
          });
        }
        function bv(e, t, i, n) {
          e.querySelector('link[rel="preload"][as="style"][' + t + ']')
            ? (n.loading = 1)
            : ((t = e.createElement('link')),
              (n.preload = t),
              t.addEventListener('load', function () {
                return (n.loading |= 1);
              }),
              t.addEventListener('error', function () {
                return (n.loading |= 2);
              }),
              Ie(t, 'link', i),
              $e(t),
              e.head.appendChild(t));
        }
        function Zn(e) {
          return '[src="' + Mt(e) + '"]';
        }
        function Ya(e) {
          return 'script[async]' + e;
        }
        function oh(e, t, i) {
          if ((t.count++, t.instance === null))
            switch (t.type) {
              case 'style':
                var n = e.querySelector(
                  'style[data-href~="' + Mt(i.href) + '"]'
                );
                if (n) return ((t.instance = n), $e(n), n);
                var o = y({}, i, {
                  'data-href': i.href,
                  'data-precedence': i.precedence,
                  href: null,
                  precedence: null,
                });
                return (
                  (n = (e.ownerDocument || e).createElement('style')),
                  $e(n),
                  Ie(n, 'style', o),
                  rs(n, i.precedence, e),
                  (t.instance = n)
                );
              case 'stylesheet':
                o = Qn(i.href);
                var c = e.querySelector(qa(o));
                if (c)
                  return ((t.state.loading |= 4), (t.instance = c), $e(c), c);
                ((n = rh(i)),
                  (o = Rt.get(o)) && Bo(n, o),
                  (c = (e.ownerDocument || e).createElement('link')),
                  $e(c));
                var m = c;
                return (
                  (m._p = new Promise(function (v, S) {
                    ((m.onload = v), (m.onerror = S));
                  })),
                  Ie(c, 'link', n),
                  (t.state.loading |= 4),
                  rs(c, i.precedence, e),
                  (t.instance = c)
                );
              case 'script':
                return (
                  (c = Zn(i.src)),
                  (o = e.querySelector(Ya(c)))
                    ? ((t.instance = o), $e(o), o)
                    : ((n = i),
                      (o = Rt.get(c)) && ((n = y({}, i)), Go(n, o)),
                      (e = e.ownerDocument || e),
                      (o = e.createElement('script')),
                      $e(o),
                      Ie(o, 'link', n),
                      e.head.appendChild(o),
                      (t.instance = o))
                );
              case 'void':
                return null;
              default:
                throw Error(r(443, t.type));
            }
          else
            t.type === 'stylesheet' &&
              (t.state.loading & 4) === 0 &&
              ((n = t.instance),
              (t.state.loading |= 4),
              rs(n, i.precedence, e));
          return t.instance;
        }
        function rs(e, t, i) {
          for (
            var n = i.querySelectorAll(
                'link[rel="stylesheet"][data-precedence],style[data-precedence]'
              ),
              o = n.length ? n[n.length - 1] : null,
              c = o,
              m = 0;
            m < n.length;
            m++
          ) {
            var v = n[m];
            if (v.dataset.precedence === t) c = v;
            else if (c !== o) break;
          }
          c
            ? c.parentNode.insertBefore(e, c.nextSibling)
            : ((t = i.nodeType === 9 ? i.head : i),
              t.insertBefore(e, t.firstChild));
        }
        function Bo(e, t) {
          (e.crossOrigin == null && (e.crossOrigin = t.crossOrigin),
            e.referrerPolicy == null && (e.referrerPolicy = t.referrerPolicy),
            e.title == null && (e.title = t.title));
        }
        function Go(e, t) {
          (e.crossOrigin == null && (e.crossOrigin = t.crossOrigin),
            e.referrerPolicy == null && (e.referrerPolicy = t.referrerPolicy),
            e.integrity == null && (e.integrity = t.integrity));
        }
        var os = null;
        function uh(e, t, i) {
          if (os === null) {
            var n = new Map(),
              o = (os = new Map());
            o.set(i, n);
          } else
            ((o = os), (n = o.get(i)), n || ((n = new Map()), o.set(i, n)));
          if (n.has(e)) return n;
          for (
            n.set(e, null), i = i.getElementsByTagName(e), o = 0;
            o < i.length;
            o++
          ) {
            var c = i[o];
            if (
              !(
                c[ia] ||
                c[We] ||
                (e === 'link' && c.getAttribute('rel') === 'stylesheet')
              ) &&
              c.namespaceURI !== 'http://www.w3.org/2000/svg'
            ) {
              var m = c.getAttribute(t) || '';
              m = e + m;
              var v = n.get(m);
              v ? v.push(c) : n.set(m, [c]);
            }
          }
          return n;
        }
        function ch(e, t, i) {
          ((e = e.ownerDocument || e),
            e.head.insertBefore(
              i,
              t === 'title' ? e.querySelector('head > title') : null
            ));
        }
        function Sv(e, t, i) {
          if (i === 1 || t.itemProp != null) return !1;
          switch (e) {
            case 'meta':
            case 'title':
              return !0;
            case 'style':
              if (
                typeof t.precedence != 'string' ||
                typeof t.href != 'string' ||
                t.href === ''
              )
                break;
              return !0;
            case 'link':
              if (
                typeof t.rel != 'string' ||
                typeof t.href != 'string' ||
                t.href === '' ||
                t.onLoad ||
                t.onError
              )
                break;
              switch (t.rel) {
                case 'stylesheet':
                  return (
                    (e = t.disabled),
                    typeof t.precedence == 'string' && e == null
                  );
                default:
                  return !0;
              }
            case 'script':
              if (
                t.async &&
                typeof t.async != 'function' &&
                typeof t.async != 'symbol' &&
                !t.onLoad &&
                !t.onError &&
                t.src &&
                typeof t.src == 'string'
              )
                return !0;
          }
          return !1;
        }
        function fh(e) {
          return !(e.type === 'stylesheet' && (e.state.loading & 3) === 0);
        }
        var $a = null;
        function xv() {}
        function Tv(e, t, i) {
          if ($a === null) throw Error(r(475));
          var n = $a;
          if (
            t.type === 'stylesheet' &&
            (typeof i.media != 'string' ||
              matchMedia(i.media).matches !== !1) &&
            (t.state.loading & 4) === 0
          ) {
            if (t.instance === null) {
              var o = Qn(i.href),
                c = e.querySelector(qa(o));
              if (c) {
                ((e = c._p),
                  e !== null &&
                    typeof e == 'object' &&
                    typeof e.then == 'function' &&
                    (n.count++, (n = us.bind(n)), e.then(n, n)),
                  (t.state.loading |= 4),
                  (t.instance = c),
                  $e(c));
                return;
              }
              ((c = e.ownerDocument || e),
                (i = rh(i)),
                (o = Rt.get(o)) && Bo(i, o),
                (c = c.createElement('link')),
                $e(c));
              var m = c;
              ((m._p = new Promise(function (v, S) {
                ((m.onload = v), (m.onerror = S));
              })),
                Ie(c, 'link', i),
                (t.instance = c));
            }
            (n.stylesheets === null && (n.stylesheets = new Map()),
              n.stylesheets.set(t, e),
              (e = t.state.preload) &&
                (t.state.loading & 3) === 0 &&
                (n.count++,
                (t = us.bind(n)),
                e.addEventListener('load', t),
                e.addEventListener('error', t)));
          }
        }
        function Ev() {
          if ($a === null) throw Error(r(475));
          var e = $a;
          return (
            e.stylesheets && e.count === 0 && Vo(e, e.stylesheets),
            0 < e.count
              ? function (t) {
                  var i = setTimeout(function () {
                    if ((e.stylesheets && Vo(e, e.stylesheets), e.unsuspend)) {
                      var n = e.unsuspend;
                      ((e.unsuspend = null), n());
                    }
                  }, 6e4);
                  return (
                    (e.unsuspend = t),
                    function () {
                      ((e.unsuspend = null), clearTimeout(i));
                    }
                  );
                }
              : null
          );
        }
        function us() {
          if ((this.count--, this.count === 0)) {
            if (this.stylesheets) Vo(this, this.stylesheets);
            else if (this.unsuspend) {
              var e = this.unsuspend;
              ((this.unsuspend = null), e());
            }
          }
        }
        var cs = null;
        function Vo(e, t) {
          ((e.stylesheets = null),
            e.unsuspend !== null &&
              (e.count++,
              (cs = new Map()),
              t.forEach(wv, e),
              (cs = null),
              us.call(e)));
        }
        function wv(e, t) {
          if (!(t.state.loading & 4)) {
            var i = cs.get(e);
            if (i) var n = i.get(null);
            else {
              ((i = new Map()), cs.set(e, i));
              for (
                var o = e.querySelectorAll(
                    'link[data-precedence],style[data-precedence]'
                  ),
                  c = 0;
                c < o.length;
                c++
              ) {
                var m = o[c];
                (m.nodeName === 'LINK' ||
                  m.getAttribute('media') !== 'not all') &&
                  (i.set(m.dataset.precedence, m), (n = m));
              }
              n && i.set(null, n);
            }
            ((o = t.instance),
              (m = o.getAttribute('data-precedence')),
              (c = i.get(m) || n),
              c === n && i.set(null, o),
              i.set(m, o),
              this.count++,
              (n = us.bind(this)),
              o.addEventListener('load', n),
              o.addEventListener('error', n),
              c
                ? c.parentNode.insertBefore(o, c.nextSibling)
                : ((e = e.nodeType === 9 ? e.head : e),
                  e.insertBefore(o, e.firstChild)),
              (t.state.loading |= 4));
          }
        }
        var Xa = {
          $$typeof: Y,
          Provider: null,
          Consumer: null,
          _currentValue: $,
          _currentValue2: $,
          _threadCount: 0,
        };
        function Mv(e, t, i, n, o, c, m, v) {
          ((this.tag = 1),
            (this.containerInfo = e),
            (this.pingCache = this.current = this.pendingChildren = null),
            (this.timeoutHandle = -1),
            (this.callbackNode =
              this.next =
              this.pendingContext =
              this.context =
              this.cancelPendingCommit =
                null),
            (this.callbackPriority = 0),
            (this.expirationTimes = js(-1)),
            (this.entangledLanes =
              this.shellSuspendCounter =
              this.errorRecoveryDisabledLanes =
              this.expiredLanes =
              this.warmLanes =
              this.pingedLanes =
              this.suspendedLanes =
              this.pendingLanes =
                0),
            (this.entanglements = js(0)),
            (this.hiddenUpdates = js(null)),
            (this.identifierPrefix = n),
            (this.onUncaughtError = o),
            (this.onCaughtError = c),
            (this.onRecoverableError = m),
            (this.pooledCache = null),
            (this.pooledCacheLanes = 0),
            (this.formState = v),
            (this.incompleteTransitions = new Map()));
        }
        function dh(e, t, i, n, o, c, m, v, S, N, H, K) {
          return (
            (e = new Mv(e, t, i, m, v, S, N, K)),
            (t = 1),
            c === !0 && (t |= 24),
            (c = gt(3, null, null, t)),
            (e.current = c),
            (c.stateNode = e),
            (t = Sr()),
            t.refCount++,
            (e.pooledCache = t),
            t.refCount++,
            (c.memoizedState = { element: n, isDehydrated: i, cache: t }),
            wr(c),
            e
          );
        }
        function hh(e) {
          return e ? ((e = wn), e) : wn;
        }
        function ph(e, t, i, n, o, c) {
          ((o = hh(o)),
            n.context === null ? (n.context = o) : (n.pendingContext = o),
            (n = pi(t)),
            (n.payload = { element: i }),
            (c = c === void 0 ? null : c),
            c !== null && (n.callback = c),
            (i = mi(e, n, t)),
            i !== null && (xt(i, e, t), xa(i, e, t)));
        }
        function mh(e, t) {
          if (((e = e.memoizedState), e !== null && e.dehydrated !== null)) {
            var i = e.retryLane;
            e.retryLane = i !== 0 && i < t ? i : t;
          }
        }
        function Ko(e, t) {
          (mh(e, t), (e = e.alternate) && mh(e, t));
        }
        function gh(e) {
          if (e.tag === 13) {
            var t = En(e, 67108864);
            (t !== null && xt(t, e, 67108864), Ko(e, 67108864));
          }
        }
        var fs = !0;
        function Av(e, t, i, n) {
          var o = L.T;
          L.T = null;
          var c = Z.p;
          try {
            ((Z.p = 2), qo(e, t, i, n));
          } finally {
            ((Z.p = c), (L.T = o));
          }
        }
        function Ov(e, t, i, n) {
          var o = L.T;
          L.T = null;
          var c = Z.p;
          try {
            ((Z.p = 8), qo(e, t, i, n));
          } finally {
            ((Z.p = c), (L.T = o));
          }
        }
        function qo(e, t, i, n) {
          if (fs) {
            var o = Yo(n);
            if (o === null) (Co(e, t, n, ds, i), yh(e, n));
            else if (Cv(o, e, t, i, n)) n.stopPropagation();
            else if ((yh(e, n), t & 4 && -1 < _v.indexOf(e))) {
              for (; o !== null; ) {
                var c = fn(o);
                if (c !== null)
                  switch (c.tag) {
                    case 3:
                      if (
                        ((c = c.stateNode),
                        c.current.memoizedState.isDehydrated)
                      ) {
                        var m = Ui(c.pendingLanes);
                        if (m !== 0) {
                          var v = c;
                          for (
                            v.pendingLanes |= 2, v.entangledLanes |= 2;
                            m;
                          ) {
                            var S = 1 << (31 - pt(m));
                            ((v.entanglements[1] |= S), (m &= ~S));
                          }
                          (Kt(c), (Ee & 6) === 0 && ((Jl = Ht() + 500), Ba(0)));
                        }
                      }
                      break;
                    case 13:
                      ((v = En(c, 2)),
                        v !== null && xt(v, c, 2),
                        Pl(),
                        Ko(c, 2));
                  }
                if (((c = Yo(n)), c === null && Co(e, t, n, ds, i), c === o))
                  break;
                o = c;
              }
              o !== null && n.stopPropagation();
            } else Co(e, t, n, null, i);
          }
        }
        function Yo(e) {
          return ((e = Zs(e)), $o(e));
        }
        var ds = null;
        function $o(e) {
          if (((ds = null), (e = cn(e)), e !== null)) {
            var t = f(e);
            if (t === null) e = null;
            else {
              var i = t.tag;
              if (i === 13) {
                if (((e = p(t)), e !== null)) return e;
                e = null;
              } else if (i === 3) {
                if (t.stateNode.current.memoizedState.isDehydrated)
                  return t.tag === 3 ? t.stateNode.containerInfo : null;
                e = null;
              } else t !== e && (e = null);
            }
          }
          return ((ds = e), null);
        }
        function vh(e) {
          switch (e) {
            case 'beforetoggle':
            case 'cancel':
            case 'click':
            case 'close':
            case 'contextmenu':
            case 'copy':
            case 'cut':
            case 'auxclick':
            case 'dblclick':
            case 'dragend':
            case 'dragstart':
            case 'drop':
            case 'focusin':
            case 'focusout':
            case 'input':
            case 'invalid':
            case 'keydown':
            case 'keypress':
            case 'keyup':
            case 'mousedown':
            case 'mouseup':
            case 'paste':
            case 'pause':
            case 'play':
            case 'pointercancel':
            case 'pointerdown':
            case 'pointerup':
            case 'ratechange':
            case 'reset':
            case 'resize':
            case 'seeked':
            case 'submit':
            case 'toggle':
            case 'touchcancel':
            case 'touchend':
            case 'touchstart':
            case 'volumechange':
            case 'change':
            case 'selectionchange':
            case 'textInput':
            case 'compositionstart':
            case 'compositionend':
            case 'compositionupdate':
            case 'beforeblur':
            case 'afterblur':
            case 'beforeinput':
            case 'blur':
            case 'fullscreenchange':
            case 'focus':
            case 'hashchange':
            case 'popstate':
            case 'select':
            case 'selectstart':
              return 2;
            case 'drag':
            case 'dragenter':
            case 'dragexit':
            case 'dragleave':
            case 'dragover':
            case 'mousemove':
            case 'mouseout':
            case 'mouseover':
            case 'pointermove':
            case 'pointerout':
            case 'pointerover':
            case 'scroll':
            case 'touchmove':
            case 'wheel':
            case 'mouseenter':
            case 'mouseleave':
            case 'pointerenter':
            case 'pointerleave':
              return 8;
            case 'message':
              switch (hm()) {
                case Nu:
                  return 2;
                case zu:
                  return 8;
                case al:
                case pm:
                  return 32;
                case Ru:
                  return 268435456;
                default:
                  return 32;
              }
            default:
              return 32;
          }
        }
        var Xo = !1,
          _i = null,
          Ci = null,
          Ni = null,
          Qa = new Map(),
          Za = new Map(),
          zi = [],
          _v =
            'mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset'.split(
              ' '
            );
        function yh(e, t) {
          switch (e) {
            case 'focusin':
            case 'focusout':
              _i = null;
              break;
            case 'dragenter':
            case 'dragleave':
              Ci = null;
              break;
            case 'mouseover':
            case 'mouseout':
              Ni = null;
              break;
            case 'pointerover':
            case 'pointerout':
              Qa.delete(t.pointerId);
              break;
            case 'gotpointercapture':
            case 'lostpointercapture':
              Za.delete(t.pointerId);
          }
        }
        function ka(e, t, i, n, o, c) {
          return e === null || e.nativeEvent !== c
            ? ((e = {
                blockedOn: t,
                domEventName: i,
                eventSystemFlags: n,
                nativeEvent: c,
                targetContainers: [o],
              }),
              t !== null && ((t = fn(t)), t !== null && gh(t)),
              e)
            : ((e.eventSystemFlags |= n),
              (t = e.targetContainers),
              o !== null && t.indexOf(o) === -1 && t.push(o),
              e);
        }
        function Cv(e, t, i, n, o) {
          switch (t) {
            case 'focusin':
              return ((_i = ka(_i, e, t, i, n, o)), !0);
            case 'dragenter':
              return ((Ci = ka(Ci, e, t, i, n, o)), !0);
            case 'mouseover':
              return ((Ni = ka(Ni, e, t, i, n, o)), !0);
            case 'pointerover':
              var c = o.pointerId;
              return (Qa.set(c, ka(Qa.get(c) || null, e, t, i, n, o)), !0);
            case 'gotpointercapture':
              return (
                (c = o.pointerId),
                Za.set(c, ka(Za.get(c) || null, e, t, i, n, o)),
                !0
              );
          }
          return !1;
        }
        function bh(e) {
          var t = cn(e.target);
          if (t !== null) {
            var i = f(t);
            if (i !== null) {
              if (((t = i.tag), t === 13)) {
                if (((t = p(i)), t !== null)) {
                  ((e.blockedOn = t),
                    Tm(e.priority, function () {
                      if (i.tag === 13) {
                        var n = St();
                        n = Hs(n);
                        var o = En(i, n);
                        (o !== null && xt(o, i, n), Ko(i, n));
                      }
                    }));
                  return;
                }
              } else if (
                t === 3 &&
                i.stateNode.current.memoizedState.isDehydrated
              ) {
                e.blockedOn = i.tag === 3 ? i.stateNode.containerInfo : null;
                return;
              }
            }
          }
          e.blockedOn = null;
        }
        function hs(e) {
          if (e.blockedOn !== null) return !1;
          for (var t = e.targetContainers; 0 < t.length; ) {
            var i = Yo(e.nativeEvent);
            if (i === null) {
              i = e.nativeEvent;
              var n = new i.constructor(i.type, i);
              ((Qs = n), i.target.dispatchEvent(n), (Qs = null));
            } else
              return ((t = fn(i)), t !== null && gh(t), (e.blockedOn = i), !1);
            t.shift();
          }
          return !0;
        }
        function Sh(e, t, i) {
          hs(e) && i.delete(t);
        }
        function Nv() {
          ((Xo = !1),
            _i !== null && hs(_i) && (_i = null),
            Ci !== null && hs(Ci) && (Ci = null),
            Ni !== null && hs(Ni) && (Ni = null),
            Qa.forEach(Sh),
            Za.forEach(Sh));
        }
        function ps(e, t) {
          e.blockedOn === t &&
            ((e.blockedOn = null),
            Xo ||
              ((Xo = !0),
              l.unstable_scheduleCallback(l.unstable_NormalPriority, Nv)));
        }
        var ms = null;
        function xh(e) {
          ms !== e &&
            ((ms = e),
            l.unstable_scheduleCallback(l.unstable_NormalPriority, function () {
              ms === e && (ms = null);
              for (var t = 0; t < e.length; t += 3) {
                var i = e[t],
                  n = e[t + 1],
                  o = e[t + 2];
                if (typeof n != 'function') {
                  if ($o(n || i) === null) continue;
                  break;
                }
                var c = fn(i);
                c !== null &&
                  (e.splice(t, 3),
                  (t -= 3),
                  Yr(
                    c,
                    { pending: !0, data: o, method: i.method, action: n },
                    n,
                    o
                  ));
              }
            }));
        }
        function Ja(e) {
          function t(S) {
            return ps(S, e);
          }
          (_i !== null && ps(_i, e),
            Ci !== null && ps(Ci, e),
            Ni !== null && ps(Ni, e),
            Qa.forEach(t),
            Za.forEach(t));
          for (var i = 0; i < zi.length; i++) {
            var n = zi[i];
            n.blockedOn === e && (n.blockedOn = null);
          }
          for (; 0 < zi.length && ((i = zi[0]), i.blockedOn === null); )
            (bh(i), i.blockedOn === null && zi.shift());
          if (((i = (e.ownerDocument || e).$$reactFormReplay), i != null))
            for (n = 0; n < i.length; n += 3) {
              var o = i[n],
                c = i[n + 1],
                m = o[lt] || null;
              if (typeof c == 'function') m || xh(i);
              else if (m) {
                var v = null;
                if (c && c.hasAttribute('formAction')) {
                  if (((o = c), (m = c[lt] || null))) v = m.formAction;
                  else if ($o(o) !== null) continue;
                } else v = m.action;
                (typeof v == 'function'
                  ? (i[n + 1] = v)
                  : (i.splice(n, 3), (n -= 3)),
                  xh(i));
              }
            }
        }
        function Qo(e) {
          this._internalRoot = e;
        }
        ((gs.prototype.render = Qo.prototype.render =
          function (e) {
            var t = this._internalRoot;
            if (t === null) throw Error(r(409));
            var i = t.current,
              n = St();
            ph(i, n, e, t, null, null);
          }),
          (gs.prototype.unmount = Qo.prototype.unmount =
            function () {
              var e = this._internalRoot;
              if (e !== null) {
                this._internalRoot = null;
                var t = e.containerInfo;
                (ph(e.current, 2, null, e, null, null), Pl(), (t[un] = null));
              }
            }));
        function gs(e) {
          this._internalRoot = e;
        }
        gs.prototype.unstable_scheduleHydration = function (e) {
          if (e) {
            var t = Uu();
            e = { blockedOn: null, target: e, priority: t };
            for (
              var i = 0;
              i < zi.length && t !== 0 && t < zi[i].priority;
              i++
            );
            (zi.splice(i, 0, e), i === 0 && bh(e));
          }
        };
        var Th = a.version;
        if (Th !== '19.1.1') throw Error(r(527, Th, '19.1.1'));
        Z.findDOMNode = function (e) {
          var t = e._reactInternals;
          if (t === void 0)
            throw typeof e.render == 'function'
              ? Error(r(188))
              : ((e = Object.keys(e).join(',')), Error(r(268, e)));
          return (
            (e = d(t)),
            (e = e !== null ? h(e) : null),
            (e = e === null ? null : e.stateNode),
            e
          );
        };
        var zv = {
          bundleType: 0,
          version: '19.1.1',
          rendererPackageName: 'react-dom',
          currentDispatcherRef: L,
          reconcilerVersion: '19.1.1',
        };
        if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < 'u') {
          var vs = __REACT_DEVTOOLS_GLOBAL_HOOK__;
          if (!vs.isDisabled && vs.supportsFiber)
            try {
              ((Wn = vs.inject(zv)), (ht = vs));
            } catch {}
        }
        return (
          (Pa.createRoot = function (e, t) {
            if (!u(e)) throw Error(r(299));
            var i = !1,
              n = '',
              o = Bf,
              c = Gf,
              m = Vf,
              v = null;
            return (
              t != null &&
                (t.unstable_strictMode === !0 && (i = !0),
                t.identifierPrefix !== void 0 && (n = t.identifierPrefix),
                t.onUncaughtError !== void 0 && (o = t.onUncaughtError),
                t.onCaughtError !== void 0 && (c = t.onCaughtError),
                t.onRecoverableError !== void 0 && (m = t.onRecoverableError),
                t.unstable_transitionCallbacks !== void 0 &&
                  (v = t.unstable_transitionCallbacks)),
              (t = dh(e, 1, !1, null, null, i, n, o, c, m, v, null)),
              (e[un] = t.current),
              _o(e),
              new Qo(t)
            );
          }),
          (Pa.hydrateRoot = function (e, t, i) {
            if (!u(e)) throw Error(r(299));
            var n = !1,
              o = '',
              c = Bf,
              m = Gf,
              v = Vf,
              S = null,
              N = null;
            return (
              i != null &&
                (i.unstable_strictMode === !0 && (n = !0),
                i.identifierPrefix !== void 0 && (o = i.identifierPrefix),
                i.onUncaughtError !== void 0 && (c = i.onUncaughtError),
                i.onCaughtError !== void 0 && (m = i.onCaughtError),
                i.onRecoverableError !== void 0 && (v = i.onRecoverableError),
                i.unstable_transitionCallbacks !== void 0 &&
                  (S = i.unstable_transitionCallbacks),
                i.formState !== void 0 && (N = i.formState)),
              (t = dh(e, 1, !0, t, i ?? null, n, o, c, m, v, S, N)),
              (t.context = hh(null)),
              (i = t.current),
              (n = St()),
              (n = Hs(n)),
              (o = pi(n)),
              (o.callback = null),
              mi(i, o, n),
              (i = n),
              (t.current.lanes = i),
              ta(t, i),
              Kt(t),
              (e[un] = t.current),
              _o(e),
              new gs(t)
            );
          }),
          (Pa.version = '19.1.1'),
          Pa
        );
      }
      var Rh;
      function qv() {
        if (Rh) return ko.exports;
        Rh = 1;
        function l() {
          if (
            !(
              typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > 'u' ||
              typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != 'function'
            )
          )
            try {
              __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(l);
            } catch (a) {
              console.error(a);
            }
        }
        return (l(), (ko.exports = Kv()), ko.exports);
      }
      var Yv = qv(),
        I = wu();
      const Ye = Dv(I),
        ue = l => typeof l == 'string',
        Ia = () => {
          let l, a;
          const s = new Promise((r, u) => {
            ((l = r), (a = u));
          });
          return ((s.resolve = l), (s.reject = a), s);
        },
        Dh = l => (l == null ? '' : '' + l),
        $v = (l, a, s) => {
          l.forEach(r => {
            a[r] && (s[r] = a[r]);
          });
        },
        Xv = /###/g,
        Lh = l => (l && l.indexOf('###') > -1 ? l.replace(Xv, '.') : l),
        jh = l => !l || ue(l),
        Wa = (l, a, s) => {
          const r = ue(a) ? a.split('.') : a;
          let u = 0;
          for (; u < r.length - 1; ) {
            if (jh(l)) return {};
            const f = Lh(r[u]);
            (!l[f] && s && (l[f] = new s()),
              Object.prototype.hasOwnProperty.call(l, f)
                ? (l = l[f])
                : (l = {}),
              ++u);
          }
          return jh(l) ? {} : { obj: l, k: Lh(r[u]) };
        },
        Hh = (l, a, s) => {
          const { obj: r, k: u } = Wa(l, a, Object);
          if (r !== void 0 || a.length === 1) {
            r[u] = s;
            return;
          }
          let f = a[a.length - 1],
            p = a.slice(0, a.length - 1),
            g = Wa(l, p, Object);
          for (; g.obj === void 0 && p.length; )
            ((f = `${p[p.length - 1]}.${f}`),
              (p = p.slice(0, p.length - 1)),
              (g = Wa(l, p, Object)),
              g?.obj && typeof g.obj[`${g.k}.${f}`] < 'u' && (g.obj = void 0));
          g.obj[`${g.k}.${f}`] = s;
        },
        Qv = (l, a, s, r) => {
          const { obj: u, k: f } = Wa(l, a, Object);
          ((u[f] = u[f] || []), u[f].push(s));
        },
        ws = (l, a) => {
          const { obj: s, k: r } = Wa(l, a);
          if (s && Object.prototype.hasOwnProperty.call(s, r)) return s[r];
        },
        Zv = (l, a, s) => {
          const r = ws(l, s);
          return r !== void 0 ? r : ws(a, s);
        },
        op = (l, a, s) => {
          for (const r in a)
            r !== '__proto__' &&
              r !== 'constructor' &&
              (r in l
                ? ue(l[r]) ||
                  l[r] instanceof String ||
                  ue(a[r]) ||
                  a[r] instanceof String
                  ? s && (l[r] = a[r])
                  : op(l[r], a[r], s)
                : (l[r] = a[r]));
          return l;
        },
        kn = l => l.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
      var kv = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
        '/': '&#x2F;',
      };
      const Jv = l => (ue(l) ? l.replace(/[&<>"'\/]/g, a => kv[a]) : l);
      class Fv {
        constructor(a) {
          ((this.capacity = a),
            (this.regExpMap = new Map()),
            (this.regExpQueue = []));
        }
        getRegExp(a) {
          const s = this.regExpMap.get(a);
          if (s !== void 0) return s;
          const r = new RegExp(a);
          return (
            this.regExpQueue.length === this.capacity &&
              this.regExpMap.delete(this.regExpQueue.shift()),
            this.regExpMap.set(a, r),
            this.regExpQueue.push(a),
            r
          );
        }
      }
      const Pv = [' ', ',', '?', '!', ';'],
        Iv = new Fv(20),
        Wv = (l, a, s) => {
          ((a = a || ''), (s = s || ''));
          const r = Pv.filter(p => a.indexOf(p) < 0 && s.indexOf(p) < 0);
          if (r.length === 0) return !0;
          const u = Iv.getRegExp(
            `(${r.map(p => (p === '?' ? '\\?' : p)).join('|')})`
          );
          let f = !u.test(l);
          if (!f) {
            const p = l.indexOf(s);
            p > 0 && !u.test(l.substring(0, p)) && (f = !0);
          }
          return f;
        },
        cu = (l, a, s = '.') => {
          if (!l) return;
          if (l[a])
            return Object.prototype.hasOwnProperty.call(l, a) ? l[a] : void 0;
          const r = a.split(s);
          let u = l;
          for (let f = 0; f < r.length; ) {
            if (!u || typeof u != 'object') return;
            let p,
              g = '';
            for (let d = f; d < r.length; ++d)
              if (
                (d !== f && (g += s), (g += r[d]), (p = u[g]), p !== void 0)
              ) {
                if (
                  ['string', 'number', 'boolean'].indexOf(typeof p) > -1 &&
                  d < r.length - 1
                )
                  continue;
                f += d - f + 1;
                break;
              }
            u = p;
          }
          return u;
        },
        tl = l => l?.replace('_', '-'),
        ey = {
          type: 'logger',
          log(l) {
            this.output('log', l);
          },
          warn(l) {
            this.output('warn', l);
          },
          error(l) {
            this.output('error', l);
          },
          output(l, a) {
            console?.[l]?.apply?.(console, a);
          },
        };
      class Ms {
        constructor(a, s = {}) {
          this.init(a, s);
        }
        init(a, s = {}) {
          ((this.prefix = s.prefix || 'i18next:'),
            (this.logger = a || ey),
            (this.options = s),
            (this.debug = s.debug));
        }
        log(...a) {
          return this.forward(a, 'log', '', !0);
        }
        warn(...a) {
          return this.forward(a, 'warn', '', !0);
        }
        error(...a) {
          return this.forward(a, 'error', '');
        }
        deprecate(...a) {
          return this.forward(a, 'warn', 'WARNING DEPRECATED: ', !0);
        }
        forward(a, s, r, u) {
          return u && !this.debug
            ? null
            : (ue(a[0]) && (a[0] = `${r}${this.prefix} ${a[0]}`),
              this.logger[s](a));
        }
        create(a) {
          return new Ms(this.logger, {
            prefix: `${this.prefix}:${a}:`,
            ...this.options,
          });
        }
        clone(a) {
          return (
            (a = a || this.options),
            (a.prefix = a.prefix || this.prefix),
            new Ms(this.logger, a)
          );
        }
      }
      var qt = new Ms();
      class Ns {
        constructor() {
          this.observers = {};
        }
        on(a, s) {
          return (
            a.split(' ').forEach(r => {
              this.observers[r] || (this.observers[r] = new Map());
              const u = this.observers[r].get(s) || 0;
              this.observers[r].set(s, u + 1);
            }),
            this
          );
        }
        off(a, s) {
          if (this.observers[a]) {
            if (!s) {
              delete this.observers[a];
              return;
            }
            this.observers[a].delete(s);
          }
        }
        emit(a, ...s) {
          (this.observers[a] &&
            Array.from(this.observers[a].entries()).forEach(([u, f]) => {
              for (let p = 0; p < f; p++) u(...s);
            }),
            this.observers['*'] &&
              Array.from(this.observers['*'].entries()).forEach(([u, f]) => {
                for (let p = 0; p < f; p++) u.apply(u, [a, ...s]);
              }));
        }
      }
      class Uh extends Ns {
        constructor(a, s = { ns: ['translation'], defaultNS: 'translation' }) {
          (super(),
            (this.data = a || {}),
            (this.options = s),
            this.options.keySeparator === void 0 &&
              (this.options.keySeparator = '.'),
            this.options.ignoreJSONStructure === void 0 &&
              (this.options.ignoreJSONStructure = !0));
        }
        addNamespaces(a) {
          this.options.ns.indexOf(a) < 0 && this.options.ns.push(a);
        }
        removeNamespaces(a) {
          const s = this.options.ns.indexOf(a);
          s > -1 && this.options.ns.splice(s, 1);
        }
        getResource(a, s, r, u = {}) {
          const f =
              u.keySeparator !== void 0
                ? u.keySeparator
                : this.options.keySeparator,
            p =
              u.ignoreJSONStructure !== void 0
                ? u.ignoreJSONStructure
                : this.options.ignoreJSONStructure;
          let g;
          a.indexOf('.') > -1
            ? (g = a.split('.'))
            : ((g = [a, s]),
              r &&
                (Array.isArray(r)
                  ? g.push(...r)
                  : ue(r) && f
                    ? g.push(...r.split(f))
                    : g.push(r)));
          const d = ws(this.data, g);
          return (
            !d &&
              !s &&
              !r &&
              a.indexOf('.') > -1 &&
              ((a = g[0]), (s = g[1]), (r = g.slice(2).join('.'))),
            d || !p || !ue(r) ? d : cu(this.data?.[a]?.[s], r, f)
          );
        }
        addResource(a, s, r, u, f = { silent: !1 }) {
          const p =
            f.keySeparator !== void 0
              ? f.keySeparator
              : this.options.keySeparator;
          let g = [a, s];
          (r && (g = g.concat(p ? r.split(p) : r)),
            a.indexOf('.') > -1 && ((g = a.split('.')), (u = s), (s = g[1])),
            this.addNamespaces(s),
            Hh(this.data, g, u),
            f.silent || this.emit('added', a, s, r, u));
        }
        addResources(a, s, r, u = { silent: !1 }) {
          for (const f in r)
            (ue(r[f]) || Array.isArray(r[f])) &&
              this.addResource(a, s, f, r[f], { silent: !0 });
          u.silent || this.emit('added', a, s, r);
        }
        addResourceBundle(a, s, r, u, f, p = { silent: !1, skipCopy: !1 }) {
          let g = [a, s];
          (a.indexOf('.') > -1 &&
            ((g = a.split('.')), (u = r), (r = s), (s = g[1])),
            this.addNamespaces(s));
          let d = ws(this.data, g) || {};
          (p.skipCopy || (r = JSON.parse(JSON.stringify(r))),
            u ? op(d, r, f) : (d = { ...d, ...r }),
            Hh(this.data, g, d),
            p.silent || this.emit('added', a, s, r));
        }
        removeResourceBundle(a, s) {
          (this.hasResourceBundle(a, s) && delete this.data[a][s],
            this.removeNamespaces(s),
            this.emit('removed', a, s));
        }
        hasResourceBundle(a, s) {
          return this.getResource(a, s) !== void 0;
        }
        getResourceBundle(a, s) {
          return (s || (s = this.options.defaultNS), this.getResource(a, s));
        }
        getDataByLanguage(a) {
          return this.data[a];
        }
        hasLanguageSomeTranslations(a) {
          const s = this.getDataByLanguage(a);
          return !!((s && Object.keys(s)) || []).find(
            u => s[u] && Object.keys(s[u]).length > 0
          );
        }
        toJSON() {
          return this.data;
        }
      }
      var up = {
        processors: {},
        addPostProcessor(l) {
          this.processors[l.name] = l;
        },
        handle(l, a, s, r, u) {
          return (
            l.forEach(f => {
              a = this.processors[f]?.process(a, s, r, u) ?? a;
            }),
            a
          );
        },
      };
      const cp = Symbol('i18next/PATH_KEY');
      function ty() {
        const l = [],
          a = Object.create(null);
        let s;
        return (
          (a.get = (r, u) => (
            s?.revoke?.(),
            u === cp ? l : (l.push(u), (s = Proxy.revocable(r, a)), s.proxy)
          )),
          Proxy.revocable(Object.create(null), a).proxy
        );
      }
      function fu(l, a) {
        const { [cp]: s } = l(ty());
        return s.join(a?.keySeparator ?? '.');
      }
      const Bh = {},
        Wo = l => !ue(l) && typeof l != 'boolean' && typeof l != 'number';
      class As extends Ns {
        constructor(a, s = {}) {
          (super(),
            $v(
              [
                'resourceStore',
                'languageUtils',
                'pluralResolver',
                'interpolator',
                'backendConnector',
                'i18nFormat',
                'utils',
              ],
              a,
              this
            ),
            (this.options = s),
            this.options.keySeparator === void 0 &&
              (this.options.keySeparator = '.'),
            (this.logger = qt.create('translator')));
        }
        changeLanguage(a) {
          a && (this.language = a);
        }
        exists(a, s = { interpolation: {} }) {
          const r = { ...s };
          if (a == null) return !1;
          const u = this.resolve(a, r);
          if (u?.res === void 0) return !1;
          const f = Wo(u.res);
          return !(r.returnObjects === !1 && f);
        }
        extractFromKey(a, s) {
          let r =
            s.nsSeparator !== void 0 ? s.nsSeparator : this.options.nsSeparator;
          r === void 0 && (r = ':');
          const u =
            s.keySeparator !== void 0
              ? s.keySeparator
              : this.options.keySeparator;
          let f = s.ns || this.options.defaultNS || [];
          const p = r && a.indexOf(r) > -1,
            g =
              !this.options.userDefinedKeySeparator &&
              !s.keySeparator &&
              !this.options.userDefinedNsSeparator &&
              !s.nsSeparator &&
              !Wv(a, r, u);
          if (p && !g) {
            const d = a.match(this.interpolator.nestingRegexp);
            if (d && d.length > 0)
              return { key: a, namespaces: ue(f) ? [f] : f };
            const h = a.split(r);
            ((r !== u || (r === u && this.options.ns.indexOf(h[0]) > -1)) &&
              (f = h.shift()),
              (a = h.join(u)));
          }
          return { key: a, namespaces: ue(f) ? [f] : f };
        }
        translate(a, s, r) {
          let u = typeof s == 'object' ? { ...s } : s;
          if (
            (typeof u != 'object' &&
              this.options.overloadTranslationOptionHandler &&
              (u = this.options.overloadTranslationOptionHandler(arguments)),
            typeof u == 'object' && (u = { ...u }),
            u || (u = {}),
            a == null)
          )
            return '';
          (typeof a == 'function' && (a = fu(a, { ...this.options, ...u })),
            Array.isArray(a) || (a = [String(a)]));
          const f =
              u.returnDetails !== void 0
                ? u.returnDetails
                : this.options.returnDetails,
            p =
              u.keySeparator !== void 0
                ? u.keySeparator
                : this.options.keySeparator,
            { key: g, namespaces: d } = this.extractFromKey(a[a.length - 1], u),
            h = d[d.length - 1];
          let y =
            u.nsSeparator !== void 0 ? u.nsSeparator : this.options.nsSeparator;
          y === void 0 && (y = ':');
          const b = u.lng || this.language,
            w =
              u.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
          if (b?.toLowerCase() === 'cimode')
            return w
              ? f
                ? {
                    res: `${h}${y}${g}`,
                    usedKey: g,
                    exactUsedKey: g,
                    usedLng: b,
                    usedNS: h,
                    usedParams: this.getUsedParamsDetails(u),
                  }
                : `${h}${y}${g}`
              : f
                ? {
                    res: g,
                    usedKey: g,
                    exactUsedKey: g,
                    usedLng: b,
                    usedNS: h,
                    usedParams: this.getUsedParamsDetails(u),
                  }
                : g;
          const T = this.resolve(a, u);
          let _ = T?.res;
          const O = T?.usedKey || g,
            D = T?.exactUsedKey || g,
            q = ['[object Number]', '[object Function]', '[object RegExp]'],
            U =
              u.joinArrays !== void 0 ? u.joinArrays : this.options.joinArrays,
            Y = !this.i18nFormat || this.i18nFormat.handleAsObject,
            X = u.count !== void 0 && !ue(u.count),
            B = As.hasDefaultValue(u),
            W = X ? this.pluralResolver.getSuffix(b, u.count, u) : '',
            k =
              u.ordinal && X
                ? this.pluralResolver.getSuffix(b, u.count, { ordinal: !1 })
                : '',
            V = X && !u.ordinal && u.count === 0,
            ee =
              (V && u[`defaultValue${this.options.pluralSeparator}zero`]) ||
              u[`defaultValue${W}`] ||
              u[`defaultValue${k}`] ||
              u.defaultValue;
          let Q = _;
          Y && !_ && B && (Q = ee);
          const J = Wo(Q),
            ie = Object.prototype.toString.apply(Q);
          if (
            Y &&
            Q &&
            J &&
            q.indexOf(ie) < 0 &&
            !(ue(U) && Array.isArray(Q))
          ) {
            if (!u.returnObjects && !this.options.returnObjects) {
              this.options.returnedObjectHandler ||
                this.logger.warn(
                  'accessing an object - but returnObjects options is not enabled!'
                );
              const de = this.options.returnedObjectHandler
                ? this.options.returnedObjectHandler(O, Q, { ...u, ns: d })
                : `key '${g} (${this.language})' returned an object instead of string.`;
              return f
                ? ((T.res = de),
                  (T.usedParams = this.getUsedParamsDetails(u)),
                  T)
                : de;
            }
            if (p) {
              const de = Array.isArray(Q),
                ve = de ? [] : {},
                be = de ? D : O;
              for (const L in Q)
                if (Object.prototype.hasOwnProperty.call(Q, L)) {
                  const Z = `${be}${p}${L}`;
                  (B && !_
                    ? (ve[L] = this.translate(Z, {
                        ...u,
                        defaultValue: Wo(ee) ? ee[L] : void 0,
                        joinArrays: !1,
                        ns: d,
                      }))
                    : (ve[L] = this.translate(Z, {
                        ...u,
                        joinArrays: !1,
                        ns: d,
                      })),
                    ve[L] === Z && (ve[L] = Q[L]));
                }
              _ = ve;
            }
          } else if (Y && ue(U) && Array.isArray(_))
            ((_ = _.join(U)), _ && (_ = this.extendTranslation(_, a, u, r)));
          else {
            let de = !1,
              ve = !1;
            (!this.isValidLookup(_) && B && ((de = !0), (_ = ee)),
              this.isValidLookup(_) || ((ve = !0), (_ = g)));
            const L =
                (u.missingKeyNoValueFallbackToKey ||
                  this.options.missingKeyNoValueFallbackToKey) &&
                ve
                  ? void 0
                  : _,
              Z = B && ee !== _ && this.options.updateMissing;
            if (ve || de || Z) {
              if (
                (this.logger.log(
                  Z ? 'updateKey' : 'missingKey',
                  b,
                  h,
                  g,
                  Z ? ee : _
                ),
                p)
              ) {
                const j = this.resolve(g, { ...u, keySeparator: !1 });
                j &&
                  j.res &&
                  this.logger.warn(
                    'Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.'
                  );
              }
              let $ = [];
              const ne = this.languageUtils.getFallbackCodes(
                this.options.fallbackLng,
                u.lng || this.language
              );
              if (this.options.saveMissingTo === 'fallback' && ne && ne[0])
                for (let j = 0; j < ne.length; j++) $.push(ne[j]);
              else
                this.options.saveMissingTo === 'all'
                  ? ($ = this.languageUtils.toResolveHierarchy(
                      u.lng || this.language
                    ))
                  : $.push(u.lng || this.language);
              const x = (j, P, F) => {
                const le = B && F !== _ ? F : L;
                (this.options.missingKeyHandler
                  ? this.options.missingKeyHandler(j, h, P, le, Z, u)
                  : this.backendConnector?.saveMissing &&
                    this.backendConnector.saveMissing(j, h, P, le, Z, u),
                  this.emit('missingKey', j, h, P, _));
              };
              this.options.saveMissing &&
                (this.options.saveMissingPlurals && X
                  ? $.forEach(j => {
                      const P = this.pluralResolver.getSuffixes(j, u);
                      (V &&
                        u[`defaultValue${this.options.pluralSeparator}zero`] &&
                        P.indexOf(`${this.options.pluralSeparator}zero`) < 0 &&
                        P.push(`${this.options.pluralSeparator}zero`),
                        P.forEach(F => {
                          x([j], g + F, u[`defaultValue${F}`] || ee);
                        }));
                    })
                  : x($, g, ee));
            }
            ((_ = this.extendTranslation(_, a, u, T, r)),
              ve &&
                _ === g &&
                this.options.appendNamespaceToMissingKey &&
                (_ = `${h}${y}${g}`),
              (ve || de) &&
                this.options.parseMissingKeyHandler &&
                (_ = this.options.parseMissingKeyHandler(
                  this.options.appendNamespaceToMissingKey ? `${h}${y}${g}` : g,
                  de ? _ : void 0,
                  u
                )));
          }
          return f
            ? ((T.res = _), (T.usedParams = this.getUsedParamsDetails(u)), T)
            : _;
        }
        extendTranslation(a, s, r, u, f) {
          if (this.i18nFormat?.parse)
            a = this.i18nFormat.parse(
              a,
              { ...this.options.interpolation.defaultVariables, ...r },
              r.lng || this.language || u.usedLng,
              u.usedNS,
              u.usedKey,
              { resolved: u }
            );
          else if (!r.skipInterpolation) {
            r.interpolation &&
              this.interpolator.init({
                ...r,
                interpolation: {
                  ...this.options.interpolation,
                  ...r.interpolation,
                },
              });
            const d =
              ue(a) &&
              (r?.interpolation?.skipOnVariables !== void 0
                ? r.interpolation.skipOnVariables
                : this.options.interpolation.skipOnVariables);
            let h;
            if (d) {
              const b = a.match(this.interpolator.nestingRegexp);
              h = b && b.length;
            }
            let y = r.replace && !ue(r.replace) ? r.replace : r;
            if (
              (this.options.interpolation.defaultVariables &&
                (y = { ...this.options.interpolation.defaultVariables, ...y }),
              (a = this.interpolator.interpolate(
                a,
                y,
                r.lng || this.language || u.usedLng,
                r
              )),
              d)
            ) {
              const b = a.match(this.interpolator.nestingRegexp),
                w = b && b.length;
              h < w && (r.nest = !1);
            }
            (!r.lng && u && u.res && (r.lng = this.language || u.usedLng),
              r.nest !== !1 &&
                (a = this.interpolator.nest(
                  a,
                  (...b) =>
                    f?.[0] === b[0] && !r.context
                      ? (this.logger.warn(
                          `It seems you are nesting recursively key: ${b[0]} in key: ${s[0]}`
                        ),
                        null)
                      : this.translate(...b, s),
                  r
                )),
              r.interpolation && this.interpolator.reset());
          }
          const p = r.postProcess || this.options.postProcess,
            g = ue(p) ? [p] : p;
          return (
            a != null &&
              g?.length &&
              r.applyPostProcessor !== !1 &&
              (a = up.handle(
                g,
                a,
                s,
                this.options && this.options.postProcessPassResolved
                  ? {
                      i18nResolved: {
                        ...u,
                        usedParams: this.getUsedParamsDetails(r),
                      },
                      ...r,
                    }
                  : r,
                this
              )),
            a
          );
        }
        resolve(a, s = {}) {
          let r, u, f, p, g;
          return (
            ue(a) && (a = [a]),
            a.forEach(d => {
              if (this.isValidLookup(r)) return;
              const h = this.extractFromKey(d, s),
                y = h.key;
              u = y;
              let b = h.namespaces;
              this.options.fallbackNS &&
                (b = b.concat(this.options.fallbackNS));
              const w = s.count !== void 0 && !ue(s.count),
                T = w && !s.ordinal && s.count === 0,
                _ =
                  s.context !== void 0 &&
                  (ue(s.context) || typeof s.context == 'number') &&
                  s.context !== '',
                O = s.lngs
                  ? s.lngs
                  : this.languageUtils.toResolveHierarchy(
                      s.lng || this.language,
                      s.fallbackLng
                    );
              b.forEach(D => {
                this.isValidLookup(r) ||
                  ((g = D),
                  !Bh[`${O[0]}-${D}`] &&
                    this.utils?.hasLoadedNamespace &&
                    !this.utils?.hasLoadedNamespace(g) &&
                    ((Bh[`${O[0]}-${D}`] = !0),
                    this.logger.warn(
                      `key "${u}" for languages "${O.join(', ')}" won't get resolved as namespace "${g}" was not yet loaded`,
                      'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!'
                    )),
                  O.forEach(q => {
                    if (this.isValidLookup(r)) return;
                    p = q;
                    const U = [y];
                    if (this.i18nFormat?.addLookupKeys)
                      this.i18nFormat.addLookupKeys(U, y, q, D, s);
                    else {
                      let X;
                      w && (X = this.pluralResolver.getSuffix(q, s.count, s));
                      const B = `${this.options.pluralSeparator}zero`,
                        W = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                      if (
                        (w &&
                          (s.ordinal &&
                            X.indexOf(W) === 0 &&
                            U.push(
                              y + X.replace(W, this.options.pluralSeparator)
                            ),
                          U.push(y + X),
                          T && U.push(y + B)),
                        _)
                      ) {
                        const k = `${y}${this.options.contextSeparator || '_'}${s.context}`;
                        (U.push(k),
                          w &&
                            (s.ordinal &&
                              X.indexOf(W) === 0 &&
                              U.push(
                                k + X.replace(W, this.options.pluralSeparator)
                              ),
                            U.push(k + X),
                            T && U.push(k + B)));
                      }
                    }
                    let Y;
                    for (; (Y = U.pop()); )
                      this.isValidLookup(r) ||
                        ((f = Y), (r = this.getResource(q, D, Y, s)));
                  }));
              });
            }),
            { res: r, usedKey: u, exactUsedKey: f, usedLng: p, usedNS: g }
          );
        }
        isValidLookup(a) {
          return (
            a !== void 0 &&
            !(!this.options.returnNull && a === null) &&
            !(!this.options.returnEmptyString && a === '')
          );
        }
        getResource(a, s, r, u = {}) {
          return this.i18nFormat?.getResource
            ? this.i18nFormat.getResource(a, s, r, u)
            : this.resourceStore.getResource(a, s, r, u);
        }
        getUsedParamsDetails(a = {}) {
          const s = [
              'defaultValue',
              'ordinal',
              'context',
              'replace',
              'lng',
              'lngs',
              'fallbackLng',
              'ns',
              'keySeparator',
              'nsSeparator',
              'returnObjects',
              'returnDetails',
              'joinArrays',
              'postProcess',
              'interpolation',
            ],
            r = a.replace && !ue(a.replace);
          let u = r ? a.replace : a;
          if (
            (r && typeof a.count < 'u' && (u.count = a.count),
            this.options.interpolation.defaultVariables &&
              (u = { ...this.options.interpolation.defaultVariables, ...u }),
            !r)
          ) {
            u = { ...u };
            for (const f of s) delete u[f];
          }
          return u;
        }
        static hasDefaultValue(a) {
          const s = 'defaultValue';
          for (const r in a)
            if (
              Object.prototype.hasOwnProperty.call(a, r) &&
              s === r.substring(0, s.length) &&
              a[r] !== void 0
            )
              return !0;
          return !1;
        }
      }
      class Gh {
        constructor(a) {
          ((this.options = a),
            (this.supportedLngs = this.options.supportedLngs || !1),
            (this.logger = qt.create('languageUtils')));
        }
        getScriptPartFromCode(a) {
          if (((a = tl(a)), !a || a.indexOf('-') < 0)) return null;
          const s = a.split('-');
          return s.length === 2 ||
            (s.pop(), s[s.length - 1].toLowerCase() === 'x')
            ? null
            : this.formatLanguageCode(s.join('-'));
        }
        getLanguagePartFromCode(a) {
          if (((a = tl(a)), !a || a.indexOf('-') < 0)) return a;
          const s = a.split('-');
          return this.formatLanguageCode(s[0]);
        }
        formatLanguageCode(a) {
          if (ue(a) && a.indexOf('-') > -1) {
            let s;
            try {
              s = Intl.getCanonicalLocales(a)[0];
            } catch {}
            return (
              s && this.options.lowerCaseLng && (s = s.toLowerCase()),
              s || (this.options.lowerCaseLng ? a.toLowerCase() : a)
            );
          }
          return this.options.cleanCode || this.options.lowerCaseLng
            ? a.toLowerCase()
            : a;
        }
        isSupportedCode(a) {
          return (
            (this.options.load === 'languageOnly' ||
              this.options.nonExplicitSupportedLngs) &&
              (a = this.getLanguagePartFromCode(a)),
            !this.supportedLngs ||
              !this.supportedLngs.length ||
              this.supportedLngs.indexOf(a) > -1
          );
        }
        getBestMatchFromCodes(a) {
          if (!a) return null;
          let s;
          return (
            a.forEach(r => {
              if (s) return;
              const u = this.formatLanguageCode(r);
              (!this.options.supportedLngs || this.isSupportedCode(u)) &&
                (s = u);
            }),
            !s &&
              this.options.supportedLngs &&
              a.forEach(r => {
                if (s) return;
                const u = this.getScriptPartFromCode(r);
                if (this.isSupportedCode(u)) return (s = u);
                const f = this.getLanguagePartFromCode(r);
                if (this.isSupportedCode(f)) return (s = f);
                s = this.options.supportedLngs.find(p => {
                  if (p === f) return p;
                  if (
                    !(p.indexOf('-') < 0 && f.indexOf('-') < 0) &&
                    ((p.indexOf('-') > 0 &&
                      f.indexOf('-') < 0 &&
                      p.substring(0, p.indexOf('-')) === f) ||
                      (p.indexOf(f) === 0 && f.length > 1))
                  )
                    return p;
                });
              }),
            s || (s = this.getFallbackCodes(this.options.fallbackLng)[0]),
            s
          );
        }
        getFallbackCodes(a, s) {
          if (!a) return [];
          if (
            (typeof a == 'function' && (a = a(s)),
            ue(a) && (a = [a]),
            Array.isArray(a))
          )
            return a;
          if (!s) return a.default || [];
          let r = a[s];
          return (
            r || (r = a[this.getScriptPartFromCode(s)]),
            r || (r = a[this.formatLanguageCode(s)]),
            r || (r = a[this.getLanguagePartFromCode(s)]),
            r || (r = a.default),
            r || []
          );
        }
        toResolveHierarchy(a, s) {
          const r = this.getFallbackCodes(
              (s === !1 ? [] : s) || this.options.fallbackLng || [],
              a
            ),
            u = [],
            f = p => {
              p &&
                (this.isSupportedCode(p)
                  ? u.push(p)
                  : this.logger.warn(
                      `rejecting language code not found in supportedLngs: ${p}`
                    ));
            };
          return (
            ue(a) && (a.indexOf('-') > -1 || a.indexOf('_') > -1)
              ? (this.options.load !== 'languageOnly' &&
                  f(this.formatLanguageCode(a)),
                this.options.load !== 'languageOnly' &&
                  this.options.load !== 'currentOnly' &&
                  f(this.getScriptPartFromCode(a)),
                this.options.load !== 'currentOnly' &&
                  f(this.getLanguagePartFromCode(a)))
              : ue(a) && f(this.formatLanguageCode(a)),
            r.forEach(p => {
              u.indexOf(p) < 0 && f(this.formatLanguageCode(p));
            }),
            u
          );
        }
      }
      const Vh = { zero: 0, one: 1, two: 2, few: 3, many: 4, other: 5 },
        Kh = {
          select: l => (l === 1 ? 'one' : 'other'),
          resolvedOptions: () => ({ pluralCategories: ['one', 'other'] }),
        };
      class iy {
        constructor(a, s = {}) {
          ((this.languageUtils = a),
            (this.options = s),
            (this.logger = qt.create('pluralResolver')),
            (this.pluralRulesCache = {}));
        }
        addRule(a, s) {
          this.rules[a] = s;
        }
        clearCache() {
          this.pluralRulesCache = {};
        }
        getRule(a, s = {}) {
          const r = tl(a === 'dev' ? 'en' : a),
            u = s.ordinal ? 'ordinal' : 'cardinal',
            f = JSON.stringify({ cleanedCode: r, type: u });
          if (f in this.pluralRulesCache) return this.pluralRulesCache[f];
          let p;
          try {
            p = new Intl.PluralRules(r, { type: u });
          } catch {
            if (!Intl)
              return (
                this.logger.error(
                  'No Intl support, please use an Intl polyfill!'
                ),
                Kh
              );
            if (!a.match(/-|_/)) return Kh;
            const d = this.languageUtils.getLanguagePartFromCode(a);
            p = this.getRule(d, s);
          }
          return ((this.pluralRulesCache[f] = p), p);
        }
        needsPlural(a, s = {}) {
          let r = this.getRule(a, s);
          return (
            r || (r = this.getRule('dev', s)),
            r?.resolvedOptions().pluralCategories.length > 1
          );
        }
        getPluralFormsOfKey(a, s, r = {}) {
          return this.getSuffixes(a, r).map(u => `${s}${u}`);
        }
        getSuffixes(a, s = {}) {
          let r = this.getRule(a, s);
          return (
            r || (r = this.getRule('dev', s)),
            r
              ? r
                  .resolvedOptions()
                  .pluralCategories.sort((u, f) => Vh[u] - Vh[f])
                  .map(
                    u =>
                      `${this.options.prepend}${s.ordinal ? `ordinal${this.options.prepend}` : ''}${u}`
                  )
              : []
          );
        }
        getSuffix(a, s, r = {}) {
          const u = this.getRule(a, r);
          return u
            ? `${this.options.prepend}${r.ordinal ? `ordinal${this.options.prepend}` : ''}${u.select(s)}`
            : (this.logger.warn(`no plural rule found for: ${a}`),
              this.getSuffix('dev', s, r));
        }
      }
      const qh = (l, a, s, r = '.', u = !0) => {
          let f = Zv(l, a, s);
          return (
            !f &&
              u &&
              ue(s) &&
              ((f = cu(l, s, r)), f === void 0 && (f = cu(a, s, r))),
            f
          );
        },
        eu = l => l.replace(/\$/g, '$$$$');
      class ny {
        constructor(a = {}) {
          ((this.logger = qt.create('interpolator')),
            (this.options = a),
            (this.format = a?.interpolation?.format || (s => s)),
            this.init(a));
        }
        init(a = {}) {
          a.interpolation || (a.interpolation = { escapeValue: !0 });
          const {
            escape: s,
            escapeValue: r,
            useRawValueToEscape: u,
            prefix: f,
            prefixEscaped: p,
            suffix: g,
            suffixEscaped: d,
            formatSeparator: h,
            unescapeSuffix: y,
            unescapePrefix: b,
            nestingPrefix: w,
            nestingPrefixEscaped: T,
            nestingSuffix: _,
            nestingSuffixEscaped: O,
            nestingOptionsSeparator: D,
            maxReplaces: q,
            alwaysFormat: U,
          } = a.interpolation;
          ((this.escape = s !== void 0 ? s : Jv),
            (this.escapeValue = r !== void 0 ? r : !0),
            (this.useRawValueToEscape = u !== void 0 ? u : !1),
            (this.prefix = f ? kn(f) : p || '{{'),
            (this.suffix = g ? kn(g) : d || '}}'),
            (this.formatSeparator = h || ','),
            (this.unescapePrefix = y ? '' : b || '-'),
            (this.unescapeSuffix = this.unescapePrefix ? '' : y || ''),
            (this.nestingPrefix = w ? kn(w) : T || kn('$t(')),
            (this.nestingSuffix = _ ? kn(_) : O || kn(')')),
            (this.nestingOptionsSeparator = D || ','),
            (this.maxReplaces = q || 1e3),
            (this.alwaysFormat = U !== void 0 ? U : !1),
            this.resetRegExp());
        }
        reset() {
          this.options && this.init(this.options);
        }
        resetRegExp() {
          const a = (s, r) =>
            s?.source === r ? ((s.lastIndex = 0), s) : new RegExp(r, 'g');
          ((this.regexp = a(this.regexp, `${this.prefix}(.+?)${this.suffix}`)),
            (this.regexpUnescape = a(
              this.regexpUnescape,
              `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`
            )),
            (this.nestingRegexp = a(
              this.nestingRegexp,
              `${this.nestingPrefix}((?:[^()"']+|"[^"]*"|'[^']*'|\\((?:[^()]|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`
            )));
        }
        interpolate(a, s, r, u) {
          let f, p, g;
          const d =
              (this.options &&
                this.options.interpolation &&
                this.options.interpolation.defaultVariables) ||
              {},
            h = T => {
              if (T.indexOf(this.formatSeparator) < 0) {
                const q = qh(
                  s,
                  d,
                  T,
                  this.options.keySeparator,
                  this.options.ignoreJSONStructure
                );
                return this.alwaysFormat
                  ? this.format(q, void 0, r, {
                      ...u,
                      ...s,
                      interpolationkey: T,
                    })
                  : q;
              }
              const _ = T.split(this.formatSeparator),
                O = _.shift().trim(),
                D = _.join(this.formatSeparator).trim();
              return this.format(
                qh(
                  s,
                  d,
                  O,
                  this.options.keySeparator,
                  this.options.ignoreJSONStructure
                ),
                D,
                r,
                { ...u, ...s, interpolationkey: O }
              );
            };
          this.resetRegExp();
          const y =
              u?.missingInterpolationHandler ||
              this.options.missingInterpolationHandler,
            b =
              u?.interpolation?.skipOnVariables !== void 0
                ? u.interpolation.skipOnVariables
                : this.options.interpolation.skipOnVariables;
          return (
            [
              { regex: this.regexpUnescape, safeValue: T => eu(T) },
              {
                regex: this.regexp,
                safeValue: T => (this.escapeValue ? eu(this.escape(T)) : eu(T)),
              },
            ].forEach(T => {
              for (g = 0; (f = T.regex.exec(a)); ) {
                const _ = f[1].trim();
                if (((p = h(_)), p === void 0))
                  if (typeof y == 'function') {
                    const D = y(a, f, u);
                    p = ue(D) ? D : '';
                  } else if (u && Object.prototype.hasOwnProperty.call(u, _))
                    p = '';
                  else if (b) {
                    p = f[0];
                    continue;
                  } else
                    (this.logger.warn(
                      `missed to pass in variable ${_} for interpolating ${a}`
                    ),
                      (p = ''));
                else !ue(p) && !this.useRawValueToEscape && (p = Dh(p));
                const O = T.safeValue(p);
                if (
                  ((a = a.replace(f[0], O)),
                  b
                    ? ((T.regex.lastIndex += p.length),
                      (T.regex.lastIndex -= f[0].length))
                    : (T.regex.lastIndex = 0),
                  g++,
                  g >= this.maxReplaces)
                )
                  break;
              }
            }),
            a
          );
        }
        nest(a, s, r = {}) {
          let u, f, p;
          const g = (d, h) => {
            const y = this.nestingOptionsSeparator;
            if (d.indexOf(y) < 0) return d;
            const b = d.split(new RegExp(`${y}[ ]*{`));
            let w = `{${b[1]}`;
            ((d = b[0]), (w = this.interpolate(w, p)));
            const T = w.match(/'/g),
              _ = w.match(/"/g);
            (((T?.length ?? 0) % 2 === 0 && !_) || _.length % 2 !== 0) &&
              (w = w.replace(/'/g, '"'));
            try {
              ((p = JSON.parse(w)), h && (p = { ...h, ...p }));
            } catch (O) {
              return (
                this.logger.warn(
                  `failed parsing options string in nesting for key ${d}`,
                  O
                ),
                `${d}${y}${w}`
              );
            }
            return (
              p.defaultValue &&
                p.defaultValue.indexOf(this.prefix) > -1 &&
                delete p.defaultValue,
              d
            );
          };
          for (; (u = this.nestingRegexp.exec(a)); ) {
            let d = [];
            ((p = { ...r }),
              (p = p.replace && !ue(p.replace) ? p.replace : p),
              (p.applyPostProcessor = !1),
              delete p.defaultValue);
            const h = /{.*}/.test(u[1])
              ? u[1].lastIndexOf('}') + 1
              : u[1].indexOf(this.formatSeparator);
            if (
              (h !== -1 &&
                ((d = u[1]
                  .slice(h)
                  .split(this.formatSeparator)
                  .map(y => y.trim())
                  .filter(Boolean)),
                (u[1] = u[1].slice(0, h))),
              (f = s(g.call(this, u[1].trim(), p), p)),
              f && u[0] === a && !ue(f))
            )
              return f;
            (ue(f) || (f = Dh(f)),
              f ||
                (this.logger.warn(`missed to resolve ${u[1]} for nesting ${a}`),
                (f = '')),
              d.length &&
                (f = d.reduce(
                  (y, b) =>
                    this.format(y, b, r.lng, {
                      ...r,
                      interpolationkey: u[1].trim(),
                    }),
                  f.trim()
                )),
              (a = a.replace(u[0], f)),
              (this.regexp.lastIndex = 0));
          }
          return a;
        }
      }
      const ay = l => {
          let a = l.toLowerCase().trim();
          const s = {};
          if (l.indexOf('(') > -1) {
            const r = l.split('(');
            a = r[0].toLowerCase().trim();
            const u = r[1].substring(0, r[1].length - 1);
            a === 'currency' && u.indexOf(':') < 0
              ? s.currency || (s.currency = u.trim())
              : a === 'relativetime' && u.indexOf(':') < 0
                ? s.range || (s.range = u.trim())
                : u.split(';').forEach(p => {
                    if (p) {
                      const [g, ...d] = p.split(':'),
                        h = d
                          .join(':')
                          .trim()
                          .replace(/^'+|'+$/g, ''),
                        y = g.trim();
                      (s[y] || (s[y] = h),
                        h === 'false' && (s[y] = !1),
                        h === 'true' && (s[y] = !0),
                        isNaN(h) || (s[y] = parseInt(h, 10)));
                    }
                  });
          }
          return { formatName: a, formatOptions: s };
        },
        Yh = l => {
          const a = {};
          return (s, r, u) => {
            let f = u;
            u &&
              u.interpolationkey &&
              u.formatParams &&
              u.formatParams[u.interpolationkey] &&
              u[u.interpolationkey] &&
              (f = { ...f, [u.interpolationkey]: void 0 });
            const p = r + JSON.stringify(f);
            let g = a[p];
            return (g || ((g = l(tl(r), u)), (a[p] = g)), g(s));
          };
        },
        ly = l => (a, s, r) => l(tl(s), r)(a);
      class sy {
        constructor(a = {}) {
          ((this.logger = qt.create('formatter')),
            (this.options = a),
            this.init(a));
        }
        init(a, s = { interpolation: {} }) {
          this.formatSeparator = s.interpolation.formatSeparator || ',';
          const r = s.cacheInBuiltFormats ? Yh : ly;
          this.formats = {
            number: r((u, f) => {
              const p = new Intl.NumberFormat(u, { ...f });
              return g => p.format(g);
            }),
            currency: r((u, f) => {
              const p = new Intl.NumberFormat(u, { ...f, style: 'currency' });
              return g => p.format(g);
            }),
            datetime: r((u, f) => {
              const p = new Intl.DateTimeFormat(u, { ...f });
              return g => p.format(g);
            }),
            relativetime: r((u, f) => {
              const p = new Intl.RelativeTimeFormat(u, { ...f });
              return g => p.format(g, f.range || 'day');
            }),
            list: r((u, f) => {
              const p = new Intl.ListFormat(u, { ...f });
              return g => p.format(g);
            }),
          };
        }
        add(a, s) {
          this.formats[a.toLowerCase().trim()] = s;
        }
        addCached(a, s) {
          this.formats[a.toLowerCase().trim()] = Yh(s);
        }
        format(a, s, r, u = {}) {
          const f = s.split(this.formatSeparator);
          if (
            f.length > 1 &&
            f[0].indexOf('(') > 1 &&
            f[0].indexOf(')') < 0 &&
            f.find(g => g.indexOf(')') > -1)
          ) {
            const g = f.findIndex(d => d.indexOf(')') > -1);
            f[0] = [f[0], ...f.splice(1, g)].join(this.formatSeparator);
          }
          return f.reduce((g, d) => {
            const { formatName: h, formatOptions: y } = ay(d);
            if (this.formats[h]) {
              let b = g;
              try {
                const w = u?.formatParams?.[u.interpolationkey] || {},
                  T = w.locale || w.lng || u.locale || u.lng || r;
                b = this.formats[h](g, T, { ...y, ...u, ...w });
              } catch (w) {
                this.logger.warn(w);
              }
              return b;
            } else this.logger.warn(`there was no format function for ${h}`);
            return g;
          }, a);
        }
      }
      const ry = (l, a) => {
        l.pending[a] !== void 0 && (delete l.pending[a], l.pendingCount--);
      };
      class oy extends Ns {
        constructor(a, s, r, u = {}) {
          (super(),
            (this.backend = a),
            (this.store = s),
            (this.services = r),
            (this.languageUtils = r.languageUtils),
            (this.options = u),
            (this.logger = qt.create('backendConnector')),
            (this.waitingReads = []),
            (this.maxParallelReads = u.maxParallelReads || 10),
            (this.readingCalls = 0),
            (this.maxRetries = u.maxRetries >= 0 ? u.maxRetries : 5),
            (this.retryTimeout = u.retryTimeout >= 1 ? u.retryTimeout : 350),
            (this.state = {}),
            (this.queue = []),
            this.backend?.init?.(r, u.backend, u));
        }
        queueLoad(a, s, r, u) {
          const f = {},
            p = {},
            g = {},
            d = {};
          return (
            a.forEach(h => {
              let y = !0;
              (s.forEach(b => {
                const w = `${h}|${b}`;
                !r.reload && this.store.hasResourceBundle(h, b)
                  ? (this.state[w] = 2)
                  : this.state[w] < 0 ||
                    (this.state[w] === 1
                      ? p[w] === void 0 && (p[w] = !0)
                      : ((this.state[w] = 1),
                        (y = !1),
                        p[w] === void 0 && (p[w] = !0),
                        f[w] === void 0 && (f[w] = !0),
                        d[b] === void 0 && (d[b] = !0)));
              }),
                y || (g[h] = !0));
            }),
            (Object.keys(f).length || Object.keys(p).length) &&
              this.queue.push({
                pending: p,
                pendingCount: Object.keys(p).length,
                loaded: {},
                errors: [],
                callback: u,
              }),
            {
              toLoad: Object.keys(f),
              pending: Object.keys(p),
              toLoadLanguages: Object.keys(g),
              toLoadNamespaces: Object.keys(d),
            }
          );
        }
        loaded(a, s, r) {
          const u = a.split('|'),
            f = u[0],
            p = u[1];
          (s && this.emit('failedLoading', f, p, s),
            !s &&
              r &&
              this.store.addResourceBundle(f, p, r, void 0, void 0, {
                skipCopy: !0,
              }),
            (this.state[a] = s ? -1 : 2),
            s && r && (this.state[a] = 0));
          const g = {};
          (this.queue.forEach(d => {
            (Qv(d.loaded, [f], p),
              ry(d, a),
              s && d.errors.push(s),
              d.pendingCount === 0 &&
                !d.done &&
                (Object.keys(d.loaded).forEach(h => {
                  g[h] || (g[h] = {});
                  const y = d.loaded[h];
                  y.length &&
                    y.forEach(b => {
                      g[h][b] === void 0 && (g[h][b] = !0);
                    });
                }),
                (d.done = !0),
                d.errors.length ? d.callback(d.errors) : d.callback()));
          }),
            this.emit('loaded', g),
            (this.queue = this.queue.filter(d => !d.done)));
        }
        read(a, s, r, u = 0, f = this.retryTimeout, p) {
          if (!a.length) return p(null, {});
          if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
              lng: a,
              ns: s,
              fcName: r,
              tried: u,
              wait: f,
              callback: p,
            });
            return;
          }
          this.readingCalls++;
          const g = (h, y) => {
              if ((this.readingCalls--, this.waitingReads.length > 0)) {
                const b = this.waitingReads.shift();
                this.read(b.lng, b.ns, b.fcName, b.tried, b.wait, b.callback);
              }
              if (h && y && u < this.maxRetries) {
                setTimeout(() => {
                  this.read.call(this, a, s, r, u + 1, f * 2, p);
                }, f);
                return;
              }
              p(h, y);
            },
            d = this.backend[r].bind(this.backend);
          if (d.length === 2) {
            try {
              const h = d(a, s);
              h && typeof h.then == 'function'
                ? h.then(y => g(null, y)).catch(g)
                : g(null, h);
            } catch (h) {
              g(h);
            }
            return;
          }
          return d(a, s, g);
        }
        prepareLoading(a, s, r = {}, u) {
          if (!this.backend)
            return (
              this.logger.warn(
                'No backend was added via i18next.use. Will not load resources.'
              ),
              u && u()
            );
          (ue(a) && (a = this.languageUtils.toResolveHierarchy(a)),
            ue(s) && (s = [s]));
          const f = this.queueLoad(a, s, r, u);
          if (!f.toLoad.length) return (f.pending.length || u(), null);
          f.toLoad.forEach(p => {
            this.loadOne(p);
          });
        }
        load(a, s, r) {
          this.prepareLoading(a, s, {}, r);
        }
        reload(a, s, r) {
          this.prepareLoading(a, s, { reload: !0 }, r);
        }
        loadOne(a, s = '') {
          const r = a.split('|'),
            u = r[0],
            f = r[1];
          this.read(u, f, 'read', void 0, void 0, (p, g) => {
            (p &&
              this.logger.warn(
                `${s}loading namespace ${f} for language ${u} failed`,
                p
              ),
              !p &&
                g &&
                this.logger.log(
                  `${s}loaded namespace ${f} for language ${u}`,
                  g
                ),
              this.loaded(a, p, g));
          });
        }
        saveMissing(a, s, r, u, f, p = {}, g = () => {}) {
          if (
            this.services?.utils?.hasLoadedNamespace &&
            !this.services?.utils?.hasLoadedNamespace(s)
          ) {
            this.logger.warn(
              `did not save key "${r}" as the namespace "${s}" was not yet loaded`,
              'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!'
            );
            return;
          }
          if (!(r == null || r === '')) {
            if (this.backend?.create) {
              const d = { ...p, isUpdate: f },
                h = this.backend.create.bind(this.backend);
              if (h.length < 6)
                try {
                  let y;
                  (h.length === 5
                    ? (y = h(a, s, r, u, d))
                    : (y = h(a, s, r, u)),
                    y && typeof y.then == 'function'
                      ? y.then(b => g(null, b)).catch(g)
                      : g(null, y));
                } catch (y) {
                  g(y);
                }
              else h(a, s, r, u, g, d);
            }
            !a || !a[0] || this.store.addResource(a[0], s, r, u);
          }
        }
      }
      const $h = () => ({
          debug: !1,
          initAsync: !0,
          ns: ['translation'],
          defaultNS: ['translation'],
          fallbackLng: ['dev'],
          fallbackNS: !1,
          supportedLngs: !1,
          nonExplicitSupportedLngs: !1,
          load: 'all',
          preload: !1,
          simplifyPluralSuffix: !0,
          keySeparator: '.',
          nsSeparator: ':',
          pluralSeparator: '_',
          contextSeparator: '_',
          partialBundledLanguages: !1,
          saveMissing: !1,
          updateMissing: !1,
          saveMissingTo: 'fallback',
          saveMissingPlurals: !0,
          missingKeyHandler: !1,
          missingInterpolationHandler: !1,
          postProcess: !1,
          postProcessPassResolved: !1,
          returnNull: !1,
          returnEmptyString: !0,
          returnObjects: !1,
          joinArrays: !1,
          returnedObjectHandler: !1,
          parseMissingKeyHandler: !1,
          appendNamespaceToMissingKey: !1,
          appendNamespaceToCIMode: !1,
          overloadTranslationOptionHandler: l => {
            let a = {};
            if (
              (typeof l[1] == 'object' && (a = l[1]),
              ue(l[1]) && (a.defaultValue = l[1]),
              ue(l[2]) && (a.tDescription = l[2]),
              typeof l[2] == 'object' || typeof l[3] == 'object')
            ) {
              const s = l[3] || l[2];
              Object.keys(s).forEach(r => {
                a[r] = s[r];
              });
            }
            return a;
          },
          interpolation: {
            escapeValue: !0,
            format: l => l,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1e3,
            skipOnVariables: !0,
          },
          cacheInBuiltFormats: !0,
        }),
        Xh = l => (
          ue(l.ns) && (l.ns = [l.ns]),
          ue(l.fallbackLng) && (l.fallbackLng = [l.fallbackLng]),
          ue(l.fallbackNS) && (l.fallbackNS = [l.fallbackNS]),
          l.supportedLngs?.indexOf?.('cimode') < 0 &&
            (l.supportedLngs = l.supportedLngs.concat(['cimode'])),
          typeof l.initImmediate == 'boolean' &&
            (l.initAsync = l.initImmediate),
          l
        ),
        ys = () => {},
        uy = l => {
          Object.getOwnPropertyNames(Object.getPrototypeOf(l)).forEach(s => {
            typeof l[s] == 'function' && (l[s] = l[s].bind(l));
          });
        };
      class il extends Ns {
        constructor(a = {}, s) {
          if (
            (super(),
            (this.options = Xh(a)),
            (this.services = {}),
            (this.logger = qt),
            (this.modules = { external: [] }),
            uy(this),
            s && !this.isInitialized && !a.isClone)
          ) {
            if (!this.options.initAsync) return (this.init(a, s), this);
            setTimeout(() => {
              this.init(a, s);
            }, 0);
          }
        }
        init(a = {}, s) {
          ((this.isInitializing = !0),
            typeof a == 'function' && ((s = a), (a = {})),
            a.defaultNS == null &&
              a.ns &&
              (ue(a.ns)
                ? (a.defaultNS = a.ns)
                : a.ns.indexOf('translation') < 0 && (a.defaultNS = a.ns[0])));
          const r = $h();
          ((this.options = { ...r, ...this.options, ...Xh(a) }),
            (this.options.interpolation = {
              ...r.interpolation,
              ...this.options.interpolation,
            }),
            a.keySeparator !== void 0 &&
              (this.options.userDefinedKeySeparator = a.keySeparator),
            a.nsSeparator !== void 0 &&
              (this.options.userDefinedNsSeparator = a.nsSeparator));
          const u = h => (h ? (typeof h == 'function' ? new h() : h) : null);
          if (!this.options.isClone) {
            this.modules.logger
              ? qt.init(u(this.modules.logger), this.options)
              : qt.init(null, this.options);
            let h;
            this.modules.formatter ? (h = this.modules.formatter) : (h = sy);
            const y = new Gh(this.options);
            this.store = new Uh(this.options.resources, this.options);
            const b = this.services;
            ((b.logger = qt),
              (b.resourceStore = this.store),
              (b.languageUtils = y),
              (b.pluralResolver = new iy(y, {
                prepend: this.options.pluralSeparator,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix,
              })),
              this.options.interpolation.format &&
                this.options.interpolation.format !== r.interpolation.format &&
                this.logger.deprecate(
                  'init: you are still using the legacy format function, please use the new approach: https://www.i18next.com/translation-function/formatting'
                ),
              h &&
                (!this.options.interpolation.format ||
                  this.options.interpolation.format ===
                    r.interpolation.format) &&
                ((b.formatter = u(h)),
                b.formatter.init && b.formatter.init(b, this.options),
                (this.options.interpolation.format = b.formatter.format.bind(
                  b.formatter
                ))),
              (b.interpolator = new ny(this.options)),
              (b.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this),
              }),
              (b.backendConnector = new oy(
                u(this.modules.backend),
                b.resourceStore,
                b,
                this.options
              )),
              b.backendConnector.on('*', (T, ..._) => {
                this.emit(T, ..._);
              }),
              this.modules.languageDetector &&
                ((b.languageDetector = u(this.modules.languageDetector)),
                b.languageDetector.init &&
                  b.languageDetector.init(
                    b,
                    this.options.detection,
                    this.options
                  )),
              this.modules.i18nFormat &&
                ((b.i18nFormat = u(this.modules.i18nFormat)),
                b.i18nFormat.init && b.i18nFormat.init(this)),
              (this.translator = new As(this.services, this.options)),
              this.translator.on('*', (T, ..._) => {
                this.emit(T, ..._);
              }),
              this.modules.external.forEach(T => {
                T.init && T.init(this);
              }));
          }
          if (
            ((this.format = this.options.interpolation.format),
            s || (s = ys),
            this.options.fallbackLng &&
              !this.services.languageDetector &&
              !this.options.lng)
          ) {
            const h = this.services.languageUtils.getFallbackCodes(
              this.options.fallbackLng
            );
            h.length > 0 && h[0] !== 'dev' && (this.options.lng = h[0]);
          }
          (!this.services.languageDetector &&
            !this.options.lng &&
            this.logger.warn(
              'init: no languageDetector is used and no lng is defined'
            ),
            [
              'getResource',
              'hasResourceBundle',
              'getResourceBundle',
              'getDataByLanguage',
            ].forEach(h => {
              this[h] = (...y) => this.store[h](...y);
            }),
            [
              'addResource',
              'addResources',
              'addResourceBundle',
              'removeResourceBundle',
            ].forEach(h => {
              this[h] = (...y) => (this.store[h](...y), this);
            }));
          const g = Ia(),
            d = () => {
              const h = (y, b) => {
                ((this.isInitializing = !1),
                  this.isInitialized &&
                    !this.initializedStoreOnce &&
                    this.logger.warn(
                      'init: i18next is already initialized. You should call init just once!'
                    ),
                  (this.isInitialized = !0),
                  this.options.isClone ||
                    this.logger.log('initialized', this.options),
                  this.emit('initialized', this.options),
                  g.resolve(b),
                  s(y, b));
              };
              if (this.languages && !this.isInitialized)
                return h(null, this.t.bind(this));
              this.changeLanguage(this.options.lng, h);
            };
          return (
            this.options.resources || !this.options.initAsync
              ? d()
              : setTimeout(d, 0),
            g
          );
        }
        loadResources(a, s = ys) {
          let r = s;
          const u = ue(a) ? a : this.language;
          if (
            (typeof a == 'function' && (r = a),
            !this.options.resources || this.options.partialBundledLanguages)
          ) {
            if (
              u?.toLowerCase() === 'cimode' &&
              (!this.options.preload || this.options.preload.length === 0)
            )
              return r();
            const f = [],
              p = g => {
                if (!g || g === 'cimode') return;
                this.services.languageUtils.toResolveHierarchy(g).forEach(h => {
                  h !== 'cimode' && f.indexOf(h) < 0 && f.push(h);
                });
              };
            (u
              ? p(u)
              : this.services.languageUtils
                  .getFallbackCodes(this.options.fallbackLng)
                  .forEach(d => p(d)),
              this.options.preload?.forEach?.(g => p(g)),
              this.services.backendConnector.load(f, this.options.ns, g => {
                (!g &&
                  !this.resolvedLanguage &&
                  this.language &&
                  this.setResolvedLanguage(this.language),
                  r(g));
              }));
          } else r(null);
        }
        reloadResources(a, s, r) {
          const u = Ia();
          return (
            typeof a == 'function' && ((r = a), (a = void 0)),
            typeof s == 'function' && ((r = s), (s = void 0)),
            a || (a = this.languages),
            s || (s = this.options.ns),
            r || (r = ys),
            this.services.backendConnector.reload(a, s, f => {
              (u.resolve(), r(f));
            }),
            u
          );
        }
        use(a) {
          if (!a)
            throw new Error(
              'You are passing an undefined module! Please check the object you are passing to i18next.use()'
            );
          if (!a.type)
            throw new Error(
              'You are passing a wrong module! Please check the object you are passing to i18next.use()'
            );
          return (
            a.type === 'backend' && (this.modules.backend = a),
            (a.type === 'logger' || (a.log && a.warn && a.error)) &&
              (this.modules.logger = a),
            a.type === 'languageDetector' &&
              (this.modules.languageDetector = a),
            a.type === 'i18nFormat' && (this.modules.i18nFormat = a),
            a.type === 'postProcessor' && up.addPostProcessor(a),
            a.type === 'formatter' && (this.modules.formatter = a),
            a.type === '3rdParty' && this.modules.external.push(a),
            this
          );
        }
        setResolvedLanguage(a) {
          if (
            !(!a || !this.languages) &&
            !(['cimode', 'dev'].indexOf(a) > -1)
          ) {
            for (let s = 0; s < this.languages.length; s++) {
              const r = this.languages[s];
              if (
                !(['cimode', 'dev'].indexOf(r) > -1) &&
                this.store.hasLanguageSomeTranslations(r)
              ) {
                this.resolvedLanguage = r;
                break;
              }
            }
            !this.resolvedLanguage &&
              this.languages.indexOf(a) < 0 &&
              this.store.hasLanguageSomeTranslations(a) &&
              ((this.resolvedLanguage = a), this.languages.unshift(a));
          }
        }
        changeLanguage(a, s) {
          this.isLanguageChangingTo = a;
          const r = Ia();
          this.emit('languageChanging', a);
          const u = g => {
              ((this.language = g),
                (this.languages =
                  this.services.languageUtils.toResolveHierarchy(g)),
                (this.resolvedLanguage = void 0),
                this.setResolvedLanguage(g));
            },
            f = (g, d) => {
              (d
                ? this.isLanguageChangingTo === a &&
                  (u(d),
                  this.translator.changeLanguage(d),
                  (this.isLanguageChangingTo = void 0),
                  this.emit('languageChanged', d),
                  this.logger.log('languageChanged', d))
                : (this.isLanguageChangingTo = void 0),
                r.resolve((...h) => this.t(...h)),
                s && s(g, (...h) => this.t(...h)));
            },
            p = g => {
              !a && !g && this.services.languageDetector && (g = []);
              const d = ue(g) ? g : g && g[0],
                h = this.store.hasLanguageSomeTranslations(d)
                  ? d
                  : this.services.languageUtils.getBestMatchFromCodes(
                      ue(g) ? [g] : g
                    );
              (h &&
                (this.language || u(h),
                this.translator.language || this.translator.changeLanguage(h),
                this.services.languageDetector?.cacheUserLanguage?.(h)),
                this.loadResources(h, y => {
                  f(y, h);
                }));
            };
          return (
            !a &&
            this.services.languageDetector &&
            !this.services.languageDetector.async
              ? p(this.services.languageDetector.detect())
              : !a &&
                  this.services.languageDetector &&
                  this.services.languageDetector.async
                ? this.services.languageDetector.detect.length === 0
                  ? this.services.languageDetector.detect().then(p)
                  : this.services.languageDetector.detect(p)
                : p(a),
            r
          );
        }
        getFixedT(a, s, r) {
          const u = (f, p, ...g) => {
            let d;
            (typeof p != 'object'
              ? (d = this.options.overloadTranslationOptionHandler(
                  [f, p].concat(g)
                ))
              : (d = { ...p }),
              (d.lng = d.lng || u.lng),
              (d.lngs = d.lngs || u.lngs),
              (d.ns = d.ns || u.ns),
              d.keyPrefix !== '' &&
                (d.keyPrefix = d.keyPrefix || r || u.keyPrefix));
            const h = this.options.keySeparator || '.';
            let y;
            return (
              d.keyPrefix && Array.isArray(f)
                ? (y = f.map(
                    b => (
                      typeof b == 'function' &&
                        (b = fu(b, { ...this.options, ...p })),
                      `${d.keyPrefix}${h}${b}`
                    )
                  ))
                : (typeof f == 'function' &&
                    (f = fu(f, { ...this.options, ...p })),
                  (y = d.keyPrefix ? `${d.keyPrefix}${h}${f}` : f)),
              this.t(y, d)
            );
          };
          return (
            ue(a) ? (u.lng = a) : (u.lngs = a),
            (u.ns = s),
            (u.keyPrefix = r),
            u
          );
        }
        t(...a) {
          return this.translator?.translate(...a);
        }
        exists(...a) {
          return this.translator?.exists(...a);
        }
        setDefaultNamespace(a) {
          this.options.defaultNS = a;
        }
        hasLoadedNamespace(a, s = {}) {
          if (!this.isInitialized)
            return (
              this.logger.warn(
                'hasLoadedNamespace: i18next was not initialized',
                this.languages
              ),
              !1
            );
          if (!this.languages || !this.languages.length)
            return (
              this.logger.warn(
                'hasLoadedNamespace: i18n.languages were undefined or empty',
                this.languages
              ),
              !1
            );
          const r = s.lng || this.resolvedLanguage || this.languages[0],
            u = this.options ? this.options.fallbackLng : !1,
            f = this.languages[this.languages.length - 1];
          if (r.toLowerCase() === 'cimode') return !0;
          const p = (g, d) => {
            const h = this.services.backendConnector.state[`${g}|${d}`];
            return h === -1 || h === 0 || h === 2;
          };
          if (s.precheck) {
            const g = s.precheck(this, p);
            if (g !== void 0) return g;
          }
          return !!(
            this.hasResourceBundle(r, a) ||
            !this.services.backendConnector.backend ||
            (this.options.resources && !this.options.partialBundledLanguages) ||
            (p(r, a) && (!u || p(f, a)))
          );
        }
        loadNamespaces(a, s) {
          const r = Ia();
          return this.options.ns
            ? (ue(a) && (a = [a]),
              a.forEach(u => {
                this.options.ns.indexOf(u) < 0 && this.options.ns.push(u);
              }),
              this.loadResources(u => {
                (r.resolve(), s && s(u));
              }),
              r)
            : (s && s(), Promise.resolve());
        }
        loadLanguages(a, s) {
          const r = Ia();
          ue(a) && (a = [a]);
          const u = this.options.preload || [],
            f = a.filter(
              p =>
                u.indexOf(p) < 0 &&
                this.services.languageUtils.isSupportedCode(p)
            );
          return f.length
            ? ((this.options.preload = u.concat(f)),
              this.loadResources(p => {
                (r.resolve(), s && s(p));
              }),
              r)
            : (s && s(), Promise.resolve());
        }
        dir(a) {
          if (
            (a ||
              (a =
                this.resolvedLanguage ||
                (this.languages?.length > 0
                  ? this.languages[0]
                  : this.language)),
            !a)
          )
            return 'rtl';
          try {
            const u = new Intl.Locale(a);
            if (u && u.getTextInfo) {
              const f = u.getTextInfo();
              if (f && f.direction) return f.direction;
            }
          } catch {}
          const s = [
              'ar',
              'shu',
              'sqr',
              'ssh',
              'xaa',
              'yhd',
              'yud',
              'aao',
              'abh',
              'abv',
              'acm',
              'acq',
              'acw',
              'acx',
              'acy',
              'adf',
              'ads',
              'aeb',
              'aec',
              'afb',
              'ajp',
              'apc',
              'apd',
              'arb',
              'arq',
              'ars',
              'ary',
              'arz',
              'auz',
              'avl',
              'ayh',
              'ayl',
              'ayn',
              'ayp',
              'bbz',
              'pga',
              'he',
              'iw',
              'ps',
              'pbt',
              'pbu',
              'pst',
              'prp',
              'prd',
              'ug',
              'ur',
              'ydd',
              'yds',
              'yih',
              'ji',
              'yi',
              'hbo',
              'men',
              'xmn',
              'fa',
              'jpr',
              'peo',
              'pes',
              'prs',
              'dv',
              'sam',
              'ckb',
            ],
            r = this.services?.languageUtils || new Gh($h());
          return a.toLowerCase().indexOf('-latn') > 1
            ? 'ltr'
            : s.indexOf(r.getLanguagePartFromCode(a)) > -1 ||
                a.toLowerCase().indexOf('-arab') > 1
              ? 'rtl'
              : 'ltr';
        }
        static createInstance(a = {}, s) {
          return new il(a, s);
        }
        cloneInstance(a = {}, s = ys) {
          const r = a.forkResourceStore;
          r && delete a.forkResourceStore;
          const u = { ...this.options, ...a, isClone: !0 },
            f = new il(u);
          if (
            ((a.debug !== void 0 || a.prefix !== void 0) &&
              (f.logger = f.logger.clone(a)),
            ['store', 'services', 'language'].forEach(g => {
              f[g] = this[g];
            }),
            (f.services = { ...this.services }),
            (f.services.utils = {
              hasLoadedNamespace: f.hasLoadedNamespace.bind(f),
            }),
            r)
          ) {
            const g = Object.keys(this.store.data).reduce(
              (d, h) => (
                (d[h] = { ...this.store.data[h] }),
                (d[h] = Object.keys(d[h]).reduce(
                  (y, b) => ((y[b] = { ...d[h][b] }), y),
                  d[h]
                )),
                d
              ),
              {}
            );
            ((f.store = new Uh(g, u)), (f.services.resourceStore = f.store));
          }
          return (
            (f.translator = new As(f.services, u)),
            f.translator.on('*', (g, ...d) => {
              f.emit(g, ...d);
            }),
            f.init(u, s),
            (f.translator.options = u),
            (f.translator.backendConnector.services.utils = {
              hasLoadedNamespace: f.hasLoadedNamespace.bind(f),
            }),
            f
          );
        }
        toJSON() {
          return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage,
          };
        }
      }
      const Mu = il.createInstance();
      Mu.createInstance = il.createInstance;
      const cy = (l, a, s, r) => {
          const u = [s, { code: a, ...(r || {}) }];
          if (l?.services?.logger?.forward)
            return l.services.logger.forward(u, 'warn', 'react-i18next::', !0);
          (sn(u[0]) && (u[0] = `react-i18next:: ${u[0]}`),
            l?.services?.logger?.warn
              ? l.services.logger.warn(...u)
              : console?.warn && console.warn(...u));
        },
        Qh = {},
        du = (l, a, s, r) => {
          (sn(s) && Qh[s]) || (sn(s) && (Qh[s] = new Date()), cy(l, a, s, r));
        },
        fp = (l, a) => () => {
          if (l.isInitialized) a();
          else {
            const s = () => {
              (setTimeout(() => {
                l.off('initialized', s);
              }, 0),
                a());
            };
            l.on('initialized', s);
          }
        },
        hu = (l, a, s) => {
          l.loadNamespaces(a, fp(l, s));
        },
        Zh = (l, a, s, r) => {
          if (
            (sn(s) && (s = [s]),
            l.options.preload && l.options.preload.indexOf(a) > -1)
          )
            return hu(l, s, r);
          (s.forEach(u => {
            l.options.ns.indexOf(u) < 0 && l.options.ns.push(u);
          }),
            l.loadLanguages(a, fp(l, r)));
        },
        fy = (l, a, s = {}) =>
          !a.languages || !a.languages.length
            ? (du(a, 'NO_LANGUAGES', 'i18n.languages were undefined or empty', {
                languages: a.languages,
              }),
              !0)
            : a.hasLoadedNamespace(l, {
                lng: s.lng,
                precheck: (r, u) => {
                  if (
                    s.bindI18n &&
                    s.bindI18n.indexOf('languageChanging') > -1 &&
                    r.services.backendConnector.backend &&
                    r.isLanguageChangingTo &&
                    !u(r.isLanguageChangingTo, l)
                  )
                    return !1;
                },
              }),
        sn = l => typeof l == 'string',
        dy = l => typeof l == 'object' && l !== null,
        hy =
          /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g,
        py = {
          '&amp;': '&',
          '&#38;': '&',
          '&lt;': '<',
          '&#60;': '<',
          '&gt;': '>',
          '&#62;': '>',
          '&apos;': "'",
          '&#39;': "'",
          '&quot;': '"',
          '&#34;': '"',
          '&nbsp;': ' ',
          '&#160;': ' ',
          '&copy;': '©',
          '&#169;': '©',
          '&reg;': '®',
          '&#174;': '®',
          '&hellip;': '…',
          '&#8230;': '…',
          '&#x2F;': '/',
          '&#47;': '/',
        },
        my = l => py[l],
        gy = l => l.replace(hy, my);
      let pu = {
        bindI18n: 'languageChanged',
        bindI18nStore: '',
        transEmptyNodeValue: '',
        transSupportBasicHtmlNodes: !0,
        transWrapTextNodes: '',
        transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
        useSuspense: !0,
        unescape: gy,
      };
      const vy = (l = {}) => {
          pu = { ...pu, ...l };
        },
        yy = () => pu;
      let dp;
      const by = l => {
          dp = l;
        },
        Sy = () => dp,
        xy = {
          type: '3rdParty',
          init(l) {
            (vy(l.options.react), by(l));
          },
        },
        hp = I.createContext();
      class Ty {
        constructor() {
          this.usedNamespaces = {};
        }
        addUsedNamespaces(a) {
          a.forEach(s => {
            this.usedNamespaces[s] || (this.usedNamespaces[s] = !0);
          });
        }
        getUsedNamespaces() {
          return Object.keys(this.usedNamespaces);
        }
      }
      const Ey = (l, a) => {
          const s = I.useRef();
          return (
            I.useEffect(() => {
              s.current = l;
            }, [l, a]),
            s.current
          );
        },
        pp = (l, a, s, r) => l.getFixedT(a, s, r),
        wy = (l, a, s, r) => I.useCallback(pp(l, a, s, r), [l, a, s, r]),
        Je = (l, a = {}) => {
          const { i18n: s } = a,
            { i18n: r, defaultNS: u } = I.useContext(hp) || {},
            f = s || r || Sy();
          if (
            (f && !f.reportNamespaces && (f.reportNamespaces = new Ty()), !f)
          ) {
            du(
              f,
              'NO_I18NEXT_INSTANCE',
              'useTranslation: You will need to pass in an i18next instance by using initReactI18next'
            );
            const X = (W, k) =>
                sn(k)
                  ? k
                  : dy(k) && sn(k.defaultValue)
                    ? k.defaultValue
                    : Array.isArray(W)
                      ? W[W.length - 1]
                      : W,
              B = [X, {}, !1];
            return ((B.t = X), (B.i18n = {}), (B.ready = !1), B);
          }
          f.options.react?.wait &&
            du(
              f,
              'DEPRECATED_OPTION',
              'useTranslation: It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.'
            );
          const p = { ...yy(), ...f.options.react, ...a },
            { useSuspense: g, keyPrefix: d } = p;
          let h = l || u || f.options?.defaultNS;
          ((h = sn(h) ? [h] : h || ['translation']),
            f.reportNamespaces.addUsedNamespaces?.(h));
          const y =
              (f.isInitialized || f.initializedStoreOnce) &&
              h.every(X => fy(X, f, p)),
            b = wy(f, a.lng || null, p.nsMode === 'fallback' ? h : h[0], d),
            w = () => b,
            T = () =>
              pp(f, a.lng || null, p.nsMode === 'fallback' ? h : h[0], d),
            [_, O] = I.useState(w);
          let D = h.join();
          a.lng && (D = `${a.lng}${D}`);
          const q = Ey(D),
            U = I.useRef(!0);
          (I.useEffect(() => {
            const { bindI18n: X, bindI18nStore: B } = p;
            ((U.current = !0),
              !y &&
                !g &&
                (a.lng
                  ? Zh(f, a.lng, h, () => {
                      U.current && O(T);
                    })
                  : hu(f, h, () => {
                      U.current && O(T);
                    })),
              y && q && q !== D && U.current && O(T));
            const W = () => {
              U.current && O(T);
            };
            return (
              X && f?.on(X, W),
              B && f?.store.on(B, W),
              () => {
                ((U.current = !1),
                  f && X && X?.split(' ').forEach(k => f.off(k, W)),
                  B && f && B.split(' ').forEach(k => f.store.off(k, W)));
              }
            );
          }, [f, D]),
            I.useEffect(() => {
              U.current && y && O(w);
            }, [f, d, y]));
          const Y = [_, f, y];
          if (((Y.t = _), (Y.i18n = f), (Y.ready = y), y || (!y && !g)))
            return Y;
          throw new Promise(X => {
            a.lng ? Zh(f, a.lng, h, () => X()) : hu(f, h, () => X());
          });
        };
      function My({ i18n: l, defaultNS: a, children: s }) {
        const r = I.useMemo(() => ({ i18n: l, defaultNS: a }), [l, a]);
        return I.createElement(hp.Provider, { value: r }, s);
      }
      const Ay = 'page_pthAT',
        Oy = { page: Ay },
        _y = 'stack_dxDPx',
        Cy = { stack: _y },
        Ny = 'nav_rXNGR',
        zy = 'visible_RhMiR',
        Ry = 'inner_RHzjE',
        Dy = 'title_l6OwX',
        Ly = 'cta_SesQR',
        jy = 'mbNav_uhV4w',
        Jn = { nav: Ny, visible: zy, inner: Ry, title: Dy, cta: Ly, mbNav: jy },
        Hy = new Set([
          'creality.com',
          'www.creality.com',
          'devofficial.creality.com',
        ]);
      function Uy() {
        return Hy.has(window.location.hostname.toLowerCase());
      }
      function By({ variant: l = 'pc' }) {
        const { t: a } = Je(),
          s = l === 'mb',
          r = I.useRef(null),
          [u, f] = I.useState(!1),
          [p, g] = I.useState(!1);
        return (
          I.useEffect(() => {
            Uy() || f(!0);
          }, []),
          I.useEffect(() => {
            if (!u) return;
            const d =
              document.querySelector('.t1-nav-trigger') ??
              r.current?.nextElementSibling;
            if (!d) return;
            const h = () => {
              g(d.getBoundingClientRect().top < -24);
            };
            return (
              window.addEventListener('scroll', h, { passive: !0 }),
              window.addEventListener('resize', h),
              h(),
              () => {
                (window.removeEventListener('scroll', h),
                  window.removeEventListener('resize', h));
              }
            );
          }, [u]),
          u
            ? A.jsx('nav', {
                ref: r,
                className: `t1-sticky-nav ${Jn.nav} ${s ? Jn.mbNav : ''} ${p ? Jn.visible : ''}`,
                'aria-hidden': !p,
                children: A.jsxs('div', {
                  className: Jn.inner,
                  children: [
                    A.jsx('span', {
                      className: Jn.title,
                      children: a('stickyNav.title'),
                    }),
                    A.jsx('a', {
                      className: Jn.cta,
                      href: a('stickyNav.shopLink'),
                      target: '_blank',
                      rel: 'noreferrer',
                      children: a('stickyNav.shopNow'),
                    }),
                  ],
                }),
              })
            : null
        );
      }
      function Gy(l) {
        return l.replace(/\n/g, '<br />');
      }
      function _e({ html: l, as: a = 'p', ...s }) {
        return l
          ? A.jsx(a, { ...s, dangerouslySetInnerHTML: { __html: Gy(l) } })
          : null;
      }
      /*! lozad.js - v1.16.0 - 2020-09-06
       * https://github.com/ApoorvSaxena/lozad.js
       * Copyright (c) 2020 Apoorv Saxena; Licensed MIT */ const Vy =
          typeof document < 'u' && document.documentMode,
        Ky = {
          rootMargin: '0px',
          threshold: 0,
          load(l) {
            if (l.nodeName.toLowerCase() === 'picture') {
              let s = l.querySelector('img'),
                r = !1;
              (s === null && ((s = document.createElement('img')), (r = !0)),
                Vy &&
                  l.getAttribute('data-iesrc') &&
                  (s.src = l.getAttribute('data-iesrc')),
                l.getAttribute('data-alt') &&
                  (s.alt = l.getAttribute('data-alt')),
                r && l.append(s));
            }
            if (
              l.nodeName.toLowerCase() === 'video' &&
              !l.getAttribute('data-src') &&
              l.children
            ) {
              const s = l.children;
              let r;
              for (let u = 0; u <= s.length - 1; u++)
                ((r = s[u].getAttribute('data-src')), r && (s[u].src = r));
              l.load();
            }
            (l.getAttribute('data-poster') &&
              (l.poster = l.getAttribute('data-poster')),
              l.getAttribute('data-src') &&
                (l.src = l.getAttribute('data-src')),
              l.getAttribute('data-srcset') &&
                l.setAttribute('srcset', l.getAttribute('data-srcset')));
            let a = ',';
            if (
              (l.getAttribute('data-background-delimiter') &&
                (a = l.getAttribute('data-background-delimiter')),
              l.getAttribute('data-background-image'))
            )
              l.style.backgroundImage = `url('${l.getAttribute('data-background-image').split(a).join("'),url('")}')`;
            else if (l.getAttribute('data-background-image-set')) {
              const s = l.getAttribute('data-background-image-set').split(a);
              let r = s[0].substr(0, s[0].indexOf(' ')) || s[0];
              ((r = r.indexOf('url(') === -1 ? `url(${r})` : r),
                s.length === 1
                  ? (l.style.backgroundImage = r)
                  : l.setAttribute(
                      'style',
                      (l.getAttribute('style') || '') +
                        `background-image: ${r}; background-image: -webkit-image-set(${s}); background-image: image-set(${s})`
                    ));
            }
            l.getAttribute('data-toggle-class') &&
              l.classList.toggle(l.getAttribute('data-toggle-class'));
          },
          loaded() {},
        };
      function mu(l) {
        l.setAttribute('data-loaded', !0);
      }
      function qy(l) {
        l.getAttribute('data-placeholder-background') &&
          (l.style.background = l.getAttribute('data-placeholder-background'));
      }
      const gu = l => l.getAttribute('data-loaded') === 'true',
        Yy = (l, a) => (s, r) => {
          s.forEach(u => {
            (u.intersectionRatio > 0 || u.isIntersecting) &&
              (r.unobserve(u.target),
              gu(u.target) || (l(u.target), mu(u.target), a(u.target)));
          });
        },
        kh = (l, a = document) =>
          l instanceof Element
            ? [l]
            : l instanceof NodeList
              ? l
              : a.querySelectorAll(l);
      function $y(l = '.lozad', a = {}) {
        const {
          root: s,
          rootMargin: r,
          threshold: u,
          load: f,
          loaded: p,
        } = Object.assign({}, Ky, a);
        let g;
        typeof window < 'u' &&
          window.IntersectionObserver &&
          (g = new IntersectionObserver(Yy(f, p), {
            root: s,
            rootMargin: r,
            threshold: u,
          }));
        const d = kh(l, s);
        for (let h = 0; h < d.length; h++) qy(d[h]);
        return {
          observe() {
            const h = kh(l, s);
            for (let y = 0; y < h.length; y++)
              if (!gu(h[y])) {
                if (g) {
                  g.observe(h[y]);
                  continue;
                }
                (f(h[y]), mu(h[y]), p(h[y]));
              }
          },
          triggerLoad(h) {
            gu(h) || (f(h), mu(h), p(h));
          },
          observer: g,
        };
      }
      const Xy = ({ name: l, className: a = '', style: s, size: r, ...u }) => {
        const f = { lineHeight: '1', fontSize: r, ...s };
        return A.jsx('i', {
          className: `creality-product-info-iconfont ${l} ${a}`,
          style: f,
          ...u,
        });
      };
      function mp(...l) {
        const a = [];
        for (const s of l)
          if (s) {
            if (typeof s == 'string' || typeof s == 'number') a.push(s);
            else if (Array.isArray(s)) {
              const r = mp(...s);
              r && a.push(r);
            } else if (typeof s == 'object')
              for (const r in s) s.hasOwnProperty(r) && s[r] && a.push(r);
          }
        return a.join(' ');
      }
      const Qy = () => {
          if (typeof window > 'u') {
            const l = globalThis.__SSR_LANG__;
            if (l) return l;
          }
          return 'en';
        },
        Zy = 'mediaPicture_GEnv7',
        ky = 'mediaImage_pGzlz',
        Jh = { mediaPicture: Zy, mediaImage: ky },
        tu = '(max-width: 768px)';
      function Fh(l) {
        return l
          ? Object.entries(l)
              .filter(([, a]) => a != null && a !== '')
              .map(([a, s]) => {
                const r = a.startsWith('--')
                    ? a
                    : a.replace(/[A-Z]/g, f => `-${f.toLowerCase()}`),
                  u =
                    typeof s == 'number' &&
                    !/^(zIndex|opacity|flex|order|lineHeight|fontWeight|zoom)$/.test(
                      a
                    )
                      ? `${s}px`
                      : String(s);
                return `${r}:${u} !important;`;
              })
              .join('')
          : '';
      }
      function Ph(l) {
        if (typeof l != 'string') return;
        const a = l.trim();
        if (a !== '') return a.startsWith('//') ? `https:${a}` : a;
      }
      const Jy = ({
          pcSrc: l,
          mobileSrc: a,
          style: s,
          pcAspectRatio: r,
          mobileAspectRatio: u,
          pcClassName: f,
          mobileClassName: p,
          pcStyle: g,
          mobileStyle: d,
          fallback: h,
          showFallbackText: y = !0,
          enableLazyLoad: b = !1,
          rootMargin: w = '400px',
          threshold: T = 0,
          alt: _ = '',
          ...O
        }) => {
          const [D, q] = I.useState(!1),
            [U, Y] = I.useState(!1),
            X = I.useRef(null),
            W = `mediaImage-${I.useId().replace(/[^a-zA-Z0-9_-]/g, '')}`,
            k = Ph(l),
            V = Ph(a),
            ee = k ?? V;
          (I.useEffect(() => {
            Y(!0);
          }, []),
            I.useEffect(() => {
              q(!1);
            }, [k, V]),
            I.useEffect(() => {
              if (!b || !U || !X.current) return;
              $y(X.current, {
                rootMargin: w,
                threshold: T,
                loaded: be => be.classList.add('lozad-loaded'),
              }).observe();
            }, [U, b, w, T, k, V]));
          const Q = A.jsx('div', {
            style: {
              width: O.width || '100%',
              height: O.height || '100%',
              aspectRatio: r || u,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'rgba(243,244,246)',
              ...s,
            },
            children: A.jsx(Xy, {
              name: 'icon-zhanweifu',
              style: {
                fontSize: '36px',
                lineHeight: '40px',
                color: 'rgba(156,163,175)',
                opacity: 0.2,
              },
            }),
          });
          if (!ee) return h ? A.jsx(A.Fragment, { children: h }) : y ? Q : null;
          if (U && D)
            return h ? A.jsx(A.Fragment, { children: h }) : y ? Q : null;
          const J = Fh({ ...(r ? { aspectRatio: r } : {}), ...g }),
            ie = Fh({ ...(u ? { aspectRatio: u } : {}), ...d }),
            de = [
              J ? `@media not all and ${tu}{.${W}{${J}}}` : '',
              ie ? `@media ${tu}{.${W}{${ie}}}` : '',
            ]
              .filter(Boolean)
              .join('');
          return A.jsxs(A.Fragment, {
            children: [
              de && A.jsx('style', { dangerouslySetInnerHTML: { __html: de } }),
              A.jsxs('picture', {
                className: Jh.mediaPicture,
                children: [
                  V && A.jsx('source', { media: tu, srcSet: V }),
                  k && A.jsx('source', { srcSet: k }),
                  A.jsx('img', {
                    loading: 'lazy',
                    ref: X,
                    'data-src': b ? ee : void 0,
                    src: b ? void 0 : ee,
                    alt: _,
                    onError: () => q(!0),
                    ...O,
                    className: mp('lozad', Jh.mediaImage, W, O.className, f, p),
                    style: {
                      ...(O.width ? { width: O.width } : {}),
                      ...(O.height ? { height: O.height } : {}),
                      objectFit: 'cover',
                      display: 'block',
                      ...s,
                    },
                  }),
                ],
              }),
            ],
          });
        },
        gp = (l, a, s = `${a}M`) => {
          const r = l(a),
            u = l(s) || r;
          return { pcSrc: r, mobileSrc: u };
        },
        Fy = 'media_YW1YQ',
        Py = 'host_wic8k',
        Iy = 'placeholder_zVmBp',
        vu = { media: Fy, host: Py, placeholder: Iy },
        Wy = '1400px 0px',
        e0 = /\.(mp4|webm|ogg|mov)(\?|#|$)/i;
      function Et({
        imageKey: l,
        mobileImageKey: a,
        className: s,
        eager: r = !1,
        pcAspectRatio: u,
        mobileAspectRatio: f,
        alt: p = '',
        variant: g = 'pc',
        kind: d = 'image',
        active: h,
        loop: y = !0,
        onEnded: b,
      }) {
        const { t: w } = Je('imageUrl'),
          { pcSrc: T, mobileSrc: _ } = gp(w, l, a),
          O = g === 'mb' ? _ : T,
          D = `${vu.media} ${s ?? ''}`,
          q = A.jsx('div', {
            className: `${D} ${vu.placeholder}`,
            style: { '--t1-media-pc-ar': u, '--t1-media-mb-ar': f },
            'aria-hidden': 'true',
          });
        if (d === 'video') {
          if (!O) return q;
          if (e0.test(O))
            return A.jsx(t0, {
              src: O,
              eager: r,
              active: h,
              loop: y,
              onEnded: b,
              className: s,
              mediaClass: D,
              placeholder: q,
            });
        }
        return A.jsx(Jy, {
          className: D,
          fallback: q,
          pcSrc: T,
          mobileSrc: _,
          pcAspectRatio: u,
          mobileAspectRatio: f,
          alt: p,
          loading: r ? 'eager' : 'lazy',
          fetchPriority: r ? 'high' : void 0,
          enableLazyLoad: !1,
        });
      }
      function t0({
        src: l,
        eager: a,
        active: s,
        loop: r,
        onEnded: u,
        className: f,
        mediaClass: p,
        placeholder: g,
      }) {
        const d = I.useRef(null),
          h = I.useRef(null),
          [y, b] = I.useState(a),
          [w, T] = I.useState(!1),
          _ = w && s !== !1;
        return (
          I.useEffect(() => {
            const O = d.current;
            if (!O) return;
            const D = new IntersectionObserver(
                ([U]) => {
                  U?.isIntersecting && b(!0);
                },
                { rootMargin: Wy }
              ),
              q = new IntersectionObserver(
                ([U]) => {
                  U?.target.isConnected && T(U.isIntersecting);
                },
                { threshold: 0 }
              );
            return (
              D.observe(O),
              q.observe(O),
              () => {
                (D.disconnect(), q.disconnect());
              }
            );
          }, []),
          I.useEffect(() => {
            const O = h.current;
            if (O) {
              if (_) {
                O.play().catch(() => {});
                return;
              }
              O.pause();
            }
          }, [_, l]),
          I.useEffect(() => {
            if (r || s === !1) return;
            const O = h.current;
            if (
              !O ||
              !(
                O.ended ||
                (Number.isFinite(O.duration) &&
                  O.duration > 0 &&
                  O.currentTime >= O.duration - 0.05)
              )
            )
              return;
            const q = () => {
              (O.removeEventListener('seeked', q), O.play().catch(() => {}));
            };
            return (
              O.addEventListener('seeked', q),
              (O.currentTime = 0),
              () => O.removeEventListener('seeked', q)
            );
          }, [s, r, l]),
          A.jsx('div', {
            ref: d,
            className: `${vu.host} ${f ?? ''}`,
            children: y
              ? A.jsx(
                  'video',
                  {
                    ref: h,
                    className: p,
                    src: l,
                    muted: !0,
                    loop: r,
                    playsInline: !0,
                    preload: 'auto',
                    onEnded: u,
                  },
                  l
                )
              : g,
          })
        );
      }
      const i0 = 'section_YEWnq',
        n0 = 'mbSection_L-1AL',
        a0 = 'bg_ZyIU2',
        l0 = 'content_GMdXW',
        s0 = 'title_IO2Wi',
        r0 = 'subtitle_1hBHL',
        o0 = 'cta_PXCPf',
        tn = {
          section: i0,
          mbSection: n0,
          bg: a0,
          content: l0,
          title: s0,
          subtitle: r0,
          cta: o0,
        };
      function vp({ variant: l = 'pc' }) {
        const { t: a } = Je(),
          s = l === 'mb';
        return A.jsxs('section', {
          className: `t1-nav-trigger ${tn.section} ${s ? tn.mbSection : ''}`,
          children: [
            A.jsx(Et, {
              className: tn.bg,
              imageKey: 'heroKV',
              pcAspectRatio: '2560/1442',
              mobileAspectRatio: '750/1000',
              eager: !0,
            }),
            A.jsxs('div', {
              className: tn.content,
              children: [
                A.jsx(_e, {
                  as: 'h1',
                  className: tn.title,
                  html: a('section1.title'),
                }),
                A.jsx(_e, {
                  className: tn.subtitle,
                  html: a('section1.subtitle'),
                }),
                A.jsx('a', {
                  className: tn.cta,
                  href: a('section1.shopLink'),
                  target: '_blank',
                  children: a('section1.shopNow'),
                }),
              ],
            }),
          ],
        });
      }
      const u0 = 'section_oP-G1',
        c0 = 'mbSection_KdU7v',
        f0 = 'body_RR1gM',
        iu = { section: u0, mbSection: c0, body: f0 };
      function yp({ variant: l = 'pc' }) {
        const { t: a } = Je(),
          s = l === 'mb';
        return A.jsx('section', {
          className: `${iu.section} ${s ? iu.mbSection : ''}`,
          children: A.jsx(_e, { className: iu.body, html: a('section2.body') }),
        });
      }
      function yu(l) {
        return `calc(${l} / 2560 * 100 * var(--t1-pc-vw, 1vw))`;
      }
      function bu(l) {
        return `calc(${l} / 750 * 100vw)`;
      }
      const d0 = 'section_-scnU',
        h0 = 'mbSection_dKcDT',
        p0 = 'grid_3MEe7',
        m0 = 'row_FiOaw',
        g0 = 'rowReversed_juFK1',
        v0 = 'column_AhsKT',
        y0 = 'big_ZLg2I',
        b0 = 'small_gV5BY',
        S0 = 'card_lnWuI',
        x0 = 'cardMedia_RQ6nf',
        T0 = 'cardText_h72Su',
        E0 = 'mbList_7o8ZW',
        w0 = 'mbCard_VE2eO',
        ft = {
          section: d0,
          mbSection: h0,
          grid: p0,
          row: m0,
          rowReversed: g0,
          column: v0,
          big: y0,
          small: b0,
          card: S0,
          cardMedia: x0,
          cardText: T0,
          mbList: E0,
          mbCard: w0,
        },
        bs = (l, a, s) => {
          const r = `rgba(0, 0, 0, ${l})`;
          return `linear-gradient(180deg, ${a > 0 ? `${r} 0%, ${r} ${a}%` : `${r} 0%`}, rgba(0, 0, 0, 0) ${s}%)`;
        },
        ke = {
          fiveLasers: {
            id: 'fiveLasers',
            textKey: 'fiveLasers',
            imageKey: 'hlModule',
            kind: 'video',
            textTop: 14,
            textTopMb: 29,
            mask: 'rgba(11, 11, 11, 0.71)',
            maskMb:
              'linear-gradient(180deg, #0b0b0b 0%, rgba(11, 11, 11, 0) 34%), rgba(11, 11, 11, 0.19)',
          },
          micron: {
            id: 'micron',
            textKey: 'micron',
            imageKey: 'hlPrecision',
            textTop: 14,
            textTopMb: 67,
            mask: bs(1, 2, 45),
          },
          galvoSpeed: {
            id: 'galvoSpeed',
            textKey: 'galvoSpeed',
            imageKey: 'hlGalvo',
            textTop: 21,
            textTopMb: 58,
            mask: bs(1, 14, 54),
          },
          autoFocus: {
            id: 'autoFocus',
            textKey: 'autoFocus',
            mbTextKey: 'autoFocusMb',
            imageKey: 'hlAutoFocus',
            textTop: 24,
            textTopMb: 60,
            mask: `${bs(0.88, 0, 63)}, linear-gradient(0deg, rgba(0, 0, 0, 0.24) 0%, rgba(0, 0, 0, 0) 37%)`,
          },
          touch: {
            id: 'touch',
            textKey: 'touch',
            imageKey: 'hlScreen',
            textTop: 22,
            textTopMb: 58,
          },
          galvoLight: {
            id: 'galvoLight',
            textKey: 'galvoLight',
            imageKey: 'hlDetail',
            kind: 'video',
            textTop: 50,
            textTopMb: 39,
            mask: 'rgba(0, 0, 0, 0.64)',
          },
          class1: {
            id: 'class1',
            textKey: 'class1',
            imageKey: 'hlSafety',
            kind: 'video',
            textTop: 45,
            textTopMb: 39,
            mask: 'rgba(0, 0, 0, 0.65)',
          },
          conveyor: {
            id: 'conveyor',
            textKey: 'conveyor',
            imageKey: 'hlConveyor',
            textTop: 45,
            textTopMb: 56,
          },
          ai: {
            id: 'ai',
            textKey: 'ai',
            imageKey: 'hlAi',
            textTop: 17,
            textTopMb: 39,
            mask: bs(0.91, 0, 63),
          },
        },
        M0 = [
          { big: ke.fiveLasers, smalls: [ke.micron, ke.galvoSpeed] },
          {
            big: ke.galvoLight,
            smalls: [ke.autoFocus, ke.touch],
            reversed: !0,
          },
          { big: ke.class1, smalls: [ke.conveyor, ke.ai] },
        ],
        A0 = [
          ke.galvoSpeed,
          ke.micron,
          ke.fiveLasers,
          ke.autoFocus,
          ke.touch,
          ke.galvoLight,
          ke.class1,
          ke.conveyor,
          ke.ai,
        ];
      function Su({ card: l, className: a, mb: s = !1 }) {
        const { t: r } = Je(),
          u = s && l.mbTextKey ? l.mbTextKey : l.textKey;
        return A.jsxs('div', {
          className: `${ft.card} ${a ?? ''}`,
          children: [
            A.jsx(Et, {
              className: ft.cardMedia,
              imageKey: l.imageKey,
              variant: s ? 'mb' : 'pc',
              kind: l.kind,
              eager: !0,
            }),
            A.jsx(_e, {
              className: ft.cardText,
              style: {
                '--t1-card-text-top': s ? bu(l.textTopMb) : yu(l.textTop),
              },
              html: r(`section3.${u}`),
            }),
          ],
        });
      }
      function O0() {
        return A.jsx('section', {
          className: ft.section,
          children: A.jsx('div', {
            className: ft.grid,
            children: M0.map(l =>
              A.jsxs(
                'div',
                {
                  className: `${ft.row} ${l.reversed ? ft.rowReversed : ''}`,
                  children: [
                    A.jsx(Su, { card: l.big, className: ft.big }),
                    A.jsx('div', {
                      className: ft.column,
                      children: l.smalls.map(a =>
                        A.jsx(Su, { card: a, className: ft.small }, a.id)
                      ),
                    }),
                  ],
                },
                l.big.id
              )
            ),
          }),
        });
      }
      function _0() {
        return A.jsx('section', {
          className: `${ft.section} ${ft.mbSection}`,
          children: A.jsx('div', {
            className: ft.mbList,
            children: A0.map(l =>
              A.jsx(Su, { card: l, className: ft.mbCard, mb: !0 }, l.id)
            ),
          }),
        });
      }
      function bp({ variant: l = 'pc' }) {
        return l === 'mb' ? A.jsx(_0, {}) : A.jsx(O0, {});
      }
      const C0 = 'section_Phmlm',
        N0 = 'mbSection_mSUnW',
        z0 = 'content_42VUL',
        R0 = 'title_k6tyc',
        D0 = 'body_6S5O6',
        L0 = 'media_Hy35-',
        j0 = 'video_BFmxf',
        nn = {
          section: C0,
          mbSection: N0,
          content: z0,
          title: R0,
          body: D0,
          media: L0,
          video: j0,
        };
      function Sp({ variant: l = 'pc' }) {
        const { t: a } = Je(),
          s = l === 'mb';
        return A.jsxs('section', {
          className: `${nn.section} ${s ? nn.mbSection : ''}`,
          children: [
            A.jsxs('div', {
              className: nn.content,
              children: [
                A.jsx(_e, {
                  as: 'h2',
                  className: nn.title,
                  html: a('section4.title'),
                }),
                A.jsx(_e, { className: nn.body, html: a('section4.body') }),
              ],
            }),
            A.jsx('div', {
              className: nn.media,
              children: A.jsx(Et, {
                className: nn.video,
                imageKey: 'section4Bg',
                variant: l,
                kind: 'video',
                pcAspectRatio: '2560/1200',
                mobileAspectRatio: '750/1000',
              }),
            }),
          ],
        });
      }
      function Ih(l) {
        return (
          l !== null &&
          typeof l == 'object' &&
          'constructor' in l &&
          l.constructor === Object
        );
      }
      function Au(l = {}, a = {}) {
        const s = ['__proto__', 'constructor', 'prototype'];
        Object.keys(a)
          .filter(r => s.indexOf(r) < 0)
          .forEach(r => {
            typeof l[r] > 'u'
              ? (l[r] = a[r])
              : Ih(a[r]) &&
                Ih(l[r]) &&
                Object.keys(a[r]).length > 0 &&
                Au(l[r], a[r]);
          });
      }
      const xp = {
        body: {},
        addEventListener() {},
        removeEventListener() {},
        activeElement: { blur() {}, nodeName: '' },
        querySelector() {
          return null;
        },
        querySelectorAll() {
          return [];
        },
        getElementById() {
          return null;
        },
        createEvent() {
          return { initEvent() {} };
        },
        createElement() {
          return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute() {},
            getElementsByTagName() {
              return [];
            },
          };
        },
        createElementNS() {
          return {};
        },
        importNode() {
          return null;
        },
        location: {
          hash: '',
          host: '',
          hostname: '',
          href: '',
          origin: '',
          pathname: '',
          protocol: '',
          search: '',
        },
      };
      function on() {
        const l = typeof document < 'u' ? document : {};
        return (Au(l, xp), l);
      }
      const H0 = {
        document: xp,
        navigator: { userAgent: '' },
        location: {
          hash: '',
          host: '',
          hostname: '',
          href: '',
          origin: '',
          pathname: '',
          protocol: '',
          search: '',
        },
        history: { replaceState() {}, pushState() {}, go() {}, back() {} },
        CustomEvent: function () {
          return this;
        },
        addEventListener() {},
        removeEventListener() {},
        getComputedStyle() {
          return {
            getPropertyValue() {
              return '';
            },
          };
        },
        Image() {},
        Date() {},
        screen: {},
        setTimeout() {},
        clearTimeout() {},
        matchMedia() {
          return {};
        },
        requestAnimationFrame(l) {
          return typeof setTimeout > 'u' ? (l(), null) : setTimeout(l, 0);
        },
        cancelAnimationFrame(l) {
          typeof setTimeout > 'u' || clearTimeout(l);
        },
      };
      function at() {
        const l = typeof window < 'u' ? window : {};
        return (Au(l, H0), l);
      }
      function U0(l = '') {
        return l
          .trim()
          .split(' ')
          .filter(a => !!a.trim());
      }
      function B0(l) {
        const a = l;
        Object.keys(a).forEach(s => {
          try {
            a[s] = null;
          } catch {}
          try {
            delete a[s];
          } catch {}
        });
      }
      function Tp(l, a = 0) {
        return setTimeout(l, a);
      }
      function Os() {
        return Date.now();
      }
      function G0(l) {
        const a = at();
        let s;
        return (
          a.getComputedStyle && (s = a.getComputedStyle(l, null)),
          !s && l.currentStyle && (s = l.currentStyle),
          s || (s = l.style),
          s
        );
      }
      function V0(l, a = 'x') {
        const s = at();
        let r, u, f;
        const p = G0(l);
        return (
          s.WebKitCSSMatrix
            ? ((u = p.transform || p.webkitTransform),
              u.split(',').length > 6 &&
                (u = u
                  .split(', ')
                  .map(g => g.replace(',', '.'))
                  .join(', ')),
              (f = new s.WebKitCSSMatrix(u === 'none' ? '' : u)))
            : ((f =
                p.MozTransform ||
                p.OTransform ||
                p.MsTransform ||
                p.msTransform ||
                p.transform ||
                p
                  .getPropertyValue('transform')
                  .replace('translate(', 'matrix(1, 0, 0, 1,')),
              (r = f.toString().split(','))),
          a === 'x' &&
            (s.WebKitCSSMatrix
              ? (u = f.m41)
              : r.length === 16
                ? (u = parseFloat(r[12]))
                : (u = parseFloat(r[4]))),
          a === 'y' &&
            (s.WebKitCSSMatrix
              ? (u = f.m42)
              : r.length === 16
                ? (u = parseFloat(r[13]))
                : (u = parseFloat(r[5]))),
          u || 0
        );
      }
      function Ss(l) {
        return (
          typeof l == 'object' &&
          l !== null &&
          l.constructor &&
          Object.prototype.toString.call(l).slice(8, -1) === 'Object'
        );
      }
      function K0(l) {
        return typeof window < 'u' && typeof window.HTMLElement < 'u'
          ? l instanceof HTMLElement
          : l && (l.nodeType === 1 || l.nodeType === 11);
      }
      function Tt(...l) {
        const a = Object(l[0]),
          s = ['__proto__', 'constructor', 'prototype'];
        for (let r = 1; r < l.length; r += 1) {
          const u = l[r];
          if (u != null && !K0(u)) {
            const f = Object.keys(Object(u)).filter(p => s.indexOf(p) < 0);
            for (let p = 0, g = f.length; p < g; p += 1) {
              const d = f[p],
                h = Object.getOwnPropertyDescriptor(u, d);
              h !== void 0 &&
                h.enumerable &&
                (Ss(a[d]) && Ss(u[d])
                  ? u[d].__swiper__
                    ? (a[d] = u[d])
                    : Tt(a[d], u[d])
                  : !Ss(a[d]) && Ss(u[d])
                    ? ((a[d] = {}),
                      u[d].__swiper__ ? (a[d] = u[d]) : Tt(a[d], u[d]))
                    : (a[d] = u[d]));
            }
          }
        }
        return a;
      }
      function xs(l, a, s) {
        l.style.setProperty(a, s);
      }
      function Ep({ swiper: l, targetPosition: a, side: s }) {
        const r = at(),
          u = -l.translate;
        let f = null,
          p;
        const g = l.params.speed;
        ((l.wrapperEl.style.scrollSnapType = 'none'),
          r.cancelAnimationFrame(l.cssModeFrameID));
        const d = a > u ? 'next' : 'prev',
          h = (b, w) => (d === 'next' && b >= w) || (d === 'prev' && b <= w),
          y = () => {
            ((p = new Date().getTime()), f === null && (f = p));
            const b = Math.max(Math.min((p - f) / g, 1), 0),
              w = 0.5 - Math.cos(b * Math.PI) / 2;
            let T = u + w * (a - u);
            if (
              (h(T, a) && (T = a), l.wrapperEl.scrollTo({ [s]: T }), h(T, a))
            ) {
              ((l.wrapperEl.style.overflow = 'hidden'),
                (l.wrapperEl.style.scrollSnapType = ''),
                setTimeout(() => {
                  ((l.wrapperEl.style.overflow = ''),
                    l.wrapperEl.scrollTo({ [s]: T }));
                }),
                r.cancelAnimationFrame(l.cssModeFrameID));
              return;
            }
            l.cssModeFrameID = r.requestAnimationFrame(y);
          };
        y();
      }
      function ri(l, a = '') {
        const s = at(),
          r = [...l.children];
        return (
          s.HTMLSlotElement &&
            l instanceof HTMLSlotElement &&
            r.push(...l.assignedElements()),
          a ? r.filter(u => u.matches(a)) : r
        );
      }
      function q0(l, a) {
        const s = [a];
        for (; s.length > 0; ) {
          const r = s.shift();
          if (l === r) return !0;
          s.push(
            ...r.children,
            ...(r.shadowRoot ? r.shadowRoot.children : []),
            ...(r.assignedElements ? r.assignedElements() : [])
          );
        }
      }
      function Y0(l, a) {
        const s = at();
        let r = a.contains(l);
        return (
          !r &&
            s.HTMLSlotElement &&
            a instanceof HTMLSlotElement &&
            ((r = [...a.assignedElements()].includes(l)), r || (r = q0(l, a))),
          r
        );
      }
      function _s(l) {
        try {
          console.warn(l);
          return;
        } catch {}
      }
      function xu(l, a = []) {
        const s = document.createElement(l);
        return (s.classList.add(...(Array.isArray(a) ? a : U0(a))), s);
      }
      function $0(l, a) {
        const s = [];
        for (; l.previousElementSibling; ) {
          const r = l.previousElementSibling;
          (a ? r.matches(a) && s.push(r) : s.push(r), (l = r));
        }
        return s;
      }
      function X0(l, a) {
        const s = [];
        for (; l.nextElementSibling; ) {
          const r = l.nextElementSibling;
          (a ? r.matches(a) && s.push(r) : s.push(r), (l = r));
        }
        return s;
      }
      function Li(l, a) {
        return at().getComputedStyle(l, null).getPropertyValue(a);
      }
      function Wh(l) {
        let a = l,
          s;
        if (a) {
          for (s = 0; (a = a.previousSibling) !== null; )
            a.nodeType === 1 && (s += 1);
          return s;
        }
      }
      function Q0(l, a) {
        const s = [];
        let r = l.parentElement;
        for (; r; ) (s.push(r), (r = r.parentElement));
        return s;
      }
      function ep(l, a, s) {
        const r = at();
        return (
          l[a === 'width' ? 'offsetWidth' : 'offsetHeight'] +
          parseFloat(
            r
              .getComputedStyle(l, null)
              .getPropertyValue(a === 'width' ? 'margin-right' : 'margin-top')
          ) +
          parseFloat(
            r
              .getComputedStyle(l, null)
              .getPropertyValue(a === 'width' ? 'margin-left' : 'margin-bottom')
          )
        );
      }
      function tp(l, a = '') {
        typeof trustedTypes < 'u'
          ? (l.innerHTML = trustedTypes
              .createPolicy('html', { createHTML: s => s })
              .createHTML(a))
          : (l.innerHTML = a);
      }
      let nu;
      function Z0() {
        const l = at(),
          a = on();
        return {
          smoothScroll:
            a.documentElement &&
            a.documentElement.style &&
            'scrollBehavior' in a.documentElement.style,
          touch: !!(
            'ontouchstart' in l ||
            (l.DocumentTouch && a instanceof l.DocumentTouch)
          ),
        };
      }
      function wp() {
        return (nu || (nu = Z0()), nu);
      }
      let au;
      function k0({ userAgent: l } = {}) {
        const a = wp(),
          s = at(),
          r = s.navigator.platform,
          u = l || s.navigator.userAgent,
          f = { ios: !1, android: !1 },
          p = s.screen.width,
          g = s.screen.height,
          d = u.match(/(Android);?[\s\/]+([\d.]+)?/);
        let h = u.match(/(iPad)(?!\1).*OS\s([\d_]+)/);
        const y = u.match(/(iPod)(.*OS\s([\d_]+))?/),
          b = !h && u.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
          w = r === 'Win32';
        let T = r === 'MacIntel';
        const _ = [
          '1024x1366',
          '1366x1024',
          '834x1194',
          '1194x834',
          '834x1112',
          '1112x834',
          '768x1024',
          '1024x768',
          '820x1180',
          '1180x820',
          '810x1080',
          '1080x810',
        ];
        return (
          !h &&
            T &&
            a.touch &&
            _.indexOf(`${p}x${g}`) >= 0 &&
            ((h = u.match(/(Version)\/([\d.]+)/)),
            h || (h = [0, 1, '13_0_0']),
            (T = !1)),
          d && !w && ((f.os = 'android'), (f.android = !0)),
          (h || b || y) && ((f.os = 'ios'), (f.ios = !0)),
          f
        );
      }
      function Mp(l = {}) {
        return (au || (au = k0(l)), au);
      }
      let lu;
      function J0() {
        const l = at(),
          a = Mp();
        let s = !1;
        function r() {
          const g = l.navigator.userAgent.toLowerCase();
          return (
            g.indexOf('safari') >= 0 &&
            g.indexOf('chrome') < 0 &&
            g.indexOf('android') < 0
          );
        }
        if (r()) {
          const g = String(l.navigator.userAgent);
          if (g.includes('Version/')) {
            const [d, h] = g
              .split('Version/')[1]
              .split(' ')[0]
              .split('.')
              .map(y => Number(y));
            s = d < 16 || (d === 16 && h < 2);
          }
        }
        const u = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
            l.navigator.userAgent
          ),
          f = r(),
          p = f || (u && a.ios);
        return {
          isSafari: s || f,
          needPerspectiveFix: s,
          need3dFix: p,
          isWebView: u,
        };
      }
      function Ap() {
        return (lu || (lu = J0()), lu);
      }
      function F0({ swiper: l, on: a, emit: s }) {
        const r = at();
        let u = null,
          f = null;
        const p = () => {
            !l ||
              l.destroyed ||
              !l.initialized ||
              (s('beforeResize'), s('resize'));
          },
          g = () => {
            !l ||
              l.destroyed ||
              !l.initialized ||
              ((u = new ResizeObserver(y => {
                f = r.requestAnimationFrame(() => {
                  const { width: b, height: w } = l;
                  let T = b,
                    _ = w;
                  (y.forEach(
                    ({ contentBoxSize: O, contentRect: D, target: q }) => {
                      (q && q !== l.el) ||
                        ((T = D ? D.width : (O[0] || O).inlineSize),
                        (_ = D ? D.height : (O[0] || O).blockSize));
                    }
                  ),
                    (T !== b || _ !== w) && p());
                });
              })),
              u.observe(l.el));
          },
          d = () => {
            (f && r.cancelAnimationFrame(f),
              u && u.unobserve && l.el && (u.unobserve(l.el), (u = null)));
          },
          h = () => {
            !l || l.destroyed || !l.initialized || s('orientationchange');
          };
        (a('init', () => {
          if (l.params.resizeObserver && typeof r.ResizeObserver < 'u') {
            g();
            return;
          }
          (r.addEventListener('resize', p),
            r.addEventListener('orientationchange', h));
        }),
          a('destroy', () => {
            (d(),
              r.removeEventListener('resize', p),
              r.removeEventListener('orientationchange', h));
          }));
      }
      function P0({ swiper: l, extendParams: a, on: s, emit: r }) {
        const u = [],
          f = at(),
          p = (h, y = {}) => {
            const b = f.MutationObserver || f.WebkitMutationObserver,
              w = new b(T => {
                if (l.__preventObserver__) return;
                if (T.length === 1) {
                  r('observerUpdate', T[0]);
                  return;
                }
                const _ = function () {
                  r('observerUpdate', T[0]);
                };
                f.requestAnimationFrame
                  ? f.requestAnimationFrame(_)
                  : f.setTimeout(_, 0);
              });
            (w.observe(h, {
              attributes: typeof y.attributes > 'u' ? !0 : y.attributes,
              childList:
                l.isElement || (typeof y.childList > 'u' ? !0 : y).childList,
              characterData:
                typeof y.characterData > 'u' ? !0 : y.characterData,
            }),
              u.push(w));
          },
          g = () => {
            if (l.params.observer) {
              if (l.params.observeParents) {
                const h = Q0(l.hostEl);
                for (let y = 0; y < h.length; y += 1) p(h[y]);
              }
              (p(l.hostEl, { childList: l.params.observeSlideChildren }),
                p(l.wrapperEl, { attributes: !1 }));
            }
          },
          d = () => {
            (u.forEach(h => {
              h.disconnect();
            }),
              u.splice(0, u.length));
          };
        (a({ observer: !1, observeParents: !1, observeSlideChildren: !1 }),
          s('init', g),
          s('destroy', d));
      }
      var I0 = {
        on(l, a, s) {
          const r = this;
          if (!r.eventsListeners || r.destroyed || typeof a != 'function')
            return r;
          const u = s ? 'unshift' : 'push';
          return (
            l.split(' ').forEach(f => {
              (r.eventsListeners[f] || (r.eventsListeners[f] = []),
                r.eventsListeners[f][u](a));
            }),
            r
          );
        },
        once(l, a, s) {
          const r = this;
          if (!r.eventsListeners || r.destroyed || typeof a != 'function')
            return r;
          function u(...f) {
            (r.off(l, u),
              u.__emitterProxy && delete u.__emitterProxy,
              a.apply(r, f));
          }
          return ((u.__emitterProxy = a), r.on(l, u, s));
        },
        onAny(l, a) {
          const s = this;
          if (!s.eventsListeners || s.destroyed || typeof l != 'function')
            return s;
          const r = a ? 'unshift' : 'push';
          return (
            s.eventsAnyListeners.indexOf(l) < 0 && s.eventsAnyListeners[r](l),
            s
          );
        },
        offAny(l) {
          const a = this;
          if (!a.eventsListeners || a.destroyed || !a.eventsAnyListeners)
            return a;
          const s = a.eventsAnyListeners.indexOf(l);
          return (s >= 0 && a.eventsAnyListeners.splice(s, 1), a);
        },
        off(l, a) {
          const s = this;
          return (
            !s.eventsListeners ||
              s.destroyed ||
              !s.eventsListeners ||
              l.split(' ').forEach(r => {
                typeof a > 'u'
                  ? (s.eventsListeners[r] = [])
                  : s.eventsListeners[r] &&
                    s.eventsListeners[r].forEach((u, f) => {
                      (u === a ||
                        (u.__emitterProxy && u.__emitterProxy === a)) &&
                        s.eventsListeners[r].splice(f, 1);
                    });
              }),
            s
          );
        },
        emit(...l) {
          const a = this;
          if (!a.eventsListeners || a.destroyed || !a.eventsListeners) return a;
          let s, r, u;
          return (
            typeof l[0] == 'string' || Array.isArray(l[0])
              ? ((s = l[0]), (r = l.slice(1, l.length)), (u = a))
              : ((s = l[0].events), (r = l[0].data), (u = l[0].context || a)),
            r.unshift(u),
            (Array.isArray(s) ? s : s.split(' ')).forEach(p => {
              (a.eventsAnyListeners &&
                a.eventsAnyListeners.length &&
                a.eventsAnyListeners.forEach(g => {
                  g.apply(u, [p, ...r]);
                }),
                a.eventsListeners &&
                  a.eventsListeners[p] &&
                  a.eventsListeners[p].forEach(g => {
                    g.apply(u, r);
                  }));
            }),
            a
          );
        },
      };
      function W0() {
        const l = this;
        let a, s;
        const r = l.el;
        (typeof l.params.width < 'u' && l.params.width !== null
          ? (a = l.params.width)
          : (a = r.clientWidth),
          typeof l.params.height < 'u' && l.params.height !== null
            ? (s = l.params.height)
            : (s = r.clientHeight),
          !((a === 0 && l.isHorizontal()) || (s === 0 && l.isVertical())) &&
            ((a =
              a -
              parseInt(Li(r, 'padding-left') || 0, 10) -
              parseInt(Li(r, 'padding-right') || 0, 10)),
            (s =
              s -
              parseInt(Li(r, 'padding-top') || 0, 10) -
              parseInt(Li(r, 'padding-bottom') || 0, 10)),
            Number.isNaN(a) && (a = 0),
            Number.isNaN(s) && (s = 0),
            Object.assign(l, {
              width: a,
              height: s,
              size: l.isHorizontal() ? a : s,
            })));
      }
      function eb() {
        const l = this;
        function a(Q, J) {
          return parseFloat(Q.getPropertyValue(l.getDirectionLabel(J)) || 0);
        }
        const s = l.params,
          { wrapperEl: r, slidesEl: u, rtlTranslate: f, wrongRTL: p } = l,
          g = l.virtual && s.virtual.enabled,
          d = g ? l.virtual.slides.length : l.slides.length,
          h = ri(u, `.${l.params.slideClass}, swiper-slide`),
          y = g ? l.virtual.slides.length : h.length;
        let b = [];
        const w = [],
          T = [];
        let _ = s.slidesOffsetBefore;
        typeof _ == 'function' && (_ = s.slidesOffsetBefore.call(l));
        let O = s.slidesOffsetAfter;
        typeof O == 'function' && (O = s.slidesOffsetAfter.call(l));
        const D = l.snapGrid.length,
          q = l.slidesGrid.length,
          U = l.size - _ - O;
        let Y = s.spaceBetween,
          X = -_,
          B = 0,
          W = 0;
        if (typeof U > 'u') return;
        (typeof Y == 'string' && Y.indexOf('%') >= 0
          ? (Y = (parseFloat(Y.replace('%', '')) / 100) * U)
          : typeof Y == 'string' && (Y = parseFloat(Y)),
          (l.virtualSize = -Y - _ - O),
          h.forEach(Q => {
            (f ? (Q.style.marginLeft = '') : (Q.style.marginRight = ''),
              (Q.style.marginBottom = ''),
              (Q.style.marginTop = ''));
          }),
          s.centeredSlides &&
            s.cssMode &&
            (xs(r, '--swiper-centered-offset-before', ''),
            xs(r, '--swiper-centered-offset-after', '')));
        const k = s.grid && s.grid.rows > 1 && l.grid;
        k ? l.grid.initSlides(h) : l.grid && l.grid.unsetSlides();
        let V;
        const ee =
          s.slidesPerView === 'auto' &&
          s.breakpoints &&
          Object.keys(s.breakpoints).filter(
            Q => typeof s.breakpoints[Q].slidesPerView < 'u'
          ).length > 0;
        for (let Q = 0; Q < y; Q += 1) {
          V = 0;
          const J = h[Q];
          if (
            !(
              J &&
              (k && l.grid.updateSlide(Q, J, h), Li(J, 'display') === 'none')
            )
          ) {
            if (g && s.slidesPerView === 'auto')
              (s.virtual.slidesPerViewAutoSlideSize &&
                (V = s.virtual.slidesPerViewAutoSlideSize),
                V &&
                  J &&
                  (s.roundLengths && (V = Math.floor(V)),
                  (J.style[l.getDirectionLabel('width')] = `${V}px`)));
            else if (s.slidesPerView === 'auto') {
              ee && (J.style[l.getDirectionLabel('width')] = '');
              const ie = getComputedStyle(J),
                de = J.style.transform,
                ve = J.style.webkitTransform;
              if (
                (de && (J.style.transform = 'none'),
                ve && (J.style.webkitTransform = 'none'),
                s.roundLengths)
              )
                V = l.isHorizontal() ? ep(J, 'width') : ep(J, 'height');
              else {
                const be = a(ie, 'width'),
                  L = a(ie, 'padding-left'),
                  Z = a(ie, 'padding-right'),
                  $ = a(ie, 'margin-left'),
                  ne = a(ie, 'margin-right'),
                  x = ie.getPropertyValue('box-sizing');
                if (x && x === 'border-box') V = be + $ + ne;
                else {
                  const { clientWidth: j, offsetWidth: P } = J;
                  V = be + L + Z + $ + ne + (P - j);
                }
              }
              (de && (J.style.transform = de),
                ve && (J.style.webkitTransform = ve),
                s.roundLengths && (V = Math.floor(V)));
            } else
              ((V = (U - (s.slidesPerView - 1) * Y) / s.slidesPerView),
                s.roundLengths && (V = Math.floor(V)),
                J && (J.style[l.getDirectionLabel('width')] = `${V}px`));
            (J && (J.swiperSlideSize = V),
              T.push(V),
              s.centeredSlides
                ? ((X = X + V / 2 + B / 2 + Y),
                  B === 0 && Q !== 0 && (X = X - U / 2 - Y),
                  Q === 0 && (X = X - U / 2 - Y),
                  Math.abs(X) < 1 / 1e3 && (X = 0),
                  s.roundLengths && (X = Math.floor(X)),
                  W % s.slidesPerGroup === 0 && b.push(X),
                  w.push(X))
                : (s.roundLengths && (X = Math.floor(X)),
                  (W - Math.min(l.params.slidesPerGroupSkip, W)) %
                    l.params.slidesPerGroup ===
                    0 && b.push(X),
                  w.push(X),
                  (X = X + V + Y)),
              (l.virtualSize += V + Y),
              (B = V),
              (W += 1));
          }
        }
        if (
          ((l.virtualSize = Math.max(l.virtualSize, U) + O),
          f &&
            p &&
            (s.effect === 'slide' || s.effect === 'coverflow') &&
            (r.style.width = `${l.virtualSize + Y}px`),
          s.setWrapperSize &&
            (r.style[l.getDirectionLabel('width')] = `${l.virtualSize + Y}px`),
          k && l.grid.updateWrapperSize(V, b),
          !s.centeredSlides)
        ) {
          const Q = [];
          for (let J = 0; J < b.length; J += 1) {
            let ie = b[J];
            (s.roundLengths && (ie = Math.floor(ie)),
              b[J] <= l.virtualSize - U && Q.push(ie));
          }
          ((b = Q),
            Math.floor(l.virtualSize - U) - Math.floor(b[b.length - 1]) > 1 &&
              b.push(l.virtualSize - U));
        }
        if (g && s.loop) {
          const Q = T[0] + Y;
          if (s.slidesPerGroup > 1) {
            const J = Math.ceil(
                (l.virtual.slidesBefore + l.virtual.slidesAfter) /
                  s.slidesPerGroup
              ),
              ie = Q * s.slidesPerGroup;
            for (let de = 0; de < J; de += 1) b.push(b[b.length - 1] + ie);
          }
          for (
            let J = 0;
            J < l.virtual.slidesBefore + l.virtual.slidesAfter;
            J += 1
          )
            (s.slidesPerGroup === 1 && b.push(b[b.length - 1] + Q),
              w.push(w[w.length - 1] + Q),
              (l.virtualSize += Q));
        }
        if ((b.length === 0 && (b = [0]), Y !== 0)) {
          const Q =
            l.isHorizontal() && f
              ? 'marginLeft'
              : l.getDirectionLabel('marginRight');
          h.filter((J, ie) =>
            !s.cssMode || s.loop ? !0 : ie !== h.length - 1
          ).forEach(J => {
            J.style[Q] = `${Y}px`;
          });
        }
        if (s.centeredSlides && s.centeredSlidesBounds) {
          let Q = 0;
          (T.forEach(ie => {
            Q += ie + (Y || 0);
          }),
            (Q -= Y));
          const J = Q > U ? Q - U : 0;
          b = b.map(ie => (ie <= 0 ? -_ : ie > J ? J + O : ie));
        }
        if (s.centerInsufficientSlides) {
          let Q = 0;
          (T.forEach(ie => {
            Q += ie + (Y || 0);
          }),
            (Q -= Y));
          const J = (_ || 0) + (O || 0);
          if (Q + J < U) {
            const ie = (U - Q - J) / 2;
            (b.forEach((de, ve) => {
              b[ve] = de - ie;
            }),
              w.forEach((de, ve) => {
                w[ve] = de + ie;
              }));
          }
        }
        if (
          (Object.assign(l, {
            slides: h,
            snapGrid: b,
            slidesGrid: w,
            slidesSizesGrid: T,
          }),
          s.centeredSlides && s.cssMode && !s.centeredSlidesBounds)
        ) {
          (xs(r, '--swiper-centered-offset-before', `${-b[0]}px`),
            xs(
              r,
              '--swiper-centered-offset-after',
              `${l.size / 2 - T[T.length - 1] / 2}px`
            ));
          const Q = -l.snapGrid[0],
            J = -l.slidesGrid[0];
          ((l.snapGrid = l.snapGrid.map(ie => ie + Q)),
            (l.slidesGrid = l.slidesGrid.map(ie => ie + J)));
        }
        if (
          (y !== d && l.emit('slidesLengthChange'),
          b.length !== D &&
            (l.params.watchOverflow && l.checkOverflow(),
            l.emit('snapGridLengthChange')),
          w.length !== q && l.emit('slidesGridLengthChange'),
          s.watchSlidesProgress && l.updateSlidesOffset(),
          l.emit('slidesUpdated'),
          !g && !s.cssMode && (s.effect === 'slide' || s.effect === 'fade'))
        ) {
          const Q = `${s.containerModifierClass}backface-hidden`,
            J = l.el.classList.contains(Q);
          y <= s.maxBackfaceHiddenSlides
            ? J || l.el.classList.add(Q)
            : J && l.el.classList.remove(Q);
        }
      }
      function tb(l) {
        const a = this,
          s = [],
          r = a.virtual && a.params.virtual.enabled;
        let u = 0,
          f;
        typeof l == 'number'
          ? a.setTransition(l)
          : l === !0 && a.setTransition(a.params.speed);
        const p = g => (r ? a.slides[a.getSlideIndexByData(g)] : a.slides[g]);
        if (a.params.slidesPerView !== 'auto' && a.params.slidesPerView > 1)
          if (a.params.centeredSlides)
            (a.visibleSlides || []).forEach(g => {
              s.push(g);
            });
          else
            for (f = 0; f < Math.ceil(a.params.slidesPerView); f += 1) {
              const g = a.activeIndex + f;
              if (g > a.slides.length && !r) break;
              s.push(p(g));
            }
        else s.push(p(a.activeIndex));
        for (f = 0; f < s.length; f += 1)
          if (typeof s[f] < 'u') {
            const g = s[f].offsetHeight;
            u = g > u ? g : u;
          }
        (u || u === 0) && (a.wrapperEl.style.height = `${u}px`);
      }
      function ib() {
        const l = this,
          a = l.slides,
          s = l.isElement
            ? l.isHorizontal()
              ? l.wrapperEl.offsetLeft
              : l.wrapperEl.offsetTop
            : 0;
        for (let r = 0; r < a.length; r += 1)
          a[r].swiperSlideOffset =
            (l.isHorizontal() ? a[r].offsetLeft : a[r].offsetTop) -
            s -
            l.cssOverflowAdjustment();
      }
      const ip = (l, a, s) => {
        a && !l.classList.contains(s)
          ? l.classList.add(s)
          : !a && l.classList.contains(s) && l.classList.remove(s);
      };
      function nb(l = (this && this.translate) || 0) {
        const a = this,
          s = a.params,
          { slides: r, rtlTranslate: u, snapGrid: f } = a;
        if (r.length === 0) return;
        typeof r[0].swiperSlideOffset > 'u' && a.updateSlidesOffset();
        let p = -l;
        (u && (p = l), (a.visibleSlidesIndexes = []), (a.visibleSlides = []));
        let g = s.spaceBetween;
        typeof g == 'string' && g.indexOf('%') >= 0
          ? (g = (parseFloat(g.replace('%', '')) / 100) * a.size)
          : typeof g == 'string' && (g = parseFloat(g));
        for (let d = 0; d < r.length; d += 1) {
          const h = r[d];
          let y = h.swiperSlideOffset;
          s.cssMode && s.centeredSlides && (y -= r[0].swiperSlideOffset);
          const b =
              (p + (s.centeredSlides ? a.minTranslate() : 0) - y) /
              (h.swiperSlideSize + g),
            w =
              (p - f[0] + (s.centeredSlides ? a.minTranslate() : 0) - y) /
              (h.swiperSlideSize + g),
            T = -(p - y),
            _ = T + a.slidesSizesGrid[d],
            O = T >= 0 && T <= a.size - a.slidesSizesGrid[d],
            D =
              (T >= 0 && T < a.size - 1) ||
              (_ > 1 && _ <= a.size) ||
              (T <= 0 && _ >= a.size);
          (D && (a.visibleSlides.push(h), a.visibleSlidesIndexes.push(d)),
            ip(h, D, s.slideVisibleClass),
            ip(h, O, s.slideFullyVisibleClass),
            (h.progress = u ? -b : b),
            (h.originalProgress = u ? -w : w));
        }
      }
      function ab(l) {
        const a = this;
        if (typeof l > 'u') {
          const y = a.rtlTranslate ? -1 : 1;
          l = (a && a.translate && a.translate * y) || 0;
        }
        const s = a.params,
          r = a.maxTranslate() - a.minTranslate();
        let { progress: u, isBeginning: f, isEnd: p, progressLoop: g } = a;
        const d = f,
          h = p;
        if (r === 0) ((u = 0), (f = !0), (p = !0));
        else {
          u = (l - a.minTranslate()) / r;
          const y = Math.abs(l - a.minTranslate()) < 1,
            b = Math.abs(l - a.maxTranslate()) < 1;
          ((f = y || u <= 0), (p = b || u >= 1), y && (u = 0), b && (u = 1));
        }
        if (s.loop) {
          const y = a.getSlideIndexByData(0),
            b = a.getSlideIndexByData(a.slides.length - 1),
            w = a.slidesGrid[y],
            T = a.slidesGrid[b],
            _ = a.slidesGrid[a.slidesGrid.length - 1],
            O = Math.abs(l);
          (O >= w ? (g = (O - w) / _) : (g = (O + _ - T) / _),
            g > 1 && (g -= 1));
        }
        (Object.assign(a, {
          progress: u,
          progressLoop: g,
          isBeginning: f,
          isEnd: p,
        }),
          (s.watchSlidesProgress || (s.centeredSlides && s.autoHeight)) &&
            a.updateSlidesProgress(l),
          f && !d && a.emit('reachBeginning toEdge'),
          p && !h && a.emit('reachEnd toEdge'),
          ((d && !f) || (h && !p)) && a.emit('fromEdge'),
          a.emit('progress', u));
      }
      const su = (l, a, s) => {
        a && !l.classList.contains(s)
          ? l.classList.add(s)
          : !a && l.classList.contains(s) && l.classList.remove(s);
      };
      function lb() {
        const l = this,
          { slides: a, params: s, slidesEl: r, activeIndex: u } = l,
          f = l.virtual && s.virtual.enabled,
          p = l.grid && s.grid && s.grid.rows > 1,
          g = b => ri(r, `.${s.slideClass}${b}, swiper-slide${b}`)[0];
        let d, h, y;
        if (f)
          if (s.loop) {
            let b = u - l.virtual.slidesBefore;
            (b < 0 && (b = l.virtual.slides.length + b),
              b >= l.virtual.slides.length && (b -= l.virtual.slides.length),
              (d = g(`[data-swiper-slide-index="${b}"]`)));
          } else d = g(`[data-swiper-slide-index="${u}"]`);
        else
          p
            ? ((d = a.find(b => b.column === u)),
              (y = a.find(b => b.column === u + 1)),
              (h = a.find(b => b.column === u - 1)))
            : (d = a[u]);
        (d &&
          (p ||
            ((y = X0(d, `.${s.slideClass}, swiper-slide`)[0]),
            s.loop && !y && (y = a[0]),
            (h = $0(d, `.${s.slideClass}, swiper-slide`)[0]),
            s.loop && !h === 0 && (h = a[a.length - 1]))),
          a.forEach(b => {
            (su(b, b === d, s.slideActiveClass),
              su(b, b === y, s.slideNextClass),
              su(b, b === h, s.slidePrevClass));
          }),
          l.emitSlidesClasses());
      }
      const Es = (l, a) => {
          if (!l || l.destroyed || !l.params) return;
          const s = () =>
              l.isElement ? 'swiper-slide' : `.${l.params.slideClass}`,
            r = a.closest(s());
          if (r) {
            let u = r.querySelector(`.${l.params.lazyPreloaderClass}`);
            (!u &&
              l.isElement &&
              (r.shadowRoot
                ? (u = r.shadowRoot.querySelector(
                    `.${l.params.lazyPreloaderClass}`
                  ))
                : requestAnimationFrame(() => {
                    r.shadowRoot &&
                      ((u = r.shadowRoot.querySelector(
                        `.${l.params.lazyPreloaderClass}`
                      )),
                      u && u.remove());
                  })),
              u && u.remove());
          }
        },
        ru = (l, a) => {
          if (!l.slides[a]) return;
          const s = l.slides[a].querySelector('[loading="lazy"]');
          s && s.removeAttribute('loading');
        },
        Tu = l => {
          if (!l || l.destroyed || !l.params) return;
          let a = l.params.lazyPreloadPrevNext;
          const s = l.slides.length;
          if (!s || !a || a < 0) return;
          a = Math.min(a, s);
          const r =
              l.params.slidesPerView === 'auto'
                ? l.slidesPerViewDynamic()
                : Math.ceil(l.params.slidesPerView),
            u = l.activeIndex;
          if (l.params.grid && l.params.grid.rows > 1) {
            const p = u,
              g = [p - a];
            (g.push(...Array.from({ length: a }).map((d, h) => p + r + h)),
              l.slides.forEach((d, h) => {
                g.includes(d.column) && ru(l, h);
              }));
            return;
          }
          const f = u + r - 1;
          if (l.params.rewind || l.params.loop)
            for (let p = u - a; p <= f + a; p += 1) {
              const g = ((p % s) + s) % s;
              (g < u || g > f) && ru(l, g);
            }
          else
            for (
              let p = Math.max(u - a, 0);
              p <= Math.min(f + a, s - 1);
              p += 1
            )
              p !== u && (p > f || p < u) && ru(l, p);
        };
      function sb(l) {
        const { slidesGrid: a, params: s } = l,
          r = l.rtlTranslate ? l.translate : -l.translate;
        let u;
        for (let f = 0; f < a.length; f += 1)
          typeof a[f + 1] < 'u'
            ? r >= a[f] && r < a[f + 1] - (a[f + 1] - a[f]) / 2
              ? (u = f)
              : r >= a[f] && r < a[f + 1] && (u = f + 1)
            : r >= a[f] && (u = f);
        return (
          s.normalizeSlideIndex && (u < 0 || typeof u > 'u') && (u = 0),
          u
        );
      }
      function rb(l) {
        const a = this,
          s = a.rtlTranslate ? a.translate : -a.translate,
          {
            snapGrid: r,
            params: u,
            activeIndex: f,
            realIndex: p,
            snapIndex: g,
          } = a;
        let d = l,
          h;
        const y = T => {
          let _ = T - a.virtual.slidesBefore;
          return (
            _ < 0 && (_ = a.virtual.slides.length + _),
            _ >= a.virtual.slides.length && (_ -= a.virtual.slides.length),
            _
          );
        };
        if ((typeof d > 'u' && (d = sb(a)), r.indexOf(s) >= 0))
          h = r.indexOf(s);
        else {
          const T = Math.min(u.slidesPerGroupSkip, d);
          h = T + Math.floor((d - T) / u.slidesPerGroup);
        }
        if ((h >= r.length && (h = r.length - 1), d === f && !a.params.loop)) {
          h !== g && ((a.snapIndex = h), a.emit('snapIndexChange'));
          return;
        }
        if (d === f && a.params.loop && a.virtual && a.params.virtual.enabled) {
          a.realIndex = y(d);
          return;
        }
        const b = a.grid && u.grid && u.grid.rows > 1;
        let w;
        if (a.virtual && u.virtual.enabled && u.loop) w = y(d);
        else if (b) {
          const T = a.slides.find(O => O.column === d);
          let _ = parseInt(T.getAttribute('data-swiper-slide-index'), 10);
          (Number.isNaN(_) && (_ = Math.max(a.slides.indexOf(T), 0)),
            (w = Math.floor(_ / u.grid.rows)));
        } else if (a.slides[d]) {
          const T = a.slides[d].getAttribute('data-swiper-slide-index');
          T ? (w = parseInt(T, 10)) : (w = d);
        } else w = d;
        (Object.assign(a, {
          previousSnapIndex: g,
          snapIndex: h,
          previousRealIndex: p,
          realIndex: w,
          previousIndex: f,
          activeIndex: d,
        }),
          a.initialized && Tu(a),
          a.emit('activeIndexChange'),
          a.emit('snapIndexChange'),
          (a.initialized || a.params.runCallbacksOnInit) &&
            (p !== w && a.emit('realIndexChange'), a.emit('slideChange')));
      }
      function ob(l, a) {
        const s = this,
          r = s.params;
        let u = l.closest(`.${r.slideClass}, swiper-slide`);
        !u &&
          s.isElement &&
          a &&
          a.length > 1 &&
          a.includes(l) &&
          [...a.slice(a.indexOf(l) + 1, a.length)].forEach(g => {
            !u &&
              g.matches &&
              g.matches(`.${r.slideClass}, swiper-slide`) &&
              (u = g);
          });
        let f = !1,
          p;
        if (u) {
          for (let g = 0; g < s.slides.length; g += 1)
            if (s.slides[g] === u) {
              ((f = !0), (p = g));
              break;
            }
        }
        if (u && f)
          ((s.clickedSlide = u),
            s.virtual && s.params.virtual.enabled
              ? (s.clickedIndex = parseInt(
                  u.getAttribute('data-swiper-slide-index'),
                  10
                ))
              : (s.clickedIndex = p));
        else {
          ((s.clickedSlide = void 0), (s.clickedIndex = void 0));
          return;
        }
        r.slideToClickedSlide &&
          s.clickedIndex !== void 0 &&
          s.clickedIndex !== s.activeIndex &&
          s.slideToClickedSlide();
      }
      var ub = {
        updateSize: W0,
        updateSlides: eb,
        updateAutoHeight: tb,
        updateSlidesOffset: ib,
        updateSlidesProgress: nb,
        updateProgress: ab,
        updateSlidesClasses: lb,
        updateActiveIndex: rb,
        updateClickedSlide: ob,
      };
      function cb(l = this.isHorizontal() ? 'x' : 'y') {
        const a = this,
          { params: s, rtlTranslate: r, translate: u, wrapperEl: f } = a;
        if (s.virtualTranslate) return r ? -u : u;
        if (s.cssMode) return u;
        let p = V0(f, l);
        return ((p += a.cssOverflowAdjustment()), r && (p = -p), p || 0);
      }
      function fb(l, a) {
        const s = this,
          { rtlTranslate: r, params: u, wrapperEl: f, progress: p } = s;
        let g = 0,
          d = 0;
        const h = 0;
        (s.isHorizontal() ? (g = r ? -l : l) : (d = l),
          u.roundLengths && ((g = Math.floor(g)), (d = Math.floor(d))),
          (s.previousTranslate = s.translate),
          (s.translate = s.isHorizontal() ? g : d),
          u.cssMode
            ? (f[s.isHorizontal() ? 'scrollLeft' : 'scrollTop'] =
                s.isHorizontal() ? -g : -d)
            : u.virtualTranslate ||
              (s.isHorizontal()
                ? (g -= s.cssOverflowAdjustment())
                : (d -= s.cssOverflowAdjustment()),
              (f.style.transform = `translate3d(${g}px, ${d}px, ${h}px)`)));
        let y;
        const b = s.maxTranslate() - s.minTranslate();
        (b === 0 ? (y = 0) : (y = (l - s.minTranslate()) / b),
          y !== p && s.updateProgress(l),
          s.emit('setTranslate', s.translate, a));
      }
      function db() {
        return -this.snapGrid[0];
      }
      function hb() {
        return -this.snapGrid[this.snapGrid.length - 1];
      }
      function pb(l = 0, a = this.params.speed, s = !0, r = !0, u) {
        const f = this,
          { params: p, wrapperEl: g } = f;
        if (f.animating && p.preventInteractionOnTransition) return !1;
        const d = f.minTranslate(),
          h = f.maxTranslate();
        let y;
        if (
          (r && l > d ? (y = d) : r && l < h ? (y = h) : (y = l),
          f.updateProgress(y),
          p.cssMode)
        ) {
          const b = f.isHorizontal();
          if (a === 0) g[b ? 'scrollLeft' : 'scrollTop'] = -y;
          else {
            if (!f.support.smoothScroll)
              return (
                Ep({ swiper: f, targetPosition: -y, side: b ? 'left' : 'top' }),
                !0
              );
            g.scrollTo({ [b ? 'left' : 'top']: -y, behavior: 'smooth' });
          }
          return !0;
        }
        return (
          a === 0
            ? (f.setTransition(0),
              f.setTranslate(y),
              s &&
                (f.emit('beforeTransitionStart', a, u),
                f.emit('transitionEnd')))
            : (f.setTransition(a),
              f.setTranslate(y),
              s &&
                (f.emit('beforeTransitionStart', a, u),
                f.emit('transitionStart')),
              f.animating ||
                ((f.animating = !0),
                f.onTranslateToWrapperTransitionEnd ||
                  (f.onTranslateToWrapperTransitionEnd = function (w) {
                    !f ||
                      f.destroyed ||
                      (w.target === this &&
                        (f.wrapperEl.removeEventListener(
                          'transitionend',
                          f.onTranslateToWrapperTransitionEnd
                        ),
                        (f.onTranslateToWrapperTransitionEnd = null),
                        delete f.onTranslateToWrapperTransitionEnd,
                        (f.animating = !1),
                        s && f.emit('transitionEnd')));
                  }),
                f.wrapperEl.addEventListener(
                  'transitionend',
                  f.onTranslateToWrapperTransitionEnd
                ))),
          !0
        );
      }
      var mb = {
        getTranslate: cb,
        setTranslate: fb,
        minTranslate: db,
        maxTranslate: hb,
        translateTo: pb,
      };
      function gb(l, a) {
        const s = this;
        (s.params.cssMode ||
          ((s.wrapperEl.style.transitionDuration = `${l}ms`),
          (s.wrapperEl.style.transitionDelay = l === 0 ? '0ms' : '')),
          s.emit('setTransition', l, a));
      }
      function Op({ swiper: l, runCallbacks: a, direction: s, step: r }) {
        const { activeIndex: u, previousIndex: f } = l;
        let p = s;
        (p || (u > f ? (p = 'next') : u < f ? (p = 'prev') : (p = 'reset')),
          l.emit(`transition${r}`),
          a && p === 'reset'
            ? l.emit(`slideResetTransition${r}`)
            : a &&
              u !== f &&
              (l.emit(`slideChangeTransition${r}`),
              p === 'next'
                ? l.emit(`slideNextTransition${r}`)
                : l.emit(`slidePrevTransition${r}`)));
      }
      function vb(l = !0, a) {
        const s = this,
          { params: r } = s;
        r.cssMode ||
          (r.autoHeight && s.updateAutoHeight(),
          Op({ swiper: s, runCallbacks: l, direction: a, step: 'Start' }));
      }
      function yb(l = !0, a) {
        const s = this,
          { params: r } = s;
        ((s.animating = !1),
          !r.cssMode &&
            (s.setTransition(0),
            Op({ swiper: s, runCallbacks: l, direction: a, step: 'End' })));
      }
      var bb = { setTransition: gb, transitionStart: vb, transitionEnd: yb };
      function Sb(l = 0, a, s = !0, r, u) {
        typeof l == 'string' && (l = parseInt(l, 10));
        const f = this;
        let p = l;
        p < 0 && (p = 0);
        const {
          params: g,
          snapGrid: d,
          slidesGrid: h,
          previousIndex: y,
          activeIndex: b,
          rtlTranslate: w,
          wrapperEl: T,
          enabled: _,
        } = f;
        if (
          (!_ && !r && !u) ||
          f.destroyed ||
          (f.animating && g.preventInteractionOnTransition)
        )
          return !1;
        typeof a > 'u' && (a = f.params.speed);
        const O = Math.min(f.params.slidesPerGroupSkip, p);
        let D = O + Math.floor((p - O) / f.params.slidesPerGroup);
        D >= d.length && (D = d.length - 1);
        const q = -d[D];
        if (g.normalizeSlideIndex)
          for (let k = 0; k < h.length; k += 1) {
            const V = -Math.floor(q * 100),
              ee = Math.floor(h[k] * 100),
              Q = Math.floor(h[k + 1] * 100);
            typeof h[k + 1] < 'u'
              ? V >= ee && V < Q - (Q - ee) / 2
                ? (p = k)
                : V >= ee && V < Q && (p = k + 1)
              : V >= ee && (p = k);
          }
        if (
          f.initialized &&
          p !== b &&
          ((!f.allowSlideNext &&
            (w
              ? q > f.translate && q > f.minTranslate()
              : q < f.translate && q < f.minTranslate())) ||
            (!f.allowSlidePrev &&
              q > f.translate &&
              q > f.maxTranslate() &&
              (b || 0) !== p))
        )
          return !1;
        (p !== (y || 0) && s && f.emit('beforeSlideChangeStart'),
          f.updateProgress(q));
        let U;
        p > b ? (U = 'next') : p < b ? (U = 'prev') : (U = 'reset');
        const Y = f.virtual && f.params.virtual.enabled;
        if (
          !(Y && u) &&
          ((w && -q === f.translate) || (!w && q === f.translate))
        )
          return (
            f.updateActiveIndex(p),
            g.autoHeight && f.updateAutoHeight(),
            f.updateSlidesClasses(),
            g.effect !== 'slide' && f.setTranslate(q),
            U !== 'reset' && (f.transitionStart(s, U), f.transitionEnd(s, U)),
            !1
          );
        if (g.cssMode) {
          const k = f.isHorizontal(),
            V = w ? q : -q;
          if (a === 0)
            (Y &&
              ((f.wrapperEl.style.scrollSnapType = 'none'),
              (f._immediateVirtual = !0)),
              Y && !f._cssModeVirtualInitialSet && f.params.initialSlide > 0
                ? ((f._cssModeVirtualInitialSet = !0),
                  requestAnimationFrame(() => {
                    T[k ? 'scrollLeft' : 'scrollTop'] = V;
                  }))
                : (T[k ? 'scrollLeft' : 'scrollTop'] = V),
              Y &&
                requestAnimationFrame(() => {
                  ((f.wrapperEl.style.scrollSnapType = ''),
                    (f._immediateVirtual = !1));
                }));
          else {
            if (!f.support.smoothScroll)
              return (
                Ep({ swiper: f, targetPosition: V, side: k ? 'left' : 'top' }),
                !0
              );
            T.scrollTo({ [k ? 'left' : 'top']: V, behavior: 'smooth' });
          }
          return !0;
        }
        const W = Ap().isSafari;
        return (
          Y && !u && W && f.isElement && f.virtual.update(!1, !1, p),
          f.setTransition(a),
          f.setTranslate(q),
          f.updateActiveIndex(p),
          f.updateSlidesClasses(),
          f.emit('beforeTransitionStart', a, r),
          f.transitionStart(s, U),
          a === 0
            ? f.transitionEnd(s, U)
            : f.animating ||
              ((f.animating = !0),
              f.onSlideToWrapperTransitionEnd ||
                (f.onSlideToWrapperTransitionEnd = function (V) {
                  !f ||
                    f.destroyed ||
                    (V.target === this &&
                      (f.wrapperEl.removeEventListener(
                        'transitionend',
                        f.onSlideToWrapperTransitionEnd
                      ),
                      (f.onSlideToWrapperTransitionEnd = null),
                      delete f.onSlideToWrapperTransitionEnd,
                      f.transitionEnd(s, U)));
                }),
              f.wrapperEl.addEventListener(
                'transitionend',
                f.onSlideToWrapperTransitionEnd
              )),
          !0
        );
      }
      function xb(l = 0, a, s = !0, r) {
        typeof l == 'string' && (l = parseInt(l, 10));
        const u = this;
        if (u.destroyed) return;
        typeof a > 'u' && (a = u.params.speed);
        const f = u.grid && u.params.grid && u.params.grid.rows > 1;
        let p = l;
        if (u.params.loop)
          if (u.virtual && u.params.virtual.enabled)
            p = p + u.virtual.slidesBefore;
          else {
            let g;
            if (f) {
              const O = p * u.params.grid.rows;
              g = u.slides.find(
                D => D.getAttribute('data-swiper-slide-index') * 1 === O
              ).column;
            } else g = u.getSlideIndexByData(p);
            const d = f
                ? Math.ceil(u.slides.length / u.params.grid.rows)
                : u.slides.length,
              {
                centeredSlides: h,
                slidesOffsetBefore: y,
                slidesOffsetAfter: b,
              } = u.params,
              w = h || !!y || !!b;
            let T = u.params.slidesPerView;
            T === 'auto'
              ? (T = u.slidesPerViewDynamic())
              : ((T = Math.ceil(parseFloat(u.params.slidesPerView, 10))),
                w && T % 2 === 0 && (T = T + 1));
            let _ = d - g < T;
            if (
              (w && (_ = _ || g < Math.ceil(T / 2)),
              r && w && u.params.slidesPerView !== 'auto' && !f && (_ = !1),
              _)
            ) {
              const O = w
                ? g < u.activeIndex
                  ? 'prev'
                  : 'next'
                : g - u.activeIndex - 1 < u.params.slidesPerView
                  ? 'next'
                  : 'prev';
              u.loopFix({
                direction: O,
                slideTo: !0,
                activeSlideIndex: O === 'next' ? g + 1 : g - d + 1,
                slideRealIndex: O === 'next' ? u.realIndex : void 0,
              });
            }
            if (f) {
              const O = p * u.params.grid.rows;
              p = u.slides.find(
                D => D.getAttribute('data-swiper-slide-index') * 1 === O
              ).column;
            } else p = u.getSlideIndexByData(p);
          }
        return (
          requestAnimationFrame(() => {
            u.slideTo(p, a, s, r);
          }),
          u
        );
      }
      function Tb(l, a = !0, s) {
        const r = this,
          { enabled: u, params: f, animating: p } = r;
        if (!u || r.destroyed) return r;
        typeof l > 'u' && (l = r.params.speed);
        let g = f.slidesPerGroup;
        f.slidesPerView === 'auto' &&
          f.slidesPerGroup === 1 &&
          f.slidesPerGroupAuto &&
          (g = Math.max(r.slidesPerViewDynamic('current', !0), 1));
        const d = r.activeIndex < f.slidesPerGroupSkip ? 1 : g,
          h = r.virtual && f.virtual.enabled;
        if (f.loop) {
          if (p && !h && f.loopPreventsSliding) return !1;
          if (
            (r.loopFix({ direction: 'next' }),
            (r._clientLeft = r.wrapperEl.clientLeft),
            r.activeIndex === r.slides.length - 1 && f.cssMode)
          )
            return (
              requestAnimationFrame(() => {
                r.slideTo(r.activeIndex + d, l, a, s);
              }),
              !0
            );
        }
        return f.rewind && r.isEnd
          ? r.slideTo(0, l, a, s)
          : r.slideTo(r.activeIndex + d, l, a, s);
      }
      function Eb(l, a = !0, s) {
        const r = this,
          {
            params: u,
            snapGrid: f,
            slidesGrid: p,
            rtlTranslate: g,
            enabled: d,
            animating: h,
          } = r;
        if (!d || r.destroyed) return r;
        typeof l > 'u' && (l = r.params.speed);
        const y = r.virtual && u.virtual.enabled;
        if (u.loop) {
          if (h && !y && u.loopPreventsSliding) return !1;
          (r.loopFix({ direction: 'prev' }),
            (r._clientLeft = r.wrapperEl.clientLeft));
        }
        const b = g ? r.translate : -r.translate;
        function w(U) {
          return U < 0 ? -Math.floor(Math.abs(U)) : Math.floor(U);
        }
        const T = w(b),
          _ = f.map(U => w(U)),
          O = u.freeMode && u.freeMode.enabled;
        let D = f[_.indexOf(T) - 1];
        if (typeof D > 'u' && (u.cssMode || O)) {
          let U;
          (f.forEach((Y, X) => {
            T >= Y && (U = X);
          }),
            typeof U < 'u' && (D = O ? f[U] : f[U > 0 ? U - 1 : U]));
        }
        let q = 0;
        if (
          (typeof D < 'u' &&
            ((q = p.indexOf(D)),
            q < 0 && (q = r.activeIndex - 1),
            u.slidesPerView === 'auto' &&
              u.slidesPerGroup === 1 &&
              u.slidesPerGroupAuto &&
              ((q = q - r.slidesPerViewDynamic('previous', !0) + 1),
              (q = Math.max(q, 0)))),
          u.rewind && r.isBeginning)
        ) {
          const U =
            r.params.virtual && r.params.virtual.enabled && r.virtual
              ? r.virtual.slides.length - 1
              : r.slides.length - 1;
          return r.slideTo(U, l, a, s);
        } else if (u.loop && r.activeIndex === 0 && u.cssMode)
          return (
            requestAnimationFrame(() => {
              r.slideTo(q, l, a, s);
            }),
            !0
          );
        return r.slideTo(q, l, a, s);
      }
      function wb(l, a = !0, s) {
        const r = this;
        if (!r.destroyed)
          return (
            typeof l > 'u' && (l = r.params.speed),
            r.slideTo(r.activeIndex, l, a, s)
          );
      }
      function Mb(l, a = !0, s, r = 0.5) {
        const u = this;
        if (u.destroyed) return;
        typeof l > 'u' && (l = u.params.speed);
        let f = u.activeIndex;
        const p = Math.min(u.params.slidesPerGroupSkip, f),
          g = p + Math.floor((f - p) / u.params.slidesPerGroup),
          d = u.rtlTranslate ? u.translate : -u.translate;
        if (d >= u.snapGrid[g]) {
          const h = u.snapGrid[g],
            y = u.snapGrid[g + 1];
          d - h > (y - h) * r && (f += u.params.slidesPerGroup);
        } else {
          const h = u.snapGrid[g - 1],
            y = u.snapGrid[g];
          d - h <= (y - h) * r && (f -= u.params.slidesPerGroup);
        }
        return (
          (f = Math.max(f, 0)),
          (f = Math.min(f, u.slidesGrid.length - 1)),
          u.slideTo(f, l, a, s)
        );
      }
      function Ab() {
        const l = this;
        if (l.destroyed) return;
        const { params: a, slidesEl: s } = l,
          r =
            a.slidesPerView === 'auto'
              ? l.slidesPerViewDynamic()
              : a.slidesPerView;
        let u = l.getSlideIndexWhenGrid(l.clickedIndex),
          f;
        const p = l.isElement ? 'swiper-slide' : `.${a.slideClass}`,
          g = l.grid && l.params.grid && l.params.grid.rows > 1;
        if (a.loop) {
          if (l.animating) return;
          ((f = parseInt(
            l.clickedSlide.getAttribute('data-swiper-slide-index'),
            10
          )),
            a.centeredSlides
              ? l.slideToLoop(f)
              : u >
                  (g
                    ? (l.slides.length - r) / 2 - (l.params.grid.rows - 1)
                    : l.slides.length - r)
                ? (l.loopFix(),
                  (u = l.getSlideIndex(
                    ri(s, `${p}[data-swiper-slide-index="${f}"]`)[0]
                  )),
                  Tp(() => {
                    l.slideTo(u);
                  }))
                : l.slideTo(u));
        } else l.slideTo(u);
      }
      var Ob = {
        slideTo: Sb,
        slideToLoop: xb,
        slideNext: Tb,
        slidePrev: Eb,
        slideReset: wb,
        slideToClosest: Mb,
        slideToClickedSlide: Ab,
      };
      function _b(l, a) {
        const s = this,
          { params: r, slidesEl: u } = s;
        if (!r.loop || (s.virtual && s.params.virtual.enabled)) return;
        const f = () => {
            ri(u, `.${r.slideClass}, swiper-slide`).forEach((_, O) => {
              _.setAttribute('data-swiper-slide-index', O);
            });
          },
          p = () => {
            const T = ri(u, `.${r.slideBlankClass}`);
            (T.forEach(_ => {
              _.remove();
            }),
              T.length > 0 && (s.recalcSlides(), s.updateSlides()));
          },
          g = s.grid && r.grid && r.grid.rows > 1;
        r.loopAddBlankSlides && (r.slidesPerGroup > 1 || g) && p();
        const d = r.slidesPerGroup * (g ? r.grid.rows : 1),
          h = s.slides.length % d !== 0,
          y = g && s.slides.length % r.grid.rows !== 0,
          b = T => {
            for (let _ = 0; _ < T; _ += 1) {
              const O = s.isElement
                ? xu('swiper-slide', [r.slideBlankClass])
                : xu('div', [r.slideClass, r.slideBlankClass]);
              s.slidesEl.append(O);
            }
          };
        if (h) {
          if (r.loopAddBlankSlides) {
            const T = d - (s.slides.length % d);
            (b(T), s.recalcSlides(), s.updateSlides());
          } else
            _s(
              'Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)'
            );
          f();
        } else if (y) {
          if (r.loopAddBlankSlides) {
            const T = r.grid.rows - (s.slides.length % r.grid.rows);
            (b(T), s.recalcSlides(), s.updateSlides());
          } else
            _s(
              'Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)'
            );
          f();
        } else f();
        const w =
          r.centeredSlides || !!r.slidesOffsetBefore || !!r.slidesOffsetAfter;
        s.loopFix({
          slideRealIndex: l,
          direction: w ? void 0 : 'next',
          initial: a,
        });
      }
      function Cb({
        slideRealIndex: l,
        slideTo: a = !0,
        direction: s,
        setTranslate: r,
        activeSlideIndex: u,
        initial: f,
        byController: p,
        byMousewheel: g,
      } = {}) {
        const d = this;
        if (!d.params.loop) return;
        d.emit('beforeLoopFix');
        const {
            slides: h,
            allowSlidePrev: y,
            allowSlideNext: b,
            slidesEl: w,
            params: T,
          } = d,
          {
            centeredSlides: _,
            slidesOffsetBefore: O,
            slidesOffsetAfter: D,
            initialSlide: q,
          } = T,
          U = _ || !!O || !!D;
        if (
          ((d.allowSlidePrev = !0),
          (d.allowSlideNext = !0),
          d.virtual && T.virtual.enabled)
        ) {
          (a &&
            (!U && d.snapIndex === 0
              ? d.slideTo(d.virtual.slides.length, 0, !1, !0)
              : U && d.snapIndex < T.slidesPerView
                ? d.slideTo(d.virtual.slides.length + d.snapIndex, 0, !1, !0)
                : d.snapIndex === d.snapGrid.length - 1 &&
                  d.slideTo(d.virtual.slidesBefore, 0, !1, !0)),
            (d.allowSlidePrev = y),
            (d.allowSlideNext = b),
            d.emit('loopFix'));
          return;
        }
        let Y = T.slidesPerView;
        Y === 'auto'
          ? (Y = d.slidesPerViewDynamic())
          : ((Y = Math.ceil(parseFloat(T.slidesPerView, 10))),
            U && Y % 2 === 0 && (Y = Y + 1));
        const X = T.slidesPerGroupAuto ? Y : T.slidesPerGroup;
        let B = U ? Math.max(X, Math.ceil(Y / 2)) : X;
        (B % X !== 0 && (B += X - (B % X)),
          (B += T.loopAdditionalSlides),
          (d.loopedSlides = B));
        const W = d.grid && T.grid && T.grid.rows > 1;
        h.length < Y + B ||
        (d.params.effect === 'cards' && h.length < Y + B * 2)
          ? _s(
              'Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters'
            )
          : W &&
            T.grid.fill === 'row' &&
            _s(
              'Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`'
            );
        const k = [],
          V = [],
          ee = W ? Math.ceil(h.length / T.grid.rows) : h.length,
          Q = f && ee - q < Y && !U;
        let J = Q ? q : d.activeIndex;
        typeof u > 'u'
          ? (u = d.getSlideIndex(
              h.find($ => $.classList.contains(T.slideActiveClass))
            ))
          : (J = u);
        const ie = s === 'next' || !s,
          de = s === 'prev' || !s;
        let ve = 0,
          be = 0;
        const Z =
          (W ? h[u].column : u) + (U && typeof r > 'u' ? -Y / 2 + 0.5 : 0);
        if (Z < B) {
          ve = Math.max(B - Z, X);
          for (let $ = 0; $ < B - Z; $ += 1) {
            const ne = $ - Math.floor($ / ee) * ee;
            if (W) {
              const x = ee - ne - 1;
              for (let j = h.length - 1; j >= 0; j -= 1)
                h[j].column === x && k.push(j);
            } else k.push(ee - ne - 1);
          }
        } else if (Z + Y > ee - B) {
          ((be = Math.max(Z - (ee - B * 2), X)),
            Q && (be = Math.max(be, Y - ee + q + 1)));
          for (let $ = 0; $ < be; $ += 1) {
            const ne = $ - Math.floor($ / ee) * ee;
            W
              ? h.forEach((x, j) => {
                  x.column === ne && V.push(j);
                })
              : V.push(ne);
          }
        }
        if (
          ((d.__preventObserver__ = !0),
          requestAnimationFrame(() => {
            d.__preventObserver__ = !1;
          }),
          d.params.effect === 'cards' &&
            h.length < Y + B * 2 &&
            (V.includes(u) && V.splice(V.indexOf(u), 1),
            k.includes(u) && k.splice(k.indexOf(u), 1)),
          de &&
            k.forEach($ => {
              ((h[$].swiperLoopMoveDOM = !0),
                w.prepend(h[$]),
                (h[$].swiperLoopMoveDOM = !1));
            }),
          ie &&
            V.forEach($ => {
              ((h[$].swiperLoopMoveDOM = !0),
                w.append(h[$]),
                (h[$].swiperLoopMoveDOM = !1));
            }),
          d.recalcSlides(),
          T.slidesPerView === 'auto'
            ? d.updateSlides()
            : W &&
              ((k.length > 0 && de) || (V.length > 0 && ie)) &&
              d.slides.forEach(($, ne) => {
                d.grid.updateSlide(ne, $, d.slides);
              }),
          T.watchSlidesProgress && d.updateSlidesOffset(),
          a)
        ) {
          if (k.length > 0 && de) {
            if (typeof l > 'u') {
              const $ = d.slidesGrid[J],
                x = d.slidesGrid[J + ve] - $;
              g
                ? d.setTranslate(d.translate - x)
                : (d.slideTo(J + Math.ceil(ve), 0, !1, !0),
                  r &&
                    ((d.touchEventsData.startTranslate =
                      d.touchEventsData.startTranslate - x),
                    (d.touchEventsData.currentTranslate =
                      d.touchEventsData.currentTranslate - x)));
            } else if (r) {
              const $ = W ? k.length / T.grid.rows : k.length;
              (d.slideTo(d.activeIndex + $, 0, !1, !0),
                (d.touchEventsData.currentTranslate = d.translate));
            }
          } else if (V.length > 0 && ie)
            if (typeof l > 'u') {
              const $ = d.slidesGrid[J],
                x = d.slidesGrid[J - be] - $;
              g
                ? d.setTranslate(d.translate - x)
                : (d.slideTo(J - be, 0, !1, !0),
                  r &&
                    ((d.touchEventsData.startTranslate =
                      d.touchEventsData.startTranslate - x),
                    (d.touchEventsData.currentTranslate =
                      d.touchEventsData.currentTranslate - x)));
            } else {
              const $ = W ? V.length / T.grid.rows : V.length;
              d.slideTo(d.activeIndex - $, 0, !1, !0);
            }
        }
        if (
          ((d.allowSlidePrev = y),
          (d.allowSlideNext = b),
          d.controller && d.controller.control && !p)
        ) {
          const $ = {
            slideRealIndex: l,
            direction: s,
            setTranslate: r,
            activeSlideIndex: u,
            byController: !0,
          };
          Array.isArray(d.controller.control)
            ? d.controller.control.forEach(ne => {
                !ne.destroyed &&
                  ne.params.loop &&
                  ne.loopFix({
                    ...$,
                    slideTo:
                      ne.params.slidesPerView === T.slidesPerView ? a : !1,
                  });
              })
            : d.controller.control instanceof d.constructor &&
              d.controller.control.params.loop &&
              d.controller.control.loopFix({
                ...$,
                slideTo:
                  d.controller.control.params.slidesPerView === T.slidesPerView
                    ? a
                    : !1,
              });
        }
        d.emit('loopFix');
      }
      function Nb() {
        const l = this,
          { params: a, slidesEl: s } = l;
        if (!a.loop || !s || (l.virtual && l.params.virtual.enabled)) return;
        l.recalcSlides();
        const r = [];
        (l.slides.forEach(u => {
          const f =
            typeof u.swiperSlideIndex > 'u'
              ? u.getAttribute('data-swiper-slide-index') * 1
              : u.swiperSlideIndex;
          r[f] = u;
        }),
          l.slides.forEach(u => {
            u.removeAttribute('data-swiper-slide-index');
          }),
          r.forEach(u => {
            s.append(u);
          }),
          l.recalcSlides(),
          l.slideTo(l.realIndex, 0));
      }
      var zb = { loopCreate: _b, loopFix: Cb, loopDestroy: Nb };
      function Rb(l) {
        const a = this;
        if (
          !a.params.simulateTouch ||
          (a.params.watchOverflow && a.isLocked) ||
          a.params.cssMode
        )
          return;
        const s =
          a.params.touchEventsTarget === 'container' ? a.el : a.wrapperEl;
        (a.isElement && (a.__preventObserver__ = !0),
          (s.style.cursor = 'move'),
          (s.style.cursor = l ? 'grabbing' : 'grab'),
          a.isElement &&
            requestAnimationFrame(() => {
              a.__preventObserver__ = !1;
            }));
      }
      function Db() {
        const l = this;
        (l.params.watchOverflow && l.isLocked) ||
          l.params.cssMode ||
          (l.isElement && (l.__preventObserver__ = !0),
          (l[
            l.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'
          ].style.cursor = ''),
          l.isElement &&
            requestAnimationFrame(() => {
              l.__preventObserver__ = !1;
            }));
      }
      var Lb = { setGrabCursor: Rb, unsetGrabCursor: Db };
      function jb(l, a = this) {
        function s(r) {
          if (!r || r === on() || r === at()) return null;
          r.assignedSlot && (r = r.assignedSlot);
          const u = r.closest(l);
          return !u && !r.getRootNode ? null : u || s(r.getRootNode().host);
        }
        return s(a);
      }
      function np(l, a, s) {
        const r = at(),
          { params: u } = l,
          f = u.edgeSwipeDetection,
          p = u.edgeSwipeThreshold;
        return f && (s <= p || s >= r.innerWidth - p)
          ? f === 'prevent'
            ? (a.preventDefault(), !0)
            : !1
          : !0;
      }
      function Hb(l) {
        const a = this,
          s = on();
        let r = l;
        r.originalEvent && (r = r.originalEvent);
        const u = a.touchEventsData;
        if (r.type === 'pointerdown') {
          if (u.pointerId !== null && u.pointerId !== r.pointerId) return;
          u.pointerId = r.pointerId;
        } else
          r.type === 'touchstart' &&
            r.targetTouches.length === 1 &&
            (u.touchId = r.targetTouches[0].identifier);
        if (r.type === 'touchstart') {
          np(a, r, r.targetTouches[0].pageX);
          return;
        }
        const { params: f, touches: p, enabled: g } = a;
        if (
          !g ||
          (!f.simulateTouch && r.pointerType === 'mouse') ||
          (a.animating && f.preventInteractionOnTransition)
        )
          return;
        !a.animating && f.cssMode && f.loop && a.loopFix();
        let d = r.target;
        if (
          (f.touchEventsTarget === 'wrapper' && !Y0(d, a.wrapperEl)) ||
          ('which' in r && r.which === 3) ||
          ('button' in r && r.button > 0) ||
          (u.isTouched && u.isMoved)
        )
          return;
        const h = !!f.noSwipingClass && f.noSwipingClass !== '',
          y = r.composedPath ? r.composedPath() : r.path;
        h && r.target && r.target.shadowRoot && y && (d = y[0]);
        const b = f.noSwipingSelector
            ? f.noSwipingSelector
            : `.${f.noSwipingClass}`,
          w = !!(r.target && r.target.shadowRoot);
        if (f.noSwiping && (w ? jb(b, d) : d.closest(b))) {
          a.allowClick = !0;
          return;
        }
        if (f.swipeHandler && !d.closest(f.swipeHandler)) return;
        ((p.currentX = r.pageX), (p.currentY = r.pageY));
        const T = p.currentX,
          _ = p.currentY;
        if (!np(a, r, T)) return;
        (Object.assign(u, {
          isTouched: !0,
          isMoved: !1,
          allowTouchCallbacks: !0,
          isScrolling: void 0,
          startMoving: void 0,
        }),
          (p.startX = T),
          (p.startY = _),
          (u.touchStartTime = Os()),
          (a.allowClick = !0),
          a.updateSize(),
          (a.swipeDirection = void 0),
          f.threshold > 0 && (u.allowThresholdMove = !1));
        let O = !0;
        (d.matches(u.focusableElements) &&
          ((O = !1), d.nodeName === 'SELECT' && (u.isTouched = !1)),
          s.activeElement &&
            s.activeElement.matches(u.focusableElements) &&
            s.activeElement !== d &&
            (r.pointerType === 'mouse' ||
              (r.pointerType !== 'mouse' && !d.matches(u.focusableElements))) &&
            s.activeElement.blur());
        const D = O && a.allowTouchMove && f.touchStartPreventDefault;
        ((f.touchStartForcePreventDefault || D) &&
          !d.isContentEditable &&
          r.preventDefault(),
          f.freeMode &&
            f.freeMode.enabled &&
            a.freeMode &&
            a.animating &&
            !f.cssMode &&
            a.freeMode.onTouchStart(),
          a.emit('touchStart', r));
      }
      function Ub(l) {
        const a = on(),
          s = this,
          r = s.touchEventsData,
          { params: u, touches: f, rtlTranslate: p, enabled: g } = s;
        if (!g || (!u.simulateTouch && l.pointerType === 'mouse')) return;
        let d = l;
        if (
          (d.originalEvent && (d = d.originalEvent),
          d.type === 'pointermove' &&
            (r.touchId !== null || d.pointerId !== r.pointerId))
        )
          return;
        let h;
        if (d.type === 'touchmove') {
          if (
            ((h = [...d.changedTouches].find(B => B.identifier === r.touchId)),
            !h || h.identifier !== r.touchId)
          )
            return;
        } else h = d;
        if (!r.isTouched) {
          r.startMoving && r.isScrolling && s.emit('touchMoveOpposite', d);
          return;
        }
        const y = h.pageX,
          b = h.pageY;
        if (d.preventedByNestedSwiper) {
          ((f.startX = y), (f.startY = b));
          return;
        }
        if (!s.allowTouchMove) {
          (d.target.matches(r.focusableElements) || (s.allowClick = !1),
            r.isTouched &&
              (Object.assign(f, {
                startX: y,
                startY: b,
                currentX: y,
                currentY: b,
              }),
              (r.touchStartTime = Os())));
          return;
        }
        if (u.touchReleaseOnEdges && !u.loop)
          if (s.isVertical()) {
            if (
              (b < f.startY && s.translate <= s.maxTranslate()) ||
              (b > f.startY && s.translate >= s.minTranslate())
            ) {
              ((r.isTouched = !1), (r.isMoved = !1));
              return;
            }
          } else {
            if (
              p &&
              ((y > f.startX && -s.translate <= s.maxTranslate()) ||
                (y < f.startX && -s.translate >= s.minTranslate()))
            )
              return;
            if (
              !p &&
              ((y < f.startX && s.translate <= s.maxTranslate()) ||
                (y > f.startX && s.translate >= s.minTranslate()))
            )
              return;
          }
        if (
          (a.activeElement &&
            a.activeElement.matches(r.focusableElements) &&
            a.activeElement !== d.target &&
            d.pointerType !== 'mouse' &&
            a.activeElement.blur(),
          a.activeElement &&
            d.target === a.activeElement &&
            d.target.matches(r.focusableElements))
        ) {
          ((r.isMoved = !0), (s.allowClick = !1));
          return;
        }
        (r.allowTouchCallbacks && s.emit('touchMove', d),
          (f.previousX = f.currentX),
          (f.previousY = f.currentY),
          (f.currentX = y),
          (f.currentY = b));
        const w = f.currentX - f.startX,
          T = f.currentY - f.startY;
        if (
          s.params.threshold &&
          Math.sqrt(w ** 2 + T ** 2) < s.params.threshold
        )
          return;
        if (typeof r.isScrolling > 'u') {
          let B;
          (s.isHorizontal() && f.currentY === f.startY) ||
          (s.isVertical() && f.currentX === f.startX)
            ? (r.isScrolling = !1)
            : w * w + T * T >= 25 &&
              ((B = (Math.atan2(Math.abs(T), Math.abs(w)) * 180) / Math.PI),
              (r.isScrolling = s.isHorizontal()
                ? B > u.touchAngle
                : 90 - B > u.touchAngle));
        }
        if (
          (r.isScrolling && s.emit('touchMoveOpposite', d),
          typeof r.startMoving > 'u' &&
            (f.currentX !== f.startX || f.currentY !== f.startY) &&
            (r.startMoving = !0),
          r.isScrolling ||
            (d.type === 'touchmove' && r.preventTouchMoveFromPointerMove))
        ) {
          r.isTouched = !1;
          return;
        }
        if (!r.startMoving) return;
        ((s.allowClick = !1),
          !u.cssMode && d.cancelable && d.preventDefault(),
          u.touchMoveStopPropagation && !u.nested && d.stopPropagation());
        let _ = s.isHorizontal() ? w : T,
          O = s.isHorizontal()
            ? f.currentX - f.previousX
            : f.currentY - f.previousY;
        (u.oneWayMovement &&
          ((_ = Math.abs(_) * (p ? 1 : -1)), (O = Math.abs(O) * (p ? 1 : -1))),
          (f.diff = _),
          (_ *= u.touchRatio),
          p && ((_ = -_), (O = -O)));
        const D = s.touchesDirection;
        ((s.swipeDirection = _ > 0 ? 'prev' : 'next'),
          (s.touchesDirection = O > 0 ? 'prev' : 'next'));
        const q = s.params.loop && !u.cssMode,
          U =
            (s.touchesDirection === 'next' && s.allowSlideNext) ||
            (s.touchesDirection === 'prev' && s.allowSlidePrev);
        if (!r.isMoved) {
          if (
            (q && U && s.loopFix({ direction: s.swipeDirection }),
            (r.startTranslate = s.getTranslate()),
            s.setTransition(0),
            s.animating)
          ) {
            const B = new window.CustomEvent('transitionend', {
              bubbles: !0,
              cancelable: !0,
              detail: { bySwiperTouchMove: !0 },
            });
            s.wrapperEl.dispatchEvent(B);
          }
          ((r.allowMomentumBounce = !1),
            u.grabCursor &&
              (s.allowSlideNext === !0 || s.allowSlidePrev === !0) &&
              s.setGrabCursor(!0),
            s.emit('sliderFirstMove', d));
        }
        if (
          (new Date().getTime(),
          u._loopSwapReset !== !1 &&
            r.isMoved &&
            r.allowThresholdMove &&
            D !== s.touchesDirection &&
            q &&
            U &&
            Math.abs(_) >= 1)
        ) {
          (Object.assign(f, {
            startX: y,
            startY: b,
            currentX: y,
            currentY: b,
            startTranslate: r.currentTranslate,
          }),
            (r.loopSwapReset = !0),
            (r.startTranslate = r.currentTranslate));
          return;
        }
        (s.emit('sliderMove', d),
          (r.isMoved = !0),
          (r.currentTranslate = _ + r.startTranslate));
        let Y = !0,
          X = u.resistanceRatio;
        if (
          (u.touchReleaseOnEdges && (X = 0),
          _ > 0
            ? (q &&
                U &&
                r.allowThresholdMove &&
                r.currentTranslate >
                  (u.centeredSlides
                    ? s.minTranslate() -
                      s.slidesSizesGrid[s.activeIndex + 1] -
                      (u.slidesPerView !== 'auto' &&
                      s.slides.length - u.slidesPerView >= 2
                        ? s.slidesSizesGrid[s.activeIndex + 1] +
                          s.params.spaceBetween
                        : 0) -
                      s.params.spaceBetween
                    : s.minTranslate()) &&
                s.loopFix({
                  direction: 'prev',
                  setTranslate: !0,
                  activeSlideIndex: 0,
                }),
              r.currentTranslate > s.minTranslate() &&
                ((Y = !1),
                u.resistance &&
                  (r.currentTranslate =
                    s.minTranslate() -
                    1 +
                    (-s.minTranslate() + r.startTranslate + _) ** X)))
            : _ < 0 &&
              (q &&
                U &&
                r.allowThresholdMove &&
                r.currentTranslate <
                  (u.centeredSlides
                    ? s.maxTranslate() +
                      s.slidesSizesGrid[s.slidesSizesGrid.length - 1] +
                      s.params.spaceBetween +
                      (u.slidesPerView !== 'auto' &&
                      s.slides.length - u.slidesPerView >= 2
                        ? s.slidesSizesGrid[s.slidesSizesGrid.length - 1] +
                          s.params.spaceBetween
                        : 0)
                    : s.maxTranslate()) &&
                s.loopFix({
                  direction: 'next',
                  setTranslate: !0,
                  activeSlideIndex:
                    s.slides.length -
                    (u.slidesPerView === 'auto'
                      ? s.slidesPerViewDynamic()
                      : Math.ceil(parseFloat(u.slidesPerView, 10))),
                }),
              r.currentTranslate < s.maxTranslate() &&
                ((Y = !1),
                u.resistance &&
                  (r.currentTranslate =
                    s.maxTranslate() +
                    1 -
                    (s.maxTranslate() - r.startTranslate - _) ** X))),
          Y && (d.preventedByNestedSwiper = !0),
          !s.allowSlideNext &&
            s.swipeDirection === 'next' &&
            r.currentTranslate < r.startTranslate &&
            (r.currentTranslate = r.startTranslate),
          !s.allowSlidePrev &&
            s.swipeDirection === 'prev' &&
            r.currentTranslate > r.startTranslate &&
            (r.currentTranslate = r.startTranslate),
          !s.allowSlidePrev &&
            !s.allowSlideNext &&
            (r.currentTranslate = r.startTranslate),
          u.threshold > 0)
        )
          if (Math.abs(_) > u.threshold || r.allowThresholdMove) {
            if (!r.allowThresholdMove) {
              ((r.allowThresholdMove = !0),
                (f.startX = f.currentX),
                (f.startY = f.currentY),
                (r.currentTranslate = r.startTranslate),
                (f.diff = s.isHorizontal()
                  ? f.currentX - f.startX
                  : f.currentY - f.startY));
              return;
            }
          } else {
            r.currentTranslate = r.startTranslate;
            return;
          }
        !u.followFinger ||
          u.cssMode ||
          (((u.freeMode && u.freeMode.enabled && s.freeMode) ||
            u.watchSlidesProgress) &&
            (s.updateActiveIndex(), s.updateSlidesClasses()),
          u.freeMode &&
            u.freeMode.enabled &&
            s.freeMode &&
            s.freeMode.onTouchMove(),
          s.updateProgress(r.currentTranslate),
          s.setTranslate(r.currentTranslate));
      }
      function Bb(l) {
        const a = this,
          s = a.touchEventsData;
        let r = l;
        r.originalEvent && (r = r.originalEvent);
        let u;
        if (r.type === 'touchend' || r.type === 'touchcancel') {
          if (
            ((u = [...r.changedTouches].find(B => B.identifier === s.touchId)),
            !u || u.identifier !== s.touchId)
          )
            return;
        } else {
          if (s.touchId !== null || r.pointerId !== s.pointerId) return;
          u = r;
        }
        if (
          [
            'pointercancel',
            'pointerout',
            'pointerleave',
            'contextmenu',
          ].includes(r.type) &&
          !(
            ['pointercancel', 'contextmenu'].includes(r.type) &&
            (a.browser.isSafari || a.browser.isWebView)
          )
        )
          return;
        ((s.pointerId = null), (s.touchId = null));
        const {
          params: p,
          touches: g,
          rtlTranslate: d,
          slidesGrid: h,
          enabled: y,
        } = a;
        if (!y || (!p.simulateTouch && r.pointerType === 'mouse')) return;
        if (
          (s.allowTouchCallbacks && a.emit('touchEnd', r),
          (s.allowTouchCallbacks = !1),
          !s.isTouched)
        ) {
          (s.isMoved && p.grabCursor && a.setGrabCursor(!1),
            (s.isMoved = !1),
            (s.startMoving = !1));
          return;
        }
        p.grabCursor &&
          s.isMoved &&
          s.isTouched &&
          (a.allowSlideNext === !0 || a.allowSlidePrev === !0) &&
          a.setGrabCursor(!1);
        const b = Os(),
          w = b - s.touchStartTime;
        if (a.allowClick) {
          const B = r.path || (r.composedPath && r.composedPath());
          (a.updateClickedSlide((B && B[0]) || r.target, B),
            a.emit('tap click', r),
            w < 300 &&
              b - s.lastClickTime < 300 &&
              a.emit('doubleTap doubleClick', r));
        }
        if (
          ((s.lastClickTime = Os()),
          Tp(() => {
            a.destroyed || (a.allowClick = !0);
          }),
          !s.isTouched ||
            !s.isMoved ||
            !a.swipeDirection ||
            (g.diff === 0 && !s.loopSwapReset) ||
            (s.currentTranslate === s.startTranslate && !s.loopSwapReset))
        ) {
          ((s.isTouched = !1), (s.isMoved = !1), (s.startMoving = !1));
          return;
        }
        ((s.isTouched = !1), (s.isMoved = !1), (s.startMoving = !1));
        let T;
        if (
          (p.followFinger
            ? (T = d ? a.translate : -a.translate)
            : (T = -s.currentTranslate),
          p.cssMode)
        )
          return;
        if (p.freeMode && p.freeMode.enabled) {
          a.freeMode.onTouchEnd({ currentPos: T });
          return;
        }
        const _ = T >= -a.maxTranslate() && !a.params.loop;
        let O = 0,
          D = a.slidesSizesGrid[0];
        for (
          let B = 0;
          B < h.length;
          B += B < p.slidesPerGroupSkip ? 1 : p.slidesPerGroup
        ) {
          const W = B < p.slidesPerGroupSkip - 1 ? 1 : p.slidesPerGroup;
          typeof h[B + W] < 'u'
            ? (_ || (T >= h[B] && T < h[B + W])) &&
              ((O = B), (D = h[B + W] - h[B]))
            : (_ || T >= h[B]) &&
              ((O = B), (D = h[h.length - 1] - h[h.length - 2]));
        }
        let q = null,
          U = null;
        p.rewind &&
          (a.isBeginning
            ? (U =
                p.virtual && p.virtual.enabled && a.virtual
                  ? a.virtual.slides.length - 1
                  : a.slides.length - 1)
            : a.isEnd && (q = 0));
        const Y = (T - h[O]) / D,
          X = O < p.slidesPerGroupSkip - 1 ? 1 : p.slidesPerGroup;
        if (w > p.longSwipesMs) {
          if (!p.longSwipes) {
            a.slideTo(a.activeIndex);
            return;
          }
          (a.swipeDirection === 'next' &&
            (Y >= p.longSwipesRatio
              ? a.slideTo(p.rewind && a.isEnd ? q : O + X)
              : a.slideTo(O)),
            a.swipeDirection === 'prev' &&
              (Y > 1 - p.longSwipesRatio
                ? a.slideTo(O + X)
                : U !== null && Y < 0 && Math.abs(Y) > p.longSwipesRatio
                  ? a.slideTo(U)
                  : a.slideTo(O)));
        } else {
          if (!p.shortSwipes) {
            a.slideTo(a.activeIndex);
            return;
          }
          a.navigation &&
          (r.target === a.navigation.nextEl || r.target === a.navigation.prevEl)
            ? r.target === a.navigation.nextEl
              ? a.slideTo(O + X)
              : a.slideTo(O)
            : (a.swipeDirection === 'next' && a.slideTo(q !== null ? q : O + X),
              a.swipeDirection === 'prev' && a.slideTo(U !== null ? U : O));
        }
      }
      function ap() {
        const l = this,
          { params: a, el: s } = l;
        if (s && s.offsetWidth === 0) return;
        a.breakpoints && l.setBreakpoint();
        const { allowSlideNext: r, allowSlidePrev: u, snapGrid: f } = l,
          p = l.virtual && l.params.virtual.enabled;
        ((l.allowSlideNext = !0),
          (l.allowSlidePrev = !0),
          l.updateSize(),
          l.updateSlides(),
          l.updateSlidesClasses());
        const g = p && a.loop;
        ((a.slidesPerView === 'auto' || a.slidesPerView > 1) &&
        l.isEnd &&
        !l.isBeginning &&
        !l.params.centeredSlides &&
        !g
          ? l.slideTo(l.slides.length - 1, 0, !1, !0)
          : l.params.loop && !p
            ? l.slideToLoop(l.realIndex, 0, !1, !0)
            : l.slideTo(l.activeIndex, 0, !1, !0),
          l.autoplay &&
            l.autoplay.running &&
            l.autoplay.paused &&
            (clearTimeout(l.autoplay.resizeTimeout),
            (l.autoplay.resizeTimeout = setTimeout(() => {
              l.autoplay &&
                l.autoplay.running &&
                l.autoplay.paused &&
                l.autoplay.resume();
            }, 500))),
          (l.allowSlidePrev = u),
          (l.allowSlideNext = r),
          l.params.watchOverflow && f !== l.snapGrid && l.checkOverflow());
      }
      function Gb(l) {
        const a = this;
        a.enabled &&
          (a.allowClick ||
            (a.params.preventClicks && l.preventDefault(),
            a.params.preventClicksPropagation &&
              a.animating &&
              (l.stopPropagation(), l.stopImmediatePropagation())));
      }
      function Vb() {
        const l = this,
          { wrapperEl: a, rtlTranslate: s, enabled: r } = l;
        if (!r) return;
        ((l.previousTranslate = l.translate),
          l.isHorizontal()
            ? (l.translate = -a.scrollLeft)
            : (l.translate = -a.scrollTop),
          l.translate === 0 && (l.translate = 0),
          l.updateActiveIndex(),
          l.updateSlidesClasses());
        let u;
        const f = l.maxTranslate() - l.minTranslate();
        (f === 0 ? (u = 0) : (u = (l.translate - l.minTranslate()) / f),
          u !== l.progress && l.updateProgress(s ? -l.translate : l.translate),
          l.emit('setTranslate', l.translate, !1));
      }
      function Kb(l) {
        const a = this;
        (Es(a, l.target),
          !(
            a.params.cssMode ||
            (a.params.slidesPerView !== 'auto' && !a.params.autoHeight)
          ) && a.update());
      }
      function qb() {
        const l = this;
        l.documentTouchHandlerProceeded ||
          ((l.documentTouchHandlerProceeded = !0),
          l.params.touchReleaseOnEdges && (l.el.style.touchAction = 'auto'));
      }
      const _p = (l, a) => {
        const s = on(),
          { params: r, el: u, wrapperEl: f, device: p } = l,
          g = !!r.nested,
          d = a === 'on' ? 'addEventListener' : 'removeEventListener',
          h = a;
        !u ||
          typeof u == 'string' ||
          (s[d]('touchstart', l.onDocumentTouchStart, {
            passive: !1,
            capture: g,
          }),
          u[d]('touchstart', l.onTouchStart, { passive: !1 }),
          u[d]('pointerdown', l.onTouchStart, { passive: !1 }),
          s[d]('touchmove', l.onTouchMove, { passive: !1, capture: g }),
          s[d]('pointermove', l.onTouchMove, { passive: !1, capture: g }),
          s[d]('touchend', l.onTouchEnd, { passive: !0 }),
          s[d]('pointerup', l.onTouchEnd, { passive: !0 }),
          s[d]('pointercancel', l.onTouchEnd, { passive: !0 }),
          s[d]('touchcancel', l.onTouchEnd, { passive: !0 }),
          s[d]('pointerout', l.onTouchEnd, { passive: !0 }),
          s[d]('pointerleave', l.onTouchEnd, { passive: !0 }),
          s[d]('contextmenu', l.onTouchEnd, { passive: !0 }),
          (r.preventClicks || r.preventClicksPropagation) &&
            u[d]('click', l.onClick, !0),
          r.cssMode && f[d]('scroll', l.onScroll),
          r.updateOnWindowResize
            ? l[h](
                p.ios || p.android
                  ? 'resize orientationchange observerUpdate'
                  : 'resize observerUpdate',
                ap,
                !0
              )
            : l[h]('observerUpdate', ap, !0),
          u[d]('load', l.onLoad, { capture: !0 }));
      };
      function Yb() {
        const l = this,
          { params: a } = l;
        ((l.onTouchStart = Hb.bind(l)),
          (l.onTouchMove = Ub.bind(l)),
          (l.onTouchEnd = Bb.bind(l)),
          (l.onDocumentTouchStart = qb.bind(l)),
          a.cssMode && (l.onScroll = Vb.bind(l)),
          (l.onClick = Gb.bind(l)),
          (l.onLoad = Kb.bind(l)),
          _p(l, 'on'));
      }
      function $b() {
        _p(this, 'off');
      }
      var Xb = { attachEvents: Yb, detachEvents: $b };
      const lp = (l, a) => l.grid && a.grid && a.grid.rows > 1;
      function Qb() {
        const l = this,
          { realIndex: a, initialized: s, params: r, el: u } = l,
          f = r.breakpoints;
        if (!f || (f && Object.keys(f).length === 0)) return;
        const p = on(),
          g =
            r.breakpointsBase === 'window' || !r.breakpointsBase
              ? r.breakpointsBase
              : 'container',
          d =
            ['window', 'container'].includes(r.breakpointsBase) ||
            !r.breakpointsBase
              ? l.el
              : p.querySelector(r.breakpointsBase),
          h = l.getBreakpoint(f, g, d);
        if (!h || l.currentBreakpoint === h) return;
        const b = (h in f ? f[h] : void 0) || l.originalParams,
          w = lp(l, r),
          T = lp(l, b),
          _ = l.params.grabCursor,
          O = b.grabCursor,
          D = r.enabled;
        (w && !T
          ? (u.classList.remove(
              `${r.containerModifierClass}grid`,
              `${r.containerModifierClass}grid-column`
            ),
            l.emitContainerClasses())
          : !w &&
            T &&
            (u.classList.add(`${r.containerModifierClass}grid`),
            ((b.grid.fill && b.grid.fill === 'column') ||
              (!b.grid.fill && r.grid.fill === 'column')) &&
              u.classList.add(`${r.containerModifierClass}grid-column`),
            l.emitContainerClasses()),
          _ && !O ? l.unsetGrabCursor() : !_ && O && l.setGrabCursor(),
          ['navigation', 'pagination', 'scrollbar'].forEach(W => {
            if (typeof b[W] > 'u') return;
            const k = r[W] && r[W].enabled,
              V = b[W] && b[W].enabled;
            (k && !V && l[W].disable(), !k && V && l[W].enable());
          }));
        const q = b.direction && b.direction !== r.direction,
          U = r.loop && (b.slidesPerView !== r.slidesPerView || q),
          Y = r.loop;
        (q && s && l.changeDirection(), Tt(l.params, b));
        const X = l.params.enabled,
          B = l.params.loop;
        (Object.assign(l, {
          allowTouchMove: l.params.allowTouchMove,
          allowSlideNext: l.params.allowSlideNext,
          allowSlidePrev: l.params.allowSlidePrev,
        }),
          D && !X ? l.disable() : !D && X && l.enable(),
          (l.currentBreakpoint = h),
          l.emit('_beforeBreakpoint', b),
          s &&
            (U
              ? (l.loopDestroy(), l.loopCreate(a), l.updateSlides())
              : !Y && B
                ? (l.loopCreate(a), l.updateSlides())
                : Y && !B && l.loopDestroy()),
          l.emit('breakpoint', b));
      }
      function Zb(l, a = 'window', s) {
        if (!l || (a === 'container' && !s)) return;
        let r = !1;
        const u = at(),
          f = a === 'window' ? u.innerHeight : s.clientHeight,
          p = Object.keys(l).map(g => {
            if (typeof g == 'string' && g.indexOf('@') === 0) {
              const d = parseFloat(g.substr(1));
              return { value: f * d, point: g };
            }
            return { value: g, point: g };
          });
        p.sort((g, d) => parseInt(g.value, 10) - parseInt(d.value, 10));
        for (let g = 0; g < p.length; g += 1) {
          const { point: d, value: h } = p[g];
          a === 'window'
            ? u.matchMedia(`(min-width: ${h}px)`).matches && (r = d)
            : h <= s.clientWidth && (r = d);
        }
        return r || 'max';
      }
      var kb = { setBreakpoint: Qb, getBreakpoint: Zb };
      function Jb(l, a) {
        const s = [];
        return (
          l.forEach(r => {
            typeof r == 'object'
              ? Object.keys(r).forEach(u => {
                  r[u] && s.push(a + u);
                })
              : typeof r == 'string' && s.push(a + r);
          }),
          s
        );
      }
      function Fb() {
        const l = this,
          { classNames: a, params: s, rtl: r, el: u, device: f } = l,
          p = Jb(
            [
              'initialized',
              s.direction,
              { 'free-mode': l.params.freeMode && s.freeMode.enabled },
              { autoheight: s.autoHeight },
              { rtl: r },
              { grid: s.grid && s.grid.rows > 1 },
              {
                'grid-column':
                  s.grid && s.grid.rows > 1 && s.grid.fill === 'column',
              },
              { android: f.android },
              { ios: f.ios },
              { 'css-mode': s.cssMode },
              { centered: s.cssMode && s.centeredSlides },
              { 'watch-progress': s.watchSlidesProgress },
            ],
            s.containerModifierClass
          );
        (a.push(...p), u.classList.add(...a), l.emitContainerClasses());
      }
      function Pb() {
        const l = this,
          { el: a, classNames: s } = l;
        !a ||
          typeof a == 'string' ||
          (a.classList.remove(...s), l.emitContainerClasses());
      }
      var Ib = { addClasses: Fb, removeClasses: Pb };
      function Wb() {
        const l = this,
          { isLocked: a, params: s } = l,
          { slidesOffsetBefore: r } = s;
        if (r) {
          const u = l.slides.length - 1,
            f = l.slidesGrid[u] + l.slidesSizesGrid[u] + r * 2;
          l.isLocked = l.size > f;
        } else l.isLocked = l.snapGrid.length === 1;
        (s.allowSlideNext === !0 && (l.allowSlideNext = !l.isLocked),
          s.allowSlidePrev === !0 && (l.allowSlidePrev = !l.isLocked),
          a && a !== l.isLocked && (l.isEnd = !1),
          a !== l.isLocked && l.emit(l.isLocked ? 'lock' : 'unlock'));
      }
      var e1 = { checkOverflow: Wb },
        Eu = {
          init: !0,
          direction: 'horizontal',
          oneWayMovement: !1,
          swiperElementNodeName: 'SWIPER-CONTAINER',
          touchEventsTarget: 'wrapper',
          initialSlide: 0,
          speed: 300,
          cssMode: !1,
          updateOnWindowResize: !0,
          resizeObserver: !0,
          nested: !1,
          createElements: !1,
          eventsPrefix: 'swiper',
          enabled: !0,
          focusableElements:
            'input, select, option, textarea, button, video, label',
          width: null,
          height: null,
          preventInteractionOnTransition: !1,
          userAgent: null,
          url: null,
          edgeSwipeDetection: !1,
          edgeSwipeThreshold: 20,
          autoHeight: !1,
          setWrapperSize: !1,
          virtualTranslate: !1,
          effect: 'slide',
          breakpoints: void 0,
          breakpointsBase: 'window',
          spaceBetween: 0,
          slidesPerView: 1,
          slidesPerGroup: 1,
          slidesPerGroupSkip: 0,
          slidesPerGroupAuto: !1,
          centeredSlides: !1,
          centeredSlidesBounds: !1,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
          normalizeSlideIndex: !0,
          centerInsufficientSlides: !1,
          watchOverflow: !0,
          roundLengths: !1,
          touchRatio: 1,
          touchAngle: 45,
          simulateTouch: !0,
          shortSwipes: !0,
          longSwipes: !0,
          longSwipesRatio: 0.5,
          longSwipesMs: 300,
          followFinger: !0,
          allowTouchMove: !0,
          threshold: 5,
          touchMoveStopPropagation: !1,
          touchStartPreventDefault: !0,
          touchStartForcePreventDefault: !1,
          touchReleaseOnEdges: !1,
          uniqueNavElements: !0,
          resistance: !0,
          resistanceRatio: 0.85,
          watchSlidesProgress: !1,
          grabCursor: !1,
          preventClicks: !0,
          preventClicksPropagation: !0,
          slideToClickedSlide: !1,
          loop: !1,
          loopAddBlankSlides: !0,
          loopAdditionalSlides: 0,
          loopPreventsSliding: !0,
          rewind: !1,
          allowSlidePrev: !0,
          allowSlideNext: !0,
          swipeHandler: null,
          noSwiping: !0,
          noSwipingClass: 'swiper-no-swiping',
          noSwipingSelector: null,
          passiveListeners: !0,
          maxBackfaceHiddenSlides: 10,
          containerModifierClass: 'swiper-',
          slideClass: 'swiper-slide',
          slideBlankClass: 'swiper-slide-blank',
          slideActiveClass: 'swiper-slide-active',
          slideVisibleClass: 'swiper-slide-visible',
          slideFullyVisibleClass: 'swiper-slide-fully-visible',
          slideNextClass: 'swiper-slide-next',
          slidePrevClass: 'swiper-slide-prev',
          wrapperClass: 'swiper-wrapper',
          lazyPreloaderClass: 'swiper-lazy-preloader',
          lazyPreloadPrevNext: 0,
          runCallbacksOnInit: !0,
          _emitClasses: !1,
        };
      function t1(l, a) {
        return function (r = {}) {
          const u = Object.keys(r)[0],
            f = r[u];
          if (typeof f != 'object' || f === null) {
            Tt(a, r);
            return;
          }
          if (
            (l[u] === !0 && (l[u] = { enabled: !0 }),
            u === 'navigation' &&
              l[u] &&
              l[u].enabled &&
              !l[u].prevEl &&
              !l[u].nextEl &&
              (l[u].auto = !0),
            ['pagination', 'scrollbar'].indexOf(u) >= 0 &&
              l[u] &&
              l[u].enabled &&
              !l[u].el &&
              (l[u].auto = !0),
            !(u in l && 'enabled' in f))
          ) {
            Tt(a, r);
            return;
          }
          (typeof l[u] == 'object' &&
            !('enabled' in l[u]) &&
            (l[u].enabled = !0),
            l[u] || (l[u] = { enabled: !1 }),
            Tt(a, r));
        };
      }
      const ou = {
          eventsEmitter: I0,
          update: ub,
          translate: mb,
          transition: bb,
          slide: Ob,
          loop: zb,
          grabCursor: Lb,
          events: Xb,
          breakpoints: kb,
          checkOverflow: e1,
          classes: Ib,
        },
        uu = {};
      let Ou = class si {
        constructor(...a) {
          let s, r;
          (a.length === 1 &&
          a[0].constructor &&
          Object.prototype.toString.call(a[0]).slice(8, -1) === 'Object'
            ? (r = a[0])
            : ([s, r] = a),
            r || (r = {}),
            (r = Tt({}, r)),
            s && !r.el && (r.el = s));
          const u = on();
          if (
            r.el &&
            typeof r.el == 'string' &&
            u.querySelectorAll(r.el).length > 1
          ) {
            const d = [];
            return (
              u.querySelectorAll(r.el).forEach(h => {
                const y = Tt({}, r, { el: h });
                d.push(new si(y));
              }),
              d
            );
          }
          const f = this;
          ((f.__swiper__ = !0),
            (f.support = wp()),
            (f.device = Mp({ userAgent: r.userAgent })),
            (f.browser = Ap()),
            (f.eventsListeners = {}),
            (f.eventsAnyListeners = []),
            (f.modules = [...f.__modules__]),
            r.modules &&
              Array.isArray(r.modules) &&
              f.modules.push(...r.modules));
          const p = {};
          f.modules.forEach(d => {
            d({
              params: r,
              swiper: f,
              extendParams: t1(r, p),
              on: f.on.bind(f),
              once: f.once.bind(f),
              off: f.off.bind(f),
              emit: f.emit.bind(f),
            });
          });
          const g = Tt({}, Eu, p);
          return (
            (f.params = Tt({}, g, uu, r)),
            (f.originalParams = Tt({}, f.params)),
            (f.passedParams = Tt({}, r)),
            f.params &&
              f.params.on &&
              Object.keys(f.params.on).forEach(d => {
                f.on(d, f.params.on[d]);
              }),
            f.params && f.params.onAny && f.onAny(f.params.onAny),
            Object.assign(f, {
              enabled: f.params.enabled,
              el: s,
              classNames: [],
              slides: [],
              slidesGrid: [],
              snapGrid: [],
              slidesSizesGrid: [],
              isHorizontal() {
                return f.params.direction === 'horizontal';
              },
              isVertical() {
                return f.params.direction === 'vertical';
              },
              activeIndex: 0,
              realIndex: 0,
              isBeginning: !0,
              isEnd: !1,
              translate: 0,
              previousTranslate: 0,
              progress: 0,
              velocity: 0,
              animating: !1,
              cssOverflowAdjustment() {
                return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
              },
              allowSlideNext: f.params.allowSlideNext,
              allowSlidePrev: f.params.allowSlidePrev,
              touchEventsData: {
                isTouched: void 0,
                isMoved: void 0,
                allowTouchCallbacks: void 0,
                touchStartTime: void 0,
                isScrolling: void 0,
                currentTranslate: void 0,
                startTranslate: void 0,
                allowThresholdMove: void 0,
                focusableElements: f.params.focusableElements,
                lastClickTime: 0,
                clickTimeout: void 0,
                velocities: [],
                allowMomentumBounce: void 0,
                startMoving: void 0,
                pointerId: null,
                touchId: null,
              },
              allowClick: !0,
              allowTouchMove: f.params.allowTouchMove,
              touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0,
              },
              imagesToLoad: [],
              imagesLoaded: 0,
            }),
            f.emit('_swiper'),
            f.params.init && f.init(),
            f
          );
        }
        getDirectionLabel(a) {
          return this.isHorizontal()
            ? a
            : {
                width: 'height',
                'margin-top': 'margin-left',
                'margin-bottom ': 'margin-right',
                'margin-left': 'margin-top',
                'margin-right': 'margin-bottom',
                'padding-left': 'padding-top',
                'padding-right': 'padding-bottom',
                marginRight: 'marginBottom',
              }[a];
        }
        getSlideIndex(a) {
          const { slidesEl: s, params: r } = this,
            u = ri(s, `.${r.slideClass}, swiper-slide`),
            f = Wh(u[0]);
          return Wh(a) - f;
        }
        getSlideIndexByData(a) {
          return this.getSlideIndex(
            this.slides.find(
              s => s.getAttribute('data-swiper-slide-index') * 1 === a
            )
          );
        }
        getSlideIndexWhenGrid(a) {
          return (
            this.grid &&
              this.params.grid &&
              this.params.grid.rows > 1 &&
              (this.params.grid.fill === 'column'
                ? (a = Math.floor(a / this.params.grid.rows))
                : this.params.grid.fill === 'row' &&
                  (a =
                    a % Math.ceil(this.slides.length / this.params.grid.rows))),
            a
          );
        }
        recalcSlides() {
          const a = this,
            { slidesEl: s, params: r } = a;
          a.slides = ri(s, `.${r.slideClass}, swiper-slide`);
        }
        enable() {
          const a = this;
          a.enabled ||
            ((a.enabled = !0),
            a.params.grabCursor && a.setGrabCursor(),
            a.emit('enable'));
        }
        disable() {
          const a = this;
          a.enabled &&
            ((a.enabled = !1),
            a.params.grabCursor && a.unsetGrabCursor(),
            a.emit('disable'));
        }
        setProgress(a, s) {
          const r = this;
          a = Math.min(Math.max(a, 0), 1);
          const u = r.minTranslate(),
            p = (r.maxTranslate() - u) * a + u;
          (r.translateTo(p, typeof s > 'u' ? 0 : s),
            r.updateActiveIndex(),
            r.updateSlidesClasses());
        }
        emitContainerClasses() {
          const a = this;
          if (!a.params._emitClasses || !a.el) return;
          const s = a.el.className
            .split(' ')
            .filter(
              r =>
                r.indexOf('swiper') === 0 ||
                r.indexOf(a.params.containerModifierClass) === 0
            );
          a.emit('_containerClasses', s.join(' '));
        }
        getSlideClasses(a) {
          const s = this;
          return s.destroyed
            ? ''
            : a.className
                .split(' ')
                .filter(
                  r =>
                    r.indexOf('swiper-slide') === 0 ||
                    r.indexOf(s.params.slideClass) === 0
                )
                .join(' ');
        }
        emitSlidesClasses() {
          const a = this;
          if (!a.params._emitClasses || !a.el) return;
          const s = [];
          (a.slides.forEach(r => {
            const u = a.getSlideClasses(r);
            (s.push({ slideEl: r, classNames: u }),
              a.emit('_slideClass', r, u));
          }),
            a.emit('_slideClasses', s));
        }
        slidesPerViewDynamic(a = 'current', s = !1) {
          const r = this,
            {
              params: u,
              slides: f,
              slidesGrid: p,
              slidesSizesGrid: g,
              size: d,
              activeIndex: h,
            } = r;
          let y = 1;
          if (typeof u.slidesPerView == 'number') return u.slidesPerView;
          if (u.centeredSlides) {
            let b = f[h] ? Math.ceil(f[h].swiperSlideSize) : 0,
              w;
            for (let T = h + 1; T < f.length; T += 1)
              f[T] &&
                !w &&
                ((b += Math.ceil(f[T].swiperSlideSize)),
                (y += 1),
                b > d && (w = !0));
            for (let T = h - 1; T >= 0; T -= 1)
              f[T] &&
                !w &&
                ((b += f[T].swiperSlideSize), (y += 1), b > d && (w = !0));
          } else if (a === 'current')
            for (let b = h + 1; b < f.length; b += 1)
              (s ? p[b] + g[b] - p[h] < d : p[b] - p[h] < d) && (y += 1);
          else for (let b = h - 1; b >= 0; b -= 1) p[h] - p[b] < d && (y += 1);
          return y;
        }
        update() {
          const a = this;
          if (!a || a.destroyed) return;
          const { snapGrid: s, params: r } = a;
          (r.breakpoints && a.setBreakpoint(),
            [...a.el.querySelectorAll('[loading="lazy"]')].forEach(p => {
              p.complete && Es(a, p);
            }),
            a.updateSize(),
            a.updateSlides(),
            a.updateProgress(),
            a.updateSlidesClasses());
          function u() {
            const p = a.rtlTranslate ? a.translate * -1 : a.translate,
              g = Math.min(Math.max(p, a.maxTranslate()), a.minTranslate());
            (a.setTranslate(g), a.updateActiveIndex(), a.updateSlidesClasses());
          }
          let f;
          if (r.freeMode && r.freeMode.enabled && !r.cssMode)
            (u(), r.autoHeight && a.updateAutoHeight());
          else {
            if (
              (r.slidesPerView === 'auto' || r.slidesPerView > 1) &&
              a.isEnd &&
              !r.centeredSlides
            ) {
              const p =
                a.virtual && r.virtual.enabled ? a.virtual.slides : a.slides;
              f = a.slideTo(p.length - 1, 0, !1, !0);
            } else f = a.slideTo(a.activeIndex, 0, !1, !0);
            f || u();
          }
          (r.watchOverflow && s !== a.snapGrid && a.checkOverflow(),
            a.emit('update'));
        }
        changeDirection(a, s = !0) {
          const r = this,
            u = r.params.direction;
          return (
            a || (a = u === 'horizontal' ? 'vertical' : 'horizontal'),
            a === u ||
              (a !== 'horizontal' && a !== 'vertical') ||
              (r.el.classList.remove(`${r.params.containerModifierClass}${u}`),
              r.el.classList.add(`${r.params.containerModifierClass}${a}`),
              r.emitContainerClasses(),
              (r.params.direction = a),
              r.slides.forEach(f => {
                a === 'vertical' ? (f.style.width = '') : (f.style.height = '');
              }),
              r.emit('changeDirection'),
              s && r.update()),
            r
          );
        }
        changeLanguageDirection(a) {
          const s = this;
          (s.rtl && a === 'rtl') ||
            (!s.rtl && a === 'ltr') ||
            ((s.rtl = a === 'rtl'),
            (s.rtlTranslate = s.params.direction === 'horizontal' && s.rtl),
            s.rtl
              ? (s.el.classList.add(`${s.params.containerModifierClass}rtl`),
                (s.el.dir = 'rtl'))
              : (s.el.classList.remove(`${s.params.containerModifierClass}rtl`),
                (s.el.dir = 'ltr')),
            s.update());
        }
        mount(a) {
          const s = this;
          if (s.mounted) return !0;
          let r = a || s.params.el;
          if ((typeof r == 'string' && (r = document.querySelector(r)), !r))
            return !1;
          ((r.swiper = s),
            r.parentNode &&
              r.parentNode.host &&
              r.parentNode.host.nodeName ===
                s.params.swiperElementNodeName.toUpperCase() &&
              (s.isElement = !0));
          const u = () =>
            `.${(s.params.wrapperClass || '').trim().split(' ').join('.')}`;
          let p =
            r && r.shadowRoot && r.shadowRoot.querySelector
              ? r.shadowRoot.querySelector(u())
              : ri(r, u())[0];
          return (
            !p &&
              s.params.createElements &&
              ((p = xu('div', s.params.wrapperClass)),
              r.append(p),
              ri(r, `.${s.params.slideClass}`).forEach(g => {
                p.append(g);
              })),
            Object.assign(s, {
              el: r,
              wrapperEl: p,
              slidesEl:
                s.isElement && !r.parentNode.host.slideSlots
                  ? r.parentNode.host
                  : p,
              hostEl: s.isElement ? r.parentNode.host : r,
              mounted: !0,
              rtl:
                r.dir.toLowerCase() === 'rtl' || Li(r, 'direction') === 'rtl',
              rtlTranslate:
                s.params.direction === 'horizontal' &&
                (r.dir.toLowerCase() === 'rtl' || Li(r, 'direction') === 'rtl'),
              wrongRTL: Li(p, 'display') === '-webkit-box',
            }),
            !0
          );
        }
        init(a) {
          const s = this;
          if (s.initialized || s.mount(a) === !1) return s;
          (s.emit('beforeInit'),
            s.params.breakpoints && s.setBreakpoint(),
            s.addClasses(),
            s.updateSize(),
            s.updateSlides(),
            s.params.watchOverflow && s.checkOverflow(),
            s.params.grabCursor && s.enabled && s.setGrabCursor(),
            s.params.loop && s.virtual && s.params.virtual.enabled
              ? s.slideTo(
                  s.params.initialSlide + s.virtual.slidesBefore,
                  0,
                  s.params.runCallbacksOnInit,
                  !1,
                  !0
                )
              : s.slideTo(
                  s.params.initialSlide,
                  0,
                  s.params.runCallbacksOnInit,
                  !1,
                  !0
                ),
            s.params.loop && s.loopCreate(void 0, !0),
            s.attachEvents());
          const u = [...s.el.querySelectorAll('[loading="lazy"]')];
          return (
            s.isElement &&
              u.push(...s.hostEl.querySelectorAll('[loading="lazy"]')),
            u.forEach(f => {
              f.complete
                ? Es(s, f)
                : f.addEventListener('load', p => {
                    Es(s, p.target);
                  });
            }),
            Tu(s),
            (s.initialized = !0),
            Tu(s),
            s.emit('init'),
            s.emit('afterInit'),
            s
          );
        }
        destroy(a = !0, s = !0) {
          const r = this,
            { params: u, el: f, wrapperEl: p, slides: g } = r;
          return (
            typeof r.params > 'u' ||
              r.destroyed ||
              (r.emit('beforeDestroy'),
              (r.initialized = !1),
              r.detachEvents(),
              u.loop && r.loopDestroy(),
              s &&
                (r.removeClasses(),
                f && typeof f != 'string' && f.removeAttribute('style'),
                p && p.removeAttribute('style'),
                g &&
                  g.length &&
                  g.forEach(d => {
                    (d.classList.remove(
                      u.slideVisibleClass,
                      u.slideFullyVisibleClass,
                      u.slideActiveClass,
                      u.slideNextClass,
                      u.slidePrevClass
                    ),
                      d.removeAttribute('style'),
                      d.removeAttribute('data-swiper-slide-index'));
                  })),
              r.emit('destroy'),
              Object.keys(r.eventsListeners).forEach(d => {
                r.off(d);
              }),
              a !== !1 &&
                (r.el && typeof r.el != 'string' && (r.el.swiper = null),
                B0(r)),
              (r.destroyed = !0)),
            null
          );
        }
        static extendDefaults(a) {
          Tt(uu, a);
        }
        static get extendedDefaults() {
          return uu;
        }
        static get defaults() {
          return Eu;
        }
        static installModule(a) {
          si.prototype.__modules__ || (si.prototype.__modules__ = []);
          const s = si.prototype.__modules__;
          typeof a == 'function' && s.indexOf(a) < 0 && s.push(a);
        }
        static use(a) {
          return Array.isArray(a)
            ? (a.forEach(s => si.installModule(s)), si)
            : (si.installModule(a), si);
        }
      };
      Object.keys(ou).forEach(l => {
        Object.keys(ou[l]).forEach(a => {
          Ou.prototype[a] = ou[l][a];
        });
      });
      Ou.use([F0, P0]);
      const Cp = [
        'eventsPrefix',
        'injectStyles',
        'injectStylesUrls',
        'modules',
        'init',
        '_direction',
        'oneWayMovement',
        'swiperElementNodeName',
        'touchEventsTarget',
        'initialSlide',
        '_speed',
        'cssMode',
        'updateOnWindowResize',
        'resizeObserver',
        'nested',
        'focusableElements',
        '_enabled',
        '_width',
        '_height',
        'preventInteractionOnTransition',
        'userAgent',
        'url',
        '_edgeSwipeDetection',
        '_edgeSwipeThreshold',
        '_freeMode',
        '_autoHeight',
        'setWrapperSize',
        'virtualTranslate',
        '_effect',
        'breakpoints',
        'breakpointsBase',
        '_spaceBetween',
        '_slidesPerView',
        'maxBackfaceHiddenSlides',
        '_grid',
        '_slidesPerGroup',
        '_slidesPerGroupSkip',
        '_slidesPerGroupAuto',
        '_centeredSlides',
        '_centeredSlidesBounds',
        '_slidesOffsetBefore',
        '_slidesOffsetAfter',
        'normalizeSlideIndex',
        '_centerInsufficientSlides',
        '_watchOverflow',
        'roundLengths',
        'touchRatio',
        'touchAngle',
        'simulateTouch',
        '_shortSwipes',
        '_longSwipes',
        'longSwipesRatio',
        'longSwipesMs',
        '_followFinger',
        'allowTouchMove',
        '_threshold',
        'touchMoveStopPropagation',
        'touchStartPreventDefault',
        'touchStartForcePreventDefault',
        'touchReleaseOnEdges',
        'uniqueNavElements',
        '_resistance',
        '_resistanceRatio',
        '_watchSlidesProgress',
        '_grabCursor',
        'preventClicks',
        'preventClicksPropagation',
        '_slideToClickedSlide',
        '_loop',
        'loopAdditionalSlides',
        'loopAddBlankSlides',
        'loopPreventsSliding',
        '_rewind',
        '_allowSlidePrev',
        '_allowSlideNext',
        '_swipeHandler',
        '_noSwiping',
        'noSwipingClass',
        'noSwipingSelector',
        'passiveListeners',
        'containerModifierClass',
        'slideClass',
        'slideActiveClass',
        'slideVisibleClass',
        'slideFullyVisibleClass',
        'slideNextClass',
        'slidePrevClass',
        'slideBlankClass',
        'wrapperClass',
        'lazyPreloaderClass',
        'lazyPreloadPrevNext',
        'runCallbacksOnInit',
        'observer',
        'observeParents',
        'observeSlideChildren',
        'a11y',
        '_autoplay',
        '_controller',
        'coverflowEffect',
        'cubeEffect',
        'fadeEffect',
        'flipEffect',
        'creativeEffect',
        'cardsEffect',
        'hashNavigation',
        'history',
        'keyboard',
        'mousewheel',
        '_navigation',
        '_pagination',
        'parallax',
        '_scrollbar',
        '_thumbs',
        'virtual',
        'zoom',
        'control',
      ];
      function rn(l) {
        return (
          typeof l == 'object' &&
          l !== null &&
          l.constructor &&
          Object.prototype.toString.call(l).slice(8, -1) === 'Object' &&
          !l.__swiper__
        );
      }
      function In(l, a) {
        const s = ['__proto__', 'constructor', 'prototype'];
        Object.keys(a)
          .filter(r => s.indexOf(r) < 0)
          .forEach(r => {
            typeof l[r] > 'u'
              ? (l[r] = a[r])
              : rn(a[r]) && rn(l[r]) && Object.keys(a[r]).length > 0
                ? a[r].__swiper__
                  ? (l[r] = a[r])
                  : In(l[r], a[r])
                : (l[r] = a[r]);
          });
      }
      function Np(l = {}) {
        return (
          l.navigation &&
          typeof l.navigation.nextEl > 'u' &&
          typeof l.navigation.prevEl > 'u'
        );
      }
      function zp(l = {}) {
        return l.pagination && typeof l.pagination.el > 'u';
      }
      function Rp(l = {}) {
        return l.scrollbar && typeof l.scrollbar.el > 'u';
      }
      function Dp(l = '') {
        const a = l
            .split(' ')
            .map(r => r.trim())
            .filter(r => !!r),
          s = [];
        return (
          a.forEach(r => {
            s.indexOf(r) < 0 && s.push(r);
          }),
          s.join(' ')
        );
      }
      function i1(l = '') {
        return l
          ? l.includes('swiper-wrapper')
            ? l
            : `swiper-wrapper ${l}`
          : 'swiper-wrapper';
      }
      function n1({
        swiper: l,
        slides: a,
        passedParams: s,
        changedParams: r,
        nextEl: u,
        prevEl: f,
        scrollbarEl: p,
        paginationEl: g,
      }) {
        const d = r.filter(
            V => V !== 'children' && V !== 'direction' && V !== 'wrapperClass'
          ),
          {
            params: h,
            pagination: y,
            navigation: b,
            scrollbar: w,
            virtual: T,
            thumbs: _,
          } = l;
        let O, D, q, U, Y, X, B, W;
        (r.includes('thumbs') &&
          s.thumbs &&
          s.thumbs.swiper &&
          !s.thumbs.swiper.destroyed &&
          h.thumbs &&
          (!h.thumbs.swiper || h.thumbs.swiper.destroyed) &&
          (O = !0),
          r.includes('controller') &&
            s.controller &&
            s.controller.control &&
            h.controller &&
            !h.controller.control &&
            (D = !0),
          r.includes('pagination') &&
            s.pagination &&
            (s.pagination.el || g) &&
            (h.pagination || h.pagination === !1) &&
            y &&
            !y.el &&
            (q = !0),
          r.includes('scrollbar') &&
            s.scrollbar &&
            (s.scrollbar.el || p) &&
            (h.scrollbar || h.scrollbar === !1) &&
            w &&
            !w.el &&
            (U = !0),
          r.includes('navigation') &&
            s.navigation &&
            (s.navigation.prevEl || f) &&
            (s.navigation.nextEl || u) &&
            (h.navigation || h.navigation === !1) &&
            b &&
            !b.prevEl &&
            !b.nextEl &&
            (Y = !0));
        const k = V => {
          l[V] &&
            (l[V].destroy(),
            V === 'navigation'
              ? (l.isElement && (l[V].prevEl.remove(), l[V].nextEl.remove()),
                (h[V].prevEl = void 0),
                (h[V].nextEl = void 0),
                (l[V].prevEl = void 0),
                (l[V].nextEl = void 0))
              : (l.isElement && l[V].el.remove(),
                (h[V].el = void 0),
                (l[V].el = void 0)));
        };
        (r.includes('loop') &&
          l.isElement &&
          (h.loop && !s.loop
            ? (X = !0)
            : !h.loop && s.loop
              ? (B = !0)
              : (W = !0)),
          d.forEach(V => {
            if (rn(h[V]) && rn(s[V]))
              (Object.assign(h[V], s[V]),
                (V === 'navigation' ||
                  V === 'pagination' ||
                  V === 'scrollbar') &&
                  'enabled' in s[V] &&
                  !s[V].enabled &&
                  k(V));
            else {
              const ee = s[V];
              (ee === !0 || ee === !1) &&
              (V === 'navigation' || V === 'pagination' || V === 'scrollbar')
                ? ee === !1 && k(V)
                : (h[V] = s[V]);
            }
          }),
          d.includes('controller') &&
            !D &&
            l.controller &&
            l.controller.control &&
            h.controller &&
            h.controller.control &&
            (l.controller.control = h.controller.control),
          r.includes('children') && a && T && h.virtual.enabled
            ? ((T.slides = a), T.update(!0))
            : r.includes('virtual') &&
              T &&
              h.virtual.enabled &&
              (a && (T.slides = a), T.update(!0)),
          r.includes('children') && a && h.loop && (W = !0),
          O && _.init() && _.update(!0),
          D && (l.controller.control = h.controller.control),
          q &&
            (l.isElement &&
              (!g || typeof g == 'string') &&
              ((g = document.createElement('div')),
              g.classList.add('swiper-pagination'),
              g.part.add('pagination'),
              l.el.appendChild(g)),
            g && (h.pagination.el = g),
            y.init(),
            y.render(),
            y.update()),
          U &&
            (l.isElement &&
              (!p || typeof p == 'string') &&
              ((p = document.createElement('div')),
              p.classList.add('swiper-scrollbar'),
              p.part.add('scrollbar'),
              l.el.appendChild(p)),
            p && (h.scrollbar.el = p),
            w.init(),
            w.updateSize(),
            w.setTranslate()),
          Y &&
            (l.isElement &&
              ((!u || typeof u == 'string') &&
                ((u = document.createElement('div')),
                u.classList.add('swiper-button-next'),
                tp(u, l.hostEl.constructor.nextButtonSvg),
                u.part.add('button-next'),
                l.el.appendChild(u)),
              (!f || typeof f == 'string') &&
                ((f = document.createElement('div')),
                f.classList.add('swiper-button-prev'),
                tp(f, l.hostEl.constructor.prevButtonSvg),
                f.part.add('button-prev'),
                l.el.appendChild(f))),
            u && (h.navigation.nextEl = u),
            f && (h.navigation.prevEl = f),
            b.init(),
            b.update()),
          r.includes('allowSlideNext') && (l.allowSlideNext = s.allowSlideNext),
          r.includes('allowSlidePrev') && (l.allowSlidePrev = s.allowSlidePrev),
          r.includes('direction') && l.changeDirection(s.direction, !1),
          (X || W) && l.loopDestroy(),
          (B || W) && l.loopCreate(),
          l.update());
      }
      function a1(l = {}, a = !0) {
        const s = { on: {} },
          r = {},
          u = {};
        (In(s, Eu), (s._emitClasses = !0), (s.init = !1));
        const f = {},
          p = Cp.map(d => d.replace(/_/, '')),
          g = Object.assign({}, l);
        return (
          Object.keys(g).forEach(d => {
            typeof l[d] > 'u' ||
              (p.indexOf(d) >= 0
                ? rn(l[d])
                  ? ((s[d] = {}), (u[d] = {}), In(s[d], l[d]), In(u[d], l[d]))
                  : ((s[d] = l[d]), (u[d] = l[d]))
                : d.search(/on[A-Z]/) === 0 && typeof l[d] == 'function'
                  ? a
                    ? (r[`${d[2].toLowerCase()}${d.substr(3)}`] = l[d])
                    : (s.on[`${d[2].toLowerCase()}${d.substr(3)}`] = l[d])
                  : (f[d] = l[d]));
          }),
          ['navigation', 'pagination', 'scrollbar'].forEach(d => {
            (s[d] === !0 && (s[d] = {}), s[d] === !1 && delete s[d]);
          }),
          { params: s, passedParams: u, rest: f, events: r }
        );
      }
      function l1(
        {
          el: l,
          nextEl: a,
          prevEl: s,
          paginationEl: r,
          scrollbarEl: u,
          swiper: f,
        },
        p
      ) {
        (Np(p) &&
          a &&
          s &&
          ((f.params.navigation.nextEl = a),
          (f.originalParams.navigation.nextEl = a),
          (f.params.navigation.prevEl = s),
          (f.originalParams.navigation.prevEl = s)),
          zp(p) &&
            r &&
            ((f.params.pagination.el = r),
            (f.originalParams.pagination.el = r)),
          Rp(p) &&
            u &&
            ((f.params.scrollbar.el = u), (f.originalParams.scrollbar.el = u)),
          f.init(l));
      }
      function s1(l, a, s, r, u) {
        const f = [];
        if (!a) return f;
        const p = d => {
          f.indexOf(d) < 0 && f.push(d);
        };
        if (s && r) {
          const d = r.map(u),
            h = s.map(u);
          (d.join('') !== h.join('') && p('children'),
            r.length !== s.length && p('children'));
        }
        return (
          Cp.filter(d => d[0] === '_')
            .map(d => d.replace(/_/, ''))
            .forEach(d => {
              if (d in l && d in a)
                if (rn(l[d]) && rn(a[d])) {
                  const h = Object.keys(l[d]),
                    y = Object.keys(a[d]);
                  h.length !== y.length
                    ? p(d)
                    : (h.forEach(b => {
                        l[d][b] !== a[d][b] && p(d);
                      }),
                      y.forEach(b => {
                        l[d][b] !== a[d][b] && p(d);
                      }));
                } else l[d] !== a[d] && p(d);
            }),
          f
        );
      }
      const r1 = l => {
        !l ||
          l.destroyed ||
          !l.params.virtual ||
          (l.params.virtual && !l.params.virtual.enabled) ||
          (l.updateSlides(),
          l.updateProgress(),
          l.updateSlidesClasses(),
          l.emit('_virtualUpdated'),
          l.parallax &&
            l.params.parallax &&
            l.params.parallax.enabled &&
            l.parallax.setTranslate());
      };
      function Cs() {
        return (
          (Cs = Object.assign
            ? Object.assign.bind()
            : function (l) {
                for (var a = 1; a < arguments.length; a++) {
                  var s = arguments[a];
                  for (var r in s)
                    Object.prototype.hasOwnProperty.call(s, r) && (l[r] = s[r]);
                }
                return l;
              }),
          Cs.apply(this, arguments)
        );
      }
      function Lp(l) {
        return (
          l.type &&
          l.type.displayName &&
          l.type.displayName.includes('SwiperSlide')
        );
      }
      function jp(l) {
        const a = [];
        return (
          Ye.Children.toArray(l).forEach(s => {
            Lp(s)
              ? a.push(s)
              : s.props &&
                s.props.children &&
                jp(s.props.children).forEach(r => a.push(r));
          }),
          a
        );
      }
      function o1(l) {
        const a = [],
          s = {
            'container-start': [],
            'container-end': [],
            'wrapper-start': [],
            'wrapper-end': [],
          };
        return (
          Ye.Children.toArray(l).forEach(r => {
            if (Lp(r)) a.push(r);
            else if (r.props && r.props.slot && s[r.props.slot])
              s[r.props.slot].push(r);
            else if (r.props && r.props.children) {
              const u = jp(r.props.children);
              u.length > 0
                ? u.forEach(f => a.push(f))
                : s['container-end'].push(r);
            } else s['container-end'].push(r);
          }),
          { slides: a, slots: s }
        );
      }
      function u1(l, a, s) {
        if (!s) return null;
        const r = y => {
            let b = y;
            return (
              y < 0 ? (b = a.length + y) : b >= a.length && (b = b - a.length),
              b
            );
          },
          u = l.isHorizontal()
            ? { [l.rtlTranslate ? 'right' : 'left']: `${s.offset}px` }
            : { top: `${s.offset}px` },
          { from: f, to: p } = s,
          g = l.params.loop ? -a.length : 0,
          d = l.params.loop ? a.length * 2 : a.length,
          h = [];
        for (let y = g; y < d; y += 1) y >= f && y <= p && h.push(a[r(y)]);
        return h.map((y, b) =>
          Ye.cloneElement(y, {
            swiper: l,
            style: u,
            key: y.props.virtualIndex || y.key || `slide-${b}`,
          })
        );
      }
      function el(l, a) {
        return typeof window > 'u'
          ? I.useEffect(l, a)
          : I.useLayoutEffect(l, a);
      }
      const sp = I.createContext(null),
        c1 = I.createContext(null),
        Hp = I.forwardRef(
          (
            {
              className: l,
              tag: a = 'div',
              wrapperTag: s = 'div',
              children: r,
              onSwiper: u,
              ...f
            } = {},
            p
          ) => {
            let g = !1;
            const [d, h] = I.useState('swiper'),
              [y, b] = I.useState(null),
              [w, T] = I.useState(!1),
              _ = I.useRef(!1),
              O = I.useRef(null),
              D = I.useRef(null),
              q = I.useRef(null),
              U = I.useRef(null),
              Y = I.useRef(null),
              X = I.useRef(null),
              B = I.useRef(null),
              W = I.useRef(null),
              { params: k, passedParams: V, rest: ee, events: Q } = a1(f),
              { slides: J, slots: ie } = o1(r),
              de = () => {
                T(!w);
              };
            Object.assign(k.on, {
              _containerClasses($, ne) {
                h(ne);
              },
            });
            const ve = () => {
              (Object.assign(k.on, Q), (g = !0));
              const $ = { ...k };
              if (
                (delete $.wrapperClass,
                (D.current = new Ou($)),
                D.current.virtual && D.current.params.virtual.enabled)
              ) {
                D.current.virtual.slides = J;
                const ne = {
                  cache: !1,
                  slides: J,
                  renderExternal: b,
                  renderExternalUpdate: !1,
                };
                (In(D.current.params.virtual, ne),
                  In(D.current.originalParams.virtual, ne));
              }
            };
            (O.current || ve(),
              D.current && D.current.on('_beforeBreakpoint', de));
            const be = () => {
                g ||
                  !Q ||
                  !D.current ||
                  Object.keys(Q).forEach($ => {
                    D.current.on($, Q[$]);
                  });
              },
              L = () => {
                !Q ||
                  !D.current ||
                  Object.keys(Q).forEach($ => {
                    D.current.off($, Q[$]);
                  });
              };
            (I.useEffect(() => () => {
              D.current && D.current.off('_beforeBreakpoint', de);
            }),
              I.useEffect(() => {
                !_.current &&
                  D.current &&
                  (D.current.emitSlidesClasses(), (_.current = !0));
              }),
              el(() => {
                if ((p && (p.current = O.current), !!O.current))
                  return (
                    D.current.destroyed && ve(),
                    l1(
                      {
                        el: O.current,
                        nextEl: Y.current,
                        prevEl: X.current,
                        paginationEl: B.current,
                        scrollbarEl: W.current,
                        swiper: D.current,
                      },
                      k
                    ),
                    u && !D.current.destroyed && u(D.current),
                    () => {
                      D.current &&
                        !D.current.destroyed &&
                        D.current.destroy(!0, !1);
                    }
                  );
              }, []),
              el(() => {
                be();
                const $ = s1(V, q.current, J, U.current, ne => ne.key);
                return (
                  (q.current = V),
                  (U.current = J),
                  $.length &&
                    D.current &&
                    !D.current.destroyed &&
                    n1({
                      swiper: D.current,
                      slides: J,
                      passedParams: V,
                      changedParams: $,
                      nextEl: Y.current,
                      prevEl: X.current,
                      scrollbarEl: W.current,
                      paginationEl: B.current,
                    }),
                  () => {
                    L();
                  }
                );
              }),
              el(() => {
                r1(D.current);
              }, [y]));
            function Z() {
              return k.virtual
                ? u1(D.current, J, y)
                : J.map(($, ne) =>
                    Ye.cloneElement($, {
                      swiper: D.current,
                      swiperSlideIndex: ne,
                    })
                  );
            }
            return Ye.createElement(
              a,
              Cs({ ref: O, className: Dp(`${d}${l ? ` ${l}` : ''}`) }, ee),
              Ye.createElement(
                c1.Provider,
                { value: D.current },
                ie['container-start'],
                Ye.createElement(
                  s,
                  { className: i1(k.wrapperClass) },
                  ie['wrapper-start'],
                  Z(),
                  ie['wrapper-end']
                ),
                Np(k) &&
                  Ye.createElement(
                    Ye.Fragment,
                    null,
                    Ye.createElement('div', {
                      ref: X,
                      className: 'swiper-button-prev',
                    }),
                    Ye.createElement('div', {
                      ref: Y,
                      className: 'swiper-button-next',
                    })
                  ),
                Rp(k) &&
                  Ye.createElement('div', {
                    ref: W,
                    className: 'swiper-scrollbar',
                  }),
                zp(k) &&
                  Ye.createElement('div', {
                    ref: B,
                    className: 'swiper-pagination',
                  }),
                ie['container-end']
              )
            );
          }
        );
      Hp.displayName = 'Swiper';
      const Up = I.forwardRef(
        (
          {
            tag: l = 'div',
            children: a,
            className: s = '',
            swiper: r,
            zoom: u,
            lazy: f,
            virtualIndex: p,
            swiperSlideIndex: g,
            ...d
          } = {},
          h
        ) => {
          const y = I.useRef(null),
            [b, w] = I.useState('swiper-slide'),
            [T, _] = I.useState(!1);
          function O(Y, X, B) {
            X === y.current && w(B);
          }
          (el(() => {
            if (
              (typeof g < 'u' && (y.current.swiperSlideIndex = g),
              h && (h.current = y.current),
              !(!y.current || !r))
            ) {
              if (r.destroyed) {
                b !== 'swiper-slide' && w('swiper-slide');
                return;
              }
              return (
                r.on('_slideClass', O),
                () => {
                  r && r.off('_slideClass', O);
                }
              );
            }
          }),
            el(() => {
              r && y.current && !r.destroyed && w(r.getSlideClasses(y.current));
            }, [r]));
          const D = {
              isActive: b.indexOf('swiper-slide-active') >= 0,
              isVisible: b.indexOf('swiper-slide-visible') >= 0,
              isPrev: b.indexOf('swiper-slide-prev') >= 0,
              isNext: b.indexOf('swiper-slide-next') >= 0,
            },
            q = () => (typeof a == 'function' ? a(D) : a),
            U = () => {
              _(!0);
            };
          return Ye.createElement(
            l,
            Cs(
              {
                ref: y,
                className: Dp(`${b}${s ? ` ${s}` : ''}`),
                'data-swiper-slide-index': p,
                onLoad: U,
              },
              d
            ),
            u &&
              Ye.createElement(
                sp.Provider,
                { value: D },
                Ye.createElement(
                  'div',
                  {
                    className: 'swiper-zoom-container',
                    'data-swiper-zoom': typeof u == 'number' ? u : void 0,
                  },
                  q(),
                  f &&
                    !T &&
                    Ye.createElement('div', {
                      className: 'swiper-lazy-preloader',
                    })
                )
              ),
            !u &&
              Ye.createElement(
                sp.Provider,
                { value: D },
                q(),
                f &&
                  !T &&
                  Ye.createElement('div', {
                    className: 'swiper-lazy-preloader',
                  })
              )
          );
        }
      );
      Up.displayName = 'SwiperSlide';
      const f1 = 'wrap_Ug-sc',
        d1 = 'viewport_w-Gmq',
        h1 = 'slideItem_iuKFJ',
        p1 = 'controls_Zh-IE',
        m1 = 'controlsRow_q1Wh2',
        g1 = 'indicator_2OoUy',
        v1 = 'segment_tso5k',
        y1 = 'segmentActive_SG4yL',
        b1 = 'footer_nYQiu',
        S1 = 'arrows_OX-so',
        x1 = 'arrowHit_-t5bk',
        T1 = 'arrowHitDisabled_riq92',
        E1 = 'arrow_WSMSS',
        w1 = 'arrowIcon_gdrOY',
        M1 = 'arrowPrev_jqY0c',
        A1 = 'arrowNext_4HESO',
        He = {
          wrap: f1,
          viewport: d1,
          slideItem: h1,
          controls: p1,
          controlsRow: m1,
          indicator: g1,
          segment: v1,
          segmentActive: y1,
          footer: b1,
          arrows: S1,
          arrowHit: x1,
          arrowHitDisabled: T1,
          arrow: E1,
          arrowIcon: w1,
          arrowPrev: M1,
          arrowNext: A1,
        };
      function rp(l, a) {
        const [s, r] = I.useState(l);
        return (
          I.useEffect(() => {
            const u = () => {
              if (a === 2560) {
                const p =
                  document.querySelector('.t1-page')?.clientWidth ??
                  document.documentElement.clientWidth;
                r((l / 2560) * p);
              } else r((l / 750) * window.innerWidth);
            };
            return (
              u(),
              window.addEventListener('resize', u),
              () => window.removeEventListener('resize', u)
            );
          }, [l, a]),
          s
        );
      }
      function O1({ activeIndex: l, total: a, onPrev: s, onNext: r }) {
        const u = l <= 0,
          f = l >= a - 1;
        return A.jsxs('div', {
          className: He.arrows,
          children: [
            A.jsx('span', {
              className: `${He.arrowHit} ${u ? He.arrowHitDisabled : ''}`,
              children: A.jsx('button', {
                type: 'button',
                className: He.arrow,
                'aria-label': 'Previous',
                disabled: u,
                onClick: s,
                children: A.jsx('span', {
                  className: `${He.arrowIcon} ${He.arrowPrev}`,
                  'aria-hidden': 'true',
                }),
              }),
            }),
            A.jsx('span', {
              className: `${He.arrowHit} ${f ? He.arrowHitDisabled : ''}`,
              children: A.jsx('button', {
                type: 'button',
                className: He.arrow,
                'aria-label': 'Next',
                disabled: f,
                onClick: r,
                children: A.jsx('span', {
                  className: `${He.arrowIcon} ${He.arrowNext}`,
                  'aria-hidden': 'true',
                }),
              }),
            }),
          ],
        });
      }
      const Bp = I.forwardRef(function (
        {
          variant: a = 'pc',
          slides: s,
          pcSlideWidth: r = 1228,
          pcSlideHeight: u = 610,
          mbSlideWidth: f = 630,
          mbSlideHeight: p = 420,
          footer: g,
          showControls: d = !0,
          autoplay: h = !1,
          autoplayDelay: y = 4e3,
          onIndexChange: b,
          className: w,
        },
        T
      ) {
        const _ = I.useRef(null),
          O = a === 'pc',
          D = s.length,
          [q, U] = I.useState(0),
          [Y, X] = I.useState(!1),
          B = rp(O ? (2560 - r) / 2 : 60, O ? 2560 : 750),
          W = rp(O ? 16 : 10.5, O ? 2560 : 750),
          k = I.useCallback(
            ee => {
              ee < 0 || ee >= D || _.current?.slideTo(ee);
            },
            [D]
          ),
          V = I.useCallback(() => {
            const ee = _.current;
            if (!ee || ee.destroyed) return;
            const Q = ee.activeIndex >= D - 1 ? 0 : ee.activeIndex + 1;
            ee.slideTo(Q);
          }, [D]);
        return (
          I.useImperativeHandle(T, () => ({ slideTo: k, slideNext: V }), [
            k,
            V,
          ]),
          I.useEffect(() => {
            if (!h || Y || D <= 1) return;
            const ee = window.setTimeout(() => {
              const Q = _.current;
              if (!Q || Q.destroyed || Q.animating) return;
              const J = Q.activeIndex >= D - 1 ? 0 : Q.activeIndex + 1;
              Q.slideTo(J);
            }, y);
            return () => window.clearTimeout(ee);
          }, [h, y, Y, D, q]),
          A.jsxs('div', {
            className: `${He.wrap} ${O ? He.pcWrap : He.mbWrap} ${w ?? ''}`,
            style: {
              '--t1-slide-w': O ? yu(r) : bu(f),
              '--t1-slide-h': O ? yu(u) : bu(p),
            },
            onMouseEnter: () => {
              h && X(!0);
            },
            onMouseLeave: () => {
              h && X(!1);
            },
            children: [
              A.jsx('div', {
                className: He.viewport,
                children: A.jsx(Hp, {
                  slidesPerView: 'auto',
                  spaceBetween: W,
                  slidesOffsetBefore: B,
                  slidesOffsetAfter: B,
                  speed: 600,
                  resistanceRatio: 0.65,
                  roundLengths: !O,
                  onSwiper: ee => {
                    _.current = ee;
                  },
                  onSlideChange: ee => {
                    (U(ee.activeIndex), b?.(ee.activeIndex));
                  },
                  onSlideChangeTransitionEnd: ee => {
                    U(ee.activeIndex);
                  },
                  children: s.map((ee, Q) =>
                    A.jsx(
                      Up,
                      {
                        className: He.slideItem,
                        onClick: () => k(Q),
                        children: ee,
                      },
                      Q
                    )
                  ),
                }),
              }),
              d
                ? A.jsxs('div', {
                    className: He.controls,
                    children: [
                      A.jsxs('div', {
                        className: He.controlsRow,
                        children: [
                          A.jsx('div', {
                            className: He.indicator,
                            children: s.map((ee, Q) =>
                              A.jsx(
                                'button',
                                {
                                  type: 'button',
                                  className: `${He.segment} ${Q === q ? He.segmentActive : ''}`,
                                  'aria-label': `Go to slide ${Q + 1}`,
                                  'aria-current': Q === q,
                                  onClick: () => k(Q),
                                },
                                Q
                              )
                            ),
                          }),
                          A.jsx(O1, {
                            activeIndex: q,
                            total: D,
                            onPrev: () => k(q - 1),
                            onNext: () => k(q + 1),
                          }),
                        ],
                      }),
                      g
                        ? A.jsx('div', { className: He.footer, children: g })
                        : null,
                    ],
                  })
                : null,
            ],
          })
        );
      });
      Bp.displayName = 'T1Carousel';
      const _1 = 'section_ttC1B',
        C1 = 'head_-Gygu',
        N1 = 'title_VqOb3',
        z1 = 'body_YPqKD',
        R1 = 'slide_uei1D',
        D1 = 'slideMedia_ep1UZ',
        L1 = 'caption_rt1v0',
        j1 = 'captionName_KTKId',
        H1 = 'captionBody_JRwdz',
        ai = {
          section: _1,
          head: C1,
          title: N1,
          body: z1,
          slide: R1,
          slideMedia: D1,
          caption: L1,
          captionName: j1,
          captionBody: H1,
        };
      function ji({
        variant: l = 'pc',
        titleKey: a,
        bodyKey: s,
        imageKeys: r,
        slidesTextKey: u,
        headPosition: f = 'top',
        className: p,
        bgColor: g,
        mediaKind: d = 'image',
      }) {
        const { t: h } = Je(),
          [y, b] = I.useState(0),
          w = I.useRef(null),
          T = d === 'video',
          _ = u ? (h(u, { returnObjects: !0 }) ?? []) : [],
          O = Array.isArray(_) ? _[y] : void 0,
          D = A.jsxs('div', {
            className: ai.head,
            children: [
              A.jsx(_e, { as: 'h2', className: ai.title, html: h(a) }),
              s && A.jsx(_e, { className: ai.body, html: h(s) }),
            ],
          });
        return A.jsxs('section', {
          className: `${ai.section} ${p ?? ''}`,
          style: g ? { background: g } : void 0,
          children: [
            f === 'top' ? D : null,
            A.jsx(Bp, {
              ref: w,
              variant: l,
              autoplay: !T,
              onIndexChange: b,
              footer:
                O?.name || O?.body
                  ? A.jsxs('div', {
                      className: ai.caption,
                      children: [
                        A.jsx(_e, { className: ai.captionName, html: O.name }),
                        A.jsx(_e, { className: ai.captionBody, html: O.body }),
                      ],
                    })
                  : null,
              slides: r.map((q, U) =>
                A.jsx(
                  'div',
                  {
                    className: ai.slide,
                    children: A.jsx(Et, {
                      className: ai.slideMedia,
                      imageKey: q,
                      variant: l,
                      kind: d,
                      loop: !T,
                      active: T ? U === y : void 0,
                      onEnded: T
                        ? () => {
                            U === y && w.current?.slideNext();
                          }
                        : void 0,
                      pcAspectRatio: '1228/610',
                      mobileAspectRatio: '630/420',
                    }),
                  },
                  q
                )
              ),
            }),
            f === 'bottom' ? D : null,
          ],
        });
      }
      const U1 = 'section_rZtyP',
        B1 = { section: U1 },
        G1 = [
          'section5Slide1',
          'section5Slide2',
          'section5Slide3',
          'section5Slide4',
          'section5Slide5',
        ];
      function Gp({ variant: l = 'pc' }) {
        return A.jsx(ji, {
          variant: l,
          titleKey: 'section5.title',
          bodyKey: 'section5.body',
          imageKeys: G1,
          slidesTextKey: 'section5.slides',
          mediaKind: 'video',
          bgColor: '#050606',
          className: B1.section,
        });
      }
      const V1 = 'section_C-A2b',
        K1 = 'head_ZPZwV',
        q1 = 'title_-P9mg',
        Y1 = 'body_xUlBS',
        $1 = 'panel_2FLdG',
        X1 = 'panelMedia_GvrUJ',
        Fn = {
          section: V1,
          head: K1,
          title: q1,
          body: Y1,
          panel: $1,
          panelMedia: X1,
        };
      function Hi({
        variant: l = 'pc',
        imageKey: a,
        titleKey: s,
        bodyKey: r,
        pcWidth: u = 1228,
        pcHeight: f = 750,
        mbWidth: p = 630,
        mbHeight: g = 420,
        className: d,
        bgColor: h,
        mediaKind: y = 'image',
      }) {
        const { t: b } = Je(),
          w = l === 'mb';
        return A.jsxs('section', {
          className: `${Fn.section} ${d ?? ''}`,
          style: h ? { background: h } : void 0,
          children: [
            A.jsxs('div', {
              className: Fn.head,
              children: [
                A.jsx(_e, { as: 'h2', className: Fn.title, html: b(s) }),
                r && A.jsx(_e, { className: Fn.body, html: b(r) }),
              ],
            }),
            A.jsx('div', {
              className: Fn.panel,
              style: {
                width: w
                  ? `calc(${p} / 750 * 100vw)`
                  : `calc(${u} / 2560 * 100 * var(--t1-pc-vw, 1vw))`,
                height: w
                  ? `calc(${g} / 750 * 100vw)`
                  : `calc(${f} / 2560 * 100 * var(--t1-pc-vw, 1vw))`,
              },
              children: A.jsx(Et, {
                className: Fn.panelMedia,
                imageKey: a,
                variant: l,
                kind: y,
                pcAspectRatio: `${u}/${f}`,
                mobileAspectRatio: `${p}/${g}`,
              }),
            }),
          ],
        });
      }
      function Vp({ variant: l = 'pc' }) {
        return A.jsx(Hi, {
          variant: l,
          imageKey: 'section6Media',
          titleKey: 'section6.title',
          bodyKey: 'section6.body',
          mediaKind: 'video',
          bgColor: '#050606',
        });
      }
      const Q1 = ['section7Slide1', 'section7Slide2', 'section7Slide3'];
      function Kp({ variant: l = 'pc' }) {
        return A.jsx(ji, {
          variant: l,
          titleKey: 'section7.title',
          bodyKey: 'section7.body',
          imageKeys: Q1,
          slidesTextKey: 'section7.slides',
          bgColor: '#060606',
        });
      }
      const Z1 = 'section_Riorp',
        k1 = 'bg_VsYvD',
        J1 = 'mask_c4Pje',
        F1 = 'content_MnwBp',
        P1 = 'title_QyF--',
        I1 = 'body_ZvDVJ',
        Pn = {
          section: Z1,
          bg: k1,
          mask: J1,
          content: F1,
          title: P1,
          body: I1,
        };
      function _u({
        variant: l = 'pc',
        imageKey: a,
        titleKey: s,
        bodyKey: r,
        maskOpacity: u = 0,
        pcHeight: f = 1200,
        mbHeight: p = 1e3,
        className: g,
        bgColor: d,
        mediaKind: h = 'image',
      }) {
        const { t: y } = Je(),
          b = l === 'mb';
        return A.jsxs('section', {
          className: `${Pn.section} ${g ?? ''}`,
          style: {
            height: b
              ? `calc(${p} / 750 * 100vw)`
              : `calc(${f} / 2560 * 100 * var(--t1-pc-vw, 1vw))`,
            ...(d ? { background: d } : {}),
          },
          children: [
            A.jsx(Et, {
              className: Pn.bg,
              imageKey: a,
              variant: l,
              kind: h,
              pcAspectRatio: `2560/${f}`,
              mobileAspectRatio: `750/${p}`,
            }),
            u > 0 &&
              A.jsx('div', {
                className: Pn.mask,
                style: { background: `rgba(0, 0, 0, ${u})` },
              }),
            A.jsxs('div', {
              className: Pn.content,
              children: [
                A.jsx(_e, { as: 'h2', className: Pn.title, html: y(s) }),
                r && A.jsx(_e, { className: Pn.body, html: y(r) }),
              ],
            }),
          ],
        });
      }
      function qp({ variant: l = 'pc' }) {
        return A.jsx(_u, {
          variant: l,
          imageKey: 'section8Bg',
          titleKey: 'section8.title',
          bodyKey: 'section8.body',
          gradientMask: !0,
        });
      }
      function Yp({ variant: l = 'pc' }) {
        return A.jsx(Hi, {
          variant: l,
          imageKey: 'section9Media',
          titleKey: 'section9.title',
          bodyKey: 'section9.body',
          mediaKind: 'video',
          bgColor: '#0B0B0B',
        });
      }
      function $p({ variant: l = 'pc' }) {
        return A.jsx(Hi, {
          variant: l,
          imageKey: 'section10Bg',
          titleKey: 'section10.title',
          bodyKey: 'section10.body',
          mediaKind: 'video',
        });
      }
      const W1 = ['section11Slide1', 'section11Slide2'];
      function Xp({ variant: l = 'pc' }) {
        return A.jsx(ji, {
          variant: l,
          titleKey: 'section11.title',
          bodyKey: 'section11.body',
          imageKeys: W1,
          slidesTextKey: 'section11.slides',
          bgColor: '#0C0C0C',
        });
      }
      function Qp({ variant: l = 'pc' }) {
        return A.jsx(_u, {
          variant: l,
          imageKey: 'section12Bg',
          titleKey: 'section12.title',
          bodyKey: 'section12.body',
          gradientMask: !0,
        });
      }
      const eS = 'section_eojb5',
        tS = 'mbSection_o0kFC',
        iS = 'content_er8Xv',
        nS = 'body_TwMKm',
        aS = 'title_-SEAR',
        lS = 'media_Kk-H1',
        sS = 'video_48L1J',
        an = {
          section: eS,
          mbSection: tS,
          content: iS,
          body: nS,
          title: aS,
          media: lS,
          video: sS,
        };
      function Zp({ variant: l = 'pc' }) {
        const { t: a } = Je(),
          s = l === 'mb';
        return A.jsxs('section', {
          className: `${an.section} ${s ? an.mbSection : ''}`,
          children: [
            A.jsxs('div', {
              className: an.content,
              children: [
                A.jsx(_e, { className: an.body, html: a('section13.body') }),
                A.jsx(_e, {
                  as: 'h2',
                  className: an.title,
                  html: a('section13.title'),
                }),
              ],
            }),
            A.jsx('div', {
              className: an.media,
              children: A.jsx(Et, {
                className: an.video,
                imageKey: 'section13Bg',
                variant: l,
                kind: 'video',
                pcAspectRatio: '2560/1200',
                mobileAspectRatio: '750/1000',
              }),
            }),
          ],
        });
      }
      function kp({ variant: l = 'pc' }) {
        return A.jsx(Hi, {
          variant: l,
          imageKey: 'section14Media',
          titleKey: 'section14.title',
          bodyKey: 'section14.body',
          mediaKind: 'video',
        });
      }
      const rS = ['section15Slide1', 'section15Slide2', 'section15Slide3'];
      function Jp({ variant: l = 'pc' }) {
        return A.jsx(ji, {
          variant: l,
          titleKey: 'section15.title',
          bodyKey: 'section15.body',
          imageKeys: rS,
        });
      }
      function Fp({ variant: l = 'pc' }) {
        return A.jsx(Hi, {
          variant: l,
          imageKey: 'section16Media',
          titleKey: 'section16.title',
          bodyKey: 'section16.body',
          mediaKind: 'video',
        });
      }
      const oS = [
        'section17Slide1',
        'section17Slide2',
        'section17Slide3',
        'section17Slide4',
      ];
      function Pp({ variant: l = 'pc' }) {
        return A.jsx(ji, {
          variant: l,
          titleKey: 'section17.title',
          bodyKey: 'section17.body',
          imageKeys: oS,
          bgColor: '#0C0C0C',
        });
      }
      function Ip({ variant: l = 'pc' }) {
        return A.jsx(Hi, {
          variant: l,
          imageKey: 'section18Media',
          titleKey: 'section18.title',
          bodyKey: 'section18.body',
          mediaKind: 'video',
        });
      }
      const uS = ['section19Slide1', 'section19Slide2', 'section19Slide3'];
      function Wp({ variant: l = 'pc' }) {
        return A.jsx(ji, {
          variant: l,
          titleKey: 'section19.title',
          bodyKey: 'section19.body',
          imageKeys: uS,
        });
      }
      const cS = ['section20Slide1', 'section20Slide2', 'section20Slide3'];
      function em({ variant: l = 'pc' }) {
        return A.jsx(ji, {
          variant: l,
          titleKey: 'section20.title',
          bodyKey: 'section20.body',
          imageKeys: cS,
        });
      }
      const fS = 'section_Lp50J',
        dS = 'mbSection_OCPxC',
        hS = 'content_2HqKx',
        pS = 'title_3rxnb',
        mS = 'body_O2HP5',
        gS = 'media_zz-y3',
        vS = 'video_dp2Qd',
        ln = {
          section: fS,
          mbSection: dS,
          content: hS,
          title: pS,
          body: mS,
          media: gS,
          video: vS,
        };
      function tm({ variant: l = 'pc' }) {
        const { t: a } = Je(),
          s = l === 'mb';
        return A.jsxs('section', {
          className: `${ln.section} ${s ? ln.mbSection : ''}`,
          children: [
            A.jsxs('div', {
              className: ln.content,
              children: [
                A.jsx(_e, {
                  as: 'h2',
                  className: ln.title,
                  html: a('section21.title'),
                }),
                A.jsx(_e, { className: ln.body, html: a('section21.body') }),
              ],
            }),
            A.jsx('div', {
              className: ln.media,
              children: A.jsx(Et, {
                className: ln.video,
                imageKey: 'section21Bg',
                variant: l,
                kind: 'video',
                pcAspectRatio: '2560/1200',
                mobileAspectRatio: '750/1000',
              }),
            }),
          ],
        });
      }
      const yS = 'section_UhB38',
        bS = 'head_5QAPn',
        SS = 'title_SORpj',
        xS = 'body_zOHwA',
        TS = 'panel_YtX0K',
        ES = 'media_fks86',
        wS = 'mediaActive_EPmOB',
        MS = 'mediaImg_QrIgE',
        AS = 'tabs_zV5JV',
        OS = 'slider_6d8iZ',
        _S = 'sliderReady_X4Rnu',
        CS = 'tab_hcv2U',
        NS = 'tabActive_p-YyH',
        ct = {
          section: yS,
          head: bS,
          title: SS,
          body: xS,
          panel: TS,
          media: ES,
          mediaActive: wS,
          mediaImg: MS,
          tabs: AS,
          slider: OS,
          sliderReady: _S,
          tab: CS,
          tabActive: NS,
        },
        zS = [
          'section22Slide1',
          'section22Slide2',
          'section22Slide3',
          'section22Slide4',
        ];
      function im({ variant: l = 'pc' }) {
        const { t: a } = Je(),
          s = l === 'mb',
          [r, u] = I.useState(0),
          [f, p] = I.useState({ x: 0, w: 0 }),
          [g, d] = I.useState(!1),
          h = I.useRef(null),
          y = I.useRef([]),
          b = I.useRef(r);
        b.current = r;
        const w = a('section22.tabs', { returnObjects: !0 }) ?? [],
          T = Array.isArray(w) ? w.length : 0;
        I.useLayoutEffect(() => {
          const O = h.current;
          if (!O) return;
          const D = () => {
            const U = y.current[r];
            if (!U) return;
            const Y = U.offsetLeft,
              X = U.offsetWidth;
            (p(B => (B.x === Y && B.w === X ? B : { x: Y, w: X })), d(!0));
          };
          D();
          const q = new ResizeObserver(D);
          return (q.observe(O), () => q.disconnect());
        }, [r, T, l]);
        const _ = O => {
          O !== b.current || T <= 1 || u(D => (D + 1) % T);
        };
        return A.jsxs('section', {
          className: `${ct.section} ${s ? ct.mbSection : ''}`,
          children: [
            A.jsxs('div', {
              className: ct.head,
              children: [
                A.jsx(_e, {
                  as: 'h2',
                  className: ct.title,
                  html: a('section22.title'),
                }),
                A.jsx(_e, { className: ct.body, html: a('section22.body') }),
              ],
            }),
            A.jsx('div', {
              className: ct.panel,
              children: zS.map((O, D) =>
                A.jsx(
                  'div',
                  {
                    className: `${ct.media} ${D === r ? ct.mediaActive : ''}`,
                    'aria-hidden': D !== r,
                    children: A.jsx(Et, {
                      className: ct.mediaImg,
                      imageKey: O,
                      variant: l,
                      kind: 'video',
                      loop: !1,
                      active: D === r,
                      onEnded: () => _(D),
                      pcAspectRatio: '1220/646',
                      mobileAspectRatio: '630/420',
                    }),
                  },
                  O
                )
              ),
            }),
            A.jsxs('div', {
              className: ct.tabs,
              ref: h,
              role: 'tablist',
              children: [
                A.jsx('span', {
                  className: `${ct.slider} ${g ? ct.sliderReady : ''}`,
                  style: {
                    width: f.w,
                    transform: `translate3d(${f.x}px, 0, 0)`,
                  },
                  'aria-hidden': 'true',
                }),
                w.map((O, D) =>
                  A.jsx(
                    'button',
                    {
                      ref: q => {
                        y.current[D] = q;
                      },
                      type: 'button',
                      role: 'tab',
                      'aria-selected': D === r,
                      className: `${ct.tab} ${D === r ? ct.tabActive : ''}`,
                      onClick: () => u(D),
                      children: O,
                    },
                    O
                  )
                ),
              ],
            }),
          ],
        });
      }
      function nm({ variant: l = 'pc' }) {
        return A.jsx(_u, {
          variant: l,
          imageKey: 'section23Bg',
          titleKey: 'section23.title',
          bodyKey: 'section23.body',
        });
      }
      function am({ variant: l = 'pc' }) {
        return A.jsx(Hi, {
          variant: l,
          imageKey: 'section24Bg',
          titleKey: 'section24.title',
          bodyKey: 'section24.body',
          mediaKind: 'video',
        });
      }
      const RS = 'section_zCzSx',
        DS = 'mbSection_Hm1xN',
        LS = 'title_-GrOs',
        jS = 'grid_y8EmL',
        HS = 'card_TQkG9',
        US = 'cardMediaWrap_wq9Qc',
        BS = 'cardMedia_LqaeC',
        GS = 'cardText_Bub92',
        Di = {
          section: RS,
          mbSection: DS,
          title: LS,
          grid: jS,
          card: HS,
          cardMediaWrap: US,
          cardMedia: BS,
          cardText: GS,
        },
        VS = [
          { imageKey: 'section25Card1', textKey: 'section25.usbKey' },
          { imageKey: 'section25Card2', textKey: 'section25.emergency' },
          { imageKey: 'section25Card3', textKey: 'section25.lidOpen' },
          { imageKey: 'section25Card4', textKey: 'section25.flame' },
        ];
      function lm({ variant: l = 'pc' }) {
        const { t: a } = Je(),
          s = l === 'mb';
        return A.jsxs('section', {
          className: `${Di.section} ${s ? Di.mbSection : ''}`,
          children: [
            A.jsx(_e, {
              as: 'h2',
              className: Di.title,
              html: a('section25.title'),
            }),
            A.jsx('div', {
              className: Di.grid,
              children: VS.map(r =>
                A.jsxs(
                  'div',
                  {
                    className: Di.card,
                    children: [
                      A.jsx('div', {
                        className: Di.cardMediaWrap,
                        children: A.jsx(Et, {
                          className: Di.cardMedia,
                          imageKey: r.imageKey,
                        }),
                      }),
                      A.jsx(_e, { className: Di.cardText, html: a(r.textKey) }),
                    ],
                  },
                  r.imageKey
                )
              ),
            }),
          ],
        });
      }
      function sm({ variant: l = 'pc' }) {
        return A.jsx(Hi, {
          variant: l,
          imageKey: 'section26Media',
          titleKey: 'section26.title',
          bodyKey: 'section26.body',
          pcWidth: 1220,
          pcHeight: 771,
          bgColor: '#0C0C0C',
        });
      }
      const KS = 'section_yMZox',
        qS = 'mbSection_sejTn',
        YS = 'row_1X6M4',
        $S = 'rowReversed_YU32V',
        XS = 'media_oslqY',
        QS = 'mediaImg_WV9YY',
        ZS = 'copy_SY6zo',
        kS = 'title_g-3wI',
        JS = 'body_LpfPX',
        nt = {
          section: KS,
          mbSection: qS,
          row: YS,
          rowReversed: $S,
          media: XS,
          mediaImg: QS,
          copy: ZS,
          title: kS,
          body: JS,
        };
      function rm({ variant: l = 'pc' }) {
        const { t: a } = Je(),
          s = l === 'mb';
        return A.jsxs('section', {
          className: `${nt.section} ${s ? nt.mbSection : ''}`,
          children: [
            A.jsxs('div', {
              className: nt.row,
              children: [
                A.jsx('div', {
                  className: nt.media,
                  children: A.jsx(Et, {
                    className: nt.mediaImg,
                    imageKey: 'section27Library',
                  }),
                }),
                A.jsxs('div', {
                  className: nt.copy,
                  children: [
                    A.jsx(_e, {
                      as: 'h3',
                      className: nt.title,
                      html: a('section27.libraryTitle'),
                    }),
                    A.jsx(_e, {
                      className: nt.body,
                      html: a('section27.libraryBody'),
                    }),
                  ],
                }),
              ],
            }),
            A.jsxs('div', {
              className: `${nt.row} ${nt.rowReversed}`,
              children: [
                A.jsx('div', {
                  className: nt.media,
                  children: A.jsx(Et, {
                    className: nt.mediaImg,
                    imageKey: 'section27Wiki',
                  }),
                }),
                A.jsxs('div', {
                  className: nt.copy,
                  children: [
                    A.jsx(_e, {
                      as: 'h3',
                      className: nt.title,
                      html: a('section27.wikiTitle'),
                    }),
                    A.jsx(_e, {
                      className: nt.body,
                      html: a('section27.wikiBody'),
                    }),
                  ],
                }),
              ],
            }),
          ],
        });
      }
      const FS = [
        'section28Slide1',
        'section28Slide2',
        'section28Slide3',
        'section28Slide4',
      ];
      function om({ variant: l = 'pc' }) {
        return A.jsx(ji, {
          variant: l,
          titleKey: 'section28.title',
          bodyKey: 'section28.body',
          imageKeys: FS,
          slidesTextKey: 'section28.slides',
        });
      }
      const PS = 'section_aohWr',
        IS = 'mbSection_VhlfC',
        WS = 'title_OquD3',
        e2 = 'subtitle_04AcD',
        t2 = 'product_pm1vl',
        i2 = 'productImg_Ht8We',
        n2 = 'features_PmA2q',
        a2 = 'feature_Q7ZGk',
        l2 = 'cta_E1yGp',
        li = {
          section: PS,
          mbSection: IS,
          title: WS,
          subtitle: e2,
          product: t2,
          productImg: i2,
          features: n2,
          feature: a2,
          cta: l2,
        };
      function um({ variant: l = 'pc' }) {
        const { t: a } = Je(),
          s = l === 'mb',
          r = a('section29.features', { returnObjects: !0 }) ?? [];
        return A.jsxs('section', {
          className: `${li.section} ${s ? li.mbSection : ''}`,
          children: [
            A.jsx(_e, {
              as: 'h2',
              className: li.title,
              html: a('section29.title'),
            }),
            A.jsx(_e, {
              className: li.subtitle,
              html: a('section29.subtitle'),
            }),
            A.jsx('div', {
              className: li.product,
              children: A.jsx(Et, {
                className: li.productImg,
                imageKey: 'section29Product',
              }),
            }),
            A.jsx('div', {
              className: li.features,
              children: r.map(u =>
                A.jsx('span', { className: li.feature, children: u }, u)
              ),
            }),
            A.jsx('a', {
              className: li.cta,
              href: a('section29.shopLink'),
              target: '_blank',
              children: a('section29.shopNow'),
            }),
          ],
        });
      }
      const s2 = 'section_ZtuQ6',
        r2 = 'mbSection_NbSzK',
        o2 = 'list_dlrrx',
        u2 = 'item_UU-i8',
        Ts = { section: s2, mbSection: r2, list: o2, item: u2 };
      function cm({ variant: l = 'pc' }) {
        const { t: a } = Je(),
          s = l === 'mb',
          r = a('section30.body', { returnObjects: !0 }) ?? [];
        return A.jsx('section', {
          className: `${Ts.section} ${s ? Ts.mbSection : ''}`,
          children: A.jsx('div', {
            className: Ts.list,
            children: r.map(u =>
              A.jsx('p', { className: Ts.item, children: u }, u.slice(0, 12))
            ),
          }),
        });
      }
      const c2 = [
          vp,
          yp,
          bp,
          Sp,
          Gp,
          Vp,
          Kp,
          qp,
          Yp,
          $p,
          Xp,
          Qp,
          Zp,
          kp,
          Jp,
          Fp,
          Pp,
          Ip,
          Wp,
          em,
          tm,
          im,
          nm,
          am,
          lm,
          sm,
          rm,
          om,
          um,
          cm,
        ],
        f2 = [
          vp,
          yp,
          bp,
          Sp,
          Gp,
          Vp,
          Kp,
          qp,
          Yp,
          $p,
          Xp,
          Qp,
          Zp,
          kp,
          Jp,
          Fp,
          Pp,
          Ip,
          Wp,
          em,
          tm,
          im,
          nm,
          am,
          lm,
          sm,
          rm,
          om,
          um,
          cm,
        ];
      function d2({ variant: l = 'pc' }) {
        const a = l === 'mb' ? c2 : f2;
        return A.jsxs('div', {
          className: Cy.stack,
          children: [
            A.jsx(By, { variant: l }),
            a.map((s, r) => A.jsx(s, { variant: l }, r)),
          ],
        });
      }
      const Cu = '(max-width: 768px)';
      function h2() {
        const [l, a] = I.useState(null);
        return (
          I.useLayoutEffect(() => {
            const s = window.matchMedia(Cu),
              r = () => a(s.matches ? 'mb' : 'pc');
            return (
              r(),
              s.addEventListener('change', r),
              () => s.removeEventListener('change', r)
            );
          }, []),
          l
        );
      }
      const p2 = `not all and ${Cu}`;
      function m2() {
        const { i18n: l } = Je(),
          { t: a } = Je('imageUrl'),
          r = h2() ?? 'pc',
          { pcSrc: u, mobileSrc: f } = gp(a, 'heroKV'),
          p = I.useRef(null);
        return (
          I.useLayoutEffect(() => {
            const g = p.current;
            if (!g) return;
            const d = () => {
              g.style.setProperty('--t1-pc-vw', `${g.clientWidth / 100}px`);
            };
            d();
            const h = new ResizeObserver(d);
            return (
              h.observe(g),
              window.addEventListener('resize', d),
              () => {
                (h.disconnect(), window.removeEventListener('resize', d));
              }
            );
          }, []),
          A.jsxs('div', {
            ref: p,
            className: `t1-page ${Oy.page}`,
            'data-lang': l.language,
            children: [
              u
                ? A.jsx('link', {
                    rel: 'preload',
                    as: 'image',
                    href: u,
                    media: p2,
                    fetchPriority: 'high',
                  })
                : null,
              f
                ? A.jsx('link', {
                    rel: 'preload',
                    as: 'image',
                    href: f,
                    media: Cu,
                    fetchPriority: 'high',
                  })
                : null,
              A.jsx(d2, { variant: r }),
            ],
          })
        );
      }
      const g2 = {
          title: 'Creality Falcon T1',
          description: 'Five Lasers.Create Faster, Smarter. Grow Further.',
          stickyNav: {
            title: 'Creality Falcon T1',
            shopNow: 'Buy Now',
            shopLink:
              'https://eu.crealityfalcon.com/products/creality-falcon-t1-5-in-1-laser-engraver',
          },
          section1: {
            title: 'Creality Falcon T1',
            subtitle: 'Five Lasers.Create Faster, Smarter. Grow Further.',
            shopNow: 'Buy now',
            shopLink:
              'https://eu.crealityfalcon.com/products/creality-falcon-t1-5-in-1-laser-engraver',
          },
          section2: {
            body: 'Creality Falcon T1. Five Lasers. Infinite Possibilities. Its expandable 5-in-1 system<sup class="fn">[1]</sup> brings Diode, Fiber, MOPA, and UV technologies together—from MOPA 60W color engraving<sup class="fn">[4]</sup> to UV 5W 3D internal engraving in compatible crystal<sup class="fn">[5]</sup>. With positioning accuracy under 0.01 mm<sup class="fn">[6]</sup>, speeds up to 10,000 mm/s<sup class="fn">[7]</sup>, Autofocus in Seconds<sup class="fn">[2]</sup>, and AI-powered creation tools<sup class="fn">[10]</sup>, Falcon T1 turns more ideas into reality with precision and ease.',
          },
          section3: {
            fiveLasers: 'Five Interchangeable Modules<sup class="fn">[1]</sup>',
            micron: 'Micron Precision Fine Detail',
            galvoSpeed: 'High-Speed Galvo<br />Faster Creation',
            autoFocus: 'Autofocus in Seconds<sup class="fn">[2]</sup>',
            autoFocusMb: 'Autofocus in Seconds<sup class="fn">[2]</sup>',
            touch: 'Touch. Control. Create',
            galvoLight: 'Galvo-Controlled Light Precision in Motion',
            class1:
              'Class 1 Protection<br class="br_pc" />Create with Confidence<sup class="fn">[3]</sup>',
            conveyor: 'Continuous Batch Processing',
            ai: 'AI-Assisted Creation',
          },
          section4: {
            title:
              'Five Modules, Seamlessly Switchable<sup class="fn">[1]</sup> <br class="br_pc" />One Machine, More Ways to Create',
            body: 'Countless Materials. One Brilliant Craft.',
          },
          section5: {
            title: 'Five Modules<sup class="fn">[1]</sup> Endless Horizons',
            body: 'Unlock wood, leather, metal, crystal, and vibrant steel coloring. Recombine 5 professional <br class="br_pc" />light sources to switchwavelengths and redefine your making boundaries.',
            slides: [
              {
                name: 'MOPA 60W',
                body: 'Smart, multi-color engraving on stainless steel and titanium—no post-coloring required.<sup class="fn">[4]</sup>',
              },
              {
                name: 'UV 5W',
                body: 'Precise 3D internal engraving in compatible crystal and glass.<sup class="fn">[5]</sup>',
              },
              {
                name: 'Diode 20W',
                body: 'Cut and deep-engrave wood, leather, and acrylic in a single pass.',
              },
              {
                name: 'Diode 40W',
                body: 'Double the power for fast, efficient cutting through thick materials.',
              },
              {
                name: 'Fiber 20W',
                body: 'High-precision marking on metals and plastics with razor-sharp details.',
              },
            ],
          },
          section6: {
            title:
              '<em class="blue">20MP</em> Ultra-Clear Vision, Positioning <br class="br_pc" />Accuracy <em class="blue">&lt;0.01 mm</em><sup class="fn">[6]</sup>',
            body: 'Monitor the workspace in real time and preserve every detail. A precise focal spot under<br class="br_pc" />0.01 mm focuses on the beam, ensuring visible micron-level accuracy.',
          },
          section7: {
            title: 'See More. Miss Nothing',
            body: 'From positioning to live view and zoom, T1 keeps every step clear and visible.',
            slides: [
              {
                name: 'Identify the Workspace. Position with Speed.',
                body: '20MP Ultra-Clear Vision detects material placement and work area for precise layout.',
              },
              {
                name: 'Real-Time Sync. Intuitive Alignment',
                body: 'Live feeds and machining data are transmitted to the interface instantly.<br />Align your designs with the actual material to minimize trial and error.',
              },
              {
                name: 'Zoom in on Details Monitor the Process',
                body: 'Magnify specific areas to check intricate details and real-time status.<br />Keep your entire creative process clear and under control.',
              },
            ],
          },
          section8: {
            title:
              'High-Speed Galvo System Speeds up to 10,000 mm/s<sup class="fn">[7]</sup>',
            body: 'High-speed galvo mirrors deflect the laser beam for rapid surface scanning.<br class="br_pc" />Execute complex lines and large-area fills instantly without moving the laser head—where speed meets precision.',
          },
          section9: {
            title: 'Do More in Less Time',
            body: `Under identical conditions, the T1 finishes tasks faster thanks to its galvo system. Speed isn't<br class="br_pc" />just a spec—it translates to less waiting and higher batch efficiency.`,
            labelT1: 'Falcon T1',
            labelOther: 'Other',
          },
          section10: {
            title: 'Dual-Axis High-Speed Galvo.<br> Precise Beam Control',
            body: 'X- and Y-axis mirrors steer the beam along programmed<br class="br_pc" />paths for fast, accurate engraving.',
          },
          section11: {
            title: 'Faster results through optical innovation',
            body: 'High-Speed Galvo Scanning. Revolutionizing Motion Paths',
            slides: [
              {
                name: 'Dual-Mirror Synergy. Precise Guidance.',
                body: `X and Y axes control the beam's lateral and longitudinal deflection, working together for 2D <br class="br_pc" />scanning to cast the laser precisely onto the material.`,
              },
              {
                name: 'Galvo Moves Light Gantry Moves the Head',
                body: 'Galvo controls the optical path via mirror deflection, while traditional gantry systems physically move the laser head. <br class="br_pc" />This distinct motion gives galvo the ultimate edge in high-speed batch processing.',
              },
            ],
          },
          section12: {
            title: 'Focus locked. Ready to create',
            body: 'Autofocus in Seconds<sup class="fn">[2]</sup> Adapt to Any Material Height.',
          },
          section13: {
            title: 'One Touch All Set',
            body: 'Smart Touchscreen. Critical Info at a Glance.',
          },
          section14: {
            title: 'Precise Focus 3D Engraving Within',
            body: 'The laser focuses inside transparent materials to build detailed 3D designs layer by layer.',
          },
          section15: {
            title: 'Clear Detail Visible Depth',
            body: 'From shapes to fine textures, reveal clear internal<br class="br_pc" />depth and dimensional detail',
          },
          section16: {
            title: 'Precise Control Color on Metal',
            body: 'Fine laser parameter control creates varied<br class="br_pc" />color effects on metal surfaces',
          },
          section17: {
            title: 'More Color More Expression',
            body: 'From gradients to colorful patterns,<br class="br_pc" />create richer finishes on metal surfaces',
          },
          section18: {
            title: 'Layer by Layer Depth Takes Shape',
            body: 'The laser removes material progressively to create clear depth and texture',
          },
          section19: {
            title: 'Defined Depth Clear Texture',
            body: 'From deep engraving to relief, create stronger depth<br class="br_pc" />contrast and dimensional texture.',
          },
          section20: {
            title: 'More Materials. More Ways to Create',
            body: 'From leather and paper to wood and acrylic, explore more<br class="br_pc" />possibilities for everyday creation.',
          },
          section21: {
            title:
              'Automatic Conveyor<sup class="fn">[9]</sup> for <br class="br_pc" />Continuous Feeding and Batch Processing',
            body: 'Keep Creating. Keep Production Moving.',
          },
          section22: {
            title:
              'Versatile Accessories<sup class="fn">[9]</sup>. More Ways to Create',
            body: 'From Flat to Form. Expand What’s Possible.',
            tabs: [
              'Flexible Fixture',
              'Rotary Kit',
              '3D Engraving Riser',
              'Air Purifier',
            ],
          },
          section23: {
            title:
              'Multi-Wavelength Laser Safety Window<br>Clear View, Full Enclosure<sup class="fn">[3]</sup>',
            body: 'Contain the Beam. Keep Creation in View',
          },
          section24: {
            title: 'High-Speed Airflow. Fast Extraction',
            body: 'A high-speed fan creates steady airflow to quickly draw smoke out of the enclosure.',
          },
          section25: {
            title: 'Multiple Safeguards. Protection Throughout',
            usbKey: 'USB Security Key',
            lidOpen: 'Auto Stop on Lid Open',
            flame: 'Flame Detection',
            emergency: 'Emergency Stop',
          },
          section26: {
            title: 'AI-Assisted Creation Shape Inspiration Instantly',
            body: 'Supports AI generation, background removal, layout,<br> 3D relief generation, and color outline extraction.<sup class="fn">[10]</sup>',
          },
          section27: {
            libraryTitle: 'Extensive Asset Library<br />Ready to Use',
            libraryBody:
              'A continuously growing collection of design assets <br class="br_pc" />ensures you never have to start from scratch.',
            wikiTitle: 'From Beginner to Pro <br />Answers at Your Fingertips',
            wikiBody:
              'Real Tutorials. Real Materials. Real Projects. Everything You Need, All in One Place.',
          },
          section28: {
            title: 'From Custom Orders to Independent Brands',
            body: 'One Creation. A Business in the Making.',
            slides: [
              {
                name: 'Side Hustle',
                body: 'Start with one custom piece. Grow at your own pace.',
              },
              {
                name: 'Premium Customization',
                body: 'Give every custom piece a distinctive, premium finish.',
              },
              {
                name: 'Independent Studio',
                body: 'Go from prototype to small-batch production with one machine.',
              },
              {
                name: 'Creator Reviews',
                body: 'Turn every process into content worth sharing.',
              },
            ],
          },
          section29: {
            title: 'Creality Falcon T1',
            subtitle: 'Five Lasers. Infinite Possibilities.',
            features: [
              'Expandable Laser Modules',
              'Color & 3D Engraving',
              'High-Speed Galvo Engraving',
              'Smart Vision Creation',
              'Continuous Batch Processing',
            ],
            shopNow: 'Buy now',
            shopLink:
              'https://eu.crealityfalcon.com/products/creality-falcon-t1-5-in-1-laser-engraver',
          },
          section30: {
            body: [
              '1. The five laser modules are Diode 20W, Diode 40W, Fiber 20W, MOPA 60W, and UV 5W. Module configurations, sales options, and regional availability may vary. Refer to the local sales page for details.',
              '2. The autofocus-in-seconds figure is based on internal testing using production hardware, final firmware, and the standard test procedure. Actual focusing time may vary with the laser module, material height, calibration status, and operating environment.',
              '3. Class 1 applies when the machine is fully enclosed, the lid is properly closed, and the product is operated as instructed. In specific open-cover workflows, including conveyor and rotary modes, the product does not meet Class 1 requirements. Follow the safety instructions, use additional safeguards, and wear appropriate personal protective equipment. The protective window is designed for the product’s 355 nm, 455 nm, and 1064 nm laser wavelengths.',
              '4. Metal color engraving requires the MOPA 60W module. Colors and effects vary with metal type, surface condition, processing parameters, and operating environment. Actual results may vary by material.',
              '5. 3D internal engraving requires the UV 5W module, the matching internal-engraving F-theta lens, and the 3D Engraving Riser. It is intended for compatible transparent materials. Refer to the actual package list for included components.',
              '6. 20MP refers to the camera sensor resolution. The under-0.01 mm figure describes positioning accuracy, not laser spot size. Data is based on internal testing under controlled conditions. Actual results may vary with the laser module, calibration status, material, and operating environment.',
              '7. 10,000 mm/s is the maximum working speed and may not be available with every laser module, material, or processing mode. Actual speed varies with the laser module, material, design complexity, and processing settings.',
              '8. Material compatibility and processing results vary with composition, color, surface finish, thickness, moisture content, and parameter settings. Test the material before processing.',
              '9. The automatic conveyor, flexible fixture, rotary kit, 3D Engraving Riser, knife blade bed, and air purifier are sold separately unless expressly included in the selected bundle. Compatibility and availability may vary by laser module, processing method, and region.',
              '10. AI feature availability may vary by software or app version, device configuration, laser module, and region. Some features may require an internet connection and account sign-in. AI-generated or processed results may vary with the source content.',
              '* Project visuals are for illustrative purposes only. Actual processing results may vary.',
            ],
          },
        },
        v2 = {
          heroKV:
            'https://compress-file.creality.com/images/Agent/42b8f05f-855b-406e-a344-70e042fcd78f.webp',
          heroKVM:
            'https://compress-file.creality.com/images/Agent/7ca9c58c-8388-4f73-aad0-3da2f466505f.webp',
          hlModule:
            'https://cdn.creality.com/ow/t1-page/52bc0212-0731-4a9b-a11c-1f0b8d176039.mp4',
          hlModuleM: '',
          hlPrecision:
            'https://compress-file.creality.com/images/Agent/9a1daa71-0900-4608-b9c3-4eec86ec1e39.webp',
          hlPrecisionM:
            'https://compress-file.creality.com/images/Agent/7949101f-18b9-467a-acf9-9295ce30fa1b.webp',
          hlDetail:
            'https://compress-file.creality.com/videos/Agent/9ebb0876-af06-4a95-9516-33f4899d5e04.mp4',
          hlDetailM: '',
          hlAutoFocus:
            'https://compress-file.creality.com/images/Agent/951c93af-bffa-45f3-9bae-dbec8f696fd1.webp',
          hlAutoFocusM:
            'https://cdn.creality.com/ow/official/b1ad696c-b754-4d0b-ba12-3ac24d35881a.png',
          hlScreen:
            'https://cdn.creality.com/ow/official/26d6126a-88e3-40b6-9fe3-381c786d68fa.png',
          hlScreenM:
            'https://cdn.creality.com/ow/official/56841b60-e22d-4aab-be4d-1a0b63dd2345.png',
          hlGalvo:
            'https://compress-file.creality.com/images/Agent/98658d42-04ef-4c4c-b58f-5f1cdf05319b.webp',
          hlGalvoM: '',
          hlSafety:
            'https://compress-file.creality.com/videos/Agent/de065448-27ee-411c-b7b1-b619c1879dfc.mp4',
          hlSafetyM: '',
          hlConveyor:
            'https://compress-file.creality.com/images/Agent/4050676c-1d15-41e3-9583-af499a92d1d3.webp',
          hlConveyorM:
            'https://cdn.creality.com/ow/official/b430d735-d9ff-4c8b-8aa3-4a2f689f33cc.png',
          hlAi: 'https://compress-file.creality.com/images/Agent/6ab909d6-1acf-4349-ad37-2a25c71e911e.webp',
          hlAiM:
            'https://cdn.creality.com/ow/official/ed15ab97-df8e-4d77-962e-e4e8b0d0b657.png',
          section4Bg:
            'https://compress-file.creality.com/videos/suwei/b6fd86fa-9d34-4923-860f-3baf30b40446.mp4',
          section4BgM: '',
          section5Slide1:
            'https://compress-file.creality.com/videos/Agent/e67fb489-ed57-4c7c-a53c-f78482fc66ac.mp4',
          section5Slide1M: '',
          section5Slide2:
            'https://compress-file.creality.com/videos/Agent/f0a5bd09-12fe-4954-9ee1-84a7edab592a.mp4',
          section5Slide2M: '',
          section5Slide3:
            'https://compress-file.creality.com/videos/Agent/3fb35fce-caab-492e-9c56-dbb7320950c6.mp4',
          section5Slide3M: '',
          section5Slide4:
            'https://compress-file.creality.com/videos/Agent/76b501e5-9e8c-4f7c-b2b7-6cfc8af9f26c.mp4',
          section5Slide4M: '',
          section5Slide5:
            'https://compress-file.creality.com/videos/Agent/d7e46370-f6c9-4445-81dc-26af4a287210.mp4',
          section5Slide5M: '',
          section6Media:
            'https://compress-file.creality.com/videos/suwei/68333d59-121d-40df-9c89-29ef0b383cfa.mp4',
          section6MediaM: '',
          section7Slide1:
            'https://compress-file.creality.com/images/Agent/6a3b1cf3-72b6-4c15-bb6c-2efef61c81f1.webp',
          section7Slide1M: '',
          section7Slide2:
            'https://cdn.creality.com/ow/official/3cb86c45-7f0a-43fe-bee1-f9dffb9add6d.png',
          section7Slide2M: '',
          section7Slide3:
            'https://cdn.creality.com/ow/official/11bd6f01-9ff9-45b7-ab54-aba78d474891.png',
          section7Slide3M: '',
          section8Bg:
            'https://compress-file.creality.com/images/Agent/175f421f-27ea-43f3-bcd9-f7c8ac1a9320.webp',
          section8BgM: '',
          section9Media:
            'https://compress-file.creality.com/videos/suwei/563a91b2-e538-4e02-bd40-934c11343154.mp4',
          section9MediaM: '',
          section10Bg:
            'https://compress-file.creality.com/videos/Agent/b8a0ec11-ecdb-4d36-a804-fdb6bee18323.mp4',
          section10BgM: '',
          section11Slide1:
            'https://cdn.creality.com/ow/t1-page/1bfc147c-0c94-4e8f-b563-d9461c9b3e7a.png',
          section11Slide1M: '',
          section11Slide2:
            'https://compress-file.creality.com/images/Agent/965d99a9-42d7-4766-b4f4-a1a0dce25170.webp',
          section11Slide2M: '',
          section12Bg:
            'https://compress-file.creality.com/images/Agent/4ba120b3-f444-4f54-88e5-1e7542d42c6e.webp',
          section12BgM: '',
          section13Bg:
            'https://compress-file.creality.com/videos/Agent/ccf0fc89-b15b-4b2a-8c22-2b99c48636e1.mp4',
          section13BgM:
            'https://compress-file.creality.com/videos/Agent/804ea68b-c88a-4a75-8d3a-f996004d9121.mp4',
          section14Media:
            'https://compress-file.creality.com/videos/Agent/30a02ea9-d54c-4ad1-95f2-2747b1870241.mp4',
          section14MediaM: '',
          section15Slide1:
            'https://compress-file.creality.com/images/Agent/b4ac7965-3d3f-42a7-8887-0ced05c9c829.webp',
          section15Slide1M: '',
          section15Slide2:
            'https://compress-file.creality.com/images/Agent/c3de9327-99fb-4d3b-ba96-40f7460ad86e.webp',
          section15Slide2M: '',
          section15Slide3:
            'https://compress-file.creality.com/images/Agent/4526baa0-420a-4ee4-aca9-b4db02a9fd50.webp',
          section15Slide3M: '',
          section16Media:
            'https://compress-file.creality.com/videos/Agent/cf7dd680-00bf-4056-9c02-1110e2d43420.mp4',
          section16MediaM: '',
          section17Slide1:
            'https://compress-file.creality.com/images/Agent/96883eae-743b-4cf9-9730-83cdf43fa96f.webp',
          section17Slide1M: '',
          section17Slide2:
            'https://compress-file.creality.com/images/Agent/fed3a838-55d0-49b9-9902-107d8721e08d.webp',
          section17Slide2M: '',
          section17Slide3:
            'https://compress-file.creality.com/images/Agent/12052a78-ad30-4b86-b007-5bff0b537d0d.webp',
          section17Slide3M: '',
          section17Slide4:
            'https://compress-file.creality.com/images/Agent/b9891c99-0673-4575-bb67-e5142ceceda0.webp',
          section17Slide4M: '',
          section18Media:
            'https://compress-file.creality.com/videos/Agent/8f2f695c-5d97-468d-ad3a-5418f9f9c512.mp4',
          section18MediaM: '',
          section19Slide1:
            'https://compress-file.creality.com/images/Agent/02df9c2f-4b38-4c41-b6f8-82aeaacdd8b4.webp',
          section19Slide1M: '',
          section19Slide2:
            'https://compress-file.creality.com/images/Agent/e28db1a7-0a74-46ed-834b-e6a8a185de7d.webp',
          section19Slide2M: '',
          section19Slide3:
            'https://compress-file.creality.com/images/Agent/cf71a4ea-6b78-4d48-a0df-f9173fc502e6.webp',
          section19Slide3M: '',
          section20Slide1:
            'https://compress-file.creality.com/images/Agent/b6ba8963-f539-4a98-be21-8f65be643474.webp',
          section20Slide1M: '',
          section20Slide2:
            'https://compress-file.creality.com/images/Agent/734d1814-60ff-4834-b611-11422db32a21.webp',
          section20Slide2M: '',
          section20Slide3:
            'https://compress-file.creality.com/images/Agent/8116c04b-84c6-4cf2-86df-b495e80ad23b.webp',
          section20Slide3M: '',
          section21Bg:
            'https://compress-file.creality.com/videos/Agent/8961c5d8-dcd2-4776-bdeb-bcb8a6ae048e.mp4',
          section21BgM:
            'https://compress-file.creality.com/videos/Agent/2415bca1-a696-4b23-bf2e-28c3f846892a.mp4',
          section22Slide1:
            'https://compress-file.creality.com/videos/Agent/18e47e69-2456-431a-ae25-c66c6a8bd9ba.mp4',
          section22Slide1M: '',
          section22Slide2:
            'https://compress-file.creality.com/videos/Agent/aff4f1ce-f0f4-42ea-8d33-0f5de5ad8ace.mp4',
          section22Slide2M: '',
          section22Slide3:
            'https://compress-file.creality.com/videos/Agent/bd630867-80f9-4938-84f8-ed8a1a43788a.mp4',
          section22Slide3M: '',
          section22Slide4:
            'https://compress-file.creality.com/videos/Agent/36088f3d-f175-415a-a8e9-c9a55fa14e2b.mp4',
          section22Slide4M: '',
          section23Bg:
            'https://compress-file.creality.com/images/Agent/c46c717b-570f-4801-9c53-e44ec1d118c6.webp',
          section23BgM:
            'https://compress-file.creality.com/images/Agent/077dc369-abba-47a8-b420-1c2f667ca728.webp',
          section24Bg:
            'https://compress-file.creality.com/videos/suwei/52368a1c-ba5b-460a-80b1-60f8bfa851ab.mp4',
          section24BgM:
            'https://compress-file.creality.com/videos/Agent/4bac52eb-781c-4810-9b19-ae51b61e3a06.mp4',
          section25Card1:
            'https://cdn.creality.com/ow/t1-page/f7c86802-0b3a-480f-89ae-a5d257f361e0.png',
          section25Card1M:
            'https://cdn.creality.com/ow/t1-page/9531a61d-3d98-4ef3-aeb7-781e1b8258a6.png',
          section25Card2:
            'https://cdn.creality.com/ow/t1-page/94fb3d8d-8fee-4693-a0a7-c93375c3880b.png',
          section25Card2M:
            'https://cdn.creality.com/ow/t1-page/58456c67-6e53-4636-ac60-921fbcacb1f3.png',
          section25Card3:
            'https://cdn.creality.com/ow/t1-page/31dc659e-aa69-4a06-8d0e-c83e4c6b6be9.png',
          section25Card3M:
            'https://cdn.creality.com/ow/t1-page/81f01949-bc5a-4865-8c2d-63b9f33a7ef7.png',
          section25Card4:
            'https://cdn.creality.com/ow/t1-page/a3a9c517-20d1-4301-962e-6d334b366fa4.png',
          section25Card4M:
            'https://cdn.creality.com/ow/t1-page/bee20cce-658e-4649-b636-4d05e5f1936b.png',
          section26Media:
            'https://cdn.creality.com/ow/t1-page/823fd1e9-490c-46d9-96fc-6a3e652d35ca.png',
          section26MediaM: '',
          section27Library:
            'https://cdn.creality.com/ow/t1-page/659b3752-3cac-4643-887d-760f5abe9580.png',
          section27LibraryM: '',
          section27Wiki:
            'https://cdn.creality.com/ow/t1-page/e4a8e8b1-ce8e-4dc4-964d-de2959b79f93.png',
          section27WikiM: '',
          section28Slide1:
            'https://compress-file.creality.com/images/Agent/11753368-8d5d-4722-a61b-7be05c81adea.webp',
          section28Slide1M: '',
          section28Slide2:
            'https://compress-file.creality.com/images/Agent/b0ffb5d5-342a-48b6-b20f-9f11f5d9eeb9.webp',
          section28Slide2M: '',
          section28Slide3:
            'https://compress-file.creality.com/images/Agent/d60e4026-abe5-46d0-9b79-62ac52ea228c.webp',
          section28Slide3M: '',
          section28Slide4:
            'https://compress-file.creality.com/images/Agent/201eafbb-8d1a-492d-b9f1-101c8fbe6672.webp',
          section28Slide4M: '',
          section29Product:
            'https://cdn.creality.com/ow/t1-page/f4764d8d-c1c3-4e2f-b5b2-7cc5a803090b.png',
          section29ProductM: '',
        },
        y2 = { en: { translation: g2, imageUrl: v2 } };
      Mu.use(xy).init({
        resources: y2,
        lng: Qy(),
        fallbackLng: 'en',
        interpolation: { escapeValue: !1 },
        initImmediate: !1,
      });
      const b2 = document.getElementById('product-detail-t1-page'),
        S2 = A.jsx(My, { i18n: Mu, children: A.jsx(m2, {}) });
      Yv.createRoot(b2).render(S2);

})();